(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.tools', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider , msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.tools_home', {
                url    : '/utilidades',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pharmacist/tools/tools.html',
                        controller : 'ToolsHomeController as vm'
                    }
                },
                resolve: {
                  access: ["Access", function (Access) { return Access.hasAnyRole(['farmaceutico','comercial']); }],
                  downloads: function(api) {
                    return api.download.list({mode:'tools'}).$promise;
                  }
                }
            })

          .state('app.calculator_retail', {
            url    : '/utilidades/calculadora-pvp',
            views  : {
              'content@app': {
                templateUrl: 'app/main/pharmacist/tools/views/calculator-retail.html',
                controller : 'CalculatorRetailController as vm'
              }
            },
            resolve: {
              access: ["Access", function (Access) { return Access.hasAnyRole(['farmaceutico','comercial']); }]

            }
          });

        msNavigationServiceProvider.saveItem('tools', {
          title    : 'Utilidades',
          icon     : 'fa fa-wrench',
          state    : 'app.tools_home',
          weight   : 9
        });
    }
})();

(function () {
  'use strict';

  angular
    .module('app.tools')
    .controller('ToolsHomeController', ToolsHomeController)
    .controller('CalculatorRetailController', CalculatorRetailController)

  /** @ngInject */
  function ToolsHomeController(myConfig, $timeout, api, downloads) {
    var vm = this;
    vm.downloads = downloads;

    vm.download = function(id) {
      api.download.getLink({id:id}).$promise.then(function (d){
        location.href=d.url;
      });
    };
  }

  /** @ngInject */
  function CalculatorRetailController(api, myConfig) {
    var vm = this;
    vm.tax_types = [10, 21];
    vm.recargo_types = {10: 1.4, 21: 5.2,};

    vm.wholesale = 0;
    vm.tax = 10;
    vm.recargo = vm.recargo_types[vm.tax];
    vm.use_recargo = true;
    vm.profit = 0;

    vm.saved = {
      wholesale: null,
      tax: null,
      recargo: null,
      profit: null
    };

    vm.result = {
      calculated: {
        wholesale: null,
        profit: null,
        retail_tax_excl: null,
        tax: null,
        retail: null,
      },
      prev: {
        wholesale: null,
        profit: null,
        retail_tax_excl: null,
        tax: null,
        retail: null,
      },
      next: {
        wholesale: null,
        profit: null,
        retail_tax_excl: null,
        tax: null,
        retail: null,
      }
    };

    vm.updateRecargo = function ($event) {
      if (this.tax && vm.recargo_types[this.tax] !== undefined) {
        vm.recargo = vm.recargo_types[this.tax];
      }
    };

    vm.calculate = function (raw_tax, raw_profit, raw_wholesale, recargo) {
      var tax = 1 + (raw_tax / 100),
        profit = 1 - (raw_profit / 100);
      var retail_tax_excl = ((raw_wholesale * tax) + (raw_wholesale * (1 + (recargo / 100)))) - raw_wholesale;
      var total = retail_tax_excl / profit;
      return {
        wholesale: raw_wholesale.toLocaleString('es', {style: 'currency', currency: 'EUR', currencyDisplay: 'symbol'}),
        profit: (retail_tax_excl * (raw_profit / 100)).toLocaleString('es', {
          style: 'currency',
          currency: 'EUR',
          currencyDisplay: 'symbol'
        }),
        retail_tax_excl: retail_tax_excl.toLocaleString('es', {
          style: 'currency',
          currency: 'EUR',
          currencyDisplay: 'symbol'
        }),
        tax: (retail_tax_excl * (raw_tax / 100)).toLocaleString('es', {
          style: 'currency',
          currency: 'EUR',
          currencyDisplay: 'symbol'
        }),
        retail: total.toLocaleString('es', {style: 'currency', currency: 'EUR', currencyDisplay: 'symbol'})
      };
    };

    vm.calculateAll = function () {
      vm.saved = {
        wholesale: vm.wholesale,
        tax: vm.tax,
        recargo: vm.recargo,
        use_recargo: vm.use_recargo,
        profit: vm.profit
      };

      this.result.calculated = vm.calculate(vm.saved.tax, vm.saved.profit, vm.saved.wholesale, vm.saved.use_recargo ? vm.saved.recargo : 0);
      this.result.prev = vm.calculate(vm.saved.tax, vm.saved.profit - 5, vm.saved.wholesale, vm.saved.use_recargo ? vm.saved.recargo : 0);
      this.result.next = vm.calculate(vm.saved.tax, vm.saved.profit + 5, vm.saved.wholesale, vm.saved.use_recargo ? vm.saved.recargo : 0);
    };
  }
})();
(function()
{
  'use strict';
  angular
    .module('app.guest-promotions',[])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider
      .state('app.guest-promotions', {
        url: '/promociones?page&items&search',
        views: {
          'content@app': {
            templateUrl: 'app/main/pharmacist/promotions/views/listPromotions.html',
            controller : 'GuestPromotionsMainController as vm',
            params: {
              items: {
                value: '12',
                squash: true
              },
              page: {
                value: '1',
                squash: true
              },
              search: {
                value: '',
                squash: true
              }
            }
          }
        },
        resolve: {
          access: ["Access", function (Access) { return Access.hasAnyRole(['farmaceutico','comercial']);  }],
          activePromotionsList: function (api, $stateParams) {
            return api.promotion.paginatedList({items:$stateParams.items, status: 'enabled', page:$stateParams.page, search:$stateParams.search}).$promise;
          },
          categoriesList: function (api) {
            return api.category.list().$promise;
          },
          slider: function(api) {
            return api.slider.get({id:3}).$promise;
          }
        }
      })
      .state('app.guest-promotion-show', {
        url: '/promociones/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/pharmacist/promotions/views/showPromotion.html',
            controller: 'GuestPromotionsShowController as vm'
          }
        },
        resolve: {
          access: ["Access", function (Access) { return Access.hasAnyRole(['farmaceutico','comercial']);  }],
          promotion: function (api, $stateParams) {
            return api.promotion.get({id:$stateParams.id}).$promise;
          }
        }
      });

    msNavigationServiceProvider.saveItem('guest-promotions', {
      title    : 'Promociones',
      icon     : 'icon-tag-multiple',
      state    : 'app.guest-promotions',
      weight   : 2
    });
  }
})();

(function()
{
  'use strict';
  angular
    .module('app.guest-promotions')
    .controller('GuestPromotionsMainController',GuestPromotionsMainController)
    .controller('GuestPromotionsShowController',GuestPromotionsShowController);

  function GuestPromotionsMainController($rootScope, $cookieStore, api, activePromotionsList, slider, categoriesList, $mdSidenav, $stateParams, $state){
    var vm = this;
    vm.slider = slider;
    vm.pagination = activePromotionsList;
    vm.categories = categoriesList;
    vm.filter = {};
    vm.filter.items = activePromotionsList.per_page;
    vm.filter.search = $stateParams.search;
    vm.filter.category = $stateParams.category;
    vm.api=api.promotion.paginatedList;





    if($cookieStore.get('promotion-list-view'))
      vm.view = $cookieStore.get('promotion-list-view')
    else {
      vm.view = 'grid';
      $cookieStore.put('promotion-list-view', vm.view);
    }

    vm.setView = function(view, toggleSidenav) {
      vm.view = view;
      $cookieStore.put('promotion-list-view',view);
      if (toggleSidenav) vm.toggleSidenav('sidenav');
    };

    vm.setCategory = function(category, toggleSidenav) {
      vm.filter.category = category;
      vm.refreshPromotions();
      if (toggleSidenav) vm.toggleSidenav('sidenav');
    }

    vm.setItems = function(items, toggleSidenav) {
      vm.filter.items = items;
      vm.refreshPromotions();
      if (toggleSidenav) vm.toggleSidenav('sidenav');
    }

    vm.setSearch = function(toggleSidenav, search) {
      if (search){
        if (search == "null")
          vm.filter.search = null;
        else
          vm.filter.search = search;
      }
      vm.refreshPromotions();
      if (toggleSidenav) vm.toggleSidenav('sidenav');
    }

    vm.resetFilter = function () {
      vm.filter = { items: 12 };
      vm.refreshPromotions();
    }

    vm.refreshPromotions = function(){
      $state.go('.', {page: 1, items: vm.filter.items, search: vm.filter.search});
      // $rootScope.loadingProgress = true;
      // api.promotion.paginatedList({"items": vm.filter.items, "page" : 1, "category" : vm.filter.category, "search" : vm.filter.search}).$promise.then(
      //   function(data){
      //     vm.pagination = data;
      //     $rootScope.loadingProgress = false;
      //   },
      //   function (err) {
      //     console.log(err);
      //   }
      // );
    };

    vm.toggleSidenav = toggleSidenav;
    function toggleSidenav(sidenavId){
      $mdSidenav(sidenavId).toggle();
    }
  }

  function GuestPromotionsShowController(promotion){
    var vm = this;
    vm.promotion = promotion;
    vm.qty = 1;
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-promotionals',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider)
    {

         $stateProvider
          .state('app.guest-promotionals', {
            url    : '/mis-descuentos',
            views  : {
              'content@app': {
                templateUrl: 'app/main/pharmacist/promotionals/list.html',
                controller : 'PromotionalsGuestController as vm'
              }
            },
            resolve: {
              access: ["Access", function (Access) { return Access.hasAnyRole(['farmaceutico','comercial']);  }]
              //promotionals: function(api) {
              //  return api.user.myPromotionals().$promise;
              //}

            }
          });

         //msNavigationServiceProvider.saveItem('my-discounts', {
         //    title    : 'Mis descuentos',
         //    icon     : 'fa fa-barcode',
         //    state    : 'app.guest-promotionals',
         //    /*stateParams: {
         //        'param1': 'page'
         //     },*/
         //    weight   : 5
         //});


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-promotionals')
        .controller('PromotionalsGuestController', PromotionalsGuestController);

    function PromotionalsGuestController (api){
      var vm=this;
      api.user.myPromotionals().$promise.then(function(d){
        vm.promotionals=d;
      });


    }





})();

(function()
{
	'use strict';

	/** @ngInject */
	angular
		.module('app.guest-orders',[])
		.config(config);

	function config($stateProvider, msNavigationServiceProvider,msApiProvider) {
		$stateProvider
			.state('app.guest-orders', {
				state: 'app.guest-orders',
				url: '/pedidos',
				views: {
					'content@app': {
						templateUrl: 'app/main/pharmacist/orders/views/listOrders.html',
						controller: 'GuestOrdersMainCtrl as vm'
					}
				},
				resolve: {
          access: ["Access", function (Access) { return Access.hasAnyRole(['farmaceutico','comercial']);  }],
					myOrders: function(api) {
						return api.order.myOrders().$promise;
					}
				}
			});

    msApiProvider.register('app.user', ['http://cetait.dyndns.info/mirafarma/public/api/test-sync']);


    $stateProvider
      .state('app.guest-orders-show', {
        state: 'app.guest-orders-show',
        url: '/pedidos/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/pharmacist/orders/views/showOrder.html',
            controller: 'GuestOrdersShowCtrl as vm'
          }
        },
        resolve: {
          access: ["Access", function (Access) { return Access.hasAnyRole(['farmaceutico','comercial']);  }],
          order: function (api, $stateParams) {
            return api.order.getFromGuest({id:$stateParams.id}).$promise;
          }
        }
      });


    //msNavigationServiceProvider.saveItem('guest-orders', {
    //  title    : 'Mis pedidos',
    //  icon     : 'fa fa-truck',
    //  state    : 'app.guest-orders',
    //  //badge      : obj,
    //  /*stateParams: {
    //   'param1': 'page'
    //   },*/
    //  weight   : 5
    //});

	}
})();

(function()
{
	'use strict';

	angular
		.module('app.guest-orders')
		.controller('GuestOrdersMainCtrl', GuestOrdersMainCtrl)
		.controller('PromotionalsGuestController', PromotionalsGuestController)
		.controller('GuestOrdersShowCtrl', GuestOrdersShowCtrl);

	function GuestOrdersMainCtrl(myOrders,api,$mdToast) {

		var vm = this;
    vm.myOrders=myOrders;
    vm.monthDiscountDate = '';

    //Cancelar pedido si no esta tramitado.
    vm.cancelOrder= function (order,key){
      swal({
        title:"¿Desea cancelar el pedido?",
        type:"question",
        showCancelButton: true,
        cancelButtonText:"No",
        cancelButtonClass: 'md-button md-raised md-background-bg md-hue-1',
        cancelButtonColor: "#f5f5f5",
        confirmButtonText:"Confirmar",
        confirmButtonClass: 'md-button md-raised md-primary',
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          api.order.cancel({'order':order}).$promise.then(function(){
            vm.resfreshMyOrder();
            $mdToast.show($mdToast.simple()
              .textContent('Pedido cancelado con éxito.')
              .position('bottom right'));
          });
        }
      });
    };

    vm.resfreshMyOrder=function(){
       api.order.myOrders().$promise.then(function(d){
         vm.myOrders=d;
       });
    }
	}
  function GuestOrdersShowCtrl (order){
    var vm=this;
    vm.order=order;
    vm.monthDiscountDate=order.discounts[0].created_at;
  }
  function PromotionalsGuestController (api){
    var vm=this;
    api.user.myPromotionals().$promise.then(function(d){
      vm.promotionals=d;
    });


  }
})();

(function()
{
  'use strict';

  angular
    .module('app.guest-materials',[])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider){
    $stateProvider
      .state('app.guest-materials',{
        url: '/materiales?page&items&search',
        views: {
          'content@app': {
            templateUrl: 'app/main/pharmacist/materials/views/listMaterials.html',
            controller: 'GuestMaterialsMainCtrl as vm',
            params: {
              items: {
                value: 12,
                squash: true
              },
              page: {
                value: 1,
                squash: true
              },
              search: {
                value: '',
                squash: true
              }
            }
          }
        },
        resolve: {
          access: ["Access", function (Access) { return Access.hasAnyRole(['farmaceutico','comercial']);  }],
          campaignsSlider: function (api) {
            return api.campaign.getSlider().$promise;
          },
          activeMaterialsList: function (api, $stateParams) {
            return api.material.paginatedList({items:$stateParams.items, status: 1, page:$stateParams.page, search:$stateParams.search}).$promise;
          },
          categoriesList: function (api) {
            return api.category.list().$promise;
          },
          slider: function(api) {
            return api.slider.get({id:4}).$promise;
          }
        }
      })
      .state('app.guest-material-show',{
        url: '/materiales/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/pharmacist/materials/views/showMaterial.html',
            controller: 'GuestMaterialsShowCtrl as vm'
          }
        },
        resolve: {
          access: ["Access", function (Access) { return Access.hasAnyRole(['farmaceutico','comercial']);  }],
          material: function (api, $stateParams) {
            return api.material.get({id:$stateParams.id}).$promise;
          }
        }
      });

    msNavigationServiceProvider.saveItem('guest-materials',{
      title   : 'Materiales',
      icon    : 'icon-presentation',
      state   : 'app.guest-materials',
      weight  : 4
    });
  }
})();

(function()
{
  'use strict';

  angular
    .module('app.guest-materials')
    .controller('GuestMaterialsMainCtrl',GuestMaterialsMainCtrl)
    .controller('GuestMaterialsShowCtrl',GuestMaterialsShowCtrl);

  function GuestMaterialsMainCtrl($rootScope,api, activeMaterialsList, categoriesList, slider, $cookieStore, $mdSidenav, $stateParams, $state){
    var vm = this;
    vm.slider = slider;
    vm.pagination = activeMaterialsList;
    vm.categories = categoriesList;
    vm.filter = {};
    vm.filter.items = activeMaterialsList.per_page;
    vm.filter.search = $stateParams.search;
    vm.filter.category = $stateParams.category;
    vm.api = api.material;


    if($cookieStore.get('material-list-view'))
      vm.view = $cookieStore.get('material-list-view')
    else {
      vm.view = 'grid';
      $cookieStore.put('material-list-view', vm.view);
    }

    vm.setView = function(view, toggleSidenav) {
      vm.view = view;
      $cookieStore.put('material-list-view',view);
      if (toggleSidenav) vm.toggleSidenav('sidenav');
    };

    vm.setCategory = function(category, toggleSidenav) {
      vm.filter.category = category;
      vm.refreshMaterials();
      if (toggleSidenav) vm.toggleSidenav('sidenav');
    }

    vm.setItems = function(items, toggleSidenav) {
      vm.filter.items = items;
      vm.refreshMaterials();
      if (toggleSidenav) vm.toggleSidenav('sidenav');
    }

    vm.setSearch = function(toggleSidenav, search) {
      if (search){
        if (search == "null")
          vm.filter.search = null;
        else
          vm.filter.search = search;
      }
      vm.refreshMaterials();
      if (toggleSidenav) vm.toggleSidenav('sidenav');
    }

    vm.resetFilter = function () {
      vm.filter = { items: 12 };
      vm.refreshMaterials();
    }

    vm.refreshMaterials = function(){
      $state.go('.', {page: 1, items: vm.filter.items, search: vm.filter.search});
      // $rootScope.loadingProgress = true;
      // api.material.paginatedList({"items": vm.filter.items, "page" : 1,"status":1, "category" : vm.filter.category, "search" : vm.filter.search}).$promise.then(
      //   function(data){
      //     vm.pagination = data;
      //     $rootScope.loadingProgress = false;
      //   },
      //   function (err) {
      //     console.log(err);
      //   }
      // );
    };

    vm.onSearchChange = function($event) {
      $event.stopPropagation();
    };

    vm.toggleSidenav = toggleSidenav;
    function toggleSidenav(sidenavId){
      $mdSidenav(sidenavId).toggle();
    }
  }

  function GuestMaterialsShowCtrl(material){
    var vm = this;
    vm.material = material;
  }
})();

(function()
{
  'use strict';

  angular
    .module('app.authorization', [])
    .run(runAuth);

  function runAuth($rootScope, $state, UserProfile,$auth,$location) {

    // Detectar errores de autenticacion.
    $rootScope.$on("$stateChangeError", function (event, toState, toParams, fromState, fromParams, error , UserProfile) {
      $state.next = toState;
      $state.nextParams = toParams;

      if (error == 401) {
        //console.log($state.next);
        console.log("Error 401");
        //swal({title: "¡Error!", text: "No tiene permiso para entrar", type: "error", confirmButtonText: "Login"},
        //  function () {
        //    $state.go('app.login', {"intented": $state.next});
        //  });
        $state.go('app.login', {"intented": $state.next});
      }
      if (error == 403) {
        //console.log($state.next);
        $rootScope.loadingProgress = false;
        console.log("Error 403");
        swal({title: "¡Error! 403", text: "No tiene permiso para entrar", type: "error", confirmButtonText: "Aceptar"});
      }

    });

    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
      $state.previous = fromState;

    });


  }
})();

(function ()
{
	'use strict';

	angular
		.module('app.authorization')
		.controller('PasswordDialogController',PasswordDialogController);

    /** @ngInject */
	function PasswordDialogController($scope,api,$state) {
		var pdctrl = this;

    $scope.activate = function () {

      api.user.activateMyAccount($scope.user).$promise.then(function(d){
          $state.go('app.guest-home');
      },function(err){
        swal(
          'Error',
           err.data.message,
          'error'
        )
      });
    }

	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-home', ['slick'])
        .config(config);

    /** @ngInject */
    function config($stateProvider , msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.guest-home', {
                url    : '/',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pharmacist/home/home.html',
                        controller : 'GuestHomeController as vm'
                    }
                },
                resolve: {
                  access: ["Access", function (Access) { return Access.hasAnyRole(['farmaceutico','comercial']); }],
                  slider: function(api) {
                    return api.slider.get({id:1}).$promise;
                  },
                  activePromotionsList: function (api) {
                    return api.promotion.getByStatus({status:'enabled',take:6}).$promise;
                  }
                }
            });

        $stateProvider
          .state('app.guest-account', {
            url    : '/mi-cuenta',
            views  : {
              'content@app': {
                templateUrl: 'app/main/pharmacist/home/account.html',
                controller : 'AccountController as vm'
              }
            },
            resolve: {
              access: ["Access", function (Access) { return Access.hasAnyRole(['farmaceutico','comercial']);  }],
              myProfile: function (api) {
                return api.user.myAccount().$promise;
              }
              //access: ["Access", function (Access) { return Access.isAuthenticated(); }],
            }
          });

        msNavigationServiceProvider.saveItem('guest-home', {
          title    : 'Inicio',
          icon     : 'icon-home',
          state    : 'app.guest-home',
          /*stateParams: {
           'param1': 'page'
           },*/
          weight   : 1
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-home')
        .controller('GuestHomeController', GuestHomeController);

    /** @ngInject */
    function GuestHomeController(myConfig,$timeout, slider, activePromotionsList,UserProfile)
    {
      var vm = this;
      vm.slider = slider;
      vm.activePromotions = activePromotionsList;
      vm.hasCommercialAccess = false;

      UserProfile.then(function(userProfile){
        userProfile.$refresh().then(function(u){
          //console.log(u);
          // console.log(u.$hasAnyRole(['admin']));
          vm.hasCommercialAccess = u.$hasAnyRole(['comercial','admin']);
        })
      });
    }
})();

(function ()
{
  'use strict';

  angular
    .module('app.guest-home')
    .controller('AccountController', AccountController);

  /** @ngInject */
  function AccountController(myProfile,api,$mdToast)
  {
    var vm = this;
    vm.user=myProfile;

    vm.updateAccount=function (){
      api.user.updateMyAccount(vm.user).$promise.then(function(d){
        $mdToast.show($mdToast.simple().textContent('Datos actualizados correctamente').position('bottom right'));
      });
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-downloads',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider,  msNavigationServiceProvider   )
    {

         $stateProvider
          .state('app.download', {
            url    : '/descargas/:id',
            views  : {
              'content@app': {
                templateUrl: 'app/main/pharmacist/downloads/list.html',
                controller : 'DownloadsPharmacistDetController as vm'
              }
            },
            resolve: {
              access: ["Access", function (Access) { return Access.hasAnyRole(['farmaceutico','comercial']);  }],
              downloads: function(api) {
                return api.download.list().$promise;
              }

            }
          });
        $stateProvider
          .state('app.downloads-pharmacist', {
            url    : '/descargas',
            views  : {
              'content@app': {
                templateUrl: 'app/main/pharmacist/downloads/list.html',
                controller : 'DownloadsPharmacistController as vm'
              }
            },
            resolve: {
              access: ["Access", function (Access) { return Access.hasAnyRole(['farmaceutico','comercial']);  }],
              downloads: function(api) {
                return api.download.list().$promise;
              }

            }
          });


         msNavigationServiceProvider.saveItem('downloads', {
             title    : 'Descargas',
             icon     : 'fa fa-cloud-download',
             state    : 'app.downloads-pharmacist',
             /*stateParams: {
                 'param1': 'page'
              },*/
             weight   : 6
         });


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-downloads')
        .controller('DownloadsPharmacistDetController', detail)
        .controller('DownloadsPharmacistController', list);

    function list (downloads){
      var vm=this;
      vm.downloads=downloads;

    }

    function detail (downloads,$stateParams,api,$location){
      var vm=this;
      vm.downloads=downloads;

      vm.download=function (){
        api.download.getLink($stateParams).$promise.then(function (d){
          location.href=d.url;
        });
      };
      vm.download();
    }






})();

(function () {
  'use strict';

  angular
    .module('app.cart',[])
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('app.cart', {
        url: '/carrito',
        views: {
          'content@app': {
            templateUrl: 'app/main/pharmacist/cart/views/list.html',
            controller: 'MainCartCtrl as vm'
          }
        },
        resolve: {
          access: ["Access", function (Access) { return Access.hasAnyRole(['farmaceutico','comercial']);  }],
          lastCart: function (api) {
            return api.cart.getLast().$promise;
          }
        }
      })

  }
})();

(function () {
  'use strict';
  angular
    .module('app.cart')
    .controller('DialogCartAddPharmaCtrl', DialogCartAddPharmaCtrl)
    .controller('MenuCartCtrl', MenuCartCtrl);

  function MenuCartCtrl($rootScope, api) {
    var cartvm = this;
    api.cart.getLast().$promise.then(
      function (data) {
        cartvm.cart = data;
      },
      function (err) {
        console.log(err);
      }
    );

    $rootScope.$on('refresh-cart',function (event, d){
      cartvm.cart = d;
    });

    cartvm.delItem = function(id) {
      $rootScope.loadingProgress = true;
      api.cart.delItem({ cart: cartvm.cart.id, id: id}).$promise.then(
        function (data) {
          cartvm.cart = data;
          $rootScope.loadingProgress = false;
        },
        function (err) {
          console.log(err);
        }
      )
    };

    $(document).on("click",".del-cart-item",function(event) {
      console.log(event);
      event.stopPropagation();
    });
  }

  angular
    .module('app.cart')
    .controller('CartCtrl', CartCtrl);

  function CartCtrl($rootScope, api, $mdMedia, $mdDialog, $scope) {
    var cvm = this;
    cvm.showAdvanced = function(id, type, event) {
      $rootScope.loadingProgress = true;
      $scope.id = id;
      $scope.type = type;
      var useFullScreen = $mdMedia('sm') || $mdMedia('xs');
      $mdDialog.show({
        controller: 'CartAddCtrl as caddvm',
        templateUrl: 'app/main/pharmacist/' + $scope.type + 's/views/add.html',
        parent: angular.element(document.body),
        targetEvent: event,
        scope: $scope,
        preserveScope: true,
        clickOutsideToClose:true,
        fullscreen: useFullScreen
      });
    };
  }

  angular
    .module('app.cart')
    .controller('CartAddCtrl', CartAddCtrl);

  function CartAddCtrl($mdDialog, $scope, api, $rootScope, $state,$mdToast) {
    var caddvm = this;
    caddvm.quantity = 1;

    switch ($scope.type) {
      case "article":
        caddvm.api = api.article; break;
      case "material":
        caddvm.api = api.material; break;
      case "promotion":
        caddvm.api = api.promotion; break;
    }

    if (caddvm.api) {
      caddvm.api.get({id: $scope.id}).$promise.then(
        function (data) {
          caddvm.item = data;
          $rootScope.loadingProgress = false;
        },
        function (err) {
          console.log(err);
        }
      );
      caddvm.hide = function() {
        $mdDialog.hide();
      };
      caddvm.cancel = function() {
        $mdDialog.cancel();
      };
    }
    caddvm.submit = function(checkout, id, type, qty) {
      $rootScope.loadingProgress = true;
      if (!id) id = caddvm.item.id;
      if (!type) type = $scope.type;
      if (!qty) qty = caddvm.quantity;
      api.cart.addItem({ id: id, type: type, qty: qty}).$promise.then(
        function (d) {
          $rootScope.$emit('refresh-cart',d);
          $mdDialog.hide();
          $rootScope.loadingProgress = false;
          if (checkout) $state.go('app.cart');
          else $mdToast.show($mdToast.simple()
            .textContent('Añadido al carrito')
            .position('bottom right'));
        },
        function (err) {
          $rootScope.loadingProgress = false;

          if(err.status==423){
            swal({
              title:"¡Error!",
              text:err.data.message,
              type:"error",
              showCancelButton: true,
              cancelButtonText:"Cancelar",
              cancelButtonClass: 'md-button md-raised md-background-bg md-hue-1',
              cancelButtonColor: "#f5f5f5",
              confirmButtonText:"Sí, cambiar la cantidad",
              confirmButtonClass: 'md-button md-raised md-primary',
            }).then(function (isConfirm) {
              if (isConfirm === true) {
                $state.go('app.cart',{'#': type + '-' +id});
              }
            });
            $mdDialog.hide();
          }else if (err.status==416){
            swal({
              title:"Atención",
              text:err.data.message,
              type:"warning"
            });
          } else if (err.status == 403) {
            swal({
              title:"No se añadió el producto",
              text:err.data.message,
              type:"warning"
            });
          }
        }
      );
    };
  }

  angular
    .module('app.cart')
    .controller('MainCartCtrl', MainCartCtrl);

  function MainCartCtrl($rootScope, api, $scope ,$mdDialog,$messages,$state,CartMessage,Access,$location,$anchorScroll,$mdToast,$filter) {
    var vm = this;

    vm.promotional_data=[];
    console.log(vm.promotional_data);
    // Watcher de cartdetail
    $rootScope.$on('regenerate-cart',function ($e,$d)  {

      //Comprobar para que la informacion que se manda por campaña sea unica , una campaña un id de regla de descuento.

      vm.promotional_data=$filter('filter')(vm.promotional_data,function (i) {
        return ($d.item_type==i.item_type) && ($d.item_id!==i.item_id);
      });
      vm.promotional_data.push($d);

      api.cart.getLastWithPromotionalData(vm.promotional_data).$promise.then(
        function (data) {
          vm.cart = data;
        },
        function (err) {
          console.log(err);
        }
      );
    });

    api.cart.getLast().$promise.then(
      function (data) {
        vm.cart = data;

      },
      function (err) {
        console.log(err);
      }
    );

    $rootScope.$on('refresh-cart',function (event, d){
      vm.cart = d;
    });



    vm.delItem = function(id) {
      $rootScope.loadingProgress = true;
      api.cart.delItem({ cart: vm.cart.id, id: id}).$promise.then(
        function (data) {
          $rootScope.$emit('refresh-cart',data);
          $rootScope.loadingProgress = false;
        },
        function (err) {
          console.log(err);
        }
      )
    };

    vm.uptItem = function(id, qty) {
      $rootScope.loadingProgress = true;
      console.log(this, $(this));
      api.cart.uptItem({ cart: vm.cart.id, id: id, qty: qty}).$promise.then(
        function (data) {
          $rootScope.$emit('refresh-cart',data);
          $rootScope.loadingProgress = false;
        },
        function (err) {
          if(err.status==423){
            swal({
              title:"¡Error!",
              text:err.data.message,
              type:"error",
              confirmButtonText:"Aceptar",
              confirmButtonClass: 'md-button md-raised md-primary',
            });
            $rootScope.$emit('refresh-cart', err.data.cart);
            $rootScope.loadingProgress = false;
          }else if (err.status==416){
            swal({
              title:"Atención",
              text:err.data.message,
              type:"warning"
            });
          }


        }
      );
    };

    vm.confirm = function () {
      Access.hasRealAnyRole(['comercial','admin']).then(
        function (d) {
          if(!d){
            swal({
              title:"Confirmar pedido",
              type:"question",
              showCancelButton: true,
              cancelButtonText:"Cancelar",
              cancelButtonClass: 'md-button md-raised md-background-bg md-hue-1',
              cancelButtonColor: "#f5f5f5",
              confirmButtonText:"Confirmar",
              confirmButtonClass: 'md-button md-raised md-primary',
            }).then(function (isConfirm) {
              if (isConfirm === true) {
                api.cart.confirm({cart_id:vm.cart.id}).$promise.then(function (newCart){
                  $rootScope.$emit('refresh-cart', newCart);
                  swal(
                    'Pedido realizado',
                    'Su pedido ha sido recibido',
                    'success'
                  ).then(function() {
                    $state.go('app.guest-orders')
                  });

                },function (err){
                  if (err.status==423){
                    CartMessage.render(err.data.message,err.data.out_stock_items);
                  }
                });
              }
            });
          }else{
            //Abrimos modal para seleccionar el cliente
            $mdDialog.show({
              controller: 'DialogCartAddPharmaCtrl as modal',
              templateUrl: 'app/main/pharmacist/cart/views/dialogs/addpharmacist.html' ,
              parent: angular.element(document.body),
              scope: $scope,
              preserveScope: true,
              clickOutsideToClose:true,
              fullscreen: true
            }).finally(function(){
              var monthly_discount=false;
              if($scope.selectedClient.id){
                //Comprobamos si en el pedido podemos aplicar el decuento mensual
                api.order.checkMonthlyDiscount({client:$scope.selectedClient.id,cart_id:vm.cart.id}).$promise.then(function (res){
                  if(res.available){
                    swal({
                      title:"Descuento mensual",
                      text: "Este cliente tiene disponible su descuento mensual de "+res.amount+"€",
                      type:"warning",
                      showCancelButton: true,
                      cancelButtonText:"No",
                      cancelButtonClass: 'md-button md-raised md-background-bg md-hue-1',
                      cancelButtonColor: "#f5f5f5",
                      confirmButtonText:"Aplicar descuento",
                      confirmButtonClass: 'md-button md-raised md-primary',
                    }).then(function (isConfirm) {
                      if(isConfirm){
                        monthly_discount=true;
                      }
                      //Confirmamos pedido en el nombre del cliente
                      vm.confirmCart(vm.cart.id,$scope.selectedClient.id,monthly_discount, $scope.comment);
                      $scope.selectedClient = {};
                      $scope.comment = '';
                      $scope.searchTerm = '';
                    }).catch(function () {
                      vm.confirmCart(vm.cart.id,$scope.selectedClient.id,monthly_discount, $scope.comment);
                      $scope.selectedClient = {};
                      $scope.comment = '';
                      $scope.searchTerm = '';
                    });
                  }else{
                    //Confirmamos pedido en el nombre del cliente
                    vm.confirmCart(vm.cart.id,$scope.selectedClient.id,monthly_discount, $scope.comment);
                    $scope.selectedClient = {};
                    $scope.searchTerm = '';
                  }
                });

              }

            });
          }
        },function (err) {
          console.log('error',err);
          $scope.searchTerm = '';
        }
      );

    };
    vm.confirmCart=function (cartId, clientId, monthly_discount, comment) {
      api.cart.confirm({cart_id:cartId, client_id:clientId, monthly_discount:monthly_discount, comment:comment})
        .$promise.then(function (newCart){
        $rootScope.$emit('refresh-cart', newCart);
        swal(
          'Pedido recibido',
          'Su pedido ha sido recibido',
          'success'
        ).then(function() {
          $state.go('app.orders')
        });

      },function (err){
        if (err.status == 423) {
          CartMessage.render(err.data.message,err.data.out_stock_items);
        } else {
          $mdToast.show($mdToast.simple()
            .textContent('Se produjo un error. Revise el registro.')
            .position('bottom right'));
        }
      });
    }


  }

  function DialogCartAddPharmaCtrl ($scope,$mdDialog,api,$mdToast){
    var modal=this;
    modal.selectedClient = null;
    modal.comment = '';

    // var search = $window.document.getElementById('#searchPharmacistsearchPharmacist');
    // console.log(search);
    // search.focus();
    // //search.focus();
    setTimeout(function(){angular.element('#searchPharmacist').focus();},200);


    modal.searchPharmacist=function(term){
      $scope.elementData={};
      if (term!==''){
        $scope.loadingSearch=true;
        $scope.withOutResults=false;
        api.search.type({type:'PHARMACIST',term:term}).$promise.then(function(d){
          modal.searchResult=d;
          var input = document.getElementById('searchPharmacist');
          input.blur();
          console.log(input);

          if (d.length<1){
            $scope.withOutResults=true;
          }
          $scope.loadingSearch=false;
        });
      }
    };

    //Añadir farmaceutico al descuento
    modal.addPharma=function(){
      if(modal.selectedClient) {
        swal({
          title:"¿Desea confirmar el pedido?",
          text:"Cliente: "+modal.selectedClient.username+"-"+modal.selectedClient.name,
          type:"question",
          showCancelButton: true,
          cancelButtonText:"No",
          cancelButtonClass: 'md-button md-raised md-background-bg md-hue-1',
          cancelButtonColor: "#f5f5f5",
          confirmButtonText:"Confirmar",
          confirmButtonClass: 'md-button md-raised md-primary',
        }).then(function (isConfirm) {
          if (isConfirm === true) {
            $mdDialog.hide();
            $scope.selectedClient=modal.selectedClient;
          }
        });
      }


    }



  }
})();

(function()
{
  'use strict';

  angular
    .module('app.guest-campaigns',[])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider){
    $stateProvider
      .state('app.guest-campaigns',{
        url: '/campañas',
        views: {
          'content@app': {
            templateUrl: 'app/main/pharmacist/campaigns/views/listCampaigns.html',
            controller: 'GuestCampaignsMainCtrl as vm'
          }
        },
        resolve: {
          access: ["Access", function (Access) { return Access.hasAnyRole(['farmaceutico','comercial']);  }],
          activeCampaignsList: function(api) {
            //return api.campaign.getByStatus({status:'enabled'}).$promise;
            return api.campaign.getByStatusLite({status:'enabled'}).$promise;
          },
          comingSoonCampaigns: function(api) {
            return api.campaign.getByStatus({status:'coming_soon'}).$promise;
          },
          slider: function(api) {
            return api.slider.get({id:2}).$promise;
          }
        }
      });

    $stateProvider
      .state('app.guest-campaign-show', {
        url: '/campañas/:id',
        views: {
          'content@app' : {
            templateUrl: 'app/main/pharmacist/campaigns/views/showCampaign.html',
            controller: 'GuestCampaignsShowCtrl as vm'
          }
        },
        resolve: {
          access: ["Access", function (Access) { return Access.hasAnyRole(['farmaceutico','comercial']);  }],
          campaign: function (api, $stateParams) {
            return api.campaign.get({id:$stateParams.id}).$promise;
          }
        }
      });

    msNavigationServiceProvider.saveItem('guest-campaigns', {
      title   : 'Campañas',
      icon    : 'fa fa-bullhorn',
      state   : 'app.guest-campaigns',
      weight  : 3
    });
  }
})();

(function()
{
  'use strict';

  angular
    .module('app.guest-campaigns')
    .controller('GuestCampaignsMainCtrl',GuestCampaignsMainCtrl)
    .controller('GuestCampaignsShowCtrl',GuestCampaignsShowCtrl);

  function GuestCampaignsMainCtrl(activeCampaignsList, comingSoonCampaigns, slider){
    var vm = this;
    vm.campaigns = activeCampaignsList;
    vm.comingSoonCampaigns = comingSoonCampaigns;
    //vm.slider = slider;
  }

  function GuestCampaignsShowCtrl(campaign){
    var vm = this;
    vm.campaign = campaign;

  }
})();

(function()
{
  'use strict';

  angular
    .module('app.guest-articles',[])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider){
    var $cookies;
    angular.injector(['ngCookies']).invoke(['$cookies', function(_$cookies_){
      $cookies = _$cookies_;
    }]);
    $stateProvider
      .state('app.guest-articles',{
        state: 'app.guest-articles',
        url: '/articulos?category&page&items&search',
        views: {
          'content@app': {
            templateUrl: 'app/main/pharmacist/articles/views/listArticles.html',
            controller: 'GuestArticlesMainCtrl as vm',
            params: {
              category: {
                value: null,
                squash: true
              },
              items: {
                value: '12',
                squash: true
              },
              page: {
                value: '1',
                squash: true
              },
              search: {
                value: '',
                squash: true
              }
            }
          }
        },
        resolve: {
          access: ["Access", function (Access) { return Access.hasAnyRole(['farmaceutico','comercial']); }],
          // access: ["Access", function (Access) { return Access.hasAnyRole(['comercial','admin']); }],
          activeArticlesList: function (api, $stateParams) {
            return api.article.paginatedList({items:$stateParams.items, category: $stateParams.category, status: 'enabled', page:$stateParams.page, search:$stateParams.search}).$promise;
          },
          categoriesList: function (api) {
            return api.category.list().$promise;
          },
          slider: function(api) {
            return api.slider.get({id:2}).$promise;
          }
        }
      })
      .state('app.guest-article-show', {
        url: '/articulos/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/pharmacist/articles/views/showArticle.html',
            controller: 'GuestArticlesShowCtrl as vm'
          }
        },
        resolve: {
          access: ["Access", function (Access) { return Access.hasAnyRole(['farmaceutico','comercial']); }],
          // access: ["Access", function (Access) { return Access.hasAnyRole(['comercial','admin']); }],
          article: function (api, $stateParams) {
            return api.article.get({id:$stateParams.id}).$promise;
          }
        }
      });

    if(!$cookies.get('articles-view-items-per-page'))
      $cookies.put('articles-view-items-per-page', 12);

    /*msNavigationServiceProvider.saveItem('guest-articles',{
      title   : 'Artículos',
      icon    : 'icon-desktop-tower',
      state   : 'app.guest-articles',
      weight  : 1
    });*/
  }
})();

(function()
{
  'use strict';

  angular
    .module('app.guest-articles')
    .controller('GuestArticlesMainCtrl', GuestArticlesMainCtrl);

  function GuestArticlesMainCtrl($rootScope, $cookieStore, api, activeArticlesList, categoriesList, slider, $mdSidenav, $mdMedia, $mdDialog, $scope, $state, $stateParams, UserProfile){
    var vm = this;
    vm.pagination = activeArticlesList;
    vm.categories = categoriesList;
    vm.filter = {};
    vm.filter.items = activeArticlesList.per_page;
    vm.filter.search = $stateParams.search;
    vm.filter.category = $stateParams.category;
    vm.searchcat = "";
    vm.slider = slider;
    vm.api = api.article.paginatedList;
    vm.hasCommercialAccess = false;

    UserProfile.then(function(userProfile){
      userProfile.$refresh().then(function(u){
        //console.log(u);
        // console.log(u.$hasAnyRole(['admin']));
        vm.hasCommercialAccess = u.$hasAnyRole(['comercial','admin']);
      })
    });


    if($cookieStore.get('article-list-view'))
      vm.view = $cookieStore.get('article-list-view')
    else {
      vm.view = 'grid';
      $cookieStore.put('article-list-view', vm.view);
    }

    vm.setView = function(view, toggleSidenav) {
      vm.view = view;
      $cookieStore.put('article-list-view',view);
      if (toggleSidenav) vm.toggleSidenav('sidenav');
    };

    vm.setCategory = function(category, toggleSidenav) {
      vm.filter.category = category;
      vm.refreshArticles();
      if (toggleSidenav) vm.toggleSidenav('sidenav');
    }

    vm.setItems = function(items, toggleSidenav) {
      vm.filter.items = items;
      vm.refreshArticles();
      if (toggleSidenav) vm.toggleSidenav('sidenav');
    }

    vm.setSearch = function(toggleSidenav, search) {
      if (search){
        if (search == "null")
          vm.filter.search = null;
        else
          vm.filter.search = search;
      }
      vm.refreshArticles();
      if (toggleSidenav) vm.toggleSidenav('sidenav');
    }

    vm.resetFilter = function () {
      vm.filter = { items: 12 };
      vm.refreshArticles();
    }

    vm.refreshArticles = function(){
      $state.go('.', {page: 1, items: vm.filter.items, search: vm.filter.search, category: vm.filter.category});
      // $rootScope.loadingProgress = true;
      // api.article.paginatedList({"items": vm.filter.items, "page" : 1, "category" : vm.filter.category, "search" : vm.filter.search}).$promise.then(
      //   function(data){
      //     vm.pagination = data;
      //     $rootScope.loadingProgress = false;
      //   },
      //   function (err) {
      //     console.log(err);
      //   }
      // );
    };

    vm.onSearchChange = function($event) {
      $event.stopPropagation();
    };

    vm.toggleSidenav = function (sidenavId){
      $mdSidenav(sidenavId).toggle();
    };

    vm.onSearchChange = function($event) {
      $event.stopPropagation();
    };
  }

  angular
    .module('app.guest-articles')
    .controller('GuestArticlesShowCtrl',GuestArticlesShowCtrl);

    function GuestArticlesShowCtrl(article, UserProfile) {
      var vm = this;
      vm.article = article;
      vm.qty = 1;
      vm.hasCommercialAccess = false;

      UserProfile.then(function(userProfile){
        userProfile.$refresh().then(function(u){
          //console.log(u);
          // console.log(u.$hasAnyRole(['admin']));
          vm.hasCommercialAccess = u.$hasAnyRole(['comercial','admin']);
        })
      });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.users', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        $stateProvider
            .state('app.users', {
                url    : '/admin/users?page&search&activated',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/admin/users/views/listUsers.html',
                        controller : 'UsersMainCtrl as vm',
                        params: {
                          page: {
                            value: 1,
                            squash: true
                          },
                          search : {
                            value: '',
                            squash: true
                          },
                          activated : {
                            value: '',
                            squash: true
                          }
                        }
                    }
                },
                resolve: {
                  access: ["Access", function (Access) { return Access.hasAnyRole(['comercial','admin']); }],
                  paginatedList: function (api, $stateParams) {
                    return api.user.paginatedList({items:30, page: $stateParams.page, search: $stateParams.search,activated:$stateParams.activated}).$promise;
                  }
                }
            });
        $stateProvider
            .state('app.user-create', {
                url    : '/admin/user/create',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/admin/users/views/createUser.html',
                        controller : 'UsersCreateCtrl as vm'
                    }
                },
                resolve : {
                  access: ["Access", function (Access) { return Access.hasAnyRole(['comercial','admin']); }]
                }

            });
        $stateProvider
            .state('app.user-edit', {
                url    : '/admin/user/edit/:idUser',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/admin/users/views/editUser.html',
                        controller : 'UserEditCtrl as vm'
                    },
                },
                resolve: {
                  access: ["Access", function (Access) { return Access.hasAnyRole(['comercial','admin']); }],
                        userEdit: function (api,$stateParams){
                            return api.user.get({id:$stateParams.idUser,idRoles:true}).$promise;
                        }
                }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/admin/users');

        msNavigationServiceProvider.saveItem('manager.users', {
            title    : 'Usuarios',
            icon     : 'icon-account-multiple',
            state    : 'app.users',
            access   :  {
              roles : ['admin', 'comercial']
            },
            weight   : 2
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.users')
        .controller('UsersMainCtrl', UsersMainCtrl);

    /** @ngInject */
    function UsersMainCtrl($rootScope,api, $timeout,$element,$mdToast,$scope, paginatedList, $stateParams, $state)
    {
        var vm = this;
        vm.users = paginatedList;
        vm.filter = {};
        vm.filter.search = $stateParams.search;
        vm.filter.activated=$stateParams.activated ? JSON.parse($stateParams.activated):null;
        vm.filter.items = 30;
        vm.api=api.user;


        vm.refreshUsers = function(){
          $state.go('.', {page: 1, search: vm.filter.search,activated:JSON.parse(vm.filter.activated)});
        };

        // Conmuta estado
        vm.statusToggle=function (idUser,key){
            api.user.statusToggle({idUser:idUser})
            .$promise
            .then(function(data){
            vm.users.data[key].status=data.status;
            $mdToast.show($mdToast.simple().textContent('Usuario actualizado con éxito.').position('bottom right'));
            });
        };

        //Elimina empleado
        vm.destroy=function(id,key){
            api.user.remove({id:id})
            .$promise.then(function (){
             $mdToast.show($mdToast.simple().textContent('Usuario eliminado con éxito.').position('bottom right'));
             vm.users.data.splice(key,1);
            },
              function(){
                $mdToast.show($mdToast.simple().textContent('No se pudo eliminar el usuario').position('bottom right'));
              }
            );
        };

    }
})();


(function ()
{
    'use strict';
    angular
        .module('app.users')
        .controller('UserEditCtrl', UserEditCtrl);

    /** @ngInject */
    function UserEditCtrl(api, $timeout,$element,$mdToast,$scope,userEdit, $state)
    {
        var vm = this;
        vm.user=userEdit;
        // Necesario para que funcione el input de busqueda en el select
        vm.onSearchChange = function($event) {
                $event.stopPropagation();
            }
        // Carga los roles en el formulario de creacion de empleado
        vm.loadRoles = function(){
            return api.role.list(
                function(d){
                vm.roles=d;
                },
                function(err){
                    console.log(err);
                }
            );
        };
        vm.update= function (){
            vm.user.$update({id:vm.user.id}).then(
                function (data){
                  vm.user = data;
                   $mdToast.show($mdToast.simple().textContent('Usuario '+vm.user.firstname+' actualizado con éxito.').position('bottom right'));
                  $state.go('app.users');
                },
                function (err){
                  console.log(err);
                }
             );
        };
        api.role.list(
                function(d){
                vm.roles=d;
                },
                function(err){
                    console.log(err);
                }
            );
    }
})();

(function ()
{
  'use strict';
  angular
    .module('app.users')
    .controller('UsersCreateCtrl', UsersCreateCtrl);

  /** @ngInject */
  function UsersCreateCtrl(api, $timeout,$element,$mdToast,$scope, $state)
  {
    var vm = this;
    // Necesario para que funcione el input de busqueda en el select
    vm.onSearchChange = function($event) {
      $event.stopPropagation();
    }
    // Carga los roles en el formulario de creacion de empleado
    vm.loadRoles = function(){
      return api.role.list(
        function(d){
          vm.roles=d;
        },
        function(err){
          console.log(err);
        }
      );
    };

    // Crea un nuevo empleado
    vm.store= function (){
      var record=new api.user (vm.user);
      record.$save().then(
        function (data){
          vm.user = data;
          $mdToast.show($mdToast.simple().textContent('Usuario '+vm.user.firstname+' creado con éxito.').position('bottom right'));
          vm.user='';
          $state.go('app.users');
        },
        function (err){
            console.log(err);
            if(err.status=423){
                swal({
                        title:"Farmacia duplicada",
                        text:"Esta farmacia ya existía en el sistema , ¿desea restaurarla?",
                        type:"question",
                        showCancelButton: true,
                        cancelButtonText:"Cancelar",
                        cancelButtonClass: 'md-button md-raised md-background-bg md-hue-1',
                        cancelButtonColor: "#f5f5f5",
                        confirmButtonText:"Restaurar",
                        confirmButtonClass: 'md-button md-raised md-primary',
                }).then(function () {
                    api.user.restore({user:err.data.user_id}).$promise.then(function(d){
                         $mdToast.show($mdToast.simple().textContent('Farmacia restaurada').position('bottom right'));
                         $state.go('app.users');
                    },function(err){console.log(err)});
                })
            }
        }
      );
    };
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.sync', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,  msNavigationServiceProvider   )
    {
        // State
        $stateProvider
            .state('app.sync', {
                url    : '/admin/sync',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/admin/sync/views/create.html',
                        controller : 'SyncController as vm'
                    }
                },
                resolve: {
                    access: ["Access", function (Access) { return Access.hasAnyRole(['comercial','admin']); }]
                }
            });



         msNavigationServiceProvider.saveItem('manager.utils.sync', {
             title    : 'Sincronización',
             icon     : 'icon-sync',
             state    : 'app.sync',
             weight   : 15
         });


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.sync')
        .controller('SyncController', SyncController);

        function SyncController (api){
          var vm=this;
          vm.run=function(){
            vm.isSync=true;
            api.sync.run().$promise.then(function(d){
              vm.isSync=false;
              swal(
                'Perfecto',
                d.message,
                'success'
              )
            },function(err){
              vm.isSync=false;
              swal(
                'Error!',
                err.data.message,
                'error'
              )
            });
          }
        }






})();

(function()
{
	'use strict';

	angular
		.module('app.sliders', [])
		.config(config);

	function config($stateProvider, msNavigationServiceProvider){
		$stateProvider
			.state('app.sliders', {
				url		: '/admin/sliders',
				views	: {
			          'content@app' : {
			            templateUrl : 'app/main/admin/sliders/views/listSliders.html',
			            controller    : 'SlidersMainCtrl as vm'
			          }
				},
				resolve	: {
					access: ["Access", function(Access) { return Access.hasRole('admin');}],
					slidersList: function(api) {
						return api.slider.list().$promise;
					}
				}
			});

		//$stateProvider
		//	.state('app.sliders-create', {
		//		url		: '/admin/sliders/create',
		//		views	: {
		//			'content@app' : {
		//				templateUrl : 'app/main/admin/sliders/views/createSlider.html',
		//				controller  : 'SliderCreateCtrl as vm'
		//			}
		//		},
		//		resolve	: {
		//			access: ["Access", function(Access) { return Access.hasRole('admin');}],
		//			campaignsList	: function(api) {
		//				return api.campaign.list().$promise;
		//			}
		//		}
		//	});

		$stateProvider
			.state('app.sliders-edit', {
				url		: '/admin/sliders/edit/:idSlider',
				views	: {
					'content@app' : {
            			access: ["Access", function (Access) { return Access.hasRole('admin'); }],
						templateUrl : 'app/main/admin/sliders/views/createSlider.html',
						controller  : 'SliderEditCtrl as vm'
					}
				},
				resolve	: {
					access: ["Access", function(Access) { return Access.hasRole('admin');}],
					slider : function(api, $stateParams) {
						return api.slider.edit({id:$stateParams.idSlider}).$promise;
					},
					campaignsList : function(api) {
						return api.campaign.minList().$promise;
					}
				}
			});

		msNavigationServiceProvider.saveItem('manager.utils.appearance',{
			title: 'Apariencia',
			icon: 'icon-palette-advanced',
			weight: 10,
			access: {
				roles: ['admin']
			}
		});

		msNavigationServiceProvider.saveItem('manager.utils.appearance.sliders', {
			title: 'Sliders',
			icon: 'icon-view-day',
			weight: 1,
			state: 'app.sliders',
			access: {
				roles: ['admin']
			}
		})
	}
})();

(function()
{
  'use strict';

  angular
    .module('app.sliders')
    .controller('SlidersMainCtrl', SlidersMainCtrl);

  function SlidersMainCtrl(api, slidersList, $mdToast) {
    var vm = this;
    vm.sliders = slidersList;

    vm.toggleStatus = function(idSlider, key) {
      api.slider.toggleStatus({idSlider:idSlider})
        .$pomise
        .then(function(data){
          vm.campaigns[key].status = data.status;
          $mdToast.show($mdToast.simple()
            .textContent('Slider actualizado con éxito.')
            .position('bottom right'));
        });
    };

    vm.destroy = function(id, key) {
      api.slider.remove({id:id})
        .$promise.then(function(){
        $mdToast.show($mdToast.simple()
          .textContent('Slider eliminado con éxito.')
          .position('bottom right'));
        vm.sliders.splice(vm.sliders.indexOf(key,1));
      }).catch(function(err){
        swal({
          title:"¡Error!",
          text: err.data.message,
          type:"error",
          showCancelButton: false,
          confirmButtonText:"Cerrar",
          confirmButtonClass: 'md-button md-raised md-primary',
        });
      });
    };
  }

  angular
    .module('app.sliders')
    .controller('SliderEditCtrl', SliderEditCtrl);

  function SliderEditCtrl(api, Uploader, $mdToast, campaignsList, slider) {
    var vm = this;
    vm.slider = slider;
    vm.selectedSlide = 0;
    vm.uploaders = [];
    $.each(vm.slider.slides, function(key,value){
      vm.uploaders[key] = Uploader.getInstance();
      vm.uploaders[key].extra = {
        attachable_id: value.id,
        attachable_type: "SLIDE",
        type: "IMAGE",
        proportion: 'panoramic'
      };
      vm.uploaders[key].type = "IMAGE";
      vm.uploaders[key].uploadAction = function () {
        vm.uploaders[key].uploadAll();
      };
      vm.uploaders[key].postDeleteItem = function () {
        vm.uploaders[key].refreshImages();
      };
      vm.uploaders[key].onCompleteAll = function() {
        vm.uploaders[key].refreshImages();
      };
      vm.uploaders[key].refreshImages = function () {
        api.slider.getImage({id:vm.slider.slides[vm.uploaders.indexOf(vm.uploaders[key])].id}).$promise
          .then(
            function(d){
              console.log(d);
              if (d) vm.slider.slides[vm.uploaders.indexOf(vm.uploaders[key])].image = d;
              else vm.slider.slides[vm.uploaders.indexOf(vm.uploaders[key])].image = null;
            }
          )
          .catch(
            function (e){
              console.log(e);
            }
          );
      };
      vm.uploaders[key].autoUpload = false;
    });
    vm.campaigns = campaignsList;

    vm.addSlide = function() {
      vm.slider.slides.push({
        campaign_id: null,
        image : {},
        type: null,
        order: vm.slider.slides.length
      });
      vm.uploaders.push(Uploader.getInstance());
      var uploader = vm.uploaders[vm.uploaders.length-1];
      uploader.uploadAction = function () {
        uploader.uploadAll();
      };
      uploader.postDeleteItem = function () {
        uploader.refreshImages();
      };
      uploader.onCompleteAll = function() {
        uploader.refreshImages();
      };
      uploader.refreshImages = function () {
        api.slider.getImage({id:vm.slider.slides[vm.uploaders.indexOf(uploader)].id}).$promise
          .then(
            function(d){
              if (d) vm.slider.slides[vm.uploaders.indexOf(uploader)].image = d;
              else vm.slider.slides[vm.uploaders.indexOf(uploader)].image = null;
            }
          )
          .catch(
            function (e){
              console.log(e);
            }
          );
      };
      uploader.autoUpload = false;
    };

    vm.delSlide = function($index) {
      vm.slider.slides.splice($index, 1);
      vm.uploaders.splice($index, 1);
    };

    vm.changeOrder = function(index, action) {
      if(vm.slider.slides[index] &&
        ((action === 'left' && vm.slider.slides[index-1]) || (action === 'right' && vm.slider.slides[index+1]))
      ) {
        var slide = vm.slider.slides.splice(index, 1)[0];
        var uploader = vm.uploaders.splice(index, 1)[0];
        if(action === 'left') {
          slide.order--;
          vm.slider.slides.splice(index - 1, 0, slide);
          vm.slider.slides[index].order++;
          vm.uploaders.splice(index - 1, 0, uploader);
          vm.selectedSlide--;
        } else {
          slide.order++;
          vm.slider.slides.splice(index + 1, 0, slide);
          vm.slider.slides[index].order--;
          vm.uploaders.splice(index + 1, 0, uploader);
          vm.selectedSlide++;
        }
      }
    };

    vm.onSearchChange = function($event) {
      $event.stopPropagation();
    };

    vm.store = function() {
      var record = new api.slider (vm.slider);

      record.$update().then(
        function(data) {
          vm.slider = data;
          $mdToast.show($mdToast.simple()
            .textContent('Slider ' + vm.slider.name + ' creada con éxito.')
            .position('bottom right'));
          // Subimos todas las fotos
          $.each(vm.slider.slides, function(key,value){
            vm.uploaders[key].extra = {
              attachable_id: data.slides[key].id,
              attachable_type:"SLIDE",
              type: "IMAGE",
              proportion: 'panoramic'
            };
            vm.uploaders[key].uploadAll();
          });
        }, function (err) {
          console.log(err);
        }
      );
    };
  }

  angular
    .module('app.sliders')
    .controller('SliderCreateCtrl', SliderCreateCtrl);

  function SliderCreateCtrl(api, Uploader, $mdToast, campaignsList, $state) {
    var vm = this;
    vm.slider = {
      status : true
    };
    vm.slider.slides = [];
    vm.uploaders = [];
    vm.campaigns = campaignsList;

    vm.log = function() {
      console.log(vm.slider);
    }

    vm.addSlide = function() {
      vm.slider.slides.push({
        campaign_id: null,
        image : {},
        type: null
      });

      vm.uploaders.push(Uploader.getInstance());
      var uploader = vm.uploaders[vm.uploaders.length-1];
      uploader.uploadAction = function () {
        uploader.uploadAll();
      };
      uploader.postDeleteItem = function (){
        uploader.refreshImages();
      };
      uploader.onCompleteAll = function() {
        uploader.refreshImages();
      };
      uploader.refreshImages = function (){
        api.slider.getImage({id:vm.slider.slides[vm.uploaders.indexOf(uploader)].id}).$promise
          .then(
            function(d){
              if (d) vm.slider.slides[vm.uploaders.indexOf(uploader)].image = [d];
              else vm.slider.slides[vm.uploaders.indexOf(uploader)].image = null;
            }
          )
          .catch(
            function (e){
              console.log(e);
            }
          )
      };
      console.log(uploader);
      uploader.autoUpload = false;
    };

    vm.delSlide = function($index) {
      vm.slider.slides.splice(vm.slider.slides.indexOf($index));
      vm.uploaders.splice(vm.uploaders.indexOf($index));
    };

    vm.onSearchChange = function($event) {
      $event.stopPropagation();
    };

    vm.store = function() {
      var record = new api.slider (vm.slider);

      record.$save().then(
        function(data) {
          vm.slider = data;
          $mdToast.show($mdToast.simple()
            .textContent('Slider ' + vm.slider.name + ' creada con éxito.')
            .position('bottom right'));
          // Subimos todas las fotos
          $.each(vm.slider.slides, function(key,value){
            vm.uploaders[key].extra = {
              attachable_id: data.slides[key].id,
              attachable_type:"SLIDE",
              type: "IMAGE",
              proportion: 'panoramic'
            };
            vm.uploaders[key].uploadAll();
          });
          $state.go('app.sliders');
        }, function (err) {
          console.log(err);
        }
      );
    };
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.seller', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider   )
    {
        // State
        $stateProvider
            // .state('app.sample', {
            //     url    : '/admin/sample',
            //     views  : {
            //         'content@app': {
            //             templateUrl: 'app/main/sample/sample.html',
            //             controller : 'SampleController as vm'
            //         }
            //     },
            //     resolve: {
            //         SampleData: function (msApi)
            //         {
            //             return msApi.resolve('sample@get');
            //         }
            //     }
            // })
            .state('app.seller', {
                url    : '/admin/seller',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/admin/seller/main.html',
                        controller : 'SellerMainController as vm'
                    }
                },
                resolve: {
                    access: ["Access", function (Access) { return Access.hasAnyRole(['admin','comercial']); }]
                    // uploadImages:function (api){
                    //     return api.upload.type({type:"image"}).$promise;
                    // }
                }
            });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/sample');

        // Api


        // Navigation
        msNavigationServiceProvider.saveItem('newOrder', {
            title    : 'Nuevo pedido',
            icon     : 'icon-plus-circle-outline',
            state    : 'app.seller',
            access   :  {
                roles : ['admin','comercial']
            },

            weight   : 20
        });

        // msNavigationServiceProvider.saveItem('fuse.sample', {
        //     title    : 'Sample',
        //     icon     : 'icon-tile-four',
        //     state    : 'app.sample',
        //     /*stateParams: {
        //         'param1': 'page'
        //      },*/
        //     translate: 'SAMPLE.SAMPLE_NAV',
        //     weight   : 1
        // });

       // console.log(customNavService);

        //msNavigationServiceProvider.saveItem('uploader', {
        //    title    : 'Test',
        //    icon     : 'fa fa-upload',
        //    state    : 'app.uploader',
        //    access   :  {
        //                    //authtenticated:true,
        //                    roles : ['admin']
        //                },
        //
        //
        //    weight   : 10
        //});
       //msNavigationServiceProvider.deleteItem('uploader');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.seller')
        .controller('DialogSellerAddPharmaCtrl', DialogSellerAddPharmaCtrl)
        .controller('SellerMainController', SellerMainController);

    /** @ngInject */
    function SellerMainController(myConfig,api,Access,UserProfile,$http,$mdDialog,$scope)
    {
        var vm = this;
        vm.selectedClient={};
        vm.selectClient = function () {
            $mdDialog.show({
                controller: 'DialogSellerAddPharmaCtrl as modal',
                templateUrl: 'app/main/admin/seller/dialogs/addpharmacist.html' ,
                parent: angular.element(document.body),
                //targetEvent: event,
                resolve: {
                    // promotional: function(api) {
                    //     return api.rulePromotional.getComplete({id:item.id}).$promise;
                    // }
                },
                scope: $scope,
                preserveScope: true,
                clickOutsideToClose:true,
                fullscreen: true
            }).finally(function(){
                vm.selectedClient=$scope.selectedClient;
                $scope.selectedClient={};
                $scope.searchTerm='';
            });
        }


    }




    function DialogSellerAddPharmaCtrl ($scope,$mdDialog,api,$mdToast){
    var modal=this;

    modal.promotional={};


    modal.searchPharmacist=function(term){
        $scope.elementData={};
        if (term!==''){
            $scope.loadingSearch=true;
            $scope.withOutResults=false;
            api.search.type({type:'PHARMACIST',term:term}).$promise.then(function(d){
                modal.searchResult=d;
                if (d.length<1){
                    $scope.withOutResults=true;
                }
                $scope.loadingSearch=false;
            });
        }
    }



    //Añadir farmaceutico al descuento
    modal.addPharma=function(user){
        $mdDialog.hide();
        $scope.selectedClient=user;
    }



    }
    //DialogSellerAddPharmaCtrl
})();

(function ()
{
    'use strict';

    angular
        .module('app.sample', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider   )
    {
        // State
        $stateProvider
            // .state('app.sample', {
            //     url    : '/admin/sample',
            //     views  : {
            //         'content@app': {
            //             templateUrl: 'app/main/sample/sample.html',
            //             controller : 'SampleController as vm'
            //         }
            //     },
            //     resolve: {
            //         SampleData: function (msApi)
            //         {
            //             return msApi.resolve('sample@get');
            //         }
            //     }
            // })
            .state('app.uploader', {
                url    : '/admin/uploader',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/admin/sample/uploader.html',
                        controller : 'SampleController as vm'
                    }
                },
                resolve: {
                    access: ["Access", function (Access) { return Access.hasRole('admin'); }],
                    uploadImages:function (api){
                        return api.upload.type({type:"image"}).$promise;
                    }
                }
            });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/sample');

        // Api
        msApiProvider.register('sample', ['app/data/sample/sample.json']);

        // Navigation
        // msNavigationServiceProvider.saveItem('fuse', {
        //     title : 'SAMPLE',
        //     group : true,
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('fuse.sample', {
        //     title    : 'Sample',
        //     icon     : 'icon-tile-four',
        //     state    : 'app.sample',
        //     /*stateParams: {
        //         'param1': 'page'
        //      },*/
        //     translate: 'SAMPLE.SAMPLE_NAV',
        //     weight   : 1
        // });

       // console.log(customNavService);

        //msNavigationServiceProvider.saveItem('uploader', {
        //    title    : 'Test',
        //    icon     : 'fa fa-upload',
        //    state    : 'app.uploader',
        //    access   :  {
        //                    //authtenticated:true,
        //                    roles : ['admin']
        //                },
        //
        //
        //    weight   : 10
        //});
       //msNavigationServiceProvider.deleteItem('uploader');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.sample')
        .controller('SampleController', SampleController);

    /** @ngInject */
    function SampleController(myConfig,api,uploadImages,TestUploader,Access,UserProfile,$http)
    {
        var vm = this;



       vm.uploader = TestUploader.getInstance();

       vm.uploader.url= "Mis huevos";


       vm.uploader2 = TestUploader.getInstance();






       //console.log(vm.uploader);




    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.rules', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider   )
    {
        // State
        $stateProvider
          .state('app.rules-manager', {
                url    : '/admin/rules/manager',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/admin/rules/views/rulesWizard.html',
                        controller : 'RulesMainCtrl as vm'
                    }
                },
                resolve: {
                    access: ["Access", function (Access) { return Access.hasRole('admin'); }]


                }
            });
        $stateProvider
          .state('app.rules', {
            url    : '/admin/rules',
            views  : {
              'content@app': {
                templateUrl: 'app/main/admin/rules/views/rulesList.html',
                controller : 'RulesListCtrl as vm'
              }
            },
            resolve: {
              access: ["Access", function (Access) { return Access.hasRole('admin'); }],
              ItemsWithRules: function (api){
                return api.rule.items_with_rules().$promise;
              }
            }
          });
        $stateProvider
          .state('app.rules-promotional', {
            url    : '/admin/rules/promotional',
            views  : {
              'content@app': {
                templateUrl: 'app/main/admin/rules/views/rulesPromotionalList.html',
                controller : 'RulesPromotionalListCtrl as vm'
              }
            },
            resolve: {
              access: ["Access", function (Access) { return Access.hasRole('admin'); }],
              promotionals: function(api) {
                return api.rulePromotional.list().$promise;
              }
            }
          });

        $stateProvider
          .state('app.rules-promotional-create', {
            url    : '/admin/rules/promotional/create',
            views  : {
              'content@app': {
                templateUrl: 'app/main/admin/rules/views/rulesPromotionalCreate.html',
                controller : 'RulesPromotionalCreateCtrl as vm'
              }
            },
            resolve: {
              access: ["Access", function (Access) { return Access.hasRole('admin'); }]
            }
          });
      $stateProvider
        .state('app.rules-promotional-edit', {
          url   : '/admin/rules/promotional/edit/:idPromotional',
          views : {
            'content@app': {
              templateUrl: 'app/main/admin/rules/views/rulesPromotionalCreate.html',
              controller : 'RulesPromotionalEditCtrl as vm'
            }
          },
          resolve : {
            access: ["Access", function (Access) { return Access.hasRole('admin'); }],
            promotionalEdit: function(api, $stateParams) {
              return api.rulePromotional.get({id:$stateParams.idPromotional}).$promise;
            }
          }
        });

      $stateProvider
        .state('app.rules-monthly-discount', {
          url   : '/admin/rules/monthly-discount',
          views : {
            'content@app': {
              templateUrl: 'app/main/admin/rules/views/monthlyDiscount.html',
              controller : 'MonthlyDiscountMainCtrl as vm'
            }
          },
          resolve : {
            access: ["Access", function (Access) { return Access.hasRole('admin'); }]
          }
        });
      msNavigationServiceProvider.saveItem('manager.utils.rules.monthlydiscount', {
            title : 'D.Mensuales',
            icon     : 'fa fa-tag',
            state: 'app.rules-monthly-discount',
            weight: 8,
            access   :  {
              roles : ['admin']
            }
      });


      msNavigationServiceProvider.saveItem('manager.utils.rules', {
            title : 'Reglas de precios',
            icon     : 'fa fa-money',
            weight: 8,
            access   :  {
              roles : ['admin']
            }
      });
      //msNavigationServiceProvider.saveItem('manager.utils.rules.list', {
      //      title    : 'Listado',
      //      icon     : 'icon-book',
      //      state    : 'app.rules',
      //      access   :  {
      //        roles : ['admin']
      //      },
      //      weight   : 8
      //  });
      msNavigationServiceProvider.saveItem('manager.utils.rules.promotional', {
            title    : 'D. Promocionales',
            icon     : 'icon-star-circle',
            state    : 'app.rules-promotional',
            access   :  {
              roles : ['admin']
            },

            weight   : 7
      });
      msNavigationServiceProvider.saveItem('manager.utils.rules.manager', {
            title    : 'Manager',
            icon     : 'fa fa-sliders',
            state    : 'app.rules-manager',
            access   :  {
              roles : ['admin']
            },

            weight   : 8
      });
       //msNavigationServiceProvider.deleteItem('uploader');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.rules')
        .controller('RulesMainCtrl', RulesMainCtrl)
        .controller('RulesPromotionalListCtrl', RulesPromotionalListCtrl)
        .controller('RulesPromotionalCreateCtrl', RulesPromotionalCreateCtrl)
        .controller('RulesPromotionalEditCtrl', RulesPromotionalEditCtrl)
        .controller('RulesListCtrl',RulesListCtrl);


    //Controlador del manager
    function RulesMainCtrl($rootScope,api,ElementSelection,$mdDialog,$scope,$location,$mdToast,$filter)
    {
    var vm = this;
    // Pasar datos a un dialog
    //  http://turreta.com/2016/01/22/pass-data-to-controller-from-another-controller-using-mddialog/

    api.campaign.minList().$promise.then(function(d){
      vm.campaigns=d;
    });

    var url =  $location.$$url;



    vm.rule={};
    vm.rule.discount={};
    vm.rule.gift={};
    vm.rule.gift.gift_quantity=1;
    vm.rule.discount.ranges=[];
    vm.current_campaign={};

    $scope.rule=vm.rule;

    //Autoseleccionar la promocion
    if (url.search("/admin/promotions/edit/")!==-1){
        vm.rule.launchSelectElement = 'promotion';
        var idPromo=url.split('/')[4];
        if(idPromo !== undefined){
            api.promotion.get({id:idPromo}).$promise.then(function(d){
                $scope.selectedElement=d;
                $scope.articleOrPromo='promotion';
            });
        }else{
            swal(
                'Error...',
                'Manager : Promoción no encontrada',
                'error'
            );

        }

        $rootScope.$on('promotion-updated', function (event, data) {
            api.promotion.get({id:idPromo}).$promise.then(function(d){
                $scope.selectedElement=d;
                $scope.articleOrPromo='promotion';
            });
        });

    }


    //Compuebo si cambia el $scope.selectElement y actualizo el rule
    $scope.$watch("selectedElement",function(newValue,oldValue) {
      if (newValue===oldValue) {
        return;
      }

      vm.rule.selectedElement=newValue;
      vm.rule.articleOrPromo=$scope.articleOrPromo;
      api.rule.type({type:vm.rule.launchSelectElement,item:newValue.id,selected_capaign:vm.rule.selected_campaign}).$promise.then(function (d){

        vm.rule.selectedElement.rules=d;
        if(vm.rule.selectedElement.rules.direct==null){
          vm.rule.selectedElement.rules.direct={
            type:'discount',
            sub_type: 'direct'
          };
        }
      });
      // Si hemos seleccionado un articulo con una campaña asociada marcamos directamente descuento
      if(vm.rule.launchSelectElement==='article' && vm.rule.selected_campaign){
        vm.rule.discount_gift="discount";
      }

    });
    $scope.$watch("gift",function(newValue,oldValue) {
      if (newValue===oldValue) {
        return;
      }
      vm.rule.gift.selected=newValue;
    });
    $scope.$watch("vm.rule.discount_gift",function(newValue,oldValue) {
      if(newValue=='gift'){
        delete vm.rule.discount_type;
      }
    });
    $scope.$watch("vm.rule.selected_campaign",function(newValue,oldValue) {
      if(newValue=='-1'){
        delete vm.rule.selectedElement;
        delete vm.rule.selected_campaign;
        vm.current_campaign={};
        delete vm.rule.launchSelectElement;

      } else if(parseInt(newValue)>0){
        //vm.showSelectElement('article');
        //vm.rule.launchSelectElement='article';
        if (vm.rule.launchSelectElement==='campaign'){
          vm.rule.selectedElement = $filter('filter')(vm.campaigns, {id: vm.rule.selected_campaign})[0];
        }
        // Recuperamos los datos de la campaña seleccionada
        api.campaign.get({id:vm.rule.selected_campaign}).$promise.then(function(d){
          vm.current_campaign=d;
        })
      }
    });
    //  Observamos si seleccionamos campaña en el manager para obtener las reglas de esa campaña
    $scope.$watch("vm.rule.launchSelectElement",function(newValue,oldValue) {

    if (newValue==='campaign' && vm.rule.selected_campaign){
      api.campaign.get({id:vm.rule.selected_campaign}).$promise.then(function(d){
        vm.rule.selectedElement=d;
        api.rule.type({type:vm.rule.launchSelectElement,item:vm.rule.selectedElement.id,selected_capaign:vm.rule.selected_campaign}).$promise
          .then(function (d){
            vm.rule.selectedElement.rules=d;
          });
      });

    }

    });

    vm.showSelectElement = function (type){

      var element = ElementSelection.type(type);
      $mdDialog.show({
        controller: 'DialogRulesCtrl as modal',
        templateUrl: element.template,
        parent: angular.element(document.body),
        //targetEvent: event,
        resolve: element.resolve,
        scope: $scope,
        preserveScope: true,
        clickOutsideToClose:true,
        fullscreen: true
      }).finally(function(){
         // Al cerrar la ventana
       delete $scope.elementData;

      });
      vm.resolveData(element.getData());
      $scope.opt=element;
    };

    vm.resolveData=function (promise){
      if(promise){
        promise.then(function (d){
          console.log(d);
          $scope.elementData=d;
        });
      }

    };
    //Limpiar rangos
    vm.rule.discount.cleanRanges=function(){
      vm.rule.discount.ranges=[];
    };
    // Añadir nuevo rango
    vm.rule.discount.newRange=function(){
      var range={
          from:0,
          to:0
      };
      vm.rule.discount.ranges.push(range);
    };
    //Guardar regla
    vm.rule.save= function () {
      var record = new api.rule (vm.rule);

      record.$save().then(
        function(data) {
          //Actualizamos la vista de reglas

          api.rule.type({type:vm.rule.launchSelectElement,item:vm.rule.selectedElement.id,selected_capaign:vm.rule.selected_campaign}).$promise
            .then(function (d){
            vm.rule.selectedElement.rules=d;
            $rootScope.$emit('manager-saved',d);
          });

          $mdToast.show($mdToast.simple()
            .textContent('Regla  creada con éxito.')
            .position('bottom right'));
            //console.log(data);
            $rootScope.$emit('wizard-goto-start');

            vm.rule.clearStep2();
        }, function (err) {
          console.log(err);
        }
      );
    };


    // Eliminar una regla-regalo
    vm.rule.giftDestroy = function (id,key){
        vm.rule.destroy(id).$promise.then(function (d){
          $mdToast.show($mdToast.simple()
            .textContent('Regalo eliminado correctamente')
            .position('bottom right'));
           vm.rule.selectedElement.rules.gifts.splice(key,1);
        });
    };
    // Eliminar una regla - rango
    vm.rule.rangeDestroy = function (id,key){
        vm.rule.destroy(id).$promise.then(function (d){
          $mdToast.show($mdToast.simple()
            .textContent('Rango eliminado correctamente')
            .position('bottom right'));
          vm.rule.selectedElement.rules.ranges.splice(key,1);
        });
    };
    // Eliminar descuento directo
    vm.rule.discountDestroy = function (id){
      vm.rule.destroy(id).$promise.then(function (d){
        $mdToast.show($mdToast.simple()
          .textContent('Descuento directo eliminado correctamente')
          .position('bottom right'));
        vm.rule.selectedElement.rules.direct.percent=null;
        delete vm.rule.selectedElement.rules.direct.id;
      });
    };

    // Eliminar regla
    vm.rule.destroy = function (id){
      console.log(id);
      return api.rule.remove({id:id});
    };

    //Limpia step 2
    vm.rule.clearStep2=function(){
      vm.rule.discount.ranges=[];
      vm.rule.gift={};
      vm.rule.discount_gift={};
      vm.rule.discount_type={};
    };
    // Limpia step 1
    vm.rule.clearStep1=function(){
      vm.rule.launchSelectElement='';
      vm.rule.selected_campaign="-1";
      vm.rule.selectedElement={};
    }

    // Limpiar todos los campos
    vm.rule.clearAll = function (){
      vm.rule.clearStep1();
      vm.rule.clearStep2();
      $rootScope.$emit('wizard-goto-start');
    } ;


    vm.rule.updateDiscounts=function(type,item){

      api.rule.update({type:type,item:item,rules:vm.rule.selectedElement.rules,selected_campaign:vm.rule.selected_campaign}).$promise.then(function(d){
        $mdToast.show($mdToast.simple()
          .textContent('Reglas actualizadas correctamente')
          .position('bottom right'));
        vm.rule.selectedElement.rules=d;
        $rootScope.$emit('manager-saved',d);
      });

    }

    vm.rule.deleteAllRules = function (){

      swal({
        title: '¿ Esta seguro ?',
        text: "Se eliminarán todas las reglas comercialadas para : "+ vm.rule.selectedElement.name,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si , elimínalas',
        cancelButtonText: 'Cancelar'

      }).then(function() {
        api.rule.deleteAllRules({type:vm.rule.launchSelectElement,item:vm.rule.selectedElement.id}).$promise.then(function(d){
          vm.rule.clearAll();
          swal(
            'Eliminadas',
            'El elemento marcado ha sido limpiado',
            'success'
          );
        });

      })

    }

   }
  // Controlador de la lista
  function RulesListCtrl (ItemsWithRules){
  console.log(ItemsWithRules);
  var vm=this;




  }

  // Controlador lista de promocionales
  function RulesPromotionalListCtrl (promotionals,$mdDialog,$scope,$rootScope,api,$mdToast){
    var vm=this;
    vm.promotionals=promotionals;
    vm.details = function (item) {
      $mdDialog.show({
        controller: 'DialogRulesPromotionalDetCtrl as modal',
        templateUrl: 'app/main/admin/rules/views/dialogs/details.html' ,
        parent: angular.element(document.body),
        //targetEvent: event,
        resolve: {
          promotional: function(api) {
            return api.rulePromotional.getComplete({id:item.id}).$promise;
          }
        },
        scope: $scope,
        preserveScope: true,
        clickOutsideToClose:true,
        fullscreen: true
      }).finally(function(){
        // Al cerrar la ventana
      });
    };

    vm.addPharma=function (item){
      $mdDialog.show({
        controller: 'DialogRulesPromotionalAddPharmaCtrl as modal',
        templateUrl: 'app/main/admin/rules/views/dialogs/addpharmacist.html' ,
        parent: angular.element(document.body),
        //targetEvent: event,
        resolve: {
          promotional: function(api) {
            return api.rulePromotional.getComplete({id:item.id}).$promise;
          }
        },
        scope: $scope,
        preserveScope: true,
        clickOutsideToClose:true,
        fullscreen: true
      }).finally(function(){
        // Al cerrar la ventana
      });
    }

    $rootScope.$on('promotional-add-pharma',function(e,d){
      vm.addPharma(d.promotional);
    });

    // Eliminar regla
    vm.destroy = function (id,key){
      swal({
        title: '¿ Estas seguro ?',
        text: "Vas a eliminar un descuento promocional",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'Cancelar'
      }).then(function() {
        api.rule.remove({id:id}).$promise.then(function(){
          vm.promotionals.splice(key,1);
          $mdToast.show($mdToast.simple()
            .textContent('Descuento borrado')
            .position('bottom right'));
        });
      });

    };

  }
  // Controlador crear promocionales
  function RulesPromotionalCreateCtrl (api,$mdToast,$state){
    var vm=this;
    vm.promotional={};
    vm.promotional.ranges=[];
    vm.promotional.discount_type='direct';
    // Añadir nuevo rango
    vm.newRange=function(){
      var range={
          from:0,
          to:0
      };
      vm.promotional.ranges.push(range);
    };
    api.promotion.listToSelect().$promise.then(function(d){
      vm.promotions=d;
    });
    api.campaign.listToSelect().$promise.then(function(d){
      vm.campaigns=d;
    });

    vm.promotional.create=function (){
      var record = new api.rulePromotional (vm.promotional);
      record.$save().then(
        function(d) {
          $mdToast.show($mdToast.simple()
            .textContent('Descuento creado con éxito.')
            .position('bottom right'));
          $state.go('app.rules-promotional');
        });

    }
  }
  // Controlador editar promocionales
  function RulesPromotionalEditCtrl (api,$mdToast,promotionalEdit){
    var vm=this;
    vm.promotional=promotionalEdit;
    console.log(promotionalEdit);
    api.promotion.listToSelect().$promise.then(function(d){
      vm.promotions=d;
    });
    api.campaign.listToSelect().$promise.then(function(d){
      vm.campaigns=d;
    });

    vm.promotional.create=function (){

      vm.promotional.$update()
        .then(function(response){
          $mdToast.show($mdToast.simple()
            .textContent('Descuento  actualizado con éxito.')
            .position('bottom right'));
        });

    };



  }



})();

(function ()
{
    'use strict';

    angular
        .module('app.rules')
        .controller('MonthlyDiscountMainCtrl', MonthlyDiscountMainCtrl)



    //Controlador del manager
    function MonthlyDiscountMainCtrl($rootScope,api,ElementSelection,$mdDialog,$scope,$location,$mdToast,$filter)
    {
        var vm = this;
        vm.options = [];
        vm.loadoptions=function(){
            $rootScope.loadingProgress = true;
            api.option.getMultilple({keys:['monthly-discount-reduction','min-order-amount-monthly-discount','monthly-discount-reduction-35']}).$promise.then(
                function (data) {
                  angular.forEach(data,function(v,k){
                      vm.options[v.key]=v;
                  });
                  console.log(vm);
                  $rootScope.loadingProgress = false;
                },
                function (err) {
                  console.log(err);
                  $rootScope.loadingProgress = false;
            });
        };

        vm.save=function (){
            var data = {options:[
                vm.options['monthly-discount-reduction'],
                vm.options['min-order-amount-monthly-discount'],
                vm.options['monthly-discount-reduction-35'],
            ]};
            api.option.saveMultilple(data).$promise.then(
            function (d) {
               vm.loadoptions();
               $mdToast.show($mdToast.simple().textContent('Configuración actualizada correctamente').position('bottom right'));
            },function (err) {
               $mdToast.show($mdToast.simple().textContent('Se produjo un error, revisar consola').position('bottom right'));
            });
        };
        vm.loadoptions();




    }




})();

(function ()
{
  'use strict';

  angular
    .module('app.rules')
    .factory('ElementSelection', ElementSelection);

  /** @ngInject */
  function ElementSelection($rootScope,api) {
    var Conf = {
          opt: {
            'article': {
              type: 'article',
              title: "Seleccione un articulo",
              template: "app/main/admin/rules/views/dialogs/selectArticle.html",
              api: api.article,
              getData: function () {
                //return api.search.type({type:'ARTICLE',term:''});
                return false;
              }
            },
            'promotion': {
              type: 'promotion',
              title: "Seleccione una promoción",
              template: "app/main/admin/rules/views/dialogs/selectPromotion.html",
              api: api.promotion,
              getData: function () {
                return api.promotion.lastActive().$promise;
              }

            },
            'gift': {
              type: 'gift',
              title: "Seleccione un regalo",
              template: "app/main/admin/rules/views/dialogs/selectGift.html",
              api: api.gift,
              getData: function () {
                return api.gift.list().$promise;
              }
            },
            'material': {
              type: 'material',
              title: "Seleccione un material",
              template: "app/main/admin/rules/views/dialogs/selectMaterial.html",
              api: api.material,
              getData: function () {
                return api.material.list().$promise;
              }
            }
          },
        type:function (type){
          return Conf.opt[type];
        }
    };
    return Conf;
  }
})();

(function ()
{
  'use strict';

  angular
    .module('app.rules')
    .controller('DialogRulesPromotionalDetCtrl', DialogRulesPromotionalDetCtrl)
    .controller('DialogRulesPromotionalAddPharmaCtrl', DialogRulesPromotionalAddPharmaCtrl)
    .controller('DialogRulesCtrl', DialogRulesCtrl);

  /** @ngInject */
  function DialogRulesCtrl($scope,$mdDialog,api)
  {
    var modal = this;

    // Recuperamos  el objeto rule para manejarlo en la modal
    modal.rule=$scope.rule;

    // Seleccion de un elemento
    modal.setElement= function (element,opt) {
      $scope.selectedElement=element;
      $scope.articleOrPromo=opt;
      $mdDialog.hide();
    };
    // Seleccion de regalo
    modal.setGift= function (gift) {
      $scope.gift=gift;
      $mdDialog.hide();
    };

    // Recuperar articulos de una cierta campaña
    if(typeof modal.rule !='undefined'){
      if ( modal.rule.selected_campaign  && modal.rule.launchSelectElement==='article'){
        api.article.list({campaign:modal.rule.selected_campaign}).$promise.then(function(d){
          $scope.elementData=d;
        });
      }
    }


    //Buscar articulos sin asignar a campaña
    $scope.withOutResults=false;
    modal.searchArticle=function(term){
      $scope.elementData={};
      if (term!==''){
        $scope.loadingSearch=true;
        $scope.withOutResults=false;
        api.search.type({type:'ARTICLE',term:term}).$promise.then(function(d){
          $scope.elementData=d;
          if (d.length<1){
            $scope.withOutResults=true;
          }
          $scope.loadingSearch=false;
        });
      }
    };

    modal.searchPromotion=function(term){
      $scope.elementData={};
      if (term!==''){
        $scope.loadingSearch=true;
        $scope.withOutResults=false;
        api.search.type({type:'PROMOTION',term:term}).$promise.then(function(d){
          $scope.elementData=d;
          if (d.length<1){
            $scope.withOutResults=true;
          }
          $scope.loadingSearch=false;
        });
      }
    };
  }
  function DialogRulesPromotionalDetCtrl($scope,$mdDialog,api,promotional,$rootScope){
    var modal=this;
    modal.promotional=promotional;
    modal.promotional.active_entity=promotional.entity=='campaign' ? promotional.campaigns[0]:promotional.promotions[0];

    //Añadir farmaceutico
    modal.promotional.addPharma=function(item){
      $rootScope.$emit('promotional-add-pharma',{promotional:item});
    };



  };
  function DialogRulesPromotionalAddPharmaCtrl($scope,$mdDialog,api,promotional,$mdToast){
    var modal=this;
    modal.promotional=promotional;
    modal.promotional.active_entity=promotional.entity=='campaign' ? promotional.campaigns[0]:promotional.promotions[0];

    modal.searchPharmacist=function(term){
      $scope.elementData={};
      if (term!==''){
        $scope.loadingSearch=true;
        $scope.withOutResults=false;
        api.search.type({type:'PHARMACIST',term:term}).$promise.then(function(d){
          modal.searchResult=d;
          if (d.length<1){
            $scope.withOutResults=true;
          }
          $scope.loadingSearch=false;
        });
      }
    }

    //Refrescar modal.promotional
    modal.refreshPromotional=function(){
      api.rulePromotional.getComplete({id:modal.promotional.id}).$promise.then(function(d){
        modal.promotional=d;
      })
    }

    //Añadir farmaceutico al descuento
    modal.addPharma=function(idPromotionl,idUser){
      api.rulePromotional.addPharma({id:idPromotionl , idUser:idUser}).$promise.then(function(d){
        modal.refreshPromotional();
        $mdToast.show($mdToast.simple()
          .textContent('Farmacéutico añadido')
          .position('bottom right'));
      });
    }
    //Eliminar farmaceutico al descuento
    modal.delPharma=function(idPromotionl,idUser){

      api.rulePromotional.delPharma({id:idPromotionl , idUser:idUser}).$promise.then(function(d){
        modal.refreshPromotional();
        $mdToast.show($mdToast.simple()
          .textContent('Completado')
          .position('bottom right'));
      });
    }
  };
})();

(function()
{
  'use strict';

  angular
    .module('app.promotions',['datatables'])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider)
  {
    $stateProvider
      .state('app.promotions', {
        url   : '/admin/promotions?page&search',
        views : {
          'content@app' : {
              templateUrl : 'app/main/admin/promotions/views/listPromotions.html',
              controller  : 'PromotionsMainCtrl as vm',
              params: {
                page: {
                  value: 1,
                  squash: true
                },
                search: {
                  value: '',
                  squash: true
                }
              }
          }
        },
        resolve: {
          access: ["Access", function (Access) { return Access.hasRole('admin'); }],
          promotionsList: function (api, $stateParams) {
              console.log($stateParams);
            return api.promotion.groupedPaginatedList({page: $stateParams.page, search: $stateParams.search}).$promise;
          }
        }
      });

    $stateProvider
      .state('app.promotions-create', {
        url   : '/admin/promotions/create',
        views : {
          'content@app': {
            templateUrl : 'app/main/admin/promotions/views/createPromotion.html',
            controller  : 'PromotionsCreateCtrl as vm'
          }
        },
        resolve: {
          access: ["Access", function (Access) { return Access.hasRole('admin'); }],
          categoriesList: function (api) {
            return api.category.list().$promise;
          },
          materialsList: function(api) {
            return api.material.list().$promise;
          }
        }
      });

    $stateProvider
      .state('app.promotions-edit', {
        url   : '/admin/promotions/edit/:idPromotion',
        views : {
          'content@app': {
            templateUrl : 'app/main/admin/promotions/views/createPromotion.html',
            controller  : 'PromotionsEditCtrl as vm'
          }
        },
        resolve : {
          access: ["Access", function (Access) { return Access.hasRole('admin'); }],
          promotionEdit: function(api, $stateParams) {
            return api.promotion.edit({id:$stateParams.idPromotion}).$promise;
          },
          uploadsList: function (api, $stateParams) {
            return api.promotion.uploadList({idPromotion: $stateParams.idPromotion, type: 'image'}).$promise;
          },
          categoriesList: function (api) {
            return api.category.list().$promise;
          }
        }
      });

    //Promociones vips
    $stateProvider
      .state('app.promotions-vip', {
        url   : '/admin/promotions/vip',
        views : {
          'content@app': {
            templateUrl : 'app/main/admin/promotions/views/vipPromotions.html',
            controller  : 'PromotionsVipCtrl as vm'
          }
        },
        resolve: {
          access: ["Access", function (Access) { return Access.hasRole('admin'); }],
          vipPromotionsList: function(api) {
            return api.promotion.getVip().$promise;
          }
        }
      });

    $stateProvider
      .state('app.promotions-trash', {
        url   : '/admin/promotions/trash?page&search',
        views : {
          'content@app' : {
            templateUrl : 'app/main/admin/promotions/views/trashedPromotions.html',
            controller  : 'PromotionsTrashCtrl as vm',
            params: {
              page: {
                value: 1,
                squash: true
              },
              search: {
                value: '',
                squash: true
              }
            }
          },
        },
        resolve : {
          access: ["Access", function (Access) { return Access.hasRole('admin'); }],
          trashedPromotionsList: function (api, $stateParams) {
            return api.promotion.getTrash({page: $stateParams.page , search: $stateParams.search}).$promise;
          }
        }
      });

    msNavigationServiceProvider.saveItem('manager.promotions', {
      title   : 'Promociones',
      icon    : 'icon-tag-multiple',
      state   : 'app.promotions',
      access   :  {
        //authtenticated:true,
        roles : ['admin']
      },
      weight  : 12
    });



  }
})();

(function()
{
  'use strict';

  angular
    .module('app.promotions')
    .controller('PromotionsMainCtrl', PromotionsMainCtrl);

  function PromotionsMainCtrl(api, $timeout, $element, $mdToast, $scope, promotionsList, $stateParams, $state, $rootScope)
  {
    var vm = this;
    vm.filter = {};
    vm.filter.search = $stateParams.search;
    vm.pagination = promotionsList;
    vm.api = api.promotion.paginatedList;

    vm.onSearchChange = function($event) {
      $event.stopPropagation();
    }

    vm.toggleStatus = function(idPromotion, key) {
      api.promotion.toggleStatus({idPromotion:idPromotion})
        .$pomise
        .then(function(data){
          vm.pagination.data[key].status = data.status;
          $mdToast.show($mdToast.simple()
            .textContent('Promoción actualizada con éxito.')
            .position('bottom right'));
        });
    };

    vm.destroy = function(id, key) {
      console.log(key);
      api.promotion.remove({id:id})
        .$promise.then(function(){
        $mdToast.show($mdToast.simple()
          .textContent('Promoción eliminada con éxito.')
          .position('bottom right'));
        vm.pagination.data.splice(key,1);
      });
    };

    vm.refreshPromotions = function () {
      $state.go('.', {page: 1, search: vm.filter.search});
    }

    vm.toggleVip = function (promotion,index) {
      $rootScope.loadingProgress = true;
      var toSet=promotion.vip_order ? 0 : 1;
      api.promotion.setVip({id: promotion.id, set: toSet}).$promise.then(
        function (data) {
          vm.pagination.data[index] = data;
          $rootScope.loadingProgress = false;
        },
        function (err) {
          console.log(err);
          $rootScope.loadingProgress = false;
        });
    };

  }

})();

(function()
{
  'use strict';

  angular
    .module('app.promotions')
    .controller('PromotionsEditCtrl', PromotionsEditCtrl)
    .controller('DialogPromotionAddPharmaCtrl', DialogPromotionAddPharmaCtrl);

  function PromotionsEditCtrl(api,$rootScope, $timeout, $state, $element, $mdToast, $mdDialog, $scope, promotionEdit, uploadsList, Uploader, TextEditor, categoriesList)
  {
    var vm = this;

    vm.promotion = promotionEdit;
    vm.categories = categoriesList;


    //Descuento directo

    // var direct =  vm.promotion.avaliable_rules.direct;
    // if(direct){
    //   console.log(direct);
    //   vm.promotion.direct = direct.percent;
    // }

    vm.onSearchChange = function($event) {
      $event.stopPropagation();
    };

    vm.store = function() {
      api.promotion.update(vm.promotion).$promise.then(function(d){
            $mdToast.show($mdToast.simple()
              .textContent('Promoción ' + vm.promotion.name + ' actualizada con éxito.')
              .position('bottom right'));
            // Subimos todas las fotos
            if (vm.uploader.queue > 0 ){
              vm.uploader.uploadAll();
            }
            $rootScope.$emit('promotion-updated', vm.promotion);
            vm.promotion=d;
            //$state.go('app.promotions');
      });
    };

    $rootScope.$on('manager-saved', function (event, data) {
        vm.promotion.avaliable_rules.direct.percent =  data.direct.percent;
    });

    vm.refreshImages = function (){
      api.promotion.uploadList({idPromotion:vm.promotion.id,type:'image'}).$promise
        .then(
          function(d){
            vm.uploadImages=d;
          }
        )
        .catch(
          function (e){
            console.log(e);
          }
        )
    };
    vm.uploadImages = uploadsList;

    vm.uploader = Uploader.getInstance();

    vm.uploader.extra={
      attachable_id:vm.promotion.id,
      attachable_type:"PROMOTION",
      type: "IMAGE"
    };

    vm.uploader.postDeleteItem=function (){
      vm.refreshImages();
    };
    vm.uploader.onCompleteAll = function() {
      $state.go('app.promotions');
    };


    vm.tinymceOptions = TextEditor;


    vm.showSelectElement = function (type){

      $mdDialog.show({
        controller: 'DialogPromotionsCtrl as modal',
        templateUrl: $rootScope.dialogConfPromo[type].template,
        parent: angular.element(document.body),
        resolve: $rootScope.dialogConfPromo[type].resolve,
        scope: $scope,
        preserveScope: true,
        clickOutsideToClose:true,
        fullscreen: true
      }).finally(function(){
         // Al cerrar la ventana
         delete $scope.elementData;
      });
      vm.resolveData($rootScope.dialogConfPromo[type].getData());
      $scope.opt = $rootScope.dialogConfPromo[type];
    };

    $scope.confirm = function(type) {
      if (type == "articles")
        vm.promotion.articles = $scope.selectedArticles;
      else if (type == "materials")
        vm.promotion.materials = $scope.selectedMaterials;
      $mdDialog.hide();
    };

    $scope.hide = function() {
      $mdDialog.hide();
    };

    $scope.cancel = function() {
      $mdDialog.cancel();
    };

    vm.resolveData=function (promise){
      if(promise){
        promise.then(function (d){
          $scope.elementData=d;
        });
      }
    };

    vm.addPharma=function (item){
      $mdDialog.show({
        controller: 'DialogPromotionAddPharmaCtrl as modal',
        templateUrl: 'app/main/admin/promotions/views/dialogs/addpharmacist.html' ,
        parent: angular.element(document.body),
        //targetEvent: event,
        resolve: {
          promotion: function(api) {
            return api.promotion.get({id:item.id}).$promise;
          }
        },
        scope: $scope,
        preserveScope: true,
        clickOutsideToClose:true,
        fullscreen: true
      }).finally(function(){
        // Al cerrar la ventana
      });
    };
  }
  function DialogPromotionAddPharmaCtrl($scope,$mdDialog,api,promotion,$mdToast) {
    var modal=this;
    modal.promotion = promotion;

    modal.searchPharmacist=function(term){
      $scope.elementData={};
      if (term!==''){
        $scope.loadingSearch=true;
        $scope.withOutResults=false;
        api.search.type({type:'PHARMACIST',term:term}).$promise.then(function(d){
          modal.searchResult=d;
          if (d.length<1){
            $scope.withOutResults=true;
          }
          $scope.loadingSearch=false;
        });
      }
    }

    //Refrescar modal.promotional
    modal.refreshPromotion=function(){
      api.promotion.getPromotionPharma({id:modal.promotion.id}).$promise.then(function(d){
        modal.promotion.activated_users = d;
      });
    }

    //Añadir farmaceutico al descuento
    modal.addPharma=function(idPromotion,idUser){
      api.promotion.addPharma({id:idPromotion, idPharma:idUser}).$promise.then(function(d){
        modal.refreshPromotion();
        $mdToast.show($mdToast.simple()
          .textContent('Farmacéutico añadido.')
          .position('bottom right'));
      });
    };
    //Eliminar farmaceutico al descuento
    modal.delPharma=function(idPromotion,idUser){
      api.promotion.delPharma({id:idPromotion, idPharma:idUser}).$promise.then(function(d){
        modal.refreshPromotion();
        $mdToast.show($mdToast.simple()
          .textContent('Farmacéutico desvinculado.')
          .position('bottom right'));
      });
    };
    modal.refreshPromotion();
    modal.sendMasive=function(){
      api.promotion.addMasivePharma({id:modal.promotion.id , users:modal.masiveUsers.split(/\r?\n/)}).$promise.then(function(d){
        modal.refreshPromotion();
        modal.masiveUsers=[];
        $mdToast.show($mdToast.simple()
          .textContent('Farmacéuticos añadidos.')
          .position('bottom right'));
      },function(err){console.log(err)});

    };
    modal.delMasive=function (){
      swal({
        title: 'Estas seguro ?',
        text: "Dejara vacio el campo usuarios",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'Cancelar'
      }).then(function () {
        api.promotion.delMasivePharma({id:modal.promotion.id}).$promise.then(function(d){
          modal.refreshPromotion();
        },function(err){console.log(err)});
      })
    }
  }
})();

(function(){

  'use strict';

  angular
    .module('app.promotions')
    .controller('PromotionsVipCtrl', PromotionsVipCtrl)
    .controller('PromotionsCreateCtrl', PromotionsCreateCtrl)
    .controller('PromotionsTrashCtrl', PromotionsTrashCtrl);

  function PromotionsCreateCtrl(api, $rootScope, $state, $mdToast, $mdDialog, $scope, Uploader, TextEditor, categoriesList)
  {
    var vm = this;
    vm.promotion = {};
    vm.uploader = Uploader.getInstance();
    vm.uploader.autoUpload = false;
    vm.categories = categoriesList;
    vm.mode="create";

    vm.onSearchChange = function($event) {
      $event.stopPropagation();
    };
    vm.redirectToEdit = function(id){
        $state.go("app.promotions-edit",{idPromotion:id});
    };
    vm.store = function() {

      var record = new api.promotion (vm.promotion);
      record.$save().then(
        function(data) {
          $mdToast.show($mdToast.simple()
            .textContent('Promoción ' + vm.promotion.name + ' creada con éxito.')
            .position('bottom right'));
            //Subimos las fotos que
            vm.uploader.extra={
              attachable_id: data.id,
              attachable_type:"PROMOTION",
              type: "IMAGE",
            };

            if(vm.uploader.queue.length > 0){
              // Subimos todas las fotos
              vm.uploader.uploadAll();

            }else{
              vm.promotion={};
              vm.fuser.$setPristine();
              vm.fuser.$setUntouched();
              vm.redirectToEdit(data.id);
            }


        }, function (err) {
          console.log(err);
        }
      );
    };
    // Evento para cuando termina la subida de las fotos.
    vm.uploader.onCompleteAll=function (){
      //$state.go('app.promotions');
      vm.promotion={};
      vm.fuser.$setPristine();
      vm.fuser.$setUntouched();
      vm.redirectToEdit(data.id);
    };

    vm.promotion.description = 'Descripción';
    vm.tinymceOptions = TextEditor;


    vm.showSelectElement = function (type){

      $mdDialog.show({
        controller: 'DialogPromotionsCtrl as modal',
        templateUrl: $rootScope.dialogConfPromo[type].template,
        parent: angular.element(document.body),
        resolve: $rootScope.dialogConfPromo[type].resolve,
        scope: $scope,
        preserveScope: true,
        clickOutsideToClose:true,
        fullscreen: true
      }).finally(function(){
        // Al cerrar la ventana
        delete $scope.elementData;
      });
      vm.resolveData($rootScope.dialogConfPromo[type].getData());
      $scope.opt = $rootScope.dialogConfPromo[type];
    };

    $scope.confirm = function(type) {
      if (type == "articles")
        vm.promotion.articles = $scope.selectedArticles;
      else if (type == "materials")
        vm.promotion.materials = $scope.selectedMaterials;
      $mdDialog.hide();
    };

    $scope.hide = function() {
      $mdDialog.hide();
    };

    $scope.cancel = function() {
      $mdDialog.cancel();
    };

    vm.resolveData=function (promise){
      if(promise){
        promise.then(function (d){
          $scope.elementData=d;
        });
      }

    };
  }
  function PromotionsVipCtrl(api, vipPromotionsList, $rootScope)
  {
    var vm=this;
    vm.promotion = {};

    vm.sortableOptions = {
      'ui-floating': true,
      stop: function(event, ui) {
        var ids = [];
        $.each($("li.sortable-vip-article"), function(key, value){
          ids.push($(value).attr('data-article-id'));
        });
        api.promotion.sortVip({ids: ids}).$promise.then(
          function (data) {
            vm.promotions = data;
            console.log(data);
          },
          function (err) {
            console.log(err);
          }
        );
      }
    };

    vm.promotions = vipPromotionsList;
    vm.searchingPromotion = {};

    vm.searchPromotion=function(term){

      if (term!==''){
        api.search.type({type:'PROMOTION',term:term}).$promise.then(
          function(data){
            vm.searchingPromotion = data;
          },
          function(err){
            console.log(err);
          }
        );
      }
    };

    vm.addVip = function(id,index) {
      $rootScope.loadingProgress = true;
      api.promotion.setVip({id: id, set: 1}).$promise.then(
        function (data) {
          vm.promotions.push(data);
        },
        function (err) {
          console.log(err);
          if (err.data.error)
            swal('Error',err.data.error,'error');
        }
      );
      $rootScope.loadingProgress = false;
    };

    vm.delVip = function(id,index) {
      $rootScope.loadingProgress = true;
      api.promotion.setVip({id: id, set: 0}).$promise.then(
        function (data) {
          vm.promotions.splice(index,1);
        },
        function (err) {
          console.log(err);
          if (err.data.error)
            swal('Error',err.data.error,'error');
        }
      );
      $rootScope.loadingProgress = false;
    }
  }

  function PromotionsTrashCtrl(api, $timeout, $element, $mdToast, $scope, trashedPromotionsList, $stateParams, $state, $rootScope) {
    var vm = this;
    vm.filter = {};
    vm.filter.search = $stateParams.search;
    vm.pagination = trashedPromotionsList;

    console.log(vm.pagination);

    vm.onSearchChange = function($event) {
      $event.stopPropagation();
    }
    vm.refreshPromotions = function () {
        console.log(vm.filter);
        $state.go('.', {page: 1, search: vm.filter.search});
    }

    vm.restore = function (id, key) {
      $rootScope.loadingProgress = true;
      api.promotion.restore({id: id}).$promise.then(
        function (data) {
          $mdToast.show($mdToast.simple()
            .textContent('Promoción restaurada con éxito.')
            .position('bottom right'));
          vm.pagination.data.splice(key,1);
          $rootScope.loadingProgress = false;
        },
        function (err) {
          console.log(err);
          $rootScope.loadingProgress = false;
        });
    }
  }
})();

(function()
{
	'use strict';

	angular
    	.module('app.promotions')
		.controller('DialogPromotionsCtrl', DialogPromotionsCtrl);

  /** @ngInject */
	function DialogPromotionsCtrl($scope, api,$filter) {
	    var modal = this;
	    // Recuperamos  el objeto promotion para manejarlo en la modal
	    modal.promotion = $scope.vm.promotion;

      console.log(modal.promotion);

	    if ($scope.opt['type'] == 'article') {
	    	if (modal.promotion.articles && modal.promotion.articles.length > 0)
	    		$scope.selectedArticles = modal.promotion.articles;
	    	else $scope.selectedArticles = []
		}
	    else if ($scope.opt['type'] == 'material') {
	    	if (modal.promotion.materials && modal.promotion.materials.length > 0)
	    		$scope.selectedMaterials = modal.promotion.materials;
	    	else $scope.selectedMaterials = []
		}

	    modal.setItem = function(article) {
		    if ($scope.opt['type'] == 'article') {
          if($filter('filter')($scope.selectedArticles, {id: article.id}).length==0){
            $scope.selectedArticles.push(article);
          }
	    	} else if ($scope.opt['type'] == 'material') {
          if($filter('filter')($scope.selectedMaterials, {id: article.id}).length==0){
            $scope.selectedMaterials.push(article);
          }
	    	}
	    };

	    modal.delItem = function(type,key) {
        var selected=false;
        type == 'article' ? selected = $scope.selectedArticles : type == 'material' ? selected=$scope.selectedMaterials : false ;
        if(selected){
          selected.splice(key,1);
        }

	    };

	    $scope.withOutResults=false;
	    modal.searchArticle=function(term){
	      $scope.elementData={};
	      if (term!==''){
	        $scope.loadingSearch=true;
	        $scope.withOutResults=false;
	        api.search.type({type:'ARTICLE',term:term}).$promise.then(function(d){
	          $scope.elementData=d;
	          if (d.length<1){
	            $scope.withOutResults=true;
	          }
	          $scope.loadingSearch=false;
	        });
	      }
	    };
	    modal.searchMaterial=function(term){
	      $scope.elementData={};
	      if (term!==''){
	        $scope.loadingSearch=true;
	        $scope.withOutResults=false;
	        api.search.type({type:'MATERIAL',term:term}).$promise.then(function(d){
	          $scope.elementData=d;
	          if (d.length<1){
	            $scope.withOutResults=true;
	          }
	          $scope.loadingSearch=false;
	        });
	      }
	    };

	    modal.confirm = function() {

	    };

	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.pharmacies', ['datatables'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
            $stateProvider
                .state('app.pharmacies', {
                    url     : '/admin/pharmacies',
                    views   : {
                        'content@app': {
                            templateUrl : 'app/main/admin/pharmacies/views/listPharmacies.html',
                            controller  : 'PharmaciesMainCtrl as vm'
                        }
                    },
                  resolve: {
                    access: ["Access", function (Access) { return Access.hasRole('admin'); }],
                  }
                });

            $stateProvider
                .state('app.pharmacy-create', {
                    url     : '/admin/pharmacy/create',
                    views   : {
                        'content@app': {
                            templateUrl : 'app/main/admin/pharmacies/views/createPharmacy.html',
                            controller  : 'PharmaciesCreateCtrl as vm'
                        }
                    },
                    resolve: {
                        listUsers: function(api) {
                            return api.user.list().$promise;
                        }
                    }
                });

                $stateProvider
                    .state('app.pharmacy-edit', {
                        url     : '/admin/pharmacy/edit/:idPharmacy',
                        views   : {
                            'content@app': {
                                templateUrl : 'app/main/admin/pharmacies/views/createPharmacy.html',
                                controller  : 'PharmacyEditCtrl as vm'
                            }
                        },
                        resolve: {
                            access: ["Access", function (Access) { return Access.hasRole('admin'); }],
                            pharmacyEdit: function(api, $stateParams) {
                                return api.pharmacy.get({id:$stateParams.idPharmacy}).$promise;
                            }
                        }
                    });


        msNavigationServiceProvider.saveItem('manager.pharmacies', {
            title    : 'Farmacias',
            icon     : 'icon-store',
            state    : 'app.pharmacies',
            access   : {
              roles : ['admin']
            },
            /*stateParams: {
                'param1': 'page'
             },*/
            weight   : 1
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pharmacies')
        .controller('PharmaciesMainCtrl', PharmaciesMainCtrl);

    function PharmaciesMainCtrl(api, $timeout, $element, $mdToast, $scope)
    {
        var vm = this;

        vm.onSearchChange = function($event) {
            $event.stopPropagation();
        }

        vm.statusToggle = function (idPharmacy, key){
            api.pharmacy.statusToggle({idPharmacy:idPharmacy})
            .$promise
            .then(function(data){
                vm.pharmacies[key].status = data.status;
                $mdToast.show($mdToast.simple().textContent('Farmacia actualizada con éxito.').position('bottom right'));
            });
        };

        vm.destroy = function(id, key) {
            api.pharmacy.remove({id:id})
            .$promise.then(function (){
                $mdToast.show($mdToast.simple().textContent('Farmacia eliminada con éxito.').position('bottom right'));
                vm.pharmacies.splice(key,1);
            });
        };

        api.pharmacy.listWithUsers(
            function(d) {
                vm.pharmacies = d;
            }, function(err) {
                console.log(err);
            }
        );
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pharmacies')
        .controller('PharmacyEditCtrl', PharmacyEditCtrl);

    function PharmacyEditCtrl(api, $timeout, $element, $mdToast, $scope, pharmacyEdit)
    {
        var vm = this;


        vm.pharmacy = pharmacyEdit;

        api.user.list(
            function(d){
                vm.users = d;
            },
            function(err) {
                console.log(err);
            }
        );

        vm.onSearchChange = function($event) {
            $event.stopPropagation();
        };

        vm.store = function(){

           vm.pharmacy.$update({id:vm.pharmacy.id})
            .then(function(response){
                    vm.pharmacy=response;    
                  $mdToast.show($mdToast.simple()
                       .textContent('Farmacia '+vm.pharmacy.id+' actualizada con éxito.')
                       .position('bottom right'));  
            })

            /*api.pharmacy.get({id:vm.pharmacy.id},function(data){
                
                data.email = "asdnjk";
                data.$update({id:vm.pharmacy.id})
                    .then(
                        function(d){
                            console.log(d);

                        })
                    ;
            });
*/

            // api.pharmacy.update({id:vm.pharmacy.id, }).$promise.then(
            //     function(data) {
            //         $mdToast.show($mdToast.simple()
            //             .textContent('Farmacia '+vm.pharmacy.id+' actualizada con éxito.')
            //             .position('bottom right'));
            //     },
            //     function (err) {
            //         console.log(err);
            //     }
            // );
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pharmacies')
        .controller('PharmaciesCreateCtrl', PharmaciesCreateCtrl);

    function PharmaciesCreateCtrl(api, $timeout, $element, $mdToast, $scope, listUsers)
    {
        var vm = this;
        vm.users = listUsers;
        vm.pharmacy ={};

        vm.onSearchChange = function($event) {
            $event.stopPropagation();
        };

        vm.create = function(){
            api.users.list(
            	function(d){
            		vm.users = d;
            	},
            	function(err){
            		console.log(err);
            	}
        	);
        };

        vm.store = function() {
            var record = new api.pharmacy (vm.pharmacy);

            record.$save().then(
                function(data){
                    $mdToast.show($mdToast.simple().
                        textContent('Farmacia '+vm.pharmacy.name+' creada con éxito.').
                        position('bottom right'));
                    // vm.pharmacy = '';
                    // vm.fpharmacy.$setPristine(true);
                    // vm.fpharmacy.$setUntouched();
                },
                function (err){
                    console.log(err);
                }
            );
        };
    }
})();
(function()
{
	'use strict';

	/** @ngInject */
	angular
		.module('app.orders',[])
		.config(config);

	function config($stateProvider, msNavigationServiceProvider) {
		$stateProvider
			.state('app.orders', {
				state: 'app.orders',
				url: '/admin/orders?page&search&from&to&pending&sellers',
				views: {
					'content@app': {
						templateUrl: 'app/main/admin/orders/views/listOrders.html',
						controller: 'OrdersMainCtrl as vm'
					}
				},
        params: {
          page: {
            value: '1',
            squash: true
          },
          search: {
            value: '',
            squash: true
          },
          from: {
            value: '',
            squash: true
          },
          to: {
            value: '',
            squash: true
          } ,
          pending: {
            value: '',
            squash: true
          },
          sellers: {
            value: '',
            squash: true
          }
        },
				resolve: {
          access: ["Access", function (Access) { return Access.hasAnyRole(['admin','comercial']); }],
					orders: function (api, $stateParams) {
            return api.order.paginatedList({page: $stateParams.page,
              search: $stateParams.search,
              from:$stateParams.from,
              to:$stateParams.to,
              pending:$stateParams.pending,
              sellers:$stateParams.sellers,
            }).$promise;
          }
				}
			});

    $stateProvider
      .state('app.orders-edit', {
        state: 'app.orders-edit',
        url: '/admin/orders/edit/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/orders/views/showOrder.html',
            controller: 'OrdersEditCtrl as vm'
          }
        },
        resolve: {
          access: ["Access", function (Access) { return Access.hasAnyRole(['admin','comercial']); }],
          order: function (api, $stateParams) {
            return api.order.get({id:$stateParams.id}).$promise;
          }
        }
      });

    //msNavigationServiceProvider.saveItem('manager.orders', {
    //  title    : 'Pedidos',
    //  icon     : 'fa fa-truck',
    //  state    : 'app.orders',
    //  /*stateParams: {
    //   'param1': 'page'
    //   },*/
    //  weight   : 5
    //});a
	}
})();

(function()
{
	'use strict';

	angular
		.module('app.orders')
		.controller('OrdersMainCtrl', OrdersMainCtrl)
		.controller('OrdersEditCtrl', OrdersEditCtrl);

	function OrdersMainCtrl(orders,api,$mdToast,msNavigationService,$http,$stateParams,$state,UserProfile,CartMessage,myConfig,$auth) {

	var vm = this;
    vm.filter = {};
    vm.filter.search = $stateParams.search;
    vm.filter.pending = $stateParams.pending ? JSON.parse($stateParams.pending):null;
    vm.filter.from = $stateParams.from ? moment($stateParams.from,'DD-MM-YYYY').toDate():null;
    vm.filter.to = $stateParams.to ? new moment($stateParams.to,'DD-MM-YYYY').toDate():null;
    vm.filter.sellers = $stateParams.sellers.split(',');
    vm.pagination = orders;
    vm.api = api.promotion.paginatedList;

    vm.export={};
    vm.exportByDate=false;
    console.log($state.params);
    vm.hasAdminAccess=false;
    vm.showMoreOptions=false;
    vm.currentMonth=moment().month()+1;

    vm.headExport={};
    vm.headExport.month=vm.currentMonth;
    vm.headExport.year=(new Date()).getFullYear();
    vm.headExport.years=[];
    //Saver si es admin o no para mostrar botones de modificar / cancelar
    UserProfile.then(function(userProfile){
        userProfile.$refresh().then(function(u){
            vm.hasAdminAccess=u.$hasAnyRole(['admin']);
        })
    });

    //inicializar los años del select para la exportacion de cabeceras

    for (var i = 2016; i <= (new Date()).getFullYear(); i++) {
        vm.headExport.years.push(i);
    }

    //Obtener cuantos parametros estan en uso
    function checkParams (obj){
        var found=0;
        Object.keys(obj).forEach(function(key) {
            if(key!=='page'&&key!=='pending'){
                if(obj[key].trim()!==''){
                  found++;
                }
            }
        });
        if(obj.pending=="true") found++;
        return found;
    }
    vm.showFilter=checkParams($state.params);
    //Inicializamos el objeto de custom orders
    vm.customOrders=[];
    vm.sellers=[];

    //Obtenemos los posibles vendedores para filtrar
    api.user.sellers().$promise.then(function (d) {
       vm.sellers=d;
    });

    //Cancelar pedido si no esta tramitado.
    vm.cancel= function (order,key){
      swal({
        title:"¿Desea cancelar el pedido?",
        type:"question",
        showCancelButton: true,
        cancelButtonText:"No",
        cancelButtonClass: 'md-button md-raised md-background-bg md-hue-1',
        cancelButtonColor: "#f5f5f5",
        confirmButtonText:"Confirmar",
        confirmButtonClass: 'md-button md-raised md-primary',
      }).then(function (isConfirm) {
        if (isConfirm === true) {
          api.order.cancel({'order':order}).$promise.then(function(){
            vm.resfreshMyOrder();
            $mdToast.show($mdToast.simple()
              .textContent('Pedido cancelado con éxito.')
              .position('bottom right'));
          });
        }
      });
    };



    vm.confirm= function (order){
        swal({
            title:"¿Desea confirmar el pedido?",
            type:"question",
            showCancelButton: true,
            cancelButtonText:"No",
            cancelButtonClass: 'md-button md-raised md-background-bg md-hue-1',
            cancelButtonColor: "#f5f5f5",
            confirmButtonText:"Confirmar",
            confirmButtonClass: 'md-button md-raised md-primary',
        }).then(function (isConfirm) {
            if (isConfirm === true) {
                api.order.adminConfirm({order:order.id}).$promise.then(function(d){
                    order.status='accepted';
                    $mdToast.show($mdToast.simple()
                        .textContent('Pedido procesado.')
                        .position('bottom right'));
                    vm.order=d;

                },function(err){
                    if (err.status==423){
                        CartMessage.render(err.data.message,err.data.out_stock_items);
                    }
                })
            }
        });
        };


    vm.resfreshMyOrder=function(){
      api.order.list().$promise.then(function(d){
        vm.myOrders=d;
      });
    }
  //Exportaciones de pedidos por dias
    vm.exportOrders = function (when){
      var from;
      var to;
      if(when=='today'){
        from=moment(new Date).format('DD-MM-YYYY');
        to=moment(new Date).format('DD-MM-YYYY');
      }else{
        from=moment(vm.export.from).format('DD-MM-YYYY');
        to=moment(vm.export.to).format('DD-MM-YYYY');
      }
      var query;
      if(when=='custom'){
        query={custom:vm.customOrders.join(),check:true}
      }else{
        query={from:from,to:to,check:true};
      }

      api.order.export(query).$promise.then(function(d){
        if(d.items>0){
          location.href=d.url;
        }else{
          swal(
            'Sin pedidos',
            'No hay ningun pedido confirmado en la fecha o id seleccionado.',
            'warning'
          )
        }
      },function(err){
        swal(
          'Error en la exportación',
          'Se produjo un error al exportar los pedidos seleccionados',
          'error'
        )
        console.log(err)
      });
    }

    vm.exportToday=function(){
      var d = new Date;
      console.log()
    }

    vm.refreshOrders = function(){
      var filter={};
      filter.from=vm.filter.from?moment(vm.filter.from).format('DD-MM-YYYY'):null;
      filter.to=vm.filter.to?moment(vm.filter.to).format('DD-MM-YYYY'):null;
      filter.search=vm.filter.search;
      filter.pending=JSON.parse(vm.filter.pending);
      filter.sellers=vm.filter.sellers.join();
      filter.page=1;
      $state.go('.', filter);
    };
    vm.clearFilter=function(){
          $state.go('.', {from:null,to:null,search:null,pending:null,sellers:null});
        };
    vm.applyMonthlyDiscount=function(order){

        api.order.applyMonthlyDiscount({order:order.id}).$promise.then(function(d){
            $mdToast.show($mdToast.simple()
              .textContent('Descuento aplicado')
              .position('bottom right'));
            vm.genericRefresh();
        },function(err){console.log(err)})
    };

    vm.applyAdvanceMonthlyDiscount=function(order){
        swal({
        title:"¿Está seguro de aplicar el anticipo de descuento?",
        type:"question",
        showCancelButton: true,
        cancelButtonText:"No",
        cancelButtonClass: 'md-button md-raised md-background-bg md-hue-1',
        cancelButtonColor: "#f5f5f5",
        confirmButtonText:"Si",
        confirmButtonClass: 'md-button md-raised md-primary',
      }).then(function (isConfirm) {
        api.order.applyAdvanceMonthlyDiscount({order:order.id}).$promise.then(function(d){
            $mdToast.show($mdToast.simple()
              .textContent('Descuento aplicado')
              .position('bottom right'));
            vm.genericRefresh();
        },function(err){console.log(err)})
      });

    };

    vm.deleteMonthlyDiscount=function(order){
        api.order.deleteMonthlyDiscount({order:order.id}).$promise.then(function(d){
            $mdToast.show($mdToast.simple()
              .textContent('Descuento eliminado')
              .position('bottom right'));
            vm.genericRefresh();
        },function(err){console.log(err)})
    };

    vm.genericRefresh=function(){
        api.order.paginatedList({page: $stateParams.page,
              search: $stateParams.search,
              from:$stateParams.from,
              to:$stateParams.to,
              pending:$stateParams.pending,
              sellers:$stateParams.sellers,
            }).$promise.then(function(d){
                vm.pagination=d;
        });
    };
    vm.processHeadExport=function(){
        location.href=myConfig.endPointApi+'order/export-heads?token='+$auth.getToken()+'&month='+vm.headExport.month+'&year='+vm.headExport.year;
    }


}






  function OrdersEditCtrl (order,api,$mdToast,ElementSelection,$mdDialog,$scope,$rootScope,CartMessage,UserProfile){
    var vm=this;
    vm.order=order;
    vm.hasAdminAccess=false;
      //Saver si es admin o no para mostrar botones de modificar / cancelar

    UserProfile.then(function(userProfile){
         userProfile.$refresh().then(function(u){
             vm.hasAdminAccess=u.$hasAnyRole(['admin']);
         })
    });


    // Eliminar linea de un pedido (Elimina linea del carrito asociado al pedido , actualiza el pedido y recarga el pedido)
    vm.detailDestroy=function (detail){
      swal({
        title:"¿Desea eliminar la linea?",
        type:"question",
        showCancelButton: true,
        cancelButtonText:"No",
        cancelButtonClass: 'md-button md-raised md-background-bg md-hue-1',
        cancelButtonColor: "#f5f5f5",
        confirmButtonText:"Confirmar",
        confirmButtonClass: 'md-button md-raised md-primary',
      }).then(function (isConfirm) {
          console.log(isConfirm);
        if (isConfirm === true) {
          api.order.detailDestroy({'order':order.id,'detail':detail}).$promise.then(function(res){
            vm.order=res;
            $mdToast.show($mdToast.simple()
              .textContent('Linea de pedido eliminada.')
              .position('bottom right'));
          });
        }
      });

    };
    vm.showSelectElement = function (type){

      var element = ElementSelection.type(type);
      $scope.showQtyInputs=true;
      $mdDialog.show({
        controller: 'DialogRulesCtrl as modal',
        templateUrl: element.template,
        parent: angular.element(document.body),
        //targetEvent: event,
        resolve: element.resolve,
        scope: $scope,
        preserveScope: true,
        clickOutsideToClose:true,
        fullscreen: true
      }).finally(function(){
        // console.log($scope.selectedElement);
        api.order.addItem({ order: vm.order.id, id: $scope.selectedElement.id, type: $scope.selectedElement.type, qty: $scope.selectedElement.selectedQty,refreshOrder:'true'}).$promise.then(function(data){
          vm.order=data;
        },function(err){
          if(err.status==423){
            swal({
              title:"¡Atención!",
              text:'El elemento seleccionado ya se encuentra en el pedido, revíselo.',
              type:"warning",
              cancelButtonColor: "#f5f5f5",
              confirmButtonText:"Aceptar",
              confirmButtonClass: 'md-button md-raised md-primary',
            })
          }
          if(err.status==416){
            swal({
              title:"¡Atención!",
              text:err.data.message,
              type:"warning",
              cancelButtonColor: "#f5f5f5",
              confirmButtonText:"Aceptar",
              confirmButtonClass: 'md-button md-raised md-primary',
            })
          }
        });
        // Al cerrar la ventana
        delete $scope.selectedElement;
        delete $scope.elementData;

      });
      vm.resolveData(element.getData());
    };
    vm.resolveData=function (promise){
      if(promise){
        promise.then(function (d){
          console.log(d);
          $scope.elementData=d;
        });
      }
    };

    $rootScope.$on('refresh-order',function (event, d){
      vm.order = d;
    });

    vm.adminConfirm=function(){
      api.order.adminConfirm({order:vm.order.id}).$promise.then(function(d){
        $mdToast.show($mdToast.simple()
          .textContent('Pedido procesado.')
          .position('bottom right'));
        vm.order=d;

      },function(err){
        if (err.status==423){
          CartMessage.render(err.data.message,err.data.out_stock_items);
        }
      })
    };

    vm.applyMonthlyDiscount=function(order){

        api.order.applyMonthlyDiscount({order:order.id}).$promise.then(function(d){
            $mdToast.show($mdToast.simple()
              .textContent('Descuento aplicado')
              .position('bottom right'));
            vm.genericRefresh();
        },function(err){console.log(err)})
    };

    vm.applyAdvanceMonthlyDiscount=function(order){
        api.order.applyAdvanceMonthlyDiscount({order:order.id}).$promise.then(function(d){
            $mdToast.show($mdToast.simple()
              .textContent('Descuento aplicado')
              .position('bottom right'));
            vm.genericRefresh();
        },function(err){console.log(err)})
    };

    vm.deleteMonthlyDiscount=function(order){
        api.order.deleteMonthlyDiscount({order:order.id}).$promise.then(function(d){
            $mdToast.show($mdToast.simple()
              .textContent('Descuento eliminado')
              .position('bottom right'));
            vm.genericRefresh();
        },function(err){console.log(err)})
    };


    vm.genericRefresh=function () {
        api.order.get({id:vm.order.id}).$promise.then(function (o) {
            vm.order=o;
        })
    }


  }
})();

(function()
{
	'use strict';

	angular
		.module('app.materials',['datatables'])
		.config(config);

	function config($stateProvider, msNavigationServiceProvider)
	{
		$stateProvider
			.state('app.materials', {
				url		: '/admin/materials?page',
				views	: {
					'content@app': {
						templateUrl : 'app/main/admin/materials/views/listMaterials.html',
						controller	: 'MaterialsMainCtrl as vm',
			            params: {
			              page: {
			                value: '1',
			                squash: true
			              }
			            }
					}
				},
        resolve: {
          access: ["Access", function (Access) { return Access.hasRole('admin'); }],
          materialsList: function (api) {
            return api.material.list().$promise;
          }
        }
			});

		$stateProvider
			.state('app.materials-create', {
				url 	: '/admin/materials/create',
				views	: {
					'content@app': {
						templateUrl : 'app/main/admin/materials/views/createMaterial.html',
						controller	: 'MaterialsCreateCtrl as vm'
					}
				},
        resolve: {
          access: ["Access", function (Access) { return Access.hasRole('admin'); }],
          // campaignsList: function(api) {
          //   return api.campaign.list().$promise;
          // },
          categoriesList: function (api) {
            return api.category.list().$promise;
          }
        }
			});

		$stateProvider
			.state('app.materials-edit', {
				url 	: '/admin/materials/edit/:idMaterial',
				views	: {
					'content@app': {
						templateUrl : 'app/main/admin/materials/views/createMaterial.html',
						controller	: 'MaterialsEditCtrl as vm'
					}
				},
				resolve : {
          access: ["Access", function (Access) { return Access.hasRole('admin'); }],
          // campaignsList: function(api) {
          //   return api.campaign.list().$promise;
          // },
          campaignsIds: function(api, $stateParams) {
            return api.material.campaignsIds({idMaterial: $stateParams.idMaterial}).$promise;
          },
					materialEdit: function(api, $stateParams) {
						return api.material.get({id:$stateParams.idMaterial}).$promise;
					},
          uploadsList: function (api, $stateParams) {
            return api.material.uploadList({idMaterial: $stateParams.idMaterial, type: 'image'}).$promise;
          },
          categoriesList: function (api) {
            return api.category.list().$promise;
          }
				}
			});

        msNavigationServiceProvider.saveItem('manager.materials', {
            title    : 'Materiales',
            icon     : 'icon-presentation',
            state    : 'app.materials',
            access   :  {
              //authtenticated:true,
              roles : ['admin']
            },
            /*stateParams: {
                'param1': 'page'
             },*/
            weight   : 14
        });
	}
})();

(function ()
{
	'use strict';

	angular
		.module('app.materials')
		.controller('MaterialsMainCtrl', MaterialsMainCtrl);

	function MaterialsMainCtrl(api, $timeout, $element, $mdToast, $scope, materialsList)
	{
		var vm = this;
    vm.materials = materialsList;

		vm.onSearchChange = function($event) {
			$event.stopPropagation();
		}

		vm.toggleStatus = function(idMaterial, key) {
			api.material.toggleStatus({idMaterial:idMaterial})
			.$promise
			.then(function(data){
				vm.materials[key].status = data.status;
				$mdToast.show($mdToast.simple()
					.textContent('Material actualizado con éxito.')
					.position('bottom right'));
			});
		};

		vm.destroy = function(id, key) {
			api.material.remove({id:id})
			.$promise.then(function(){
				$mdToast.show($mdToast.simple()
					.textContent('Material eliminado con éxito.')
					.position('bottom right'));
        vm.materials.splice(key,1);
			});
		};

    vm.onSearchChange = function($event) {
      $event.stopPropagation();
    };
	}
})();

(function ()
{
	'use strict';

	angular
		.module('app.materials')
		.controller('MaterialsEditCtrl', MaterialsEditCtrl);

	function MaterialsEditCtrl(api, $timeout, $element, $mdToast, $scope, materialEdit, uploadsList, Uploader, TextEditor, categoriesList, campaignsIds, $rootScope)
	{
		var vm = this;

		vm.material = materialEdit;
    // vm.campaigns = campaignsList;
    vm.material.campaigns = campaignsIds;
    vm.categories = categoriesList;

		vm.onSearchChange = function($event) {
			$event.stopPropagation();
		};

		vm.store = function(){
      console.log(vm.material);
			vm.material.$update({id:vm.material.id})
				.then(function(response){
					$mdToast.show($mdToast.simple()
						.textContent('Material ' + vm.material.name + ' actualizado con éxito.')
						.position('bottom right'));
          vm.uploader.extra={
            attachable_id: data.id,
            attachable_type:"MATERIAL",
            type: "IMAGE",
          };
          // Subimos todas las fotos
          vm.uploader.uploadAll();
				});
		};

    vm.refreshImages = function (){
      api.material.uploadList({idMaterial:vm.material.id,type:'image'}).$promise
        .then(
          function(d){
            vm.uploadImages=d;
          }
        )
        .catch(
          function (e){
            console.log(e);
          }
        )
    };
    vm.uploadImages = uploadsList;

    vm.uploader = Uploader.getInstance();
    vm.uploader.extra={
      attachable_id:vm.material.id,
      attachable_type:"MATERIAL",
      type: "IMAGE"
    };
    vm.uploadAction = function () {
      console.log(vm.uploader);
      vm.uploader.uploadAll();
    };
    vm.uploader.postDeleteItem=function (){
      vm.refreshImages();
    };
    vm.uploader.onCompleteAll = function() {
      vm.refreshImages();
    };

    vm.tinymceOptions = TextEditor;

    $rootScope.$on('new-category',function (event, d){
      api.category.list(
        function(d){
          vm.categories = d;
        },function(err) {
          console.log(err);
        }
      );
      vm.material.category_id = d.id;
    });
	}

})();

(function(){

	'use strict';

	angular
		.module('app.materials')
		.controller('MaterialsCreateCtrl', MaterialsCreateCtrl);

	function MaterialsCreateCtrl(api,$state ,$timeout, $element, $mdToast, $scope, Uploader, TextEditor, categoriesList, $rootScope)
	{
		var vm = this;
		vm.material = {};
    // vm.campaigns = campaignsList;
    vm.categories = categoriesList;

		vm.onSearchChange = function($event) {
			$event.stopPropagation();
		};

		vm.store = function() {
			var record = new api.material (vm.material);
			record.$save().then(
				function(data) {
					$mdToast.show($mdToast.simple()
						.textContent('Material ' + vm.material.name + ' creado con éxito.')
						.position('bottom right'));
            vm.uploader.extra={
              attachable_id: data.id,
              attachable_type:"MATERIAL",
              type: "IMAGE"
            };
             vm.uploader.uploadAll();
				}, function (err) {
					console.log(err);
				}
			);
		};

    vm.refreshImages = function (){
      api.upload.type({type:"image"}).$promise
        .then(
          function(d){
            vm.uploadImages=d;
          }
        )
        .catch(
          function (e){
            console.log(e);
          }
        )
    };

    vm.uploader = Uploader.getInstance();
    vm.uploader.extra={
      attachable_id: vm.material.id,
      attachable_type:"MATERIAL",
      type: "IMAGE"
    };
    vm.uploadAction = function () {
      vm.uploader.uploadAll();
    };
    vm.uploader.postDeleteItem=function (){
      vm.refreshImages();
    };
    vm.uploader.onCompleteAll = function() {
      $state.go('app.materials');
    };
    vm.uploader.autoUpload = false;

    vm.material.description = 'Descripción';
    vm.tinymceOptions = TextEditor;

    $rootScope.$on('new-category',function (event, d){
      api.category.list(
        function(d){
          vm.categories = d;
        },function(err) {
          console.log(err);
        }
      );
      vm.material.category_id = d.id;
    });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.imports', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,  msNavigationServiceProvider   )
    {
        // State
        $stateProvider
            .state('app.import', {
                url    : '/admin/importar',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/admin/imports/views/create.html',
                        controller : 'ImportsController as vm'
                    }
                },
                resolve: {
                    access: ["Access", function (Access) { return Access.hasRole('admin'); }]
                }
            });



         msNavigationServiceProvider.saveItem('manager.utils.imports', {
             title    : 'Importaciones',
             icon     : 'fa fa-upload',
             state    : 'app.import',
             weight   : 15,
             access   :  {
               //authtenticated:true,
               roles : ['admin']
             },

         });


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.imports')
        .controller('ImportsController', make);

    /** @ngInject */
    function make(Uploader,myConfig,api,$mdToast,$state,$location){
        var vm = this;

        vm.uploader= Uploader.getInstance();
        vm.uploader.autoUpload=false;
        vm.uploader.queueLimit=1;
        vm.uploader.url=myConfig.endPointApi+'import';

        vm.uploader.extra={
          type: "FILE",
        };

        vm.uploader.onSuccessItem = function(fileItem, response, status, headers) {
        if (status==201){
          swal(
            'Perfecto!',
            'Importacíon terminada',
            'success'
          );
          vm.importing=false;
          vm.uploader.clearQueue();
        }
      };
      vm.uploader.onAfterAddingAll  = function (files){
        if(files[0].file.size > 60000000){
          vm.uploader.clearQueue();
          swal(
            'Error!',
            'Limite  60MB',
            'error'
          );
        }
      };
      vm.uploader.onErrorItem = function(fileItem, response, status, headers) {
            swal({
                title : "¡Error!",
                text  : "No se pudo subir el archivo.Msg:"+response.message+" Status:  "+status,
                type  : "error"
            });
            vm.importing=false;
            vm.uploader.clearQueue();
        };

      vm.run=function(type){
          vm.importing=true;
          if(type=='upload'){
            vm.uploader.extra.importType=vm.importType;
            vm.uploader.extra.image_element_type=vm.imageElementType;

            if(vm.importType=='upimages' && !vm.imageElementType){
              swal(
                'Error!',
                'Seleccione un tipo de importacion de fotos',
                'error'
              );
              return false;
            }
            vm.uploader.uploadAll();
          }else if (type=='action'){
           var  options={
              type:'action',
              importType:vm.importType,
              image_element_type:vm.imageElementType
            };
            api.import.import({options:options}).$promise.then(function(d){
              if (d.status==201){
                swal(
                  'Perfecto!',
                  'Importacíon terminada',
                  'success'
                );
              }
              vm.importing=false;
            },function(err){
              vm.importing=false;
              console.log(err);
            });
          }

        }

    }



})();

(function ()
{
    'use strict';

    angular
        .module('app.home', [
          'datatables',
          'flow',
          'nvd3',
          'textAngular',
          'uiGmapgoogle-maps',
          'xeditable'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider , msNavigationServiceProvider)
    {
        // State
        $stateProvider

            .state('app.home', {
                url    : '/admin',
                views  : {
                    'content@app': {
                      templateUrl: 'app/main/admin/home/dashboard.html',
                      controller : 'DashboardEcommerceController as vm'
                    }
                },
                resolve: {
                  access: ["Access", function (Access) { return Access.hasAnyRole(['admin']); }]

                },
                bodyClass: 'ecommerce'
            });



    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.home')
        .controller('DashboardEcommerceController', DashboardEcommerceController);

    /** @ngInject */
    function DashboardEcommerceController(api,myConfig)
    {
        var vm = this;
        api.stat.sellersRank().$promise.then(function(d){
            vm.donutChart = {
                totalOrders : d.total_orders,
                options: {
                    chart: {
                        type      : 'pieChart',
                        height    : 450,
                        donut     : true,
                        labelType   : function (d) {
                            return d.data.key + ' : ' +d.data.y;
                        },
                        x         : function (d)
                        {
                            return d.key;
                        },
                        y         : function (d)
                        {
                            return d.y;
                        },
                        showLabels: true,
                        labelThreshold:0.05,
                        color:['#7986CB','#43A047','#D500F9','#D4E157','#D81B60','#7986CB','#B0BEC5'],
                        pie               : {
                            startAngle: function (d)
                            {
                                return d.startAngle / 2 - Math.PI / 2;
                            },
                            endAngle  : function (d)
                            {
                                return d.endAngle / 2 - Math.PI / 2;
                            }
                        },
                        transitionDuration: 500,
                        legend            : {
                            margin: {
                                top   : 5,
                                right : 70,
                                bottom: 5,
                                left  : 0
                            }
                        }
                    }
                },
                data: d.data

            };
        });


        api.stat.orderCountByDate().$promise.then(function(d){
          vm.widget1=d;
        });

        api.stat.orderAmountByDate().$promise.then(function(d){
          vm.widget2=d;
        });
        api.stat.orderWeekGraphic().$promise.then(function(data){
          vm.widget5 = {
            title       : data.title,
            mainChart   : {
              config : {
                refreshDataOnly: true,
                deepWatchData  : true
              },
              options: {
                chart: {

                  yDomain: [0,10],
                  type        : 'discreteBarChart',
                  color       : ['#03a9f4', '#b3e5fc'],
                  height      : 420,
                  margin      : {
                    top   : 8,
                    right : 16,
                    bottom: 32,
                    left  : 32
                  },
                  clipEdge    : true,
                  groupSpacing: 0.3,
                  reduceXTicks: false,
                  stacked     : true,
                  duration    : 250,
                  x           : function (d)
                  {
                    return d.x;
                  },
                  y           : function (d)
                  {
                    return d.y;
                  },
                  yAxis: {
                    axisLabel: 'Pedidos',
                    tickFormat: function(d){
                      return d3.format('d')(d);
                    },
                  },


                  legend      : {
                    margin: {
                      top   : 8,
                      bottom: 32
                    }
                  },
                  controls    : {
                    margin: {
                      top   : 8,
                      bottom: 32
                    }
                  },
                  tooltip     : {
                    gravity: 's',
                    classes: 'gravity-s'
                  }
                }
              },
              data   : []
            },
            days        : ['Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab', 'Dom'],
            ranges      : data.ranges,
            currentRange: '',
            changeRange : function (range)
            {
              vm.widget5.currentRange = range;



              angular.forEach(data.mainChart, function (chartData, index)
              {
                //console.log(chartData,index);
                vm.widget5.mainChart.data[index] = {
                  key   : chartData.key,
                  values: chartData.values[range]
                };
              });
            },
            init        : function ()
            {

              vm.widget5.changeRange('TW');
            }
          };
          // Initialize Widget 5
          vm.widget5.init();
        });

        api.stat.orderHourGraphic().$promise.then(function(data){
          vm.widget7 = {
            title       : data.title,
            max_order : data.max_order,
            total_order : data.total_order,
            mainChart   : {
              config : {
                refreshDataOnly: true,
                deepWatchData  : true
              },
              options: {
                chart: {
                  type        : 'pieChart',
                  color       : ['#f44336', '#9c27b0', '#03a9f4','#69F0AE','#FF4081','#4CAF50','#448AFF','#CDDC39','#536DFE','#795548'],
                  height      : 400,
                  margin      : {
                    top   : 0,
                    right : 0,
                    bottom: 0,
                    left  : 0
                  },
                  donut       : true,
                  clipEdge    : true,
                  cornerRadius: 0,
                  labelType   : 'percent',
                  padAngle    : 0.02,
                  x           : function (d)
                  {
                    return d.label;
                  },
                  y           : function (d)
                  {
                    return d.value;
                  },

                  tooltip     : {
                    gravity: 's',
                    classes: 'gravity-s'
                  }
                }
              },
              data   : []
            },
            footerLeft  : data.footerLeft,
            footerRight : data.footerRight,
            ranges      : data.ranges,
            currentRange: '',
            changeRange : function (range)
            {
              vm.widget7.currentRange = range;

              angular.forEach(data.mainChart, function (data, index)
              {
                vm.widget7.mainChart.data[index] = {
                  label: data.label,
                  value: data.values[range]
                };
              });
            },
            init        : function ()
            {
              // Run this function once to initialize widget

              /**
               * Update the range for the first time
               */
              vm.widget7.changeRange('ALL');
            }
          };
          // Initialize Widget 6
          vm.widget7.init();
        });
        api.stat.userConnected().$promise.then(function(d){
          vm.widget3=d;
        });
        api.stat.resumeGeneral().$promise.then(function(d){
          vm.general=d;
        });

        api.stat.bestSalesArticles().$promise.then(function(d){
          vm.widget6=d;
        });

        api.export.info().$promise.then(function(d){
          vm.exportInfo=d;
        });

        vm.export=function(type){

          api.export.getMinToken().$promise.then(function(d){
              var actionUrl=myConfig.endPointApi+'export/'+type+'?token='+ d.token;

              if(type=='articles'){
                swal({
                  title: 'Espere',
                  text: 'Le aparecerá la descarga en unos segundos.',
                  type:'info'
                });
              }

              location.href=actionUrl;
          },
            function (err){
              swal(
                'Oops...',
                'Algo fue mal!',
                'error'
              );
              //console.log(err);
          });

          //var actionUrl=myConfig.endPointApi+'export/'+type;
          //
          //location.href=actionUrl;
        };





    }
})();

(function()
{
  'use strict';

  angular
    .module('app.articles',['datatables'])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider
      .state('app.articles',{
        url   : '/admin/articles?page&search',
        views : {
          'content@app' : {
            templateUrl : 'app/main/admin/articles/views/listArticles.html',
            controller    : 'ArticlesMainCtrl as vm',
            params: {
              page: {
                value: 1,
                squash: true
              },
              search: {
                value: '',
                squash: true
              }
            }
          }
        },
        resolve : {
          access: ["Access", function (Access) { return Access.hasRole('admin'); }],
          articlesList: function (api, $stateParams) {
            return api.article.paginatedList({items:12, page: $stateParams.page, search: $stateParams.search}).$promise;
          }
        }
      });

    $stateProvider
      .state('app.articles-create', {
        url   : '/admin/articles/create',
        views : {
          'content@app': {
            templateUrl : 'app/main/admin/articles/views/createArticle.html',
            controller  : 'ArticlesCreateCtrl as vm'
          }
        },
        resolve: {
          access: ["Access", function (Access) { return Access.hasRole('admin'); }],
        }
      });

    $stateProvider
      .state('app.articles-edit', {
        url   : '/admin/articles/edit/:idArticle',
        views : {
          'content@app': {
            templateUrl : 'app/main/admin/articles/views/createArticle.html',
            controller  : 'ArticlesEditCtrl as vm'
          }
        },
        resolve : {
          access: ["Access", function (Access) { return Access.hasRole('admin'); }],
          articleEdit: function(api, $stateParams) {
            return api.article.get({id:$stateParams.idArticle}).$promise;
          },
          uploadsList: function (api, $stateParams) {
            return api.article.uploadList({idArticle: $stateParams.idArticle, type: 'image'}).$promise;
          }
        }
      });
    //Articulos vips
    $stateProvider
      .state('app.articles-vip', {
        url   : '/admin/articles/vip',
        views : {
          'content@app': {
            templateUrl : 'app/main/admin/articles/views/vipArticles.html',
            controller  : 'ArticlesVipCtrl as vm'
          }
        },
        resolve: {
          access: ["Access", function (Access) { return Access.hasRole('admin'); }],
          vipArticlesList: function(api) {
            return api.article.getVip().$promise;
          }
        }
      });


    msNavigationServiceProvider.saveItem('manager', {
      title : 'GESTIÓN',
      icon: 'icon-cog',
      weight: 11,
      access   :  {
        //authtenticated:true,
        roles : ['admin','comercial']
      },
    });

    msNavigationServiceProvider.saveItem('manager.articles', {
      title   : 'Artículos',
      icon    : 'icon-desktop-tower',
      state   : 'app.articles',
      access   :  {
        //authtenticated:true,
        roles : ['admin']
      },
      weight  : 11
    });
  }
})();

(function()
{
  'use strict';

  angular
    .module('app.articles')
    .controller('GiftsMainCtrl', GiftsMainCtrl);

  function GiftsMainCtrl(api, $timeout, $element, $mdToast, $scope, giftsList)
  {
    var vm = this;
    vm.articles = giftsList;

    vm.destroy = function(id, key) {
      api.article.remove({id:id})
        .$promise.then(function(){
        $mdToast.show($mdToast.simple()
          .textContent('Producto eliminado con éxito.')
          .position('bottom right'));
        vm.articles.splice(vm.articles.indexOf(key,1));
      });
    };
  }
})();

(function()
{
  'use strict';

  angular
    .module('app.articles')
    .controller('GiftEditCtrl', GiftEditCtrl);

  function GiftEditCtrl(api, $timeout, $element, $mdToast, $scope, Uploader, TextEditor, giftEdit, uploadsList, $rootScope)
  {
    var vm = this;

    vm.article = giftEdit;

    api.category.list(
      function(d){
        vm.categories = d
      },function(err){
        console.log(err);
      }
    );

    vm.onSearchChange = function($event) {
      $event.stopPropagation();
    };

    vm.store = function() {
      vm.article.$update({id:vm.article.id})
        .then(function(response){
          $mdToast.show($mdToast.simple()
            .textContent('Regalo ' + vm.article.name + ' actualizado con éxito.')
            .position('bottom right'));
        })
    }

    vm.refreshImages = function (){
      api.article.uploadList({idArticle:vm.article.id,type:'image'}).$promise
        .then(
          function(d){
            vm.uploadImages=d;
          }
        )
        .catch(
          function (e){
            console.log(e);
          }
        )
    };
    vm.uploadImages = uploadsList;

    vm.uploader = Uploader.getInstance();
    vm.uploader.extra={
      attachable_id:vm.article.id,
      attachable_type:"ARTICLE",
      type: "IMAGE"
    };
    vm.uploadAction = function () {
      console.log(vm.uploader);
      vm.uploader.uploadAll();
    };
    Uploader.postDeleteItem=function (){
      vm.refreshImages();
    };
    Uploader.onCompleteAll = function() {
      vm.refreshImages();
    };

    vm.tinymceOptions = TextEditor;

    $rootScope.$on('new-category',function (event, d){
      api.category.list(
        function(d){
          vm.categories = d;
        },function(err) {
          console.log(err);
        }
      );
      vm.article.category_id = d.id;
    });
  }
})();

(function(){

  'use strict';

  angular
    .module('app.articles')
    .controller('GiftCreateCtrl', GiftCreateCtrl);

  function GiftCreateCtrl(api, $timeout, $element, $mdToast, $scope, Uploader, TextEditor, $rootScope)
  {
    var vm = this;
    vm.article = {};
    api.category.list(
      function (d) {
        vm.categories = d;
      }, function (err) {
        console.log(err);
      }
    );

    vm.uploader = Uploader.getInstance();
    vm.uploadAction = function () {
      console.log(vm.uploader);
      vm.uploader.uploadAll();
    };
    vm.uploader.postDeleteItem=function (){
      vm.uploader.refreshImages();
    };
    vm.uploader.onCompleteAll = function() {
      vm.uploader.refreshImages();
    };
    vm.uploader.autoUpload = false;

    vm.onSearchChange = function($event) {
      $event.stopPropagation();
    };

    vm.store = function() {
      var record = new api.gift (vm.article);
      record.$save().then(
        function(data) {
          $mdToast.show($mdToast.simple()
            .textContent('Artículo ' + vm.article.name + ' creado con éxito.')
            .position('bottom right'));
          vm.article = data;
          vm.uploader.extra={
            attachable_id: vm.article.id,
            attachable_type:"ARTICLE",
            type: "IMAGE",
          };
          // Subimos todas las fotos
          vm.uploader.uploadAll();
        }, function (err) {
          console.log(err);
        }
      );
    };

    vm.refreshImages = function (){
      api.article.uploadList({idArticle: vm.article.id, type:"image"}).$promise
        .then(
          function(d){
            vm.uploadImages=d;
          }
        )
        .catch(
          function (e){
            console.log(e);
          }
        )
    };

    vm.article.description = 'Descripción';
    vm.tinymceOptions = TextEditor;

    $rootScope.$on('new-category',function (event, d){
      api.category.list(
        function(d){
          vm.categories = d;
        },function(err) {
          console.log(err);
        }
      );
      vm.article.category_id = d.id;
    });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.downloads', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,  msNavigationServiceProvider   )
    {
        // State
        $stateProvider
            .state('app.downloads-create', {
                url    : '/admin/downloads/create',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/admin/downloads/create.html',
                        controller : 'DownloadsCreateController as vm'
                    }
                },
                resolve: {
                    access: ["Access", function (Access) { return Access.hasRole('admin'); }]
                }
            });
        $stateProvider
          .state('app.downloads-edit', {
            url    : '/admin/downloads/edit/:id',
            views  : {
              'content@app': {
                templateUrl: 'app/main/admin/downloads/create.html',
                controller : 'DownloadsEditController as vm'
              }
            },
            resolve: {
              access: ["Access", function (Access) { return Access.hasRole('admin'); }],
              download: function(api,$stateParams) {
                return api.download.get({id:$stateParams.id}).$promise;
              }

            }
          });
        $stateProvider
          .state('app.downloads', {
            url    : '/admin/downloads',
            views  : {
              'content@app': {
                templateUrl: 'app/main/admin/downloads/list.html',
                controller : 'DownloadsController as vm'
              }
            },
            resolve: {
              access: ["Access", function (Access) { return Access.hasRole('admin'); }],
              downloads: function(api) {
                return api.download.list().$promise;
              }
            }
          });

        msNavigationServiceProvider.saveItem('manager.utils', {
          title : 'Utilidades',
          icon: 'icon-cog',
          weight: 1,
          access   :  {
            //authtenticated:true,
            roles : ['admin','comercial']
          },
        });
         msNavigationServiceProvider.saveItem('manager.utils.downloads', {
             title    : 'Descargas',
             icon     : 'fa fa-cloud-download',
             state    : 'app.downloads',
             /*stateParams: {
                 'param1': 'page'
              },*/
             weight   : 15,
             access   :  {
               //authtenticated:true,
               roles : ['admin']
             },

         });


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.downloads')
        .controller('DownloadsCreateController', create)
        .controller('DownloadsEditController', edit)
        .controller('DownloadsController', main);

    /** @ngInject */
    function create(Uploader,myConfig,api,$mdToast,$state,$location){
        var vm = this;

        vm.uploader= Uploader.getInstance();
        vm.uploader.autoUpload=false;
        vm.uploader.queueLimit=1;

        vm.uploader.extra={
          type: "FILE",
        };
        console.log(vm.uploader);
        vm.uploader.onSuccessItem = function(fileItem, response, status, headers) {
        if (status==200){
          console.log(response);
          vm.download.upload_id=response.id;
          vm.download.url=response.url;
          var record = new api.download(vm.download);
          record.$save().then(
            function (d){
              vm.download={};
              fileItem.remove();
              $mdToast.show($mdToast.simple()
                .textContent('Descarga creada con éxito')
                .position('bottom right'));
              $location.path('admin/downloads');
            }
          );
        }
      };
        vm.create=function(){
          vm.uploader.uploadAll();
        }

    }
    function edit(Uploader,myConfig,api,$mdToast,download,$location){
      var vm = this;

      vm.uploader= Uploader.getInstance();
      vm.uploader.autoUpload=false;
      //vm.uploader.removeAfterUpload=true;
      vm.uploader.queueLimit=1;
      //vm.uploader.allowDelete=true;
      vm.uploadFiles=[];
      vm.uploader.extra={
        type: "FILE",
      };
      api.upload.get({id:download.upload_id}).$promise.then(function(d){
        vm.uploadFiles.push(d);
        console.log(vm.uploadFiles);
      });

      vm.download=download;

      //Cuando añadimos un nuevo archivo quitamos lo que esté
      vm.uploader.onAfterAddingFile=function (item){
      vm.uploadFiles=[];
      };

      vm.uploader.onSuccessItem = function(fileItem, response, status, headers) {
        if (status==200){
          vm.download.upload_id=response.id;
          vm.download.$update({id:vm.download.id})
            .then(function(response){
              $mdToast.show($mdToast.simple()
                .textContent('Descarga actualizada')
                .position('bottom right'));

              $location.path('admin/downloads');
            });

        }
      };
      vm.create=function(){
        if (vm.uploader.queue.length > 0){
          vm.uploader.uploadAll();
        }else {
          console.log(vm.download);
          vm.download.$update({id:vm.download.id})
            .then(function(response){
              $mdToast.show($mdToast.simple()
                .textContent('Descarga actualizada')
                .position('bottom right'));

              $location.path('admin/downloads');
            });
        }


      }

    }

    function main (downloads,$state,$scope,$mdToast,api,ErrorMessage){
      var vm = this;
      vm.downloads=downloads;

      $scope.$state = $state;
      vm.destroy = function(id, key) {
        api.download.remove({id:id})
          .$promise.then(function(){
          $mdToast.show($mdToast.simple()
            .textContent('Eliminado con éxito.')
            .position('bottom right'));
          vm.downloads.splice(key,1);
        },function(err){
          ErrorMessage.render('Algo fue mal',err);
        });
      };



    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.category', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider )
    {
        // State
        $stateProvider
            .state('app.category', {
                url    : '/admin/category',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/admin/category/index.html',
                        controller : 'CategoryMainController as vm'
                    }
                },
                resolve: {
                    access: ["Access", function (Access) { return Access.hasRole('admin'); }]

                }
            });

      msNavigationServiceProvider.saveItem('manager.category', {
        title    : 'Categorias',
        icon     : 'icon-folder-multiple',
        state    : 'app.category',
        access   :  {
          roles : ['admin']
        },
        weight   : 20
      });

    }
})();

(function(){
  angular
    .module('app.category')
    .controller('CategoryMainController', CategoryMainController)
    .controller('CategoryController', CategoryController);

  function CategoryController($scope, $mdDialog, $mdMedia, $mdToast, api, $rootScope) {
    var vm2 = this;
    vm2.category = {};
    vm2.showAdvanced = function(ev) {
      $mdDialog.show({
        controller: CategoryController,
        templateUrl: 'app/main/admin/category/createCategory.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
      });
    };
    vm2.hide = function() {
      $mdDialog.hide();
    };
    vm2.cancel = function() {
      $mdDialog.cancel();
    };
    vm2.store = function() {
      var record = new api.category(vm2.category);
      record.$save().then(
        function(d){
          $rootScope.$emit('new-category',d);
          $rootScope.$emit('category-updated',d);

          $mdDialog.hide();
          $mdToast.show($mdToast.simple()
            .textContent('Categoría ' + vm2.category.name + ' creada con éxito.')
            .position('bottom right'));
        },
        function (err) {
          console.log(err);
        }
      );
    };

    vm2.update=function(cat){
      api.category.update(cat).$promise.then(function (d) {
        $mdToast.show($mdToast.simple()
          .textContent('Categoría ' + d.name + ' actualizada con éxito.')
          .position('bottom right'));
        $rootScope.$emit('category-updated',d);
        $mdDialog.hide();
      },function(e){
        swal(
          'Atención',
          e.data.message,
          'error'
        )
       // console.log(e);
      });
    };

  }
  function CategoryMainController($scope, $mdDialog, api, $rootScope,$mdToast) {
    var vm = this;
    vm.category = {};

    vm.categories=[];

    vm.resfreshCategories=function (){
      api.category.list().$promise.then(function(d){
        vm.categories=d;
      });
    };

    vm.resfreshCategories();

    vm.showAdvancedEdit = function(cat) {
      $scope.category=angular.copy(cat);
      $mdDialog.show({
        controller: 'CategoryController as vm2' ,
        templateUrl: 'app/main/admin/category/editCategory.html',
        parent: angular.element(document.body),
        clickOutsideToClose:true,
        scope: $scope,        // use parent scope in template
        preserveScope: true,
      });
    };
    vm.hide = function() {
      $mdDialog.hide();
    };
    vm.cancel = function() {
      $mdDialog.cancel();
    };

    $rootScope.$on('category-updated',function(data){
     vm.resfreshCategories();
    });

    vm.delete=function (cat){
      swal({
        title: 'Estas seguro?',
        text: "Va a borrar una categoría",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
      }).then(function () {
        api.category.delete(cat).$promise.then(function(d){
          vm.resfreshCategories();
          $mdToast.show($mdToast.simple()
            .textContent('Categoría borrada con éxito.')
            .position('bottom right'));
        },function(e){
          swal(
            'Atención',
            e.data.message,
            'error'
          )
        });
      })

    };
  }
})();

(function()
{
  'use strict';

  angular
    .module('app.campaigns',['datatables'])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider
      .state('app.campaigns',{
        url   : '/admin/campaigns?page&search',
        views : {
          'content@app' : {
            templateUrl : 'app/main/admin/campaigns/views/listCampaigns.html',
            controller    : 'CampaignsMainCtrl as vm',
            params: {
                page: {
                value: 1,
                squash: true
                },
                search: {
                  value: '',
                  squash: true
                }
            }
          }
        },
        resolve: {
          access: ["Access", function (Access) { return Access.hasRole('admin'); }],
          campaignsList: function (api,$stateParams) {
            //return api.campaign.list().$promise;
              console.log($stateParams);
            return api.campaign.paginatedList({items:$stateParams.items, category: $stateParams.category, status: 'enabled', page:$stateParams.page}).$promise;
          }
        }
      });

    $stateProvider
      .state('app.campaigns-create', {
        url   : '/admin/campaigns/create',
        views : {
          'content@app': {
            templateUrl : 'app/main/admin/campaigns/views/createCampaign.html',
            controller  : 'CampaignsCreateCtrl as vm'
          }
        },
        resolve:{
          access: ["Access", function (Access) { return Access.hasRole('admin'); }],
          materialsList: function(api) {
            return api.material.list().$promise;
          },
          categoriesList: function (api) {
            return api.category.list().$promise;
          }
        }
      });

    $stateProvider
      .state('app.campaigns-edit', {
        url   : '/admin/campaigns/edit/:idCampaign',
        views : {
          'content@app': {
            access: ["Access", function (Access) { return Access.hasRole('admin'); }],
            templateUrl : 'app/main/admin/campaigns/views/createCampaign.html',
            controller  : 'CampaignsEditCtrl as vm'
          }
        },
        resolve : {
          access: ["Access", function (Access) { return Access.hasRole('admin'); }],
          campaignEdit: function(api, $stateParams) {
            return api.campaign.get({id:$stateParams.idCampaign}).$promise;
          },
          squareImages: function (api, $stateParams) {
            return api.campaign.imagesByProportion({idCampaign: $stateParams.idCampaign, proportion: 'square'}).$promise;
          },
          panoramicImages: function (api, $stateParams) {
            return api.campaign.imagesByProportion({idCampaign: $stateParams.idCampaign, proportion: 'panoramic'}).$promise;
          },
          categoriesList: function (api) {
            return api.category.list().$promise;
          }
        }
      });

    $stateProvider
      .state('app.campaigns-trash', {
        url   : '/admin/campaigns/trash?page&search',
        views : {
          'content@app' : {
            templateUrl : 'app/main/admin/campaigns/views/trashedCampaigns.html',
            controller  : 'CampaignsTrashCtrl as vm',
            params: {
              page: {
                value: 1,
                squash: true
              },
              search: {
                value: '',
                squash: true
              }
            }
          },
        },
        resolve : {
          access: ["Access", function (Access) { return Access.hasRole('admin'); }],
          trashedCampaignsList: function (api) {
            return api.campaign.getTrash().$promise;
          }
        }
      });

    msNavigationServiceProvider.saveItem('manager.campaigns', {
      title   : 'Campañas',
      icon    : 'fa fa-bullhorn',
      state   : 'app.campaigns',
      access   :  {
        //authtenticated:true,
        roles : ['admin']
      },
      weight  : 13
    });
  }
})();

(function()
{
	'use strict';

	angular
    	.module('app.campaigns')
		.controller('DialogCampaignsCtrl', DialogCampaignsCtrl);

  /** @ngInject */
	function DialogCampaignsCtrl($scope, api,$filter) {
	    var modal = this;
	    // Recuperamos  el objeto campaign para manejarlo en la modal
	    modal.campaign = $scope.vm.campaign;

      console.log(modal.campaign);

	    if ($scope.opt['type'] == 'article') {
	    	if (modal.campaign.articles && modal.campaign.articles.length > 0)
	    		$scope.selectedArticles = modal.campaign.articles;
	    	else $scope.selectedArticles = []
		}
	    else if ($scope.opt['type'] == 'material') {
	    	if (modal.campaign.materials && modal.campaign.materials.length > 0)
	    		$scope.selectedMaterials = modal.campaign.materials;
	    	else $scope.selectedMaterials = []
		}

	    modal.setItem = function(article) {
		    if ($scope.opt['type'] == 'article') {
          if($filter('filter')($scope.selectedArticles, {id: article.id}).length==0){
            $scope.selectedArticles.push(article);
          }
	    	} else if ($scope.opt['type'] == 'material') {
          if($filter('filter')($scope.selectedMaterials, {id: article.id}).length==0){
            $scope.selectedMaterials.push(article);
          }
	    	}
	    };

	    modal.delItem = function(type,key) {
        var selected=false;
        type == 'article' ? selected = $scope.selectedArticles : type == 'material' ? selected=$scope.selectedMaterials : false ;
        if(selected){
          selected.splice(key,1);
        }

	    }

	    $scope.withOutResults=false;
	    modal.searchArticle=function(term){
	      $scope.elementData={};
	      if (term!==''){
	        $scope.loadingSearch=true;
	        $scope.withOutResults=false;
	        api.search.type({type:'ARTICLE',term:term}).$promise.then(function(d){
	          $scope.elementData=d;
	          if (d.length<1){
	            $scope.withOutResults=true;
	          }
	          $scope.loadingSearch=false;
	        });
	      }
	    };
	    modal.searchMaterial=function(term){
	      $scope.elementData={};
	      if (term!==''){
	        $scope.loadingSearch=true;
	        $scope.withOutResults=false;
	        api.search.type({type:'MATERIAL',term:term}).$promise.then(function(d){
	          $scope.elementData=d;
	          if (d.length<1){
	            $scope.withOutResults=true;
	          }
	          $scope.loadingSearch=false;
	        });
	      }
	    };

	    modal.confirm = function() {

	    }
	}
})();

(function()
{
  'use strict';

  angular
    .module('app.campaigns')
    .controller('CampaignsMainCtrl', CampaignsMainCtrl);

  function CampaignsMainCtrl(api, $timeout, $element, $mdToast, $scope, campaignsList,$stateParams)
  {
    var vm = this;
    vm.filter = {};
    vm.filter.search = $stateParams.search;
    vm.pagination = campaignsList;
    vm.api = api.campaign.paginatedList;


    vm.onSearchChange = function($event) {
      $event.stopPropagation();
    }

    vm.toggleStatus = function(idCampaign, key) {
      api.campaign.toggleStatus({idCampaign:idCampaign})
        .$pomise
        .then(function(data){
          vm.campaigns[key].status = data.status;
          $mdToast.show($mdToast.simple()
            .textContent('Campaña actualizada con éxito.')
            .position('bottom right'));
        });
    };

    vm.destroy = function(id, key) {
      swal({
            title:"¿Estas seguro de eliminar esta campaña?",
            type:"warning",
            showCancelButton: true,
            cancelButtonText:"Cancelar",
            cancelButtonClass: 'md-button md-raised md-background-bg md-hue-1',
            cancelButtonColor: "#f5f5f5",
            confirmButtonText:"Si,eliminar",
            confirmButtonClass: 'md-button md-raised md-primary',
      }).then(function(){
            api.campaign.remove({id:id})
            .$promise.then(function(){
              $mdToast.show($mdToast.simple()
                .textContent('Campaña eliminada con éxito.')
                .position('bottom right'));
              api.campaign.paginatedList().$promise.then(function(d){
                 vm.pagination=d;
              });
        });
      });

    };
  }
})();

(function()
{
  'use strict';

  angular
    .module('app.campaigns')
    .controller('CampaignsEditCtrl', CampaignsEditCtrl)
    .controller('DialogCampaignAddPharmaCtrl', DialogCampaignAddPharmaCtrl);

  function CampaignsEditCtrl(api, $mdDialog,$mdToast, $scope, Uploader, TextEditor, campaignEdit, categoriesList,$rootScope)
  {
    var vm = this;

    vm.campaign = campaignEdit;
    // vm.campaign.covid19 = !!campaignEdit.covid19;
    vm.categories = categoriesList;
    vm.onSearchChange = function($event) {
      $event.stopPropagation();
    };

    vm.store = function() {
      vm.campaign.idCampaign=vm.campaign.id;
      api.campaign.update(vm.campaign).$promise
        .then(function(response){
          $mdToast.show($mdToast.simple()
            .textContent('Campaña ' + vm.campaign.name + ' actualizada con éxito.')
            .position('bottom right'));
          vm.campaign=response;
        })

    }

    vm.refreshImages = function (){
      api.campaign.imagesByProportion({idCampaign:vm.campaign.id,proportion:'square'}).$promise
        .then(function(d){vm.uploadImagesSquare=d[0];})
        .catch(function (e){console.log(e);});
      api.campaign.imagesByProportion({idCampaign:vm.campaign.id,proportion:'panoramic'}).$promise
        .then(function(d){vm.uploadImagesPanoramic=d[0];})
        .catch(function (e){console.log(e);});
    };
    vm.refreshImages();
    //vm.uploadImages = uploadsList;
    vm.uploadImages = {};
    vm.uploadImagesSlider = {};

    vm.uploader = Uploader.getInstance();
    vm.uploader.extra={
      attachable_id: vm.campaign.id,
      attachable_type:"CAMPAIGN",
      type: "IMAGE",
      proportion: 'square'
    };
    vm.uploader.uploadAction = function () {
      vm.uploader.uploadAll();
    };
    vm.uploader.postDeleteItem = function (){
      vm.refreshImages();
    };
    vm.uploader.onCompleteAll = function() {
      vm.refreshImages();
    };

    vm.uploaderSlider = Uploader.getInstance();
    vm.uploaderSlider.extra={
      attachable_id: vm.campaign.id,
      attachable_type:"CAMPAIGN",
      type: "IMAGE",
      proportion: 'panoramic'
    };
    vm.uploaderSlider.uploadAction = function () {
      vm.uploaderSlider.uploadAll();
    };
    vm.uploaderSlider.postDeleteItem = function (){
      vm.refreshImages();
    };
    vm.uploaderSlider.onCompleteAll = function() {
      vm.refreshImages();
    };

    vm.tinymceOptions = TextEditor;

    vm.addQaa = function() {
      vm.campaign.questionsAndAnswers.push({
        'question'  : '',
        'answer'    : ''
      });
    };

    vm.delQaa = function($index) {
      vm.campaign.questionsAndAnswers.pop($index);
    };

    vm.dupQaa = function($index) {
      vm.campaign.questionsAndAnswers.push(vm.campaign.questionsAndAnswers[$index]);
    };

    $rootScope.$on('new-category',function (event, d){
      api.category.list(
        function(d){
          vm.categories = d;
        },function(err) {
          console.log(err);
        }
      );
      vm.campaign.category_id = d.id;
    });

    // Seleccion de articulos y materiales

    vm.showSelectElement = function (type){

      $scope.opt = $rootScope.dialogConfCampaign[type];
      $mdDialog.show({
        controller: 'DialogCampaignsCtrl as modal',
        templateUrl: $rootScope.dialogConfCampaign[type].template,
        parent: angular.element(document.body),
        resolve: $rootScope.dialogConfCampaign[type].resolve,
        scope: $scope,
        preserveScope: true,
        clickOutsideToClose:true,
        fullscreen: true
      }).finally(function(){
        // Al cerrar la ventana
        delete $scope.elementData;
      });
      vm.resolveData($rootScope.dialogConfCampaign[type].getData());

    };

    $scope.confirm = function(type) {
      if (type == "articles")
        vm.campaign.articles = $scope.selectedArticles;
      else if (type == "materials")
        vm.campaign.materials = $scope.selectedMaterials;
      $mdDialog.hide();
    };

    $scope.hide = function() {
      $mdDialog.hide();
    };

    $scope.cancel = function() {
      $mdDialog.cancel();
    };

    vm.resolveData=function (promise){
      if(promise){
        promise.then(function (d){
          console.log(d);
          $scope.elementData=d;
        });
      }
    };

    vm.addPharma=function (item){
      $mdDialog.show({
        controller: 'DialogCampaignAddPharmaCtrl as modal',
        templateUrl: 'app/main/admin/campaigns/views/dialogs/addpharmacist.html' ,
        parent: angular.element(document.body),
        //targetEvent: event,
        resolve: {
          campaign: function(api) {
            return api.campaign.get({id:item.id}).$promise;
          }
        },
        scope: $scope,
        preserveScope: true,
        clickOutsideToClose:true,
        fullscreen: true
      }).finally(function(){
        // Al cerrar la ventana
      });
    };
  }
  function DialogCampaignAddPharmaCtrl($scope,$mdDialog,api,campaign,$mdToast) {
    var modal=this;
    modal.campaign = campaign;

    modal.searchPharmacist=function(term){
      $scope.elementData={};
      if (term!==''){
        $scope.loadingSearch=true;
        $scope.withOutResults=false;
        api.search.type({type:'PHARMACIST',term:term}).$promise.then(function(d){
          modal.searchResult=d;
          if (d.length<1){
            $scope.withOutResults=true;
          }
          $scope.loadingSearch=false;
        });
      }
    }

    //Refrescar modal.promotional
    modal.refreshCampaign=function(){
      api.campaign.getCampaignPharma({id:modal.campaign.id}).$promise.then(function(d){
        modal.campaign.activated_users = d;
      });
    }

    //Añadir farmaceutico al descuento
    modal.addPharma=function(idCampaign,idUser){
      api.campaign.addPharma({id:idCampaign, idPharma:idUser}).$promise.then(function(d){
        modal.refreshCampaign();
        $mdToast.show($mdToast.simple()
          .textContent('Farmacéutico añadido.')
          .position('bottom right'));
      });
    }
    //Eliminar farmaceutico al descuento
    modal.delPharma=function(idCampaign,idUser){
      api.campaign.delPharma({id:idCampaign, idPharma:idUser}).$promise.then(function(d){
        modal.refreshCampaign();
        $mdToast.show($mdToast.simple()
          .textContent('Farmacéutico desvinculado.')
          .position('bottom right'));
      });
    }
    modal.refreshCampaign();
    modal.sendMasive=function(){
      api.campaign.addMasivePharma({id:modal.campaign.id , users:modal.masiveUsers.split(/\r?\n/)}).$promise.then(function(d){
        modal.refreshCampaign();
      },function(err){console.log(err)});

    };
    modal.delMasive=function (){
      swal({
        title: 'Estas seguro ?',
        text: "Dejara vacio el campo usuarios",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'Cancelar'
      }).then(function () {
        api.campaign.delMasivePharma({id:modal.campaign.id}).$promise.then(function(d){
          modal.refreshCampaign();
          modal.masiveUsers=[];
          $mdToast.show($mdToast.simple()
            .textContent('Farmacéuticos añadidos.')
            .position('bottom right'));
        },function(err){console.log(err)});
      })
    }

  }
})();

(function(){

  'use strict';

  angular
    .module('app.campaigns')
    .controller('CampaignsCreateCtrl', CampaignsCreateCtrl)
    .controller('CampaignsTrashCtrl', CampaignsTrashCtrl);

  function CampaignsCreateCtrl(api,$state, $mdToast, $scope, Uploader, TextEditor, categoriesList, $rootScope,$mdDialog)
  {
    var vm = this;
    vm.campaign = {};
    vm.categories = categoriesList;

    vm.createdCampaign=null;
    vm.onSearchChange = function($event) {
      $event.stopPropagation();
    };
    vm.mode="create";
    vm.store = function() {
      var record = new api.campaign (vm.campaign);

      record.$save().then(
        function(data) {
          //Guardamos la campaña creada para redireccionar una vez subidas las fotos
          vm.createdCampaign=data;
          $mdToast.show($mdToast.simple()
            .textContent('Campaña ' + vm.campaign.name + ' creada con éxito.')
            .position('bottom right'));
          vm.uploader.extra={
            attachable_id: data.id,
            attachable_type:"CAMPAIGN",
            type: "IMAGE",
            proportion: 'square'
          };
          vm.uploaderSlider.extra={
            attachable_id: data.id,
            attachable_type:"CAMPAIGN",
            type: "IMAGE",
            proportion: 'panoramic'
          };
          // Si no hay fotos que subir , vamos al editado
          if(vm.uploader.queue.length == 0 &&  vm.uploaderSlider.queue.length ==0 ) {
            $state.go('app.campaigns-edit',{idCampaign:vm.createdCampaign.id});
          }
          vm.uploader.uploadAll();
          vm.uploaderSlider.uploadAll();


        }, function (err) {
          console.log(err);
        }
      );
    };

    vm.refreshImages = function (){
      api.upload.type({type:"image"}).$promise
        .then(
          function(d){
            vm.uploadImages = d.square;
            vm.uploadImagesSlider = d.panoramic;
          }
        )
        .catch(
          function (e){
            console.log(e);
          }
        )
    };

    vm.uploader = Uploader.getInstance();
    vm.uploader.uploadAction = function () {
      vm.uploader.uploadAll();
    };
    vm.uploader.postDeleteItem = function (){
      vm.refreshImages();
    };
    vm.uploader.onCompleteAll = function() {
      if (!vm.uploaderSlider.isUploading){
        $state.go('app.campaigns-edit',{idCampaign:vm.createdCampaign.id});
      }
    };

    vm.uploaderSlider = Uploader.getInstance();
    vm.uploaderSlider.uploadAction = function () {
      vm.uploadAll();
    };
    vm.uploaderSlider.postDeleteItem = function (){
      vm.refreshImages();
    };
    vm.uploaderSlider.onCompleteAll = function() {
      if (!vm.uploader.isUploading){
        $state.go('app.campaigns-edit',{idCampaign:vm.createdCampaign.id});
      }
    };
    vm.uploader.autoUpload = vm.uploaderSlider.autoUpload = false;

    vm.campaign.description = '';
    vm.tinymceOptions = TextEditor;

    vm.campaign.questionsAndAnswers = [];

    vm.addQaa = function() {
      vm.campaign.questionsAndAnswers.push({
        'question'  : '',
        'answer'    : ''
      });
    };

    vm.delQaa = function($index) {
      vm.campaign.questionsAndAnswers.splice(vm.campaign.questionsAndAnswers.indexOf($index));
    };

    vm.dupQaa = function($index) {
      vm.campaign.questionsAndAnswers.push(vm.campaign.questionsAndAnswers[$index]);
    };

    $rootScope.$on('new-category',function (event, d){
      api.category.list(
        function(d){
          vm.categories = d;
        },function(err) {
          console.log(err);
        }
      );
      vm.campaign.category_id = d.id;
    });

    // Seleccion de articulos y materiales

    vm.showSelectElement = function (type){

      $scope.opt = $rootScope.dialogConfCampaign[type];
      $mdDialog.show({
        controller: 'DialogCampaignsCtrl as modal',
        templateUrl: $rootScope.dialogConfCampaign[type].template,
        parent: angular.element(document.body),
        resolve: $rootScope.dialogConfCampaign[type].resolve,
        scope: $scope,
        preserveScope: true,
        clickOutsideToClose:true,
        fullscreen: true
      }).finally(function(){
        // Al cerrar la ventana
        delete $scope.elementData;
      });
      vm.resolveData($rootScope.dialogConfCampaign[type].getData());

    };

    $scope.confirm = function(type) {
      if (type == "articles")
        vm.campaign.articles = $scope.selectedArticles;
      else if (type == "materials")
        vm.campaign.materials = $scope.selectedMaterials;
      $mdDialog.hide();
    };

    $scope.hide = function() {
      $mdDialog.hide();
    };

    $scope.cancel = function() {
      $mdDialog.cancel();
    };

    vm.resolveData=function (promise){
      if(promise){
        promise.then(function (d){
          console.log(d);
          $scope.elementData=d;
        });
      }
    };
  }

  function CampaignsTrashCtrl(api, $timeout, $element, $mdToast, $scope, trashedCampaignsList, $stateParams, $state, $rootScope) {
    var vm = this;
    vm.filter = {};
    vm.filter.search = $stateParams.search;
    vm.campaigns = trashedCampaignsList;

    vm.onSearchChange = function($event) {
      $event.stopPropagation();
    }
    vm.restore = function (id, key) {
      $rootScope.loadingProgress = true;
      api.campaign.restore({id: id}).$promise.then(
        function (data) {
          $mdToast.show($mdToast.simple()
            .textContent('Campaña restaurada con éxito.')
            .position('bottom right'));
          vm.campaigns.splice(key,1);
          $rootScope.loadingProgress = false;
        },
        function (err) {
          console.log(err);
          $rootScope.loadingProgress = false;
        });
    }
  }
})();

(function()
{
  'use strict';

  angular
    .module('app.articles')
    .controller('ArticlesMainCtrl', ArticlesMainCtrl);

  function ArticlesMainCtrl(api, $timeout, $element, $mdToast, $scope, articlesList,$rootScope, $stateParams, $state)
  {
    var vm = this;
    vm.filter = {};
    vm.filter.search = $stateParams.search;
    vm.pagination = articlesList;
    vm.api = api.article.paginatedList;

    vm.destroy = function(id, key) {
      api.article.remove({id:id})
        .$promise.then(function(){
        $mdToast.show($mdToast.simple()
          .textContent('Producto eliminado con éxito.')
          .position('bottom right'));
        vm.pagination.data.splice(key,1);
      });
    };

    vm.refreshArticles = function(){
      $state.go('.', {page: 1, search: vm.filter.search});
      // $rootScope.loadingProgress = true;
      // api.article.paginatedList({"items": vm.filter.items, "page" : 1, "search" : vm.filter.search}).$promise.then(
      //   function(data){
      //     vm.pagination = data;
      //     $rootScope.loadingProgress = false;
      //   },
      //   function (err) {
      //     console.log(err);
      //   }
      // );
    };

    vm.toggleVip = function (article,index) {
      $rootScope.loadingProgress = true;
      var toSet=article.vip_order ? 0 : 1;
      api.article.setVip({id: article.id, set: toSet}).$promise.then(
        function (data) {
          vm.pagination.data[index] = data;
          $rootScope.loadingProgress = false;
        },
        function (err) {
          console.log(err);
          $rootScope.loadingProgress = false;
        });
    };

  }

})();

(function()
{
  'use strict';

  angular
    .module('app.articles')
    .controller('ArticlesEditCtrl', ArticlesEditCtrl);

  function ArticlesEditCtrl(api, $timeout, $element, $mdToast, $scope, Uploader, TextEditor, articleEdit, uploadsList, $rootScope)
  {
    var vm = this;

    vm.article = articleEdit;

    api.category.list(
      function(d){
        vm.categories = d
      },function(err){
        console.log(err);
      }
    );

    vm.onSearchChange = function($event) {
      $event.stopPropagation();
    };

    vm.store = function() {
      vm.article.$update({id:vm.article.id})
        .then(function(response){
          $mdToast.show($mdToast.simple()
            .textContent('Artículo ' + vm.article.name + ' actualizado con éxito.')
            .position('bottom right'));
        });
        vm.uploader.uploadAll();

    }

    vm.refreshImages = function (){
      api.article.uploadList({idArticle:vm.article.id,type:'image'}).$promise
        .then(
          function(d){
            vm.uploadImages=d;
          }
        )
        .catch(
          function (e){
            console.log(e);
          }
        )
    };
    vm.uploadImages = uploadsList;

    vm.uploader = Uploader.getInstance();
    vm.uploader.extra={
      attachable_id:vm.article.id,
      attachable_type:"ARTICLE",
      type: "IMAGE"
    };
    vm.uploadAction = function () {
      console.log(vm.uploader);
      vm.uploader.uploadAll();
    };
    vm.uploader.postDeleteItem=function (){
      vm.refreshImages();
    };
    vm.uploader.onCompleteAll = function() {
      vm.refreshImages();
    };

    vm.tinymceOptions = TextEditor;

    $rootScope.$on('new-category',function (event, d){
      api.category.list(
        function(d){
          vm.categories = d;
        },function(err) {
          console.log(err);
        }
      );
      vm.article.category_id = d.id;
    });
  }
})();

(function(){

  'use strict';

  angular
    .module('app.articles')
    .controller('ArticlesVipCtrl',ArticlesVipCtrl)
    .controller('ArticlesCreateCtrl', ArticlesCreateCtrl);

  function ArticlesCreateCtrl(api, $timeout, $element, $mdToast, $scope, Uploader, TextEditor, $rootScope,$state)
  {
    var vm = this;
    vm.article = {};
    api.category.list(
      function (d) {
        vm.categories = d;
      }, function (err) {
        console.log(err);
      }
    );

    vm.uploader = Uploader.getInstance();
    vm.uploadAction = function () {
      vm.uploader.uploadAll();
    };
    //vm.uploader.postDeleteItem=function (){
    //  vm.uploader.refreshImages();
    //};
    vm.uploader.onCompleteAll = function() {
      vm.refreshImages();
    };
    vm.uploader.autoUpload = false;

    vm.onSearchChange = function($event) {
      $event.stopPropagation();
    };

    vm.store = function() {
      var record = new api.article (vm.article);
      record.$save().then(
        function(data) {
          $mdToast.show($mdToast.simple()
            .textContent('Artículo ' + vm.article.name + ' creado con éxito.')
            .position('bottom right'));
          vm.article = data;
          vm.uploader.extra={
            attachable_id: vm.article.id,
            attachable_type:"ARTICLE",
            type: "IMAGE",
          };
          // Subimos todas las fotos
          vm.uploader.uploadAll();
          $state.go('app.articles');
        }, function (err) {
              swal({
                  title:"¡Error!",
                  text:err.data.message,
                  type:"error",
                  confirmButtonText:"Continuar",
              });
          console.log(err);
        }
      );
    };

    vm.refreshImages = function (){
      api.article.uploadList({idArticle: vm.article.id, type:"image"}).$promise
        .then(
          function(d){
            vm.uploadImages=d;
          }
        )
        .catch(
          function (e){
            console.log(e);
          }
        )
    };

    vm.article.description = 'Descripción';
    vm.tinymceOptions = TextEditor;

    $rootScope.$on('new-category',function (event, d){
      api.category.list(
        function(d){
          vm.categories = d;
        },function(err) {
          console.log(err);
        }
      );
      vm.article.category_id = d.id;
    });
  }

  function ArticlesVipCtrl(api, vipArticlesList, $rootScope)
  {
    var vm=this;
    vm.article = {};
    vm.sortableOptions = {
      'ui-floating': true,
      stop: function(event, ui) {
        var ids = [];
        $.each($("li.sortable-vip-article"), function(key, value){
          ids.push($(value).attr('data-article-id'));
        });
        api.article.sortVip({ids: ids}).$promise.then(
          function (data) {
            vm.articles = data;
            console.log(data);
          },
          function (err) {
            console.log(err);
          }
        );
      }
    };

    vm.articles = vipArticlesList;
    vm.searchingArticles = {};

    vm.searchArticle=function(term){
      if (term!==''){
        api.search.type({type:'ARTICLE',term:term}).$promise.then(
          function(data){
            vm.searchingArticles = data;
          },
          function(err){
            console.log(err);
          }
        );
      }
    };

    vm.addVip = function(id,index) {
      $rootScope.loadingProgress = true;
      api.article.setVip({id: id, set: 1}).$promise.then(
        function (data) {
          vm.articles.push(data);
        },
        function (err) {
          console.log(err);
          if (err.data.error)
            swal('Error',err.data.error,'error');
        }
      );
      $rootScope.loadingProgress = false;
    };

    vm.delVip = function(id,index) {
      $rootScope.loadingProgress = true;
      api.article.setVip({id: id, set: 0}).$promise.then(
        function (data) {
          vm.articles.splice(index,1);
        },
        function (err) {
          console.log(err);
          if (err.data.error)
            swal('Error',err.data.error,'error');
        }
      );
      $rootScope.loadingProgress = false;
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'satellizer',
                'angularFileUpload',
                'ui.tinymce',
                'angular-http-transform-date',
                'jsonFormatter',
                'truncate',
                'ui.sortable'

            ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                loadMore: '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element('#content');
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msStepper', msStepperDirective)
        .directive('msStepperStep', msStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            })
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            // Hide all steps
            for ( var i = 0; i < vm.steps.length; i++ )
            {
                vm.steps[i].element.hide();
            }

            // Show the current step
            vm.steps[vm.currentStepNumber - 1].element.show();
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            vm.setCurrentStep(vm.currentStepNumber - 1);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            vm.setCurrentStep(vm.currentStepNumber + 1);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msStepperDirective()
    {
        return {
            restrict        : 'A',
            require         : ['form', 'msStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        }
    }

    /** @ngInject */
    function msStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : true,
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');
        //var Access= angular.injector(['app.authentication']).get('Access');


        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item )
        {

            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem           : saveItem,
                deleteItem         : deleteItem,
                sort               : sortByWeight,
                clearNavigation    : clearNavigation,
                setActiveItem      : setActiveItem,
                getActiveItem      : getActiveItem,
                getNavigationObject: getNavigationObject,
                setNavigationScope : setNavigationScope,
                setFolded          : setFolded,
                getFolded          : getFolded,
                setFoldedOpen      : setFoldedOpen,
                getFoldedOpen      : getFoldedOpen,
                toggleFolded       : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = [];
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation object
             *
             * @param root
             * @returns {Array}
             */
            function getNavigationObject(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }
                }

                return navigation;
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService,NavCheck,UserProfile)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigationObject($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigationObject();
        }


        $scope.checkAccess = function(node){

        //return true;
        return NavCheck.checkAccess(node);
          //return $auth.isAuthenticated();

        };

      //console.log(UserProfile);
      //UserProfile.then(function(d){
      //  vm.test=d;
      //});
      //
      //setTimeout(function(){
      //  console.log(vm.test);
      //},3000);



      // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();

                        // If navigation is folded open, close it
                        if ( msNavigationService.getFolded() )
                        {
                            onFoldCollapserHover();
                        }
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService , NavCheck , $auth)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;



        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';


        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////
        if (typeof vm.node.access != 'undefined'){

         // var status=Access.isAuthenticated().catch(function(e){
         //NavCheck.userprofile.then(function(){
         //  NavCheck.checkAccess(vm.node.access);
         //});





          //NavCheck.userprofile.then(function(u){
          //  setTimeout(function(){
          //
          //
          //    console.log(msNavigationService);
          //    msNavigationService.deleteItem('uploader');
          //    console.log(vm.navigation);
          //  },2000);
          //});

         // });
        }


        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states everything except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPicker($mdMenu, $mdColorPalette, fuseGenerator)
    {
        return {
            require    : 'ngModel',
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function ($scope, element, attrs, ngModel)
            {
                // Material Color Palette
                $scope.palettes = $mdColorPalette;
                $scope.selectedPalette = false;
                $scope.selectedHues = false;

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                $scope.msModelType = $scope.msModelType || 'class';

                /**
                 * Initialize / Watch model changes
                 */
                $scope.$watch('ngModel', setSelectedColor);

                /**
                 * Activate Hue Selection
                 * @param palette
                 * @param hues
                 */
                $scope.activateHueSelection = function (palette, hues)
                {
                    $scope.selectedPalette = palette;
                    $scope.selectedHues = hues;
                };

                /**
                 * Select Color
                 * @type {selectColor}
                 */
                $scope.selectColor = function (palette, hue)
                {
                    // Update Selected Color
                    updateSelectedColor(palette, hue);

                    // Update Model Value
                    updateModel();

                    // Hide The picker
                    $mdMenu.hide();
                };

                $scope.removeColor = function ()
                {

                    $scope.selectedColor = {
                        palette: '',
                        hue    : '',
                        class  : ''
                    };

                    $scope.activateHueSelection(false, false);

                    updateModel();
                };

                /**
                 * Set SelectedColor by model type
                 */
                function setSelectedColor()
                {
                    if ( !ngModel.$viewValue || ngModel.$viewValue === '' )
                    {
                        return;
                    }

                    var palette, hue;

                    // If ModelType Class
                    if ( $scope.msModelType === 'class' )
                    {
                        var color = ngModel.$viewValue.split('-');
                        if ( color.length >= 5 )
                        {
                            palette = color[1] + '-' + color[2];
                            hue = color[3];
                        }
                        else
                        {
                            palette = color[1];
                            hue = color[2];
                        }
                    }
                    // If ModelType Object
                    else if ( $scope.msModelType === 'obj' )
                    {
                        palette = ngModel.$viewValue.palette;
                        hue = ngModel.$viewValue.hue || 500;
                    }

                    // Update Selected Color
                    updateSelectedColor(palette, hue);
                }


                /**
                 * Update Selected Color
                 * @param palette
                 * @param hue
                 */
                function updateSelectedColor(palette, hue)
                {
                    $scope.selectedColor = {
                        palette     : palette,
                        hue         : hue,
                        class       : 'md-' + palette + '-' + hue + '-bg',
                        bgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].value),
                        fgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].contrast)
                    };

                    // If Model object not Equals the selectedColor update it
                    // it can be happen when the model only have pallete and hue values
                    if ( $scope.msModelType === 'obj' && !angular.equals($scope.selectedColor, ngModel.$viewValue) )
                    {
                        // Update Model Value
                        updateModel();
                    }

                    $scope.activateHueSelection(palette, $scope.palettes[palette]);
                }

                /**
                 * Update Model Value by model type
                 */
                function updateModel()
                {
                    if ( $scope.msModelType === 'class' )
                    {
                        ngModel.$setViewValue($scope.selectedColor.class);
                    }
                    else if ( $scope.msModelType === 'obj' )
                    {
                        ngModel.$setViewValue($scope.selectedColor);
                    }
                }
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController($rootScope)
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }
        $rootScope.$on('wizard-goto-start',function(){
        firstStep();
        });
        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }
                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
	'use strict';

	angular
		.module('app.uploader', [])
		.component('uploader', {
			templateUrl: 'app/components/uploader/views/uploader.html',
			controller:  function(api){
				var $ctrl=this;
				$ctrl.idInput = 'uploader-' + Math.floor(Math.random(0,1) * Math.floor(Math.random(0,1) * 5000));

        $ctrl.uploader.loadFilters($ctrl.filters);

				$ctrl.deleteFile=function(idFile){
		            api.upload.delete({id:idFile}).$promise
		            .then(function(r){
		              //Accion despues de eliminar una imagen
		               $ctrl.uploader.postDeleteItem();
		            })
		            .catch(function(e){
		                console.log(e);
		            });
		        }
			},
			bindings: {
				images: '=',
				uploader: '=',
				filters:'=',
        files: '='
			}
		});
})();

'use strict';

  angular
    .module('app.uploader')

    .factory('Uploader', function(
      FileUploader,
      myConfig,
      $mdToast,
      $auth,
      $filter
    ) {
      function UploaderBuild(dataSet) {
        this.uploader = new FileUploader({
          url : myConfig.endPointApi+myConfig.uploaderUrl,
          extra: {},
          type:'',
          autoUpload:true
        });

        var avaliableFilters =  [
          {
            name: 'image',
            fn: function(item /*{File|FileLikeObject}*/, options) {
              var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
              var res = '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
              if(!res && typeof options === 'undefined'){
                $mdToast.show($mdToast.simple().textContent('El archivo '+item.name+' no es una imagen.' ).position('bottom right'));
              }
              return res;
            }
          },
          {
            name: 'file',
            fn: function(item /*{File|FileLikeObject}*/, options) {
              var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
              // excel - pdf - txt - docx
              var res = '|vnd.ms-excel|pdf|plain|vnd.openxmlformats-officedocument.wordprocessingml.document|vnd.openxmlformats-officedocument.spreadsheetml.sheet |'.indexOf(type) !== -1;
              if(!res){
                $mdToast.show($mdToast.simple().textContent('El archivo '+item.name+' no tiene una extensión admitida' ).position('bottom right'));
              }
              return res;
            }
          }

        ];


        this.uploader.loadFilters = function (filters){
          var up=this;
          angular.forEach (filters,function(v,k){
            if (up.checkFilter(v)){
              up.setFilter(v);
            }
          });


        };

        this.uploader.checkFilter = function (filterName){

          var inAvaliable=$filter('filter')(avaliableFilters,{name: filterName}).length > 0;
          var inFilters = $filter('filter')(this.filters,{name: filterName}).length > 0;

          if (inAvaliable && !inFilters){
            return true;
          } return false;

        }

        this.uploader.setFilter = function (filterName){
          this.filters.push($filter('filter')(avaliableFilters,{name: filterName})[0])
        }

        // Ejemplo de carga de filtros
        // <uploader images="vm.uploadImages" uploader="vm.uploader" filters="['imageFilter']"></uploader>


        this.uploader.isImage = function (item){
          var imageFilter = $filter('filter')(avaliableFilters, {name:'image'});
          if (typeof imageFilter[0] !== undefined){
            return imageFilter[0].fn(item.file,{noToast:true})
          }return false;

        };


        this.uploader.onBeforeUploadItem = function(item) {

          item.formData.push(this.extra);
          item.headers = {
            'Authorization': 'Bearer ' + $auth.getToken()
          };

        };

        this.uploader.onSuccessItem = function(fileItem, response, status, headers) {
          if (status==200){
            fileItem.formData=response;
            fileItem.remove();
          }
        };
        this.uploader.onErrorItem = function(fileItem, response, status, headers) {
          swal({
            title : "¡Error!",
            text  : "No se pudo subir el archivo.Msg:"+response.message+" Status:  "+status,
            type  : "error"
          });
        };
      }

      return {
        getInstance: function(dataSet) {
         var uploaderInstance = new UploaderBuild(dataSet);
         return uploaderInstance.uploader;
        }
      };
    });

'use strict';


angular


    .module('app.uploader')


    // Angular File Upload module does not include this directive
    // Only for example


    /**
    * The ng-thumb directive
    * @author: nerv
    * @version: 0.1.2, 2014-01-09
    */
    .directive('ngThumb', ['$window', function($window) {
        var helper = {
            support: !!($window.FileReader && $window.CanvasRenderingContext2D),
            isFile: function(item) {
                return angular.isObject(item) && item instanceof $window.File;
            },
            isImage: function(file) {
                var type =  '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
                return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
            }
        };

        return {
            restrict: 'A',
            template: '<canvas/>',
            link: function(scope, element, attributes) {
                if (!helper.support) return;

                var params = scope.$eval(attributes.ngThumb);

                if (!helper.isFile(params.file)) return;
                if (!helper.isImage(params.file)) return;

                var canvas = element.find('canvas');
                var reader = new FileReader();

                reader.onload = onLoadFile;
                reader.readAsDataURL(params.file);

                function onLoadFile(event) {
                    var img = new Image();
                    img.onload = onLoadImage;
                    img.src = event.target.result;
                }

                function onLoadImage() {
                    var width = params.width || this.width / this.height * params.height;
                    var height = params.height || this.height / this.width * params.width;
                    canvas.attr({ width: width, height: height });
                    canvas[0].getContext('2d').drawImage(this, 0, 0, width, height);
                }
            }
        };
    }]);
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

          // Core
          'app.core',
          'app.authorization',

          // Navigation
          'app.navigation',

          // Toolbar
          'app.toolbar',

          // Sample
          'ngSanitize',

          // Pages
          //'app.pages',

          // Custom modules
          'app.pagination',
          'app.product-card',
          'app.status-order',
          'app.status-campaigns',
          'app.status-promotionals',
          'app.order-item',
          'app.uploader',
          'app.slider',
          'app.numberspinner',
          'app.alert-box',
          'vAccordion',
          'ngAnimate',

          'app.cart',

          'app.articles',
          'app.campaigns',
          'app.category',
          'app.materials',
          'app.promotions',
          'app.users',
          'app.home',
          'app.guest-home',
          // 'app.guest-articles',
          'app.guest-campaigns',
          'app.guest-materials',
          'app.guest-promotions',
          'app.guest-orders',
          'app.guest-downloads',
          'app.guest-promotionals',
          'app.gifts',
          'app.rules',
          'app.sliders',
          'app.downloads',
          'app.imports',
          'app.orders',
          'app.sync',
          'app.tools',
          //'FBAngular',

          //'app.seller'
        ]);
})();

(function() {
  'use strict';

  angular
    .module('fuse')
    .factory('TextEditor', TextEditor);

  function TextEditor() {
    return {
      plugins     : 'link importcss paste code',
      menu        : {},
      toolbar     : 'undo redo | bold italic | alignleft aligncenter alignright alignjustify | code ',
      theme       : 'modern',
      baseURL :   'assets/plugins/tinymce-dist',
      skin        : 'light',
      //content_css : '/app/index.css',
      paste_as_text: true

    };
  }


})();

(function ()
{
  'use strict';

  angular
    .module('app.status-promotionals', [])
    .component('statusPromotionals', {
      templateUrl: 'app/components/statusPromotionals/statusPromotionals.html',
      controller:  function($rootScope){
          var $ctrl = this;
          $ctrl.promotional=[];

          $ctrl.savePromotional = function (item,k) {
              console.log($ctrl);
              console.log(item);
              $rootScope.$emit('regenerate-cart',{item_type:item.type,item_id:item.item_id,rule:k});
          };

      },
      bindings: {
        statusModel: '=',
        from: '=',
        hasComercialAccess: '=',
      }
    });
})();

(function ()
{
  'use strict';

  angular
    .module('app.status-order', [])
    .component('statusOrder', {
      templateUrl: 'app/components/statusOrder/statusOrder.html',
      controller:  function(){
      },
      bindings: {
        status: '='
      }
    });
})();

(function ()
{
  'use strict';

  angular
    .module('app.status-campaigns', [])
    .component('statusCampaigns', {
      templateUrl: 'app/components/statusCampaigns/statusCampaigns.html',
      controller:  function(){
      },
      bindings: {
        statusModel: '=',
        from: '='
      }
    });
})();

(function()
{
	'use strict';

	angular
		.module('app.slider',[])
		.component('slider', {
      		templateUrl: 'app/components/slider/slider.html',
      		bindings: {
      			slider: '='
      		}
		})
})();
(function ()
{
  'use strict';

  angular
    .module('app.product-card', [])
    .component('productCard', {
      templateUrl: 'app/components/productCard/productCard.html',
      controller:  function(){
      },
      bindings: {
        product: '=',
        type: '=',
        showMinQty:'@',
        from:'@',
        // hasCommercialAccess: '@'
        hasCommercialAccess: '<'
      }
    });
})();

(function ()
{
  'use strict';

  angular
    .module('app.pagination', [])
    .component('pagination', {
      templateUrl: 'app/components/pagination/pagination.html',
      controller:  function($rootScope, api, $state){
        var $ctrl = this;
        $ctrl.setPage = function(page){
          // $rootScope.loadingProgress = true;

          $state.go('.', {page: page, items: $ctrl.filter.items, search: $ctrl.filter.search, status: 'enabled'});

          // $ctrl.apiMethod(
          //   {
          //     items : $ctrl.filter.items,
          //     page : page,
          //     search: $ctrl.filter.search,
          //     category: $ctrl.filter.category
          //   },
          //   function (data) {
          //     $ctrl.pagination = data;
          //     $rootScope.loadingProgress = false;
          //     $("#content").delay(250).animate({scrollTop: $("#slider").height() + 50});
          //   },
          //   function (err) {
          //     console.log(err);
          //   }
          // )
        };
      },
      bindings: {
        pagination: '=',
        filter: '=',
        apiMethod: '='
      }
    });
})();

(function ()
{
  'use strict';

  angular
    .module('app.numberspinner', [])
    .component('numberspinner', {
      templateUrl: 'app/components/numberspinner/numberspinner.html',
      controller:  function($rootScope, api, $scope,$timeout){

        var $ctrl = this;
        if (!$ctrl.step) $ctrl.step = 1;

        $ctrl.checkRole=function(role){
          console.log(role);
        };
        //Si el rol es de pedido 'order' , mando refrescar el pedido despues de cambiar el carrito
        var refresh = false;
        if ($ctrl.role=='order'){
          refresh=true;
        }
        $scope.$watch("$ctrl.model",function(newValue,oldValue) {
          if (newValue===oldValue || newValue==null || newValue==0) {
            return;
          }
          $rootScope.loadingProgress = true;
          $timeout (
            function (){

              if($ctrl.data.order_id) {
                api.order.uptItem({ order: $ctrl.data.order_id, id: $ctrl.data.detail.id, qty: $ctrl.data.detail.qty,refreshOrder:refresh}).$promise.then(
                    function (data) {
                      $rootScope.$emit('refresh-order',data);
                      $rootScope.loadingProgress = false;
                    },function (err){
                      if (err.status==416){
                        swal({
                          title:"Atención",
                          text:err.data.message,
                          type:"warning"
                        });
                        $rootScope.loadingProgress = false;
                        $ctrl.model=err.data.prev_qty;
                      }
                    });
              } else {
                api.cart.uptItem({ cart: $ctrl.data.cart_id, id: $ctrl.data.detail.id, qty: $ctrl.data.detail.qty,refreshOrder:refresh}).$promise.then(
                    function (data) {
                      if(!refresh){
                        $rootScope.$emit('refresh-cart',data);
                      }else{
                        $rootScope.$emit('refresh-order',data);
                      }
                      $rootScope.loadingProgress = false;
                    },function (err){
                      if (err.status==416){
                        swal({
                          title:"Atención",
                          text:err.data.message,
                          type:"warning"
                        });
                        $rootScope.loadingProgress = false;
                        $ctrl.model=err.data.prev_qty;

                      }
                    });
              }
            },200
          );
        },true);

    		$ctrl.inc = function(){
    			if (!$ctrl.max || $ctrl.model < $ctrl.max)
    				$ctrl.model += $ctrl.step;
    		}
    		$ctrl.dec = function(){
    			if (!$ctrl.min || $ctrl.model > $ctrl.min)
    				$ctrl.model -= $ctrl.step;
    		}
      },
      bindings: {
      	model: '=',
      	min: '=',
      	max: '=',
      	step: '=',
        role: '=',
        data: '='
      }
    })
    .component('syncNumberSpinner', {
      templateUrl: 'app/components/numberspinner/sync-number-spinner.html',
      controller: function() {

        var $ctrl = this;
        if (!$ctrl.step) $ctrl.step = 1;

        $ctrl.inc = function(){
          if (!$ctrl.max || $ctrl.model < $ctrl.max)
            $ctrl.model += $ctrl.step;
        }
        $ctrl.dec = function(){
          if (!$ctrl.min || $ctrl.model > $ctrl.min)
            $ctrl.model -= $ctrl.step;
        }
      },
      bindings: {
        model: '=',
        min: '=',
        max: '=',
        step: '='
      }
    });
})();

(function ()
{
  'use strict';

  angular
    .module('app.alert-box', [])
    .component('alertBox', {
      templateUrl: 'app/components/alertBox/alertBox.html',
      controller:  function($sce){
        /* Uso: <alert-box></alert-box> con estos atributos encerrados ENTRE COMILLAS:
         *    icon: código del icono, incluyendo el prefijo / los prefijos (icon, fa, ion...)
         *    type: danger, warning, info o success
         *    message: texto del mensaje
         */
        var $ctrl = this;

        $ctrl.renderHtml=function(html){
          return $sce.trustAsHtml(html);
        };

        $ctrl.colors = {
          'warning' : 'orange-500',
          'danger' : 'red-500',
          'info' : 'cyan-500',
          'success' : 'green-500'
        };
      },
      bindings: {
        icon: '=',
        message: '@',
        type: '='
      }
    });
})();

(function ()
{
  'use strict';

  angular
    .module('app.order-item', [])
    .directive('orderItem', function (){
      return {
        restrict: 'A',
        replace: false,
        templateUrl: 'app/components/OrderItem/OrderItem.html',
        scope: {detail: '=' , key:'=',order:'=',vmOrder:'=',from:'@',blockOrder:'='}
      }
    })
    .directive('cartItem', function (){
      return {
        restrict: 'A',
        replace: false,
        templateUrl: 'app/components/OrderItem/CartItem.html',
        scope: {detail: '=' , key:'=',order:'=',vmOrder:'='}
      }
    });
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider()
    {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;


        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes  : getRegisteredThemes,
                setActiveTheme       : setActiveTheme,
                setThemesList        : setThemesList,
                themes               : {
                    list  : {},
                    active: {
                        'name' : '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if ( angular.isUndefined(service.themes.list[themeName]) )
                {
                    // If there is no theme called "default"...
                    if ( angular.isUndefined(service.themes.list.default) )
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider )
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);



    }

})();

(function ()
{
    'use strict';

    var fuseThemes = {
        'default'  : {
            primary   : {
                name: 'fuse-pale-blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'red'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'pink': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'blue'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'teal'     : {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'deep-orange'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-pale-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0, color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // Set active theme
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions()
    {
        return {
            restrict   : 'E',
            scope      : {
                panelOpen: '=?'
            },
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        backdropEl = angular.element('<div class="ms-theme-options-backdrop"></div>');

                    // Panel open status
                    scope.panelOpen = scope.panelOpen || false;

                    /**
                     * Toggle options panel
                     */
                    function toggleOptionsPanel()
                    {
                        if ( scope.panelOpen )
                        {
                            closeOptionsPanel();
                        }
                        else
                        {
                            openOptionsPanel();
                        }
                    }

                    function openOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = true;

                        // Add open class
                        iElement.addClass('open');

                        // Append the backdrop
                        bodyEl.append(backdropEl);

                        // Register the event
                        backdropEl.on('click touch', closeOptionsPanel);
                    }

                    /**
                     * Close options panel
                     */
                    function closeOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = false;

                        // Remove open class
                        iElement.removeClass('open');

                        // De-register the event
                        backdropEl.off('click touch', closeOptionsPanel);

                        // Remove the backdrop
                        backdropEl.remove();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsPanel = toggleOptionsPanel;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject required services
        var $log = angular.injector(['ng']).get('$log'),
            $resource = angular.injector(['ngResource']).get('$resource');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Prepare the resource object
            var resourceObj = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };

            // Assign the resource
            api[key] = $resource(resourceObj.url, resourceObj.paramDefaults, resourceObj.actions, resourceObj.options);
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($q, $log)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function(window) {
    var createModule = function(angular) {
        var module = angular.module('FBAngular', []);

        module.factory('Fullscreen', ['$document', '$rootScope', function ($document,$rootScope) {
            var document = $document[0];

            // ensure ALLOW_KEYBOARD_INPUT is available and enabled
            var isKeyboardAvailbleOnFullScreen = (typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element) && Element.ALLOW_KEYBOARD_INPUT;

            var emitter = $rootScope.$new();

            // listen event on document instead of element to avoid firefox limitation
            // see https://developer.mozilla.org/en-US/docs/Web/Guide/API/DOM/Using_full_screen_mode
            $document.on('fullscreenchange webkitfullscreenchange mozfullscreenchange MSFullscreenChange', function(){
                emitter.$emit('FBFullscreen.change', serviceInstance.isEnabled());
            });

            var serviceInstance = {
                $on: angular.bind(emitter, emitter.$on),
                all: function() {

                    serviceInstance.enable( document.documentElement );
                },
                enable: function(element) {
                    if(element.requestFullScreen) {
                        element.requestFullScreen();
                    } else if(element.mozRequestFullScreen) {
                        element.mozRequestFullScreen();
                    } else if(element.webkitRequestFullscreen) {
                        // Safari temporary fix
                        if (/Version\/[\d]{1,2}(\.[\d]{1,2}){1}(\.(\d){1,2}){0,1} Safari/.test(navigator.userAgent)) {
                            element.webkitRequestFullscreen();
                        } else {
                            element.webkitRequestFullscreen(isKeyboardAvailbleOnFullScreen);
                        }
                    } else if (element.msRequestFullscreen) {
                        element.msRequestFullscreen();
                    }
                },
                cancel: function() {
                    if(document.cancelFullScreen) {
                        document.cancelFullScreen();
                    } else if(document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if(document.webkitExitFullscreen) {
                        document.webkitExitFullscreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                },
                isEnabled: function(){
                    var fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
                    return fullscreenElement ? true : false;
                },
                toggleAll: function(){
                    console.log("paso");
                    serviceInstance.isEnabled() ? serviceInstance.cancel() : serviceInstance.all();
                },
                isSupported: function(){
                    var docElm = document.documentElement;
                    var requestFullscreen = docElm.requestFullScreen || docElm.mozRequestFullScreen || docElm.webkitRequestFullscreen || docElm.msRequestFullscreen;
                    return requestFullscreen ? true : false;
                }
            };

            return serviceInstance;
        }]);

        module.directive('fullscreen', ['Fullscreen', function(Fullscreen) {
            return {
                link : function ($scope, $element, $attrs) {
                    // Watch for changes on scope if model is provided
                    if ($attrs.fullscreen) {
                        $scope.$watch($attrs.fullscreen, function(value) {
                            var isEnabled = Fullscreen.isEnabled();
                            if (value && !isEnabled) {
                                Fullscreen.enable($element[0]);
                                $element.addClass('isInFullScreen');
                            } else if (!value && isEnabled) {
                                Fullscreen.cancel();
                                $element.removeClass('isInFullScreen');
                            }
                        });

                        // Listen on the `FBFullscreen.change`
                        // the event will fire when anything changes the fullscreen mode
                        var removeFullscreenHandler = Fullscreen.$on('FBFullscreen.change', function(evt, isFullscreenEnabled){
                            if(!isFullscreenEnabled){
                                $scope.$evalAsync(function(){
                                    $scope.$eval($attrs.fullscreen + '= false');
                                    $element.removeClass('isInFullScreen');
                                });
                            }
                        });

                        $scope.$on('$destroy', function() {
                            removeFullscreenHandler();
                        });

                    } else {
                        if ($attrs.onlyWatchedProperty !== undefined) {
                            return;
                        }

                        $element.on('click', function (ev) {
                            Fullscreen.enable(  $element[0] );
                        });
                    }
                }
            };
        }]);
        return module;
    };

    if (typeof define === "function" && define.amd) {
        define("FBAngular", ['angular'], function (angular) { return createModule(angular); } );
    } else if (typeof module !== 'undefined' && module.exports) {
        module.exports = createModule(window.angular).name;
    } else {
        createModule(window.angular);
    }
})(window);
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
  'use strict';

  angular
    .module('app.core')
    .factory('$messages', function($mdToast){

      var Message = {

        comercial : function (args){
         return $mdToast.show(
           {
             template:' <md-toast  class="md-toast msg-comercial"><span>'+ args.text+'</span></md-toast>',
             position: args.position,
             hideDelay: 60000,
           });
        }


      }
      return Message;
    });
})();

(function ()
{
  'use strict';

  angular
    .module('app.core')
    .factory('Validation', function(){

      var Validation = {

        render: function (err) {
            Validation.errorsToHtml(err);
           // return;
            swal({
              width:600,
              title: 'Error de validación',
              type: 'error',
              html:
              '<h3>Detalles:</h3>'+ Validation.errorsToHtml(err),

              showCloseButton: true,
              confirmButtonText:
                '<i class="fa fa-thumbs-up"></i> Ok'
          });

        },
        errorsToHtml : function (err){
          var html = "<div class='error-container'>";
          angular.forEach(err.data.errors , function(input,inputKey){
              angular.forEach(input,function(error,errorKey){
                  html+="<p class='validation-item-error'><i class='fa fa-thumbs-o-down'aria-hidden='true'></i>"+error+"</p>";
              });
          });
          html+="</div>";
          return html;
          console.log(err);
        }

      }
      return Validation;
    });
})();

(function ()
{
  'use strict';

  angular
  .module('app.core')
  .config(function ($provide, $httpProvider) {

    // Intercept http calls.
    $provide.factory('HttpInterceptor', function ($q,Validation) {
      return {
        // On request success
        request: function (config) {
          // console.log(config); // Contains the data about the request before it is sent.

          // Return the config or wrap it in a promise if blank.
          return config || $q.when(config);
        },

        // On request failure
        requestError: function (rejection) {
          // console.log(rejection); // Contains the data about the error on the request.

          // Return the promise rejection.
          return $q.reject(rejection);
        },

        // On response success
        response: function (response) {
          // console.log(response); // Contains the data from the response.

          // Return the response or promise.
          return response || $q.when(response);
        },

        // On response failture
        responseError: function (rejection) {

          // console.log(rejection); // Contains the data about the error.
          if (rejection.status===422){

           Validation.render(rejection);
            //swal({title: "¡Error!",
            //  html:
            //  '<h4>Error de validación</h4>' +
            //  '<p>Se sucedieron los siquientes errores</p>'
            //
            //  , type: "error", confirmButtonText: "Aceptar"});
          }
          if (rejection.status==404){
            swal('opss..',rejection.data.message,'error');
          }
          // Return the promise rejection.
          return $q.reject(rejection);
        }
      };
    });

    // Add the interceptor to the $httpProvider.
    $httpProvider.interceptors.push('HttpInterceptor');
  });
})();

(function ()
{
  'use strict';

  angular
    .module('app.core')
    .factory('ErrorMessage', function(){

      var ErrorMessage = {

        render: function (msg,err) {
          ErrorMessage.errorsToHtml(err);
           // return;
            swal({
              width:600,
              title: msg,
              type: 'error',
              html:
              '<h3>Detalles:</h3>'+ ErrorMessage.errorsToHtml(err),

              showCloseButton: true,
              confirmButtonText:
                '<i class="fa fa-thumbs-up"></i> Ok'
          });

        },
        errorsToHtml : function (err){
          console.log(err);
          var html = "<div class='error-container'>";
          html+="<p>Status:"+err.status+"</p>";
          html+="<p>Archivo:"+err.data.debug.file+"</p>";
          html+="<p>Linea:"+err.data.debug.line+"</p>";
          html+=err.data.message;
          html+="</div>";
          return html;
        }

      }
      return ErrorMessage;
    });
})();

(function ()
{
  'use strict';

  angular
    .module('app.core')
    .factory('CartMessage', function(){

      var CartMessage = {

        render: function (msg,err) {
          CartMessage.errorsToHtml(err);
           // return;
            swal({
              width:600,
              title: msg,
              type: 'warning',
              html:
              '<h3>Detalles:</h3>'+ CartMessage.errorsToHtml(err),

              showCloseButton: true,
              confirmButtonText:
                '<i class="fa fa-thumbs-up"></i> Ok'
          });

        },
        errorsToHtml : function (err){
          var html = "<div class='error-container'>";
          angular.forEach(err, function(error,key){
             html+="<p class='validation-item-error'><i class='fa fa-thumbs-o-down'aria-hidden='true'></i>"+error.cart_detail.name+"</p>";
          });
          html+="</div>";
          return html;
        }

      }
      return CartMessage;
    });
})();

angular.module('truncate', [])
  .filter('characters', function () {
    return function (input, chars, breakOnWord) {
      if (isNaN(chars)) return input;
      if (chars <= 0) return '';
      if (input && input.length > chars) {
        input = input.substring(0, chars);

        if (!breakOnWord) {
          var lastspace = input.lastIndexOf(' ');
          //get last space
          if (lastspace !== -1) {
            input = input.substr(0, lastspace);
          }
        }else{
          while(input.charAt(input.length-1) === ' '){
            input = input.substr(0, input.length -1);
          }
        }
        return input + '…';
      }
      return input;
    };
  })
  .filter('splitcharacters', function() {
    return function (input, chars) {
      if (isNaN(chars)) return input;
      if (chars <= 0) return '';
      if (input && input.length > chars) {
        var prefix = input.substring(0, chars/2);
        var postfix = input.substring(input.length-chars/2, input.length);
        return prefix + '...' + postfix;
      }
      return input;
    };
  })
  .filter('words', function () {
    return function (input, words) {
      if (isNaN(words)) return input;
      if (words <= 0) return '';
      if (input) {
        var inputWords = input.split(/\s+/);
        if (inputWords.length > words) {
          input = inputWords.slice(0, words).join(' ') + '…';
        }
      }
      return input;
    };
  });

(function ()
{
  'use strict';

  angular
    .module('app.core')
    .filter('customSearch', function() {
      return function(input, search) {
        if (!input) return input;
        if (!search) return input;
        var expected = ('' + search).toLowerCase();
        var result = {};
        angular.forEach(input, function(value, key) {
          var actual = ('' + value).toLowerCase();
          if (actual.indexOf(expected) !== -1) {
            result[key] = value;
          }
        });
        return result;
      }
    });


})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('momentHumanize',momentHumanize)
        .filter('toDate',toDate)
        .filter('momentFormat', momentFormat);




        // Le pasamos un formato a la fecha

        function momentFormat(){
            return function (date,format){
                return moment(date).format(format);
            }
        }

        // Nos devuelve una fecha en formato "Humano"

        function momentHumanize(){
            return function(date){
                var now = moment();

                var diffInHours=now.diff(moment(date),'hours');

                if(diffInHours > 24){
                  return moment(date).format('D-M-Y');
                }
                return moment(date).fromNow();
            }
        }

        function toDate(){
          return function(mydate){

            console.log(new Date (mydate));
            return new Date (mydate);
          }
        }





})();


(function ()
{
  'use strict';

  angular
    .module('app.core')
    .filter('prettyJSON', function () {
        function prettyPrintJson(json) {
          return JSON ? JSON.stringify(json, null, '  ') : 'your browser doesnt support JSON so cant pretty print';
        }
        return prettyPrintJson;
      });

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter)
        .filter('truncateText', truncateTextFilter)
        .filter('split', split);



    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
           return  angular.element(text).text();
           //return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

    /** @ngInject */
    function truncateTextFilter() {
      return function (text, length, end) {
        if (typeof text !='undefined' ){
          if (isNaN(length))
            length = 10;

          if (end === undefined)
            end = "...";

          if (text.length <= length || text.length - end.length <= length) {
            return text;
          }
          else {
            return String(text).substring(0, length-end.length) + end;
          }
        }
      };
    }

    /** @ngInject */
    function split() {
        return function(input) {
            if (!input) {
                return '';
            }
            var output = '';
            $.each(input.split("\n\n"), function(key, paragraph) {
                output += '<p>' + paragraph + '</p>';
            });
            return output;
        };
    }

})();

angular.module('app.core').directive('autoOpen', function () {

  function compile(tElement) {
    tElement.find('input').attr('ng-focus', 'ctrl.onFocus($event)');

    return function (scope, element, attrs, datePicker) {
      var focused = false;

      datePicker.onFocus = function (event)  {
        focused = !focused;

        // The datepicker is going to return focus to the input when
        // the calendar pane is closed. We don't want to reopen the
        // the calendar pane after it is closed.
        if(focused) {
          datePicker.openCalendarPane(event);
        }
      };
    };
  }

  return {
    compile: compile,
    priority: -1,
    require: 'mdDatepicker',
    restrict: 'A'
  };
});

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'EA',
            compile : function (tElement, tAttrs)
            {
                var code;
                //No attribute? code is the content
                if ( !tAttrs.code )
                {
                    code = tElement.html();
                    tElement.empty();
                }

                return function (scope, iElement, iAttrs)
                {
                    if ( iAttrs.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(iAttrs.code);
                    }
                    var shouldInterpolate = scope.$eval(iAttrs.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }

                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );

                            iElement.append(contentParent);

                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {
                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);

                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(iAttrs.language || iAttrs.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
  'use strict';

  angular
    .module('app.core')
	.directive('back', ['$window', function($window) {
	        return {
	            restrict: 'A',
		        link: function( scope, element, attrs ) {
		            element.on( 'click', function () {
		                history.back();
		                scope.$apply();
		            } );
		        }
	        };
	    }])

    .directive('timezonedDate', function () {
      return {
        require: 'ngModel',
        link: function(scope, elem, attrs, ngModel) {
          var toView = function(val) {
            return val;
          };

          var toModel = function(val) {
            var offset = moment(val).utcOffset();
            var date = new Date(moment(val).add(offset, 'm'));
            return date;
          };

          ngModel.$formatters.unshift(toView);
          ngModel.$parsers.unshift(toModel);
        }
      };

    });

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.authorization')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController(api,$auth,myConfig,$mdToast,$state,$location,UserProfile,$rootScope,$q, $mdDialog,$scope)
    {
        var vm=this;

        vm.browser_status=$rootScope.browser_status;



        // Envio de login

        vm.sendLogin=function(){

            $auth.login(vm.form,{
                url: myConfig.endPointApi+'auth'
            })
                .then(function(response) {
                    // Redirect user here after a successful log in.
                   $mdToast.show($mdToast.simple().textContent('Login correcto').position('bottom right'));
                   UserProfile.then(function(userPofile){
                     userPofile.$refresh().then(function(newUserProfile){
                       $rootScope.$emit('login');
                       if(typeof $state.next != 'undefined' ){
                         $state.go($state.next,$state.nextParams);
                       }else if(newUserProfile.$hasRole('admin')){
                         $location.path('/admin');
                       }else if(newUserProfile.$hasRole('comercial')){
                         $location.path('/');
                       }else if(newUserProfile.$hasRole('farmaceutico')){
                         console.log(newUserProfile);
                          if (!newUserProfile.activated_on) {
                            $scope.newUserProfile=newUserProfile;
                            var setPassword = $mdDialog.show({
                              controller: 'PasswordDialogController',
                              templateUrl: 'app/main/pharmacist/login/loginDialog.html',
                              parent: angular.element(document.body),
                              clickOutsideToClose: false,
                              scope:$scope
                            });
                          }else{
                            $location.path('/');
                          }


                       }else{
                         $auth.logout();
                         $q.reject('No permitido',403);
                       }
                     });

                   });

                 //  console.log($state);
                 //  console.log(response)
                })
                .catch(function(err) {
                    // Handle errors here, such as displaying a notification
                    // for invalid email and/or password.
                  if (err.status==403) {
                    $mdToast.show($mdToast.simple().textContent('No está autorizado para entrar , consúltenos.').position('top right'));
                  } else if (err.status == 503) {
                    if (err.data.error) {
                      swal({
                        title: 'En mantenimiento',
                        text: err.data.error,
                        type: 'error'
                      });
                    } else {
                      swal({
                        title: 'En mantenimiento',
                        text: 'La intranet está temporalmente fuera de servicio. Por favor, póngase en contacto con su gestor Mirafarma o bien llame al 968 169 044.',
                        type: 'error'
                      });
                    }
                  } else {
                    $mdToast.show($mdToast.simple().textContent('Error de autenticación').position('top right'));
                  }
                });

        };
        vm.logout=function (){
              $auth.logout();
              UserProfile.then(function(userPofile) {
                userPofile.$refresh();
              });

        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $mdSidenav, $translate, $mdToast,myConfig)
    {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };
        vm.endpoint=myConfig.endPointApi;
        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            },
            tr: {
                'title'      : 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code'       : 'tr',
                'flag'       : 'tr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout()
        {
            // Do logout here..
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if ( lang.code !== 'en' )
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
  'use strict';

  angular
    .module('app.navigation', [])
    .config(config);

  /** @ngInject */
  function config()
  {

  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope,$rootScope,$mdMedia)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        if($mdMedia('(max-width: 1024px)')){
            vm.folded=true;
        }


        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }




        // $rootScope.$on('toggle-sidenav',function(e,d){
        //     vm.folded=d;
        // });

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
!function(a){"function"==typeof define&&define.amd?define(["jquery","moment"],a):"object"==typeof exports?module.exports=a(require("jquery"),require("moment")):a(jQuery,moment)}(function(a,b){!function(){"use strict";var a="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),c="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),d=(b.defineLocale||b.lang).call(b,"es",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(b,d){return/-MMM-/.test(d)?c[b.month()]:a[b.month()]},weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[mañana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},ordinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}});return d}(),a.fullCalendar.datepickerLang("es","es",{closeText:"Cerrar",prevText:"&#x3C;Ant",nextText:"Sig&#x3E;",currentText:"Hoy",monthNames:["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],monthNamesShort:["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"],dayNames:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"],dayNamesShort:["dom","lun","mar","mié","jue","vie","sáb"],dayNamesMin:["D","L","M","X","J","V","S"],weekHeader:"Sm",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),a.fullCalendar.lang("es",{buttonText:{month:"Mes",week:"Semana",day:"Día",list:"Agenda"},allDayHtml:"Todo<br/>el día",eventLimitText:"más"})});

/*(function ()
{
    'use strict';

    angular
        .module('fuse')

        
     
})();
*/

// Cambiar locale datepicke https://material.angularjs.org/latest/api/service/$mdDateLocaleProvider

(function ()
{
    'use strict';

    angular
        .module('fuse')

        .constant('LangDatetime', {
        	'days' : {
        		'es' : [
                   'Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'
                ]
        	},
            'sortDays' : {
                'es' : [
                   'Dom','Lun','Mar','X','Jue','Vie','Sáb'
                ]
            },
            'months': {
                'es':[
                    'Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'
                ]
            },
            'sortMonths': {
                'es':[
                    'Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'
                ]
            },
            'msg' : {
                'es': [
                    {
                        'OPEN_CALENDAR': 'Abrir calendario',
                        'CALENDAR': 'Calendario' 

                    }


                ]
            }


        });

     
})();

'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
  var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
  $provide.value("$locale", {
    "DATETIME_FORMATS": {
      "AMPMS": [
        "a. m.",
        "p. m."
      ],
      "DAY": [
        "domingo",
        "lunes",
        "martes",
        "mi\u00e9rcoles",
        "jueves",
        "viernes",
        "s\u00e1bado"
      ],
      "ERANAMES": [
        "antes de Cristo",
        "despu\u00e9s de Cristo"
      ],
      "ERAS": [
        "a. C.",
        "d. C."
      ],
      "FIRSTDAYOFWEEK": 0,
      "MONTH": [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      "SHORTDAY": [
        "dom.",
        "lun.",
        "mar.",
        "mi\u00e9.",
        "jue.",
        "vie.",
        "s\u00e1b."
      ],
      "SHORTMONTH": [
        "ene.",
        "feb.",
        "mar.",
        "abr.",
        "may.",
        "jun.",
        "jul.",
        "ago.",
        "sept.",
        "oct.",
        "nov.",
        "dic."
      ],
      "STANDALONEMONTH": [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      "WEEKENDRANGE": [
        5,
        6
      ],
      "fullDate": "EEEE, d 'de' MMMM 'de' y",
      "longDate": "d 'de' MMMM 'de' y",
      "medium": "d MMM y H:mm:ss",
      "mediumDate": "d MMM y",
      "mediumTime": "H:mm:ss",
      "short": "d/M/yy H:mm",
      "shortDate": "d/M/yy",
      "shortTime": "H:mm"
    },
    "NUMBER_FORMATS": {
      "CURRENCY_SYM": "\u20ac",
      "DECIMAL_SEP": ",",
      "GROUP_SEP": ".",
      "PATTERNS": [
        {
          "gSize": 3,
          "lgSize": 3,
          "maxFrac": 3,
          "minFrac": 0,
          "minInt": 1,
          "negPre": "-",
          "negSuf": "",
          "posPre": "",
          "posSuf": ""
        },
        {
          "gSize": 3,
          "lgSize": 3,
          "maxFrac": 2,
          "minFrac": 2,
          "minInt": 1,
          "negPre": "-",
          "negSuf": "\u00a0\u00a4",
          "posPre": "",
          "posSuf": "\u00a0\u00a4"
        }
      ]
    },
    "id": "es-es",
    "localeID": "es_ES",
    "pluralCat": function(n, opt_precision) {  if (n == 1) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
  });
}]);

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        // toastr configuration
        toastr.options.timeOut = 3000;
        toastr.options.positionClass = 'toast-top-right';
        toastr.options.preventDuplicates = true;
        toastr.options.progressBar = true;

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('es');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.authorization')
        .factory('UserProfile', UserProfile);

    /** @ngInject */
    function UserProfile(
      api,
      $auth,
      $location,
      $state,
      $stateParams,
      $filter
      )
    {

    var userProfile = {};
    var superRoles=['root','admin','superman'];


    var getProfile = function (){

         return api.auth.checkToken({toke:$auth.getToken()}).$promise.then(function(statusToken){

          var query;
          var endPoint;

          if (typeof $auth.getPayload() == 'undefined' || statusToken.status==false) {
            endPoint=api.user.guest();
            console.log("entro");
            $state.go('app.login',$stateParams);
          } else{
            query=$auth.getPayload().sub;
            endPoint=api.user.withRoles({idEmployee: query })
          }

          return endPoint.$promise.then(function (response) {

            // Comprobamos si el usuario esta activo
            if (response.isActive==false){
              UserProfile.then(function(userPofile) {;
                $location.path('login');
              });

            }

            return angular.extend(userProfile, response, {


            $refresh: getProfile ,
            $hasRole: function (role,skipSuperRoles) {

               if(!skipSuperRoles){
                   // Compruebo si el usuario tiene algun rol de los superRoles
                   var foundSuperRole=false;
                   angular.forEach(superRoles,function(superRole){
                       if($filter('filter')(userProfile.roles,{name:superRole}).length > 0){
                           foundSuperRole=true;
                       }
                   });
                   if (foundSuperRole){
                       return true;
                   }
               }

              //console.log(foundSuperRole);
              var found=false;
              //console.log(userProfile.roles);
               angular.forEach(userProfile.roles,function(userRole){
                 if (userRole.name===role){
                   found++;
                 }
               });
               if(found > 0){
                 return true;
               }
                 return false;

              },

              $hasAnyRole: function (roles,skipSuperRoles) {

                // Compruebo si el usuario tiene algun rol de los superRoles
              if(!skipSuperRoles) {
                  var foundSuperRole = false;
                  angular.forEach(superRoles, function (superRole) {
                      if ($filter('filter')(userProfile.roles, {name: superRole}).length > 0) {
                          foundSuperRole = true;
                      }
                  });
                  if (foundSuperRole) {
                      return true;
                  }
              }
                var coincident=0;
                angular.forEach(roles,function(accessRole){
                  angular.forEach(userProfile.roles,function(userRole){
                      if(accessRole===userRole.name){
                        coincident++;
                      }
                  });
                });
               return  coincident > 0;
              },

              $isAuthenticated: function () {
                return $auth.isAuthenticated();
              }

            });

          },
          function (err){
            //console.log(err);
          });
       });
    };
       return  getProfile() ;
       //$http.get(myConfig.endPointApi+'auth/check-token').success (function (d){
       //  return getProfile();
       //});





    }







})();

(function ()
{
  'use strict';

  angular
    .module('app.authorization')
    .controller('UserProfileCtrl',UserProfileCtrl);

    function UserProfileCtrl (UserProfile){
      var vm = this;
      vm.userprofile={};
      UserProfile.then(function(d){
          vm.userprofile=d;
        },
        function(e){
          console.log(e);
        }
      );
    }
})();

(function ()
{
  'use strict';

  angular
    .module('app.authorization')
    .factory('NavCheck', function(UserProfile,$auth,$rootScope){

      var NavCheck={

        userprofile: {},
        checkAccess:function(conf){
        // return true;
          if(angular.isDefined(conf.access)){
            // Si marcamos authtenticated true
            //if (conf.access.authtenticated){
            //    if (!$auth.isAuthenticated()){
            //      return true;
            //    }
            //}
            // Si pasamos lista de roles

            //if (!$auth.isAuthenticated()){
            //        return true;
            //   }

            if (angular.isDefined(conf.access.roles)){
              return NavCheck.hasAnyRole(conf.access.roles);
            }


          }

        },
        hasAnyRole: function (roles){
          var hidden=true;
          angular.forEach(NavCheck.userprofile.roles,function(profileRole){
              angular.forEach(roles,function(confRole){
                if (profileRole.name==confRole){
                  hidden=false;
                }
              });
          });
          return hidden;
        }

      };


      //
      $rootScope.$on('login',function (event){
        UserProfile.then(function(userProfile){
          userProfile.$refresh().then(function(u){
            NavCheck.userprofile=u;
          })
        });
      });

      if ($auth.isAuthenticated()){
        UserProfile.then(function(d){
          NavCheck.userprofile=d;
        });
      }
      return NavCheck;


    });
})();

(function ()
{
    'use strict';

    angular
        .module('app.authorization')
        .factory('Access', function($q,UserProfile,$auth){

        	var Access = {
        		 OK: 200,

			    // "we don't know who you are, so we can't say if you're authorized to access
			    // this resource or not yet, please sign in first"
			    UNAUTHORIZED: 401,

			    // "we know who you are, and your profile does not allow you to access this resource"
			    FORBIDDEN: 403,

				hasRealRole:function(role){
                    return UserProfile.then(function (userProfile) {
                        if (!$auth.isAuthenticated()){
                            return false;
                        }
                        if (userProfile.$hasRole(role,true)) {
                            return true;
                        } else {
                            return false;
                        }
                    });
				},
                hasRealAnyRole:function(roles){
                    return UserProfile.then(function (userProfile) {
                        if (!$auth.isAuthenticated()){
                            return false;
                        }
                        if (userProfile.$hasAnyRole(roles,true)) {
                            return true;
                        } else {
                            return false;
                        }
                    });
                },

			    hasRole: function (role) {

			      return UserProfile.then(function (userProfile) {
					  if (!$auth.isAuthenticated()){
						return $q.reject(Access.UNAUTHORIZED);
					  }
			        if (userProfile.$hasRole(role)) {
			          return Access.OK;
			        } else {
			          return $q.reject(Access.FORBIDDEN);
			        }
			      });
			    },

			    hasAnyRole: function (roles) {

			      return UserProfile.then(function (userProfile) {

			        if (userProfile.$hasAnyRole(roles)) {
			          return Access.OK;
			        } else {
			          return $q.reject(Access.FORBIDDEN);
			        }
			      });
			    },

			    isAuthenticated: function () {
			      return UserProfile.then(function (userProfile) {

			        if ($auth.isAuthenticated()) {
			          return Access.OK;
			        } else {
			          return $q.reject(Access.UNAUTHORIZED);
			        }
			      });
			    }

			  };

        	return Access;
		});
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('UserResource', function($resource,myConfig){
        var actionUrl=myConfig.endPointApi+'user/';
        return $resource(actionUrl+':id',{
            id:'@id'
          },{
          paginatedList: {
            method: 'GET',
            url: actionUrl + 'pagination?items=:items&page=:page&status=:status&search=:search',
            isArray: false,
            params: {
              items: '@items',
              page: '@page',
              search: '@search',
              status: '@status'
            }
          },

          list: {
                  method: 'GET',
                  url: actionUrl + '/',
                  isArray: true,
                 },
          sellers: {
                  method: 'GET',
                  url: actionUrl + 'sellers',
                  isArray: true,
          },
          statusToggle: {
                  method: 'GET',
                  url: actionUrl + 'status-toggle/:idUser',
                  isArray: false,
                  params:{
                      idUser:'@idUser'
                  }
                 },
          withRoles: {
            method: 'GET',
            url: actionUrl + 'with-roles/:idEmployee',
            isArray: false,
            params:{
              idEmployee:'@idEmployee'
            }
          },
          guest: {
            method : 'GET',
            url: actionUrl + 'guest',
            isArray: false
          },
          update: {
            method: 'PUT',
            url: actionUrl + ':id'
          },
          myAccount:{
            method:'GET',
            isArray:false,
            url: actionUrl + 'my-account'
          },
          myPromotionals:{
            method:'GET',
            isArray:true,
            url: actionUrl + 'my-promotionals'
          },
          badgePromotionals:{
            method:'GET',
            isArray:false,
            url: actionUrl + 'badge-promotionals'
          },
          updateMyAccount:{
            method:'put',
            isArray:false,
            url: actionUrl + 'my-account'
          },
          activateMyAccount:{
            method:'PUT',
            isArray:false,
            url: actionUrl + 'activate-my-account'
          },
          restore:{
            method:'PUT',
            isArray:false,
            url: actionUrl + ':user/restore',
            params : {
                user:'@user'
            }

          }

        });
    });
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('UploadResource', function($resource,myConfig){

            var actionUrl=myConfig.endPointApi+'uploads/';
            return $resource(actionUrl+':id',{
                id:'@id'
            },{
                type: {
                    method: 'GET',
                    url: actionUrl + 'type/:type',
                    isArray: true,
                    params:{
                        type:'@type',
                    }
                },
                statusToggle: {
                    method: 'GET',
                    url: actionUrl + 'status-toggle/:idUser',
                    isArray: false,
                    params:{
                        idUser:'@idUser',

                    }
                }
             }
        );
    });
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('ToolsResource', function($resource,myConfig){
        var actionUrl=myConfig.endPointApi+'tools/';
        return $resource(actionUrl+':id',{
            id:'@id'
          },{
          calculateRetail: {
            method: 'POST',
            url: actionUrl + 'calculate/retail',
            isArray: false,
          },

        });
    });
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('SyncResource', function($resource,myConfig){


        var actionUrl=myConfig.endPointApi+'sync/';



        return $resource(actionUrl+':id',{
            id:'@id'
        },{
        run: {
                method: 'GET',
                url: actionUrl + 'run',
                isArray: false,
               },

           }

        );



    });



})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('StatResource', function($resource,myConfig,HttpTransformDate){

            var actionUrl=myConfig.endPointApi+'stats/';
            return $resource(actionUrl+':id',{
                id:'@id'
            },{
                get: {
                  transformResponse: HttpTransformDate.transformFromString('date_from', 'date_to')
                },
                orderCountByDate: {
                  method: 'GET',
                  url: actionUrl + 'order/count-by-date'
                },
                orderAmountByDate: {
                  method: 'GET',
                  url: actionUrl + 'order/amount'
                },
                orderWeekGraphic: {
                  method: 'GET',
                  url: actionUrl + 'order/graphic/week'
                },
                orderHourGraphic: {
                  method: 'GET',
                  url: actionUrl + 'order/graphic/hour'
                },
                userConnected: {
                  method: 'GET',
                  url: actionUrl + 'user/connected'
                },
                resumeGeneral: {
                  method: 'GET',
                  url: actionUrl + 'general-resume'
                },
                bestSalesArticles: {
                  method: 'GET',
                  url: actionUrl + 'articles-best-sales'
                },
                sellersRank: {
                  method: 'GET',
                  url: actionUrl + 'sellers-rank',
                }
             }

        );
    });
})();

(function()
{
	'use strict';

	angular
		.module('fuse')
		.factory('SliderResource', function($resource, myConfig, HttpTransformDate){
			var actionUrl = myConfig.endPointApi + 'slider/';

			return $resource(actionUrl + ':id', {
				id: '@id'
			},{
				edit: {
					method: 'GET',
					url: actionUrl + ':id/edit',
					isArray: false
				},
				list: {
					method: 'GET',
					url: actionUrl + '/',
					isArray: true
				},
				toggleStatus: {
					method: 'GET',
					url: actionUrl + 'toggle-status/:idSlider',
					isArray: false,
					params: {
						idSlider: '@idSlider'
					}
				},
				update: {
					method: 'PUT',
					url: actionUrl + ':id'
				},
				getImage: {
					method: 'GET',
					url: actionUrl + 'slides/:id/image',
					params: {
						id: '@id'
					},
					isArray: true
				}
			});
		});
})();
(function()
{
  'use strict';

  angular
    .module('fuse')
    .factory('SearchResource', function($resource,myConfig){
      var actionUrl = myConfig.endPointApi + 'search/';
      return $resource(actionUrl + ':id', {
        id: '@id'
      },{
        type: {
          method: 'GET',
          url: actionUrl + 'type/:type/:term',
          isArray: true,
          params:{
            type:'@type',
            term:'@term',
            campaign:'@campaign'
          }
        }
      });
    });
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('RuleResource', function($resource,myConfig){

            var actionUrl=myConfig.endPointApi+'rule/';
            return $resource(actionUrl+':id',{
                id:'@id'
            },{
                type: {
                    method: 'GET',
                    url: actionUrl + 'type/:type/:item',
                    isArray: false,
                    params:{
                        type:'@type',
                        item: '@item'
                    }
                },
                update: {
                  method: 'PUT',
                  url: actionUrl + 'update/:type/:item',
                  params:{
                    type:'@type',
                    item: '@item'
                  }
                },
                deleteAllRules: {
                  method: 'DELETE',
                  url: actionUrl + 'delete/:type/:item',
                  params:{
                    type:'@type',
                    item: '@item'
                  }
                },

                items_with_rules: {
                  method: 'GET',
                  url: actionUrl + 'items/only-with-rules',
                  isArray:true
                  //  params:{
                  //  type:'@type',
                  //    item: '@item'
                  //}
                }

             }
        );
    });
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('RulePromotionalResource', function($resource,myConfig,HttpTransformDate){

            var actionUrl=myConfig.endPointApi+'rule-promotional/';
            return $resource(actionUrl+':id',{
                id:'@id'
            },{
                get: {
                  transformResponse: HttpTransformDate.transformFromString('date_from', 'date_to')
                },
                list: {
                  method: 'GET',
                  url: actionUrl + '/',
                  isArray: true
                },
                getComplete: {
                  method: 'GET',
                  url: actionUrl + 'get-complete/:id',
                  isArray: false,
                  params : {
                    id: '@id',
                  }
                },
                update: {
                  method: 'PUT',
                  url: actionUrl + ':id',
                  transformResponse: HttpTransformDate.transformFromString('date_from', 'date_to')
                },
                addPharma: {
                  method: 'POST',
                  url: actionUrl + ':id/add-pharma/:idUser',
                  transformResponse: HttpTransformDate.transformFromString('date_from', 'date_to'),
                  params : {
                    id: '@id',
                    idUser: '@idUser',
                  }
                },
                delPharma: {
                  method: 'POST',
                  url: actionUrl + ':id/del-pharma/:idUser',
                  transformResponse: HttpTransformDate.transformFromString('date_from', 'date_to'),
                  params : {
                    id: '@id',
                    idUser: '@idUser',
                  }
                },
             }

        );
    });
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('RoleResource', function($resource,myConfig){
        
 
        var actionUrl=myConfig.endPointApi+'role/';

        

        return $resource(actionUrl+':id',{
            id:'@id'
        },{
        list: {
                method: 'GET',
                url: actionUrl + '/',
                isArray: true,
               }
       /* hosts: {
                method: 'GET',
                url: actionUrl + 'hosts/:idTask',
                isArray: true,
                params:{idTask:'@idTask'}
               },      
        status: {
                method: 'GET',
                url: actionUrl + 'status/:idTask/:status',
                isArray: false,
                params:{
                    idTask:'@idTask',
                    status:'@status'
                }
               }*/,          

           }       

        );
        
        
        
    });
        

    
})();
(function()
{
  'use strict';

  angular
    .module('fuse')
    .factory('PromotionResource', function($resource,myConfig,HttpTransformDate){
      var actionUrl = myConfig.endPointApi + 'promotion/';
      return $resource(actionUrl + ':id', {
        id: '@id'
      },{
        get: {
          transformResponse: HttpTransformDate.transformFromString('launch_date', 'expiration_date')
        },
        edit: {
          method: 'GET',
          url: actionUrl + ':id/edit',
          isArray: false,
          transformResponse: HttpTransformDate.transformFromString('launch_date', 'expiration_date')
        },
        list: {
          method: 'GET',
          url: actionUrl + '/',
          isArray: true
        },
        listToSelect: {
          method: 'GET',
          url: actionUrl + 'list-to-select',
          isArray: true
        },
        paginatedList: {
          method: 'GET',
          url: actionUrl + 'pagination',
          isArray: false
        },
        groupedPaginatedList: {
          method: 'GET',
          url: actionUrl + 'pagination/grouped',
          isArray: false
        },
        toggleStatus: {
          method: 'GET',
          url: actionUrl + 'toggle-status/:idPromotion',
          isArray: false,
          params: {
            idPromotion: '@idPromotion'
          }
        },
        uploadList: {
          method: 'GET',
          url: actionUrl+ ':idPromotion/uploads/:type',
          isArray: true,
          params: {
            idMaterial: '@idPromotion',
            type: '@type'
          }
        },
        update: {
          method: 'PUT',
          url: actionUrl + ':id'
        },
        getByStatus: {
          method: 'GET',
          url: actionUrl + 'status/:status',
          isArray: true,
          params: {
            status: '@status'
          }
        },
        articlesIds: {
          method: 'GET',
          url: actionUrl + ':idPromotion/articles/ids',
          isArray: true,
          params: {
            idPromotion: '@idPromotion'
          }
        },
        materialsIds: {
          method: 'GET',
          url: actionUrl + ':idPromotion/materials/ids',
          isArray: true,
          params: {
            idPromotion: '@idPromotion'
          }
        },
        setVip: {
          method: 'PUT',
          url: actionUrl + ':id/set-vip/:set',
          isArray: false,
          params: {
            set: '@set'
          }
        },
        getVip: {
          method: 'GET',
          url: actionUrl + 'vip',
          isArray: true
        },
        sortVip: {
          method: 'POST',
          url: actionUrl + 'vip',
          isArray: true
        },
        getTrash: {
          method: 'get',
          url: actionUrl + 'trash',
          isArray: false
        },
        restore: {
          method: 'put',
          url: actionUrl + 'trash/restore/:id'
        },
        getPromotionPharma: {
          method: 'GET',
          url: actionUrl + ':id/pharmacists',
          isArray: true
        },
        addPharma: {
          method: 'POST',
          url: actionUrl + ':id/pharmacists/:idPharma',
          params: {
            idPharma: '@idPharma'
          },
          isArray: true
        },
        delPharma: {
          method: 'DELETE',
          url: actionUrl + ':id/pharmacists/:idPharma'
        },

        addMasivePharma:{
          method: 'POST',
          url: actionUrl + ':id/pharmacists/masive',
          isArray: false
        },
        delMasivePharma:{
          method: 'DELETE',
          url: actionUrl + ':id/pharmacists/masive',
          isArray: false
        },
        lastActive: {
          method: 'GET',
          url: actionUrl + 'last/active',
          isArray: true
        }

      });
    });
})();

(function ()
{
	'use strict';

	angular
		.module('fuse')
		.factory('PharmacyResource', function($resource,myConfig){

			var actionUrl = myConfig.endPointApi+'pharmacy/';

			return $resource(actionUrl+':id',
				{
					id:'@id'
				},{
					list: {
						method: 'GET',
						url: actionUrl + '/',
						isArray: true,
					},
					statusToggle: {
						method: 'GET',
						url: actionUrl + ':idPharmacy/status/toggle',
						isArray: false,
						params: {
							idPharmacy:'@idPharmacy'
						}
					},
					listWithUsers: {
						method: 'GET',
						url: actionUrl + 'with-users',
						isArray: true,
					},
					update: {
						method: 'PUT',
						url: actionUrl + ':id'
					}
				}
			);
		});
})();
(function()
{
    'use strict';

    /** @ngInject */
    angular
        .module('fuse')
        .factory('OrderResource', function($resource, myConfig) {
            var actionUrl = myConfig.endPointApi + 'order/';
            return $resource(actionUrl + ':id', {
                id: '@id'
            },{
                list: {
                    method: 'GET',
                    url: actionUrl + '/',
                    isArray: true
                },
                getFromGuest: {
                    method: 'GET',
                    url: actionUrl + 'from-guest/:id',
                    isArray: false
                },
                badgeGuest: {
                    method: 'GET',
                    url: actionUrl + 'badge/guest',
                    isArray: false
                },
                badgeAdmin: {
                    method: 'GET',
                    url: actionUrl + 'badge/admin',
                    isArray: false
                },
                myOrders: {
                    method: 'GET',
                    url: actionUrl + 'my-orders',
                    isArray: true
                },
                cancel: {
                    method: 'DELETE',
                    url: actionUrl + 'cancel/:order',
                    params: {
                        cart_id: '@order'
                    }
                },
                detailDestroy: {
                    method: 'DELETE',
                    url: actionUrl + ':order/detail/:detail',
                    params: {
                        order_id: '@order',
                        detail_id: '@detail'
                    }
                },
                adminConfirm:{
                    method: 'PUT',
                    url: actionUrl + ':order/admin-confirm',
                    params: {
                        order: '@order'
                    }
                },
                export:{
                    method: 'GET',
                    url: actionUrl + 'export'
                },
                paginatedList: {
                    method: 'GET',
                    url: actionUrl + 'pagination',
                    isArray: false
                },
                checkMonthlyDiscount: {
                    method: 'GET',
                    url: actionUrl + 'check-monthly-discount/:client',
                    params: {
                        client: '@client'
                    }
                },
                applyMonthlyDiscount: {
                    method: 'POST',
                    url: actionUrl + 'apply-monthly-discount/:order',
                    params: {
                        order: '@order'
                    }
                },
                applyAdvanceMonthlyDiscount: {
                    method: 'POST',
                    url: actionUrl + 'apply-advance-monthly-discount/:order',
                    params: {
                        order: '@order'
                    }
                },
                deleteMonthlyDiscount: {
                    method: 'DELETE',
                    url: actionUrl + 'delete-monthly-discount/:order',
                    params: {
                        order: '@order'
                    }
                },
                addItem: {
                    method: 'POST',
                    url: actionUrl + ':order/detail',
                    params: {
                        order: '@order',
                        type: '@type',
                        qty: '@qty',
                        refreshOrder:'@refreshOrder'
                    }
                },
                uptItem: {
                    method: 'PUT',
                    url: actionUrl + ':order/detail/:id',
                    params: {
                        order: '@order',
                        id: '@id',
                        qty: '@qty',
                        refreshOrder:'@refreshOrder',
                    }
                },
            });
        });
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('OptionResource', function($resource,myConfig,HttpTransformDate){

            var actionUrl=myConfig.endPointApi+'option/';
            return $resource(actionUrl+':id',{
                id:'@id'
            },{
                getMultilple: {
                  method: 'POST',
                  url: actionUrl + 'get-multiple',
                  isArray: true
                },
                saveMultilple: {
                  method: 'POST',
                  url: actionUrl + 'save-multiple',
                  isArray: false
                },
             }

        );
    });
})();

(function ()
{
	'use strict';

	angular
		.module('fuse')
		.factory('MaterialResource', function($resource, myConfig){

			var actionUrl = myConfig.endPointApi + 'material/';

			return $resource(actionUrl + ':id',{
				id:'@id'
			},{
				list: {
					method : 'GET',
					url : actionUrl + '/',
					isArray: true
				},
        paginatedList: {
          method: 'GET',
          url: actionUrl + 'pagination',
          isArray: false
        },
				toggleStatus: {
					method: 'GET',
					url: actionUrl + ':idMaterial/status/toggle',
					isArray: false,
					params: {
						idMaterial: '@idMaterial'
					}
				},
        uploadList: {
					method: 'GET',
					url: actionUrl+ ':idMaterial/uploads/:type',
					isArray: true,
					params: {
						idMaterial: '@idMaterial',
            type: '@type'
					}
				},
        update: {
          method: 'PUT',
          url: actionUrl + ':id'
        },
        campaignsIds: {
          method: 'GET',
          url: actionUrl + ':idMaterial/campaigns/ids',
          isArray: true,
          params: {
            idMaterial: '@idMaterial'
          }
        },
        getByStatus: {
          method: 'GET',
          url: actionUrl + 'status/:status',
          isArray: true,
          params: {
            status: '@status'
          }
        }
			});
		});
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('ImportResource', function($resource,myConfig){

            var actionUrl=myConfig.endPointApi+'import/';
            return $resource(actionUrl+':id',{
                id:'@id'
            },{
                import: {
                    method: 'POST',
                    url: actionUrl + '/',
                    isArray: false,
                    params:{
                        type:'@type',
                    }
                },

             }
        );
    });
})();

(function()
{
  'use strict';

  angular
    .module('fuse')
    .factory('GiftResource', function($resource,myConfig){
      var actionUrl = myConfig.endPointApi + 'gift/';
      var actionArticle=myConfig.endPointApi + 'article/';
      return $resource(actionUrl + ':id', {
        id: '@id'
      },{
        list: {
          method: 'GET',
          url: actionUrl + '/',
          isArray: true
        },
        toggleStatus: {
          method: 'GET',
          url: actionUrl + 'toggle-status/:idArticle',
          isArray: false,
          params: {
            idArticle: '@idArticle'
          }
        },
        uploadList: {
          method: 'GET',
          url: actionArticle+ ':idGift/uploads/:type',
          isArray: true,
          params: {
            idArticle: '@idGift',
            type: '@type'
          }
        },
        update: {
        method: 'PUT',
          url: actionUrl + ':id'
        },
        activeList: {
          method: 'GET',
          url: actionUrl + 'active',
          isArray: true
        }
      });
    });
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('ExportResource', function($resource,myConfig){

            var actionUrl=myConfig.endPointApi+'export/';
            return $resource(actionUrl+':id',{
                id:'@id'
            },{
                getMinToken: {
                    method: 'POST',
                    url: actionUrl + 'get-min-token',
                    isArray: false,
                },
                info: {
                    method: 'GET',
                    url: actionUrl + 'info',
                    isArray: false,
                },

             }
        );
    });
})();

(function()
{
  'use strict';

  angular
    .module('fuse')
    .factory('DownloadResource', function($resource,myConfig){
      var actionUrl = myConfig.endPointApi + 'download/';
      return $resource(actionUrl + ':id', {
        id: '@id'
      },{
        list: {
          method: 'GET',
          url: actionUrl + '/',
          isArray: true
        },
        listInTools: {
          method: 'GET',
          url: myConfig.endPointApi + 'download?mode=tools',
          isArray: true
        },
        toggleStatus: {
          method: 'GET',
          url: actionUrl + 'toggle-status/:idCategory',
          isArray: false,
          params: {
            idCategory: '@idCategory'
          }
        },
        getLink:{
          method: 'GET',
          url: actionUrl + 'get-link/:id',
          isArray: false,
          params: {
            id: '@id'
          }
        },
        update: {
          method: 'PUT',
          url: actionUrl + ':id'
        },
      });
    });
})();

(function()
{
  'use strict';

  angular
    .module('fuse')
    .factory('CategoryResource', function($resource,myConfig){
      var actionUrl = myConfig.endPointApi + 'category/';
      return $resource(actionUrl + ':id', {
        id: '@id'
      },{
        list: {
          method: 'GET',
          url: actionUrl + '/',
          isArray: true
        },
        update: {
          method: 'PUT',
          url: actionUrl + ':id'
        },
        toggleStatus: {
          method: 'GET',
          url: actionUrl + 'toggle-status/:idCategory',
          isArray: false,
          params: {
            idCategory: '@idCategory'
          }
        }
      });
    });
})();

(function()
{
  angular
    .module('fuse')
    .factory('CartResource', function($resource, myConfig){
      var actionUrl = myConfig.endPointApi + 'cart/';
      return $resource(actionUrl + ':id', {
        id: '@id'
      },{
        getLast: {
          method: 'GET',
          url: actionUrl + 'date/last'
        },
        getLastWithPromotionalData: {
          method: 'POST',
          url: actionUrl + 'promotional-data'
        },
        update: {
          method: 'PUT',
          url: actionUrl + ':id'
        },
        addItem: {
          method: 'POST',
          url: actionUrl + 'detail',
          params: {
            id: '@id',
            type: '@type',
            qty: '@qty',
            refreshOrder:'@refreshOrder'
          }
        },
        delItem: {
          method: 'DELETE',
          url: actionUrl + ':cart/detail/:id',
          params: {
            cart: '@cart',
            id: '@id'
          }
        },
        uptItem: {
          method: 'PUT',
          url: actionUrl + ':cart/detail/:id',
          params: {
            cart: '@cart',
            id: '@id',
            qty: '@qty',
            refreshOrder:'@refreshOrder',
          }
        },
        confirm: {
          method: 'POST',
          url: myConfig.endPointApi + 'order',
          params: {
            cart_id: '@cart_id'
          }
        },

      });
    })
})();

(function ()
{
	'use strict';

	angular
		.module('fuse')
		.factory('CampaignResource', function($resource,myConfig,HttpTransformDate){

			var actionUrl = myConfig.endPointApi + 'campaign/';

			return $resource(actionUrl + ':id', {
				id:'@id'
			},{
            get: {
              transformResponse: HttpTransformDate.transformFromString('launch_date', 'expiration_date')
            },
            list: {
                method: 'GET',
                url: actionUrl + '/',
                isArray: true
            },
            listToSelect: {
              method: 'GET',
              url: actionUrl + 'list-to-select',
              isArray: true
            },
            toggleStatus: {
                method: 'GET',
                url: actionUrl + 'toggle-status/:idCampaign',
                isArray: false,
                params: {
                    idCampaign:'@idCampaign'
                }
            },
            uploadList: {
              method: 'GET',
              url: actionUrl+ ':idCampaign/uploads/:type',
              isArray: true,
              params: {
                idCampaign: '@idCampaign',
                type: '@type'
              }
            },
            update: {
              method: 'PUT',
              url: actionUrl + ':idCampaign',
              params: {
                idCampaign: '@idCampaign'
              }
            },
            imagesByProportion: {
              method: 'GET',
              url: actionUrl+ ':idCampaign/images-by-proportion/:proportion',
              isArray: true,
              params: {
                idCampaign: '@idCampaign',
                proportion: '@proportion'
              }
            },
            getSlider: {
              method: 'GET',
              url: actionUrl+ 'slides',
              isArray: true
            },
            getByStatus: {
              method: 'GET',
              url: actionUrl + 'status/:status',
              isArray: true,
              params: {
                status: '@status'
              }
            },
            getByStatusLite: {
              method: 'GET',
              url: actionUrl + 'status-lite/:status',
              isArray: true,
              params: {
                status: '@status'
              }
            },
            getTrash: {
              method: 'GET',
              url: actionUrl + 'trash',
              isArray: true
            },
            restore: {
              method: 'PUT',
              url: actionUrl + 'trash/restore/:id'
            },
            getCampaignPharma: {
              method: 'GET',
              url: actionUrl + ':id/pharmacists',
              isArray: true
            },
            addPharma: {
              method: 'POST',
              url: actionUrl + ':id/pharmacists/:idPharma',
              params: {
                idPharma: '@idPharma'
              },
              isArray: true
            },
            delPharma: {
              method: 'DELETE',
              url: actionUrl + ':id/pharmacists/:idPharma'
            },
            addMasivePharma:{
              method: 'POST',
              url: actionUrl + ':id/pharmacists/masive',
              isArray: false
            },
            delMasivePharma:{
              method: 'DELETE',
              url: actionUrl + ':id/pharmacists/masive',
              isArray: false
            },
            paginatedList: {
                method: 'GET',
                url: actionUrl + 'pagination',
                isArray: false
            },
            minList: {
                method: 'GET',
                url: actionUrl + 'list',
                isArray: true
            }
        });
    });
})();

(function()
{
  'use strict';

  angular
    .module('fuse')
    .factory('AuthResource', function($resource,myConfig){
      var actionUrl = myConfig.endPointApi + 'auth/';
      return $resource(actionUrl , {},{
        checkToken: {
          method: 'GET',
          url: actionUrl + 'check-token',
          isArray: false
        }
      });
    });
})();

(function()
{
  'use strict';

  angular
    .module('fuse')
    .factory('ArticleResource', function($resource,myConfig){
      var actionUrl = myConfig.endPointApi + 'article/';
      return $resource(actionUrl + ':id', {
        id: '@id'
      },{
        list: {
          method: 'GET',
          url: actionUrl + '/',
          isArray: true
        },
        paginatedList: {
          method: 'GET',
          url: actionUrl + 'pagination',
          isArray: false
        },
        toggleStatus: {
          method: 'GET',
          url: actionUrl + 'toggle-status/:idArticle',
          isArray: false,
          params: {
            idArticle: '@idArticle'
          }
        },
        uploadList: {
          method: 'GET',
          url: actionUrl+ ':idArticle/uploads/:type',
          isArray: true,
          params: {
            idArticle: '@idArticle',
            type: '@type'
          }
        },
        update: {
          method: 'PUT',
          url: actionUrl + ':id'
        },
        getByStatus: {
          method: 'GET',
          url: actionUrl + 'status/:status',
          isArray: true,
          params: {
            status: '@status'
          }
        },
        setVip: {
          method: 'PUT',
          url: actionUrl + ':id/set-vip/:set',
          isArray: false,
          params: {
            set: '@set'
          }
        },
        getVip: {
          method: 'GET',
          url: actionUrl + 'vip',
          isArray: true
        },
        sortVip: {
          method: 'POST',
          url: actionUrl + 'vip',
          isArray: true
        }
      });
    });
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state , LangDatetime ,fuseTheming,api,msNavigationService,Access) {

      // Activate loading indicator
      var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function () {
        $rootScope.loadingProgress = true;
      });

      // De-activate loading indicator
      var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
        $timeout(function () {
          updateOrdersbadge();
          $rootScope.loadingProgress = false;
        });
      });

      // Store state in the root scope for easy access
      $rootScope.state = $state;

      // Cleanup
      $rootScope.$on('$destroy', function () {
        stateChangeStartEvent();
        stateChangeSuccessEvent();
      });

      // Configuracion del tema por defecto
      fuseTheming.setActiveTheme('docs-dark');

      //Actualizar los badge de los pedidos
      function updateOrdersbadge() {
        api.order.badgeGuest().$promise.then(function successCallback(response) {
          Access.hasRealAnyRole(['admin','comercial']).then(function(r){

                if(!r){
                    msNavigationService.saveItem('guest-orders', {
                        title: 'Mis pedidos',
                        icon: 'fa fa-truck',
                        state: 'app.guest-orders',
                        badge: response,
                        weight: 4
                    });
                    msNavigationService.sort()
                }

            }, function errorCallback(response) {
                console.log('error badge pedidos')
            });
          });


        api.order.badgeAdmin().$promise.then(function successCallback(response) {
          msNavigationService.saveItem('manager.orders', {
            title    : 'Pedidos',
            icon     : 'fa fa-truck',
            state    : 'app.orders',
            badge    : response,
            weight   : 5
          });
          msNavigationService.sort()

        }, function errorCallback(response) {
          console.log('error badge pedidos')
        });

        api.user.badgePromotionals().$promise.then(function successCallback(response) {


          msNavigationService.saveItem('my-discounts', {
            title    : 'Mis descuentos',
            icon     : 'fa fa-barcode',
            state    : 'app.guest-promotionals',
            badge    : response,
            weight   : 5
          });
          msNavigationService.sort()

        }, function errorCallback(response) {
          console.log('error badge pedidos')
        });




      }

      //Configuracion de los dialogs de campañas y promociones

      var confpromo= {
        'article': {
          type: 'article',
          title: "Seleccione un artículo",
          template: "app/main/admin/promotions/views/dialogs/selectArticle.html",
          api: api.article,
          getData: function () {
            return false;
          }
        },
        'material': {
          type: 'material',
          title: "Seleccione un material",
          template: "app/main/admin/promotions/views/dialogs/selectMaterial.html",
          api: api.material,
          getData: function () {
            return false;
          }
        }
      };
      var confcampaig= {
        'article': {
          type: 'article',
          title: "Seleccione un artículo",
          template: "app/main/admin/campaigns/views/dialogs/selectArticle.html",
          api: api.article,
          getData: function () {
            return false;
          }
        },
        'material': {
          type: 'material',
          title: "Seleccione un material",
          template: "app/main/admin/campaigns/views/dialogs/selectMaterial.html",
          api: api.material,
          getData: function () {
            return false;
          }
        }
      };

      $rootScope.dialogConfPromo=confpromo;
      $rootScope.dialogConfCampaign=confcampaig;


    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        //$urlRouterProvider.otherwise('/admin/');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions

        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    }
                }
            });
    }

})();

(function ()
{
  'use strict';

  angular
    .module('fuse')
    .controller('IndexController', IndexController)
    .controller('ModalController', ModalController);

  /** @ngInject */
  function IndexController(fuseTheming,$http,msNavigationService, $mdDialog, $mdMedia, $scope, $window,$state,$rootScope,NavCheck,UserProfile)
  {
    var vm = this;

    // $rootScope.$on("$stateChangeStart",
    //     function (event, toState, toParams, fromState, fromParams) {
    //      console.log("from",fromState);
    //      console.log("to",toState);
    //     });
    $rootScope.$on('login',function (event){
      UserProfile.then(function(userProfile){
        userProfile.$refresh().then(function(u){
          $scope.hasAdminAccess=u.$hasAnyRole(['admin']);
          $scope.hasComercialAccess=u.$hasAnyRole(['comercial','admin']);
        })
      });
    });

    UserProfile.then(function(userProfile){
      userProfile.$refresh().then(function(u){
        //console.log(u);
        $scope.hasAdminAccess=u.$hasAnyRole(['admin']);
        $scope.hasComercialAccess=u.$hasAnyRole(['comercial','admin']);
      })
    });
    // Data
    vm.themes = fuseTheming.themes;


    //////////

    /*var browser = $window.navigator.userAgent;

    console.log(browser);

    if (!/firefox/i.test(browser) && !/chrome/i.test(browser)) {*/
    // Opera 8.0+
    var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

// Safari 3.0+ "[object HTMLElementConstructor]"
    var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

// Internet Explorer 6-11
    var isIE = /*@cc_on!@*/false || !!document.documentMode;

    if(isOpera || isSafari || isIE) {
      $rootScope.browser_status=false;
      console.log('Navegador no compatible');
      var useFullScreen = $mdMedia('sm') || $mdMedia('xs');
      $mdDialog.show({
        controller: 'ModalController as mc',
        templateUrl: 'app/main/pharmacist/modal/ie.html',
        parent: angular.element(document.body),
        targetEvent: event,
        scope: $scope,
        preserveScope: true,
        clickOutsideToClose: true,
        fullscreen: useFullScreen
      });
    }

    //Detectamos si el tamaño de la pantalla es de tablet
    if($mdMedia('(width: 1024px)')){
      setTimeout(function(){
        $rootScope.$emit('toggle-sidenav',true);
      },1000);

    }



    //var pusher = new Pusher('f0a8a51a2c5a9f99020c', {
    //  cluster: 'eu',
    //  encrypted: false
    //});
    //console.log(pusher);
    //var channel = pusher.subscribe('admin-channel');
    //channel.bind('App\\Events\\ReceivedOrder', function(data) {
    //  swal(
    //    'Good job!',
    //    'You clicked the button!',
    //    'success'
    //  );
    //  console.log(data)
    //});
    //console.log(channel);

  }

  /** @ngInject */
  function ModalController($mdDialog, $scope) {
    var mc = this;
    mc.hide = function() {
      $mdDialog.hide();
    };
    mc.cancel = function() {
      $mdDialog.cancel();
    };
  }


})();

(function ()
{
  'use strict';

  angular
    .module('fuse')
    .constant('myConfig', {
      // endPointApi : 'https://casilisto.es/mirafarma/public/api/',
      // endPointApi : 'http://mirafarma.test/api/',
      endPointApi : 'https://api.mirafarma.org/api/',
      // endPointApi : 'http://192.168.1.250/mirafarma/public/api/',
      // endPointApi : 'http://mirafarma.test/api/',
      // endPointApi: 'http://mirafarma.test/api',
      uploaderUrl : 'uploads'
    });


})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($mdDateLocaleProvider,LangDatetime,$mdThemingProvider)
    {
       // Primer dia de la semana
       $mdDateLocaleProvider.firstDayOfWeek = 1;

       //Dias
       $mdDateLocaleProvider.days = LangDatetime.days.es;
  	   $mdDateLocaleProvider.shortDays = LangDatetime.sortDays.es;


       //Meses
       $mdDateLocaleProvider.months = LangDatetime.months.es;
  	   $mdDateLocaleProvider.shortMonths = LangDatetime.sortMonths.es;

       //Mensajes

       $mdDateLocaleProvider.msgCalendar=LangDatetime.msg.CALENDAR;
       $mdDateLocaleProvider.msgOpenCalendar=LangDatetime.msg.OPEN_CALENDAR;

      $mdDateLocaleProvider.formatDate = function (date) {
        if (!date) {
          return null;
        }
        return moment(date).format('DD/MM/YYYY');

      };

      $mdDateLocaleProvider.parseDate = function(dateString) {
        var m = moment(dateString, 'DD/MM/YYYY', true);
        return m.isValid() ? m.toDate().toLocaleString() : new Date(NaN);
      };

      //$mdDateLocaleProvider.parseDate = function(dateString) {
      //
      //  var m = moment(dateString, 'L', true);
      //  console.log(m);
      //  return m.isValid() ? m.toDate() : new Date(NaN);
      //};

       // Tema de formularios
       $mdThemingProvider.theme('docs-dark');

    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService(
      $resource,
      UserResource,
      RoleResource,
      PharmacyResource,
      UploadResource,
      CampaignResource,
      MaterialResource,
      CategoryResource,
      PromotionResource,
      ArticleResource,
      GiftResource,
      SearchResource,
      RuleResource,
      RulePromotionalResource,
      CartResource,
      SliderResource,
      OrderResource,
      DownloadResource,
      ImportResource,
      AuthResource,
      SyncResource,
      StatResource,
      ExportResource,
      OptionResource,
      ToolsResource

      )
    {
        var api = {};

        api = {
            user :      UserResource,
            role:       RoleResource,
            pharmacy:   PharmacyResource,
            upload:     UploadResource,
            campaign:   CampaignResource,
            material:   MaterialResource,
            category:   CategoryResource,
            promotion:  PromotionResource,
            article:    ArticleResource,
            gift:       GiftResource,
            search:     SearchResource,
            rule:       RuleResource,
            rulePromotional: RulePromotionalResource,
            cart:       CartResource,
            slider:     SliderResource,
            order:      OrderResource,
            download:   DownloadResource,
            import:     ImportResource,
            auth:       AuthResource,
            sync:       SyncResource,
            stat:       StatResource,
            export:     ExportResource,
            option:     OptionResource,
            tools:      ToolsResource

        };
        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

})();

(function()
{
  'use strict';

  angular
    .module('app.gifts',[])
    .config(config);

  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider
      .state('app.gifts',{
        url   : '/admin/gifts',
        views : {
          'content@app' : {
            templateUrl : 'app/main/admin/gifts/views/listGifts.html',
            controller    : 'GiftsMainCtrl as vm'
          }
        },
        resolve : {
          access: ["Access", function (Access) { return Access.hasRole('admin'); }],
          giftsList: function (api) {
            return api.gift.list().$promise
          }
        }
      });

    $stateProvider
      .state('app.gifts-create', {
        url   : '/admin/gifts/create',
        views : {
          'content@app': {
            templateUrl : 'app/main/admin/gifts/views/createGift.html',
            controller  : 'GiftCreateCtrl as vm'
          }
        },
        resolve: {
          access: ["Access", function (Access) { return Access.hasRole('admin'); }],
        }
      });

    $stateProvider
      .state('app.gifts-edit', {
        url   : '/admin/gifts/edit/:idGift',
        views : {
          'content@app': {
            templateUrl : 'app/main/admin/gifts/views/createGift.html',
            controller  : 'GiftEditCtrl as vm'
          }
        },
        resolve : {
          access: ["Access", function (Access) { return Access.hasRole('admin'); }],
          giftEdit: function(api, $stateParams) {
            return api.gift.get({id:$stateParams.idGift}).$promise;
          },
          uploadsList: function (api, $stateParams) {
            return api.gift.uploadList({idGift: $stateParams.idGift, type: 'image'}).$promise;
          }
        }
      });

    msNavigationServiceProvider.saveItem('manager.utils.rules.gifts', {
      title   : 'Regalos',
      icon    : 'icon-gift',
      state   : 'app.gifts',
      access   :  {
        //authtenticated:true,
        roles : ['admin']
      },
      weight  : 10
    });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.authorization')
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.login', {
            url      : '/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.login': {
                    templateUrl: 'app/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation


        // Navigation
        $translatePartialLoaderProvider.addPart('app/auth/login');

        //msNavigationServiceProvider.saveItem('login', {
        //    title : 'Login',
        //    state : 'app.login',
        //    icon  : 'icon-lock',
        //    weight: 10
        //});
    }

})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label \ntranslate=\"QUICKPANEL.TODAY\">TODAY</md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label \ntranslate=\"QUICKPANEL.CHAT\">CHAT</md-tab-label><md-tab-body><md-content class=\"chat-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" ng-controller=\"ChatTabController as vm\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label translate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</md-tab-label><md-tab-body>\n<md-content class=\"activity-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" class=\"md-whiteframe-1dp\" \nui-view=\"navigation\"></div><div id=\"content-container\" flex layout=\"column\"><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-panel\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"ms-theme-options-panel-button md-primary-bg\" ng-click=\"toggleOptionsPanel()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><div class=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option\"><div \nclass=\"option-title\">Layout Style:</div><md-radio-group layout=\"column\" ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button value=\"verticalNavigation\">Vertical Navigation</md-radio-button>\n<md-radio-button value=\"horizontalNavigation\">Horizontal Navigation</md-radio-button><md-radio-button \nvalue=\"contentOnly\">Content Only</md-radio-button><md-radio-button value=\"contentWithToolbar\">Content with Toolbar\n</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">\nLayout Mode:</div><md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" \nng-change=\"vm.updateLayoutMode()\"><md-radio-button value=\"boxed\">Boxed</md-radio-button><md-radio-button value=\"wide\">\nWide</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div \nclass=\"option-title\">Color Palette:</div><md-menu-item ng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"theme\">\n<md-button class=\"md-raised theme-button\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"themeName\"><span><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" md-font-icon=\"icon-palette\">\n</md-icon><span>{{themeName}}</span></span></md-button></md-menu-item></div></div></div>");
$templateCache.put("app/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div ng-hide=\"vm.browser_status==false\" id=\"login-form\" class=\"md-whiteframe-8dp\"><img \nng-src=\"assets/images/logos/logo-mirafarma-azul.png\" alt=\"\" class=\"mt-16 mb-32\"><form name=\"loginForm\" \nng-submit=\"vm.sendLogin()\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"text\" name=\"email\" \nng-model=\"vm.form.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"LOGIN.EMAIL\"></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nplaceholder=\"Password\" translate translate-attr-placeholder=\"LOGIN.PASSWORD\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Introduzca una contraseña</span>\n</div></div></md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"></div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\">Entrar</md-button></form></div></div></div>");
$templateCache.put("app/components/OrderItem/CartItem.html","<td class=\"name\"><div layout=\"column\" layout-align=\"center start\"><span class=\"h4 mb-10\">\n{{ detail.cart_detail_type == \"Article\" ? \"Artículo\" : detail.cart_detail_type == \"Promotion\" ? \"Promoción\" : \"Material\" }}\n</span> <span class=\"h3 truncate-name\" style=\"width: 100%; max-width: 60vw\">\n{{detail.cart_detail.name | characters:40 }}</span><span class=\"h4 truncate-name\" style=\"width: 100%; max-width: 60vw\" \nng-if=\"detail.cart_detail.national_code\">REF : {{ detail.cart_detail.national_code }}</span> <span \nclass=\"h4 truncate-name\" style=\"width: 100%; max-width: 60vw\" ng-if=\"detail.cart_detail.code\">\nREF : {{ detail.cart_detail.code }}</span> <span class=\"green-500-fg\" ng-if=\"detail.cart_detail.min_amount\">\nMínimo de {{detail.cart_detail.min_amount}} unidades</span> <span class=\"green-500-fg\" \nng-if=\"detail.cart_detail.max_amount\">Máximo de {{detail.cart_detail.max_amount}} unidades</span><div layout=\"column\" \nng-if=\"detail.price.applied_discount\"><span class=\"yellow-800-fg\">Descuento aplicado</span><div layout=\"row\" \nng-if=\"detail.price.applied_discount.sub_type==\'range\'\"><div>\nEscalado de {{detail.price.applied_discount.from}} hasta {{detail.price.applied_discount.to}} <span class=\"red-500-fg\">\n-{{detail.price.applied_discount.percent}}%</span></div></div><div layout=\"row\" \nng-if=\"detail.price.applied_discount.sub_type==\'direct\' || detail.price.applied_discount.sub_type==\'direct-campaign\'\">\n<div>Descuento del <span class=\"red-500-fg\">-{{detail.price.applied_discount.percent}}%</span></div></div><span \nng-if=\"detail.price.applied_discount.campaign\">Campaña asociada: <a \nhref=\"{{detail.price.applied_discount.campaign.url}}\">{{detail.price.applied_discount.campaign.name}}</a></span></div>\n<div layout=\"column\" ng-if=\"detail.price.rule_promotional\"><span class=\"indigo-400-fg\">Descuento</span><div \nlayout=\"row\"><div><span class=\"red-500-fg\">- {{detail.price.rule_promotional.percent}}% </span><span>\nRef: {{detail.price.rule_promotional.ref}} -</span> <span title=\"{{detail.price.rule_promotional.description}}\">\n{{detail.price.rule_promotional.description | characters : 20}}</span></div></div></div><v-accordion \nclass=\"vAccordion--default\" style=\"width: 100%; max-width: 60vw\" multiple=\"multiple\"><v-pane class=\"mt-16\" \nng-if=\"detail.gifts.items.length > 0\" expanded><v-pane-header class=\"mb-0\"><span class=\"md-subheader\"><md-icon \nmd-font-icon=\"icon-gift\"></md-icon>Regalos</span></v-pane-header><v-pane-content ms-scroll><md-list \nstyle=\"max-height: 150px\"><md-list-item class=\"md-2-line\" ng-repeat=\"a in detail.gifts.items\"><img \nng-src=\"http://placehold.it/25x25\" class=\"md-avatar\" alt=\"{{a.gift.name}}\" ng-hide=\"a.gift.thumbnail\"> <img \nng-src=\"{{a.gift.thumbnail.urlth}}\" class=\"md-avatar\" alt=\"{{a.gift.name}}\" ng-show=\"a.gift.thumbnail\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h4 class=\"truncate-name\">{{ a.gift.name }}</h4><h3 class=\"red-500-fg\">\nX{{a.qty}} <span ng-if=\"a.qty==1\">unidad</span><span ng-if=\"a.qty>1\">unidades</span></h3></div></md-list-item>\n</md-list></v-pane-content></v-pane></v-accordion><v-accordion class=\"vAccordion--default\" \nstyle=\"width: 300px !important\" multiple=\"multiple\"><v-pane class=\"mt-16\" \nng-if=\"detail.cart_detail.materials.length >0\"><v-pane-header class=\"mb-0\"><span class=\"md-subheader\"><md-icon \nmd-font-icon=\"icon-gift\"></md-icon>Materiales incluidos</span></v-pane-header><v-pane-content ms-scroll><md-list \nstyle=\"max-height: 150px\"><md-list-item class=\"md-3-line md-long-text\" ng-repeat=\"g in detail.cart_detail.materials\">\n<div class=\"md-list-item-text\" layout=\"column\"><h4 class=\"truncate-name\"><strong>{{ g.name }}</strong></h4><h3 \nclass=\"red-500-fg\">X{{g.qty}} <span ng-if=\"g.qty==1\">unidad</span><span ng-if=\"g.qty>1\">unidades</span></h3></div>\n</md-list-item></md-list></v-pane-content></v-pane></v-accordion></div></td><td class=\"qty\"><numberspinner \nng-show=\"order.status==\'pending\'\" class=\"number-spinner\" role=\"\'order\'\" data=\"{cart_id:order.cart.id,detail:detail}\" \nmodel=\"detail.qty\" min=\"1\" step=\"1\"></numberspinner><span ng-show=\"order.status!==\'pending\'\">{{detail.qty}}</span></td>\n<td class=\"price\"><md-card-price layout=\"column\" layout-align=\"center center\" flex class=\"mv-8\"><span \nng-if=\"detail.price.applied_discount\" class=\"md-subhead mh-8\"><s>{{ detail.price.total_base |currency }}</s></span> \n<span class=\"yellow-900-fg\" ng-if=\"detail.price.applied_discount\">DTO {{detail.price.applied_discount.percent}}% \n</span><span ng-if=\"detail.price.rule_promotional\" class=\"md-subhead mh-8\"><s>\n{{ detail.price.total_price_without_promotional |currency }}</s></span> <span class=\"yellow-900-fg\" \nng-if=\"detail.price.rule_promotional\">DTO {{detail.price.rule_promotional.percent}}% </span><span \nclass=\"md-warn-fg md-title mh-8\">{{ detail.price.total_price |currency }}</span><div layout=\"row\"><span class=\"h-6\">\n<small>Unidad {{ detail.price.base | currency }}</small></span></div></md-card-price></td><td><md-button \nng-if=\"order.status==\'pending\'\" ng-click=\"vmOrder.detailDestroy(detail.id)\" \nclass=\"md-raised md-background-bg md-hue-3\"><md-icon md-font-icon=\"icon-delete-variant\"></md-icon>Eliminar</md-button>\n</td>");
$templateCache.put("app/components/OrderItem/OrderItem.html","<td class=\"name\"><div layout=\"column\" layout-align=\"center start\"><span class=\"h4 mb-10\">\n{{ detail.ordeable_type == \"Article\" ? \"Artículo\" : detail.ordeable_type == \"Promotion\" ? \"Promoción\" : \"Material\" }}\n</span> <span class=\"h3 truncate-name\" style=\"width: 100%; max-width: 60vw\">\n{{detail.order_detail.name | characters:40 }}</span><span class=\"h4 truncate-name\" \nstyle=\"width: 100%; max-width: 60vw\" ng-if=\"detail.order_detail.national_code\">\nREF : {{ detail.order_detail.national_code }}</span> <span class=\"h4 truncate-name\" \nstyle=\"width: 100%; max-width: 60vw\" ng-if=\"detail.order_detail.code\">REF : {{ detail.order_detail.code }}</span> <span\n class=\"green-500-fg\" ng-if=\"detail.order_detail.min_amount\">Mínimo de {{detail.order_detail.min_amount}} unidades\n</span> <span class=\"green-500-fg\" ng-if=\"detail.order_detail.max_amount\">\nMáximo de {{detail.order_detail.max_amount}} unidades</span><div layout=\"column\" ng-if=\"detail.price.applied_discount\">\n<span class=\"yellow-800-fg\">Descuento aplicado</span><div layout=\"row\" \nng-if=\"detail.price.applied_discount.sub_type==\'range\'\"><div>\nEscalado de {{detail.price.applied_discount.from}} hasta {{detail.price.applied_discount.to}} <span class=\"red-500-fg\">\n-{{detail.price.applied_discount.percent}}%</span></div></div><div layout=\"row\" \nng-if=\"detail.price.applied_discount.sub_type==\'direct\' || detail.price.applied_discount.sub_type==\'direct-campaign\'\">\n<div>Descuento del <span class=\"red-500-fg\">-{{detail.price.applied_discount.percent}}%</span></div></div><span \nng-if=\"detail.price.applied_discount.campaign\">Campaña asociada: <a \nhref=\"{{detail.price.applied_discount.campaign.url}}\">{{detail.price.applied_discount.campaign.name}}</a></span></div>\n<div layout=\"column\" ng-if=\"detail.price.rule_promotional\"><span class=\"indigo-400-fg\">Descuento</span><div \nlayout=\"row\"><div><span class=\"red-500-fg\">- {{detail.price.rule_promotional.percent}}% </span><span>\nRef: {{detail.price.rule_promotional.ref}} -</span> <span title=\"{{detail.price.rule_promotional.description}}\">\n{{detail.price.rule_promotional.description | characters : 20}}</span></div></div></div><v-accordion \nclass=\"vAccordion--default\" style=\"width: 100%; max-width: 60vw\" multiple=\"multiple\"><v-pane class=\"mt-16\" \nng-if=\"detail.gifts.items.length > 0\" expanded><v-pane-header class=\"mb-0\"><span class=\"md-subheader\"><md-icon \nmd-font-icon=\"icon-gift\"></md-icon>Regalos</span></v-pane-header><v-pane-content ms-scroll><md-list \nstyle=\"max-height: 150px\"><md-list-item class=\"md-2-line\" ng-repeat=\"a in detail.gifts.items\"><img \nng-src=\"http://placehold.it/25x25\" class=\"md-avatar\" alt=\"{{a.gift.name}}\" ng-hide=\"a.gift.thumbnail\"> <img \nng-src=\"{{a.gift.thumbnail.urlth}}\" class=\"md-avatar\" alt=\"{{a.gift.name}}\" ng-show=\"a.gift.thumbnail\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h4 class=\"truncate-name\">{{ a.gift.name }}</h4><h3 class=\"red-500-fg\">\nX{{a.qty}} <span ng-if=\"a.qty==1\">unidad</span><span ng-if=\"a.qty>1\">unidades</span></h3></div></md-list-item>\n</md-list></v-pane-content></v-pane></v-accordion><v-accordion class=\"vAccordion--default\" \nstyle=\"width: 300px !important\" multiple=\"multiple\"><v-pane class=\"mt-16\" \nng-if=\"detail.order_detail.materials.length >0\"><v-pane-header class=\"mb-0\"><span class=\"md-subheader\"><md-icon \nmd-font-icon=\"icon-gift\"></md-icon>Materiales incluidos</span></v-pane-header><v-pane-content ms-scroll><md-list \nstyle=\"max-height: 150px\"><md-list-item class=\"md-3-line md-long-text\" ng-repeat=\"g in detail.order_detail.materials\">\n<div class=\"md-list-item-text\" layout=\"column\"><h4 class=\"truncate-name\"><strong>{{ g.name }}</strong></h4><h3 \nclass=\"red-500-fg\">X{{g.qty}} <span ng-if=\"g.qty==1\">unidad</span><span ng-if=\"g.qty>1\">unidades</span></h3></div>\n</md-list-item></md-list></v-pane-content></v-pane></v-accordion></div></td><td class=\"qty\"><numberspinner \nng-show=\"order.status==\'pending\' && from!==\'guest\' && !blockOrder \" class=\"number-spinner\" role=\"\'order\'\" \ndata=\"{order_id: order.id,detail:detail}\" model=\"detail.qty\" min=\"1\" step=\"1\"></numberspinner><span>{{detail.qty}}\n</span></td><td class=\"price\"><md-card-price layout=\"column\" layout-align=\"center center\" flex class=\"mv-8\"><span \nng-if=\"detail.price.applied_discount\" class=\"md-subhead mh-8\"><s>{{ detail.price.total_base |currency }}</s></span> \n<span class=\"yellow-900-fg\" ng-if=\"detail.price.applied_discount\">DTO {{detail.price.applied_discount.percent}}% \n</span><span ng-if=\"detail.price.rule_promotional\" class=\"md-subhead mh-8\"><s>\n{{ detail.price.total_price_without_promotional |currency }}</s></span> <span class=\"yellow-900-fg\" \nng-if=\"detail.price.rule_promotional\">DTO {{detail.price.rule_promotional.percent}}% </span><span \nclass=\"md-warn-fg md-title mh-8\">{{ detail.price.total_price |currency }}</span><div layout=\"row\"><span class=\"h-6\">\n<small>Unidad {{ detail.price.base | currency }}</small></span></div></md-card-price></td><td><md-button \nng-if=\"order.status==\'pending\' && from!==\'guest\' && !blockOrder\" ng-click=\"vmOrder.detailDestroy(detail.id)\" \nclass=\"md-raised md-background-bg md-hue-3\"><md-icon md-font-icon=\"icon-delete-variant\"></md-icon>Eliminar</md-button>\n</td>");
$templateCache.put("app/components/alertBox/alertBox.html","<md-card ng-class=\"{\'alert\' : true, \'alert-{{$ctrl.type}}\' : $ctrl.type }\" layout=\"column\" layout-align=\"start center\" \nlayout-gt-xs=\"row\"><div><md-icon class=\"{{ $ctrl.colors[$ctrl.type] }}-fg\" md-font-icon=\"{{ $ctrl.icon }}\"></md-icon>\n</div><div flex><md-content ng-bind-html=\"$ctrl.message\"></md-content></div></md-card>");
$templateCache.put("app/components/pagination/pagination.html","<section class=\"pagination mv-32\" layout=\"row\" layout-align=\"stretch stretch\" flex><md-button flex=\"both\" \ntitle=\"Ir a la página\" aria-label=\"Ir a la página\" class=\"md-raised\" ng-click=\"$ctrl.setPage(1)\" \nng-disabled=\"$ctrl.pagination.current_page == 1\"><md-icon md-font-icon=\"icon-chevron-double-left\"></md-icon>\n</md-button><md-button flex=\"both\" title=\"Ir a la primera página\" aria-label=\"Ir a la primera página\" \nclass=\"md-raised\" ng-click=\"$ctrl.setPage($ctrl.pagination.current_page - 1)\" \nng-disabled=\"$ctrl.pagination.current_page == 1\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button>\n<md-button flex=\"both\" title=\"Ir a la página anterior\" aria-label=\"Ir a la página anterior\" class=\"md-raised\" \nng-click=\"$ctrl.setPage($ctrl.pagination.current_page - 2)\" ng-hide=\"$ctrl.pagination.current_page - 2 < 1\">\n{{ $ctrl.pagination.current_page - 2 }}</md-button><md-button flex=\"both\" \ntitle=\"Ir a la página {{ $ctrl.pagination.current_page - 1 }}\" \naria-label=\"Ir a la página {{ $ctrl.pagination.current_page - 1 }}\" class=\"md-raised\" \nng-click=\"$ctrl.setPage($ctrl.pagination.current_page - 1)\" ng-hide=\"$ctrl.pagination.current_page - 1 < 1\">\n{{ $ctrl.pagination.current_page - 1 }}</md-button><md-button flex=\"both\" title=\"Página actual\" \naria-label=\"Página actual\" class=\"md-raised md-accent\">{{ $ctrl.pagination.current_page }}</md-button><md-button \nflex=\"both\" title=\"Ir a la página {{ $ctrl.pagination.current_page + 1 }}\" \naria-label=\"Ir a la página {{ $ctrl.pagination.current_page + 1 }}\" class=\"md-raised\" \nng-click=\"$ctrl.setPage($ctrl.pagination.current_page + 1)\" \nng-hide=\"$ctrl.pagination.current_page + 1 > $ctrl.pagination.last_page\">{{ $ctrl.pagination.current_page + 1 }}\n</md-button><md-button flex=\"both\" title=\"Ir a la página {{ $ctrl.pagination.current_page + 2 }}\" \naria-label=\"Ir a la página {{ $ctrl.pagination.current_page + 2 }}\" class=\"md-raised\" \nng-click=\"$ctrl.setPage($ctrl.pagination.current_page + 2)\" \nng-hide=\"$ctrl.pagination.current_page + 2 > $ctrl.pagination.last_page\">{{ $ctrl.pagination.current_page + 2 }}\n</md-button><md-button flex=\"both\" title=\"Ir a la página siguiente\" aria-label=\"Ir a la página siguiente\" \nclass=\"md-raised\" ng-click=\"$ctrl.setPage($ctrl.pagination.current_page + 1)\" \nng-disabled=\"$ctrl.pagination.current_page == $ctrl.pagination.last_page\"><md-icon md-font-icon=\"icon-chevron-right\">\n</md-icon></md-button><md-button flex=\"both\" title=\"Ir a la última página\" aria-label=\"Ir a la última página\" \nclass=\"md-raised\" ng-click=\"$ctrl.setPage($ctrl.pagination.last_page)\" \nng-disabled=\"$ctrl.pagination.current_page == $ctrl.pagination.last_page\"><md-icon \nmd-font-icon=\"icon-chevron-double-right\"></md-icon></md-button></section>");
$templateCache.put("app/components/numberspinner/numberspinner.html","<md-button ng-disabled=\"$ctrl.model <= $ctrl.min\" aria-label=\"Añadir\" title=\"Añadir\" ng-click=\"$ctrl.dec()\"><md-icon \nmd-font-icon=\"icon-minus\"></md-icon></md-button><input type=\"number\" ng-model=\"$ctrl.model\" min=\"$ctrl.min\" \nmax=\"$ctrl.max\" step=\"$ctrl.step\" value=\"$ctrl.min\" ng-model-options=\"{updateOn: \'blur\'}\"><md-button \nng-disabled=\"$ctrl.model >= $ctrl.max\" aria-label=\"Quitar\" title=\"Quitar\" ng-click=\"$ctrl.inc()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button>");
$templateCache.put("app/components/numberspinner/sync-number-spinner.html","<md-button ng-disabled=\"$ctrl.model <= $ctrl.min\" aria-label=\"Añadir\" title=\"Añadir\" ng-click=\"$ctrl.dec()\"><md-icon \nmd-font-icon=\"icon-minus\"></md-icon></md-button><input type=\"number\" ng-model=\"$ctrl.model\" min=\"$ctrl.min\" \nmax=\"$ctrl.max\" step=\"$ctrl.step\" value=\"$ctrl.min\"><md-button ng-disabled=\"$ctrl.model >= $ctrl.max\" \naria-label=\"Quitar\" title=\"Quitar\" ng-click=\"$ctrl.inc()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>");
$templateCache.put("app/components/productCard/productCard.html","<md-card style=\"background-color: white\" class=\"campaign-label promotion-label\" flex><span class=\"discount\" \nng-show=\"$ctrl.product.discount\">{{ $ctrl.product.discount }}</span><div class=\"md-card-image hover-effect-zoom\" \nstyle=\"background-image: url({{ $ctrl.product.thumbnail.url ? $ctrl.product.thumbnail.url : \'/assets/images/placeholder/no-disponible.png\' }})\">\n<div class=\"labels labels-left\" layout=\"column\" layout-align=\"start center\"><div class=\"label-45\" \naria-label=\"Precio rebajado\" ng-if=\"$ctrl.product.discounted\"><div class=\"md-red-600-bg\"><md-icon \nmd-font-icon=\"icon-arrow-down-bold\" class=\"red-50-fg\"></md-icon><span class=\"red-50-fg\">Rebajado</span></div></div>\n</div><div class=\"labels labels-bottom-left\" layout=\"column\" layout-align=\"start center\"><span \nclass=\"md-orange-400-bg has-promotions\" aria-label=\"Últimas unidades\" ng-if=\"$ctrl.product.low_stock\"><md-tooltip \nmd-direction=\"left\">Últimas unidades</md-tooltip><md-icon md-font-icon=\"icon-flash\"></md-icon></span></div><div \nclass=\"labels\" layout=\"column\" layout-align=\"start end\"><span class=\"md-blue-400-bg has-campaigns\" \nng-if=\"$ctrl.product.hasCampaigns\" aria-label=\"Está en campaña\"><md-tooltip md-direction=\"left\">Está en campaña\n</md-tooltip><md-icon md-font-icon=\"fa fa-bullhorn\"></md-icon></span><span class=\"md-yellow-500-bg has-promotions\" \nng-if=\"$ctrl.product.hasPromotions\" aria-label=\"Parte de una promoción\"><md-tooltip md-direction=\"left\">\nParte de una promoción</md-tooltip><md-icon md-font-icon=\"icon-tag-multiple\"></md-icon></span><span \nclass=\"md-green-A400-bg has-promotions\" ng-if=\"$ctrl.product.avaliable_rules.gifts.length > 0\" \naria-label=\"Tiene regalo\"><md-tooltip md-direction=\"left\">Tiene regalo</md-tooltip><md-icon md-font-icon=\"icon-gift\">\n</md-icon></span><span class=\"md-blue-grey-A400-bg has-promotions\" ng-if=\"$ctrl.product.materials.length > 0\" \naria-label=\"Tiene material\"><md-tooltip md-direction=\"left\">Tiene material</md-tooltip><md-icon \nmd-font-icon=\"icon-presentation\"></md-icon></span><span class=\"md-pink-400-bg has-promotions\" \nng-if=\"$ctrl.product.hasGiftCampaign\" aria-label=\"Está en campaña con regalo\"><md-tooltip md-direction=\"left\">\nEstá en campaña con regalo</md-tooltip><md-icon md-font-icon=\"icon-gift\"></md-icon></span><span \nclass=\"md-blue-500-bg white-fg has-promotions has-promotions--text\" \nng-if=\"$ctrl.type == \'promotion\' && $ctrl.product.covid19\" aria-label=\"COVID19\">COVID19</span> <span \nclass=\"md-yellow-500-bg black-fg has-promotions has-promotions--text\" \nng-if=\"$ctrl.type == \'promotion\' && $ctrl.product.soon\" aria-label=\"SOON\">Próximamente</span></div><a \nui-sref=\"{{\'app.guest-\' + $ctrl.product.type + \'-show({ id: $ctrl.product.id })\'}}\" class=\"overlay\"></a></div>\n<md-card-title flex=\"nogrow\"><md-card-title-text><span title=\"{{ $ctrl.product.name }}\" \naria-label=\"{{ $ctrl.product.name }}\" class=\"title h3\" data-ng-bind=\"$ctrl.product.name | truncateText:40\" \nui-sref=\"{{\'app.guest-\' + $ctrl.product.type + \'-show({ id: $ctrl.product.id })\'}}\" style=\"cursor: pointer\"></span> \n<span ng-if=\"$ctrl.product.national_code\" title=\"{{ $ctrl.product.national_code }}\" \naria-label=\"{{ $ctrl.product.national_code }}\" class=\"category-title h4 secondary-text\" \ndata-ng-bind=\"\'REF : \' + $ctrl.product.national_code | truncateText:40\"></span> <span ng-if=\"$ctrl.product.code\" \ntitle=\"{{ $ctrl.product.code }}\" aria-label=\"{{ $ctrl.product.code }}\" class=\"category-title h4 secondary-text\" \ndata-ng-bind=\"\'REF : \' + $ctrl.product.code | truncateText:40\"></span> <span title=\"{{ $ctrl.product.category.name }}\" \naria-label=\"{{ $ctrl.product.category.name }}\" class=\"category-title h4 secondary-text\" \ndata-ng-bind=\"$ctrl.product.category.name | truncateText:40\"></span> <span \ntitle=\"Solo podrá acceder a las ventajas de esta campaña si pide las unidades requeridas o más\" class=\"green-500-fg\" \nng-if=\"$ctrl.showMinQty==\'true\' && $ctrl.product.campaign_min_qty > 0\">\nMínimo de {{$ctrl.product.campaign_min_qty}} unidades</span> <span class=\"green-500-fg\" \nng-if=\"$ctrl.product.min_amount > 1 && ($ctrl.type==\'promotion\' || ($ctrl.type==\'article\' && $ctrl.from !==\'article-campaign\')) && ($ctrl.product.min_amount <= $ctrl.product.stock )\">\nMínimo de {{$ctrl.product.min_amount}} unidades</span></md-card-title-text></md-card-title><md-card-content \nng-bind=\"$ctrl.product.description | htmlToPlaintext | truncateText:150\"></md-card-content><span flex></span>\n<md-card-actions layout=\"column\" layout-align=\"start center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"center end\">\n<md-card-price layout=\"row\" layout-align=\"space-around center\" flex class=\"mv-8\"><div layout=\"column\"><span \nng-if=\"$ctrl.product.best_price.applied_rule\" class=\"md-subhead mh-8\"><s>{{ $ctrl.product.price|currency}}</s></span> \n<span ng-if=\"$ctrl.product.best_price.applied_rule\" class=\"md-warn-fg md-title mh-8\">\n{{ $ctrl.product.best_price.discounted_price | currency}}</span> <span \nng-if=\"$ctrl.product.best_price.applied_rule==null\" class=\"md-warn-fg md-title mh-8\">\n{{ $ctrl.product.price | currency}}</span></div><span ng-if=\"$ctrl.product.best_price.applied_rule\" \nclass=\"yellow-800-fg\">\n{{$ctrl.product.best_price.applied_rule.sub_type==\'range\'? \'Hasta\':\'\'}} -{{$ctrl.product.best_price.applied_rule.percent}}%\n</span></md-card-price><md-button \nng-if=\"$ctrl.product.stock > 0 && ($ctrl.type != \'article\' || $ctrl.product.hasCampaigns || $ctrl.hasCommercialAccess)\" \ntitle=\"Comprar\" aria-label=\"Comprar\" class=\"btn btn-md md-raised md-accent\" ng-controller=\"CartCtrl as cvm\" \nng-click=\"cvm.showAdvanced($ctrl.product.id,$ctrl.type)\"><md-icon md-font-icon=\"icon-cart\"></md-icon></md-button>\n</md-card-actions><div layout=\"column\" layout-align=\"center center\"><span ng-if=\"$ctrl.product.stock == 0\" \nclass=\"md-red-600-bg p-10 h4\" style=\"margin-bottom: 8px\">Agotado</span></div></md-card>");
$templateCache.put("app/components/slider/slider.html","<slick id=\"slider\" dots=\"true\" autoplay=\"true\" arrows=\"false\" class=\"mb-0\" ng-show=\"$ctrl.slider.status\"><div \nng-repeat=\"slide in $ctrl.slider.slides\"><a ng-if=\"slide.linktype == \'static\'\" href=\"{{ slide.link }}\" \nclass=\"link-wrapper\"></a> <a ng-if=\"slide.linktype == \'angular\'\" ui-sref=\"{{ slide.link }}\" class=\"link-wrapper\"></a> \n<img ng-src=\"{{slide.image[0].url}}\" alt=\"\"> <img ng-src=\"http://placehold.it/1920x500\" alt=\"\" ng-hide=\"slide.image\">\n</div></slick>");
$templateCache.put("app/components/statusCampaigns/statusCampaigns.html","<div class=\"simple-table-container md-whiteframe-4dp mt-32\" ng-if=\"$ctrl.statusModel.length > 0\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"ph-16 pv-16\"><span id=\"status-campaign\" class=\"md-display-1\">Campañas asociadas\n</span></div><table class=\"simple\" ms-responsive-table id=\"cart\"><thead><tr><th style=\"width: 287px\">Miniatura</th><th>\nDescripción</th></tr></thead><tbody><tr ng-repeat=\"(key,campaign) in $ctrl.statusModel\"><td class=\"thumbnail\"><img \nng-hide=\"campaign.thumbnail\" ng-src=\"http://placehold.it/200x200\" alt=\"\" width=\"200\" height=\"200\"> <img \nng-show=\"campaign.thumbnail\" ng-src=\"{{campaign.thumbnail.urlth}}\" alt=\"\" width=\"200\" height=\"200\"></td><td \nclass=\"name\"><div layout=\"column\" layout-align=\"center start\"><span class=\"h3 truncate-name\" style=\"max-width: 100%\">\n{{campaign.name}}</span> <span class=\"h4 red-500-fg\" ng-if=\"campaign.restriction_info.isRestricted\">Restringida</span> \n<span class=\"h4 green-500-fg\" ng-if=\"campaign.restriction_info.isRestricted==false\">Activa</span> <span \nclass=\"h4 orange-500-fg\" ng-if=\"campaign.restriction_info.isRestricted==false && campaign.direct_discount\">\nDescuento en todos sus artículos del {{campaign.direct_discount.percent}}%</span><div layout=\"column\" \nstyle=\"margin-top: 30px\" ng-show=\"campaign.restriction_info.isRestricted\"><h2>Motivo de la restricción: <small \nng-show=\"campaign.restriction_info.restriction_mode==\'particular_qty\'\">\nNecesario pedir algún producto mas de esta campaña</small> <small \nng-show=\"campaign.restriction_info.restriction_mode==\'global_qty\'\">\nNecesario alcanzar el mínimo de artículos de esta campaña</small></h2><div layout=\"row\" \nlayout-align=\"space-around center\" ng-if=\"campaign.restriction_info.restriction_mode==\'global_qty\'\"><span class=\"h2\">\nCantidad de articulos requerida: <span class=\"green-500-fg\">{{campaign.restriction_info.min_global_qty}}</span> </span>\n<span class=\"h2\">{{$ctrl.from==\'guest-order\' ? \'Pedido\' : \'Actual\'}}: <span class=\"orange-500-fg\">\n{{campaign.restriction_info.current_global_qty}}</span></span></div><table class=\"simple\" ms-responsive-table \nng-if=\"campaign.restriction_info.restriction_mode==\'particular_qty\'\"><thead><tr><th>CN</th><th>Cantidad mínima</th><th>\nArtículo</th><th></th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr \nng-class=\"mandatory.stock==false ? \'red-500-fg\':\'\'\" \nng-repeat=\"(key,mandatory) in campaign.restriction_info.particular_qty_info.mandatory_articles\"><td>\n{{ mandatory.national_code }}</td><td><span \nng-class=\"mandatory.campaign_min_qty > mandatory.current_qty ? \'red-500-fg\':\'green-500-fg\'\">\n{{mandatory.campaign_min_qty }} - {{$ctrl.from==\'guest-order\' ? \'pedido\' : \'actual\'}} ({{mandatory.current_qty}})\n</span></td><td><span>{{ mandatory.name }}</span></td><td ng-if=\"mandatory.current_qty == 0 && mandatory.stock\">\n<md-button title=\"Comprar\" ng-controller=\"CartCtrl as cvm\" aria-label=\"Comprar\" class=\"btn btn-sm md-raised md-accent\" \nng-click=\"cvm.showAdvanced(mandatory.id,\'article\')\"><md-icon md-font-icon=\"icon-cart-outline\"></md-icon></md-button>\n</td><td><span ng-if=\"mandatory.stock==false\">Agotado</span></td></tr></tbody></table><span \nng-if=\"campaign.restriction_info.restriction_mode==\'particular_qty\'\">\n**Si el artículo está agotado deberá compensar con unidades de cualquier otro artículo</span></div><div layout=\"row\">\n<v-accordion class=\"vAccordion--default mr-10\" style=\"width: 300px !important\" multiple=\"multiple\" \nng-show=\"campaign.restriction_info.isRestricted==false\"><v-pane class=\"mt-16\" \nng-if=\"campaign.restriction_info.gifts.length > 0\" expanded><v-pane-header class=\"mb-0\"><span class=\"md-subheader\">\n<md-icon md-font-icon=\"icon-gift\"></md-icon>Regalos</span></v-pane-header><v-pane-content ms-scroll><md-list \nstyle=\"max-height: 150px\"><md-list-item class=\"md-3-line md-long-text\" \nng-repeat=\"g in campaign.restriction_info.gifts\"><img ng-src=\"http://placehold.it/25x25\" class=\"md-avatar\" \nalt=\"{{g.gift.name}}\" ng-hide=\"g.gift.thumbnail\"> <img ng-src=\"{{g.gift.thumbnail.urlth}}\" class=\"md-avatar\" \nalt=\"{{g.gift.name}}\" ng-show=\"g.gift.thumbnail\"><div class=\"md-list-item-text\" layout=\"column\"><h4 \nclass=\"truncate-name\"><strong>{{ g.gift.name }}</strong></h4><h3 class=\"red-500-fg\">X{{g.qty}} <span ng-if=\"g.qty==1\">\nunidad</span><span ng-if=\"g.qty>1\">unidades</span></h3></div></md-list-item></md-list></v-pane-content></v-pane>\n</v-accordion><v-accordion class=\"vAccordion--default\" style=\"width: 300px !important\" multiple=\"multiple\" \nng-show=\"campaign.restriction_info.isRestricted==false\"><v-pane class=\"mt-16\" \nng-if=\"campaign.restriction_info.gifts.length > 0\" expanded><v-pane-header class=\"mb-0\"><span class=\"md-subheader\">\n<md-icon md-font-icon=\"icon-gift\"></md-icon>Materiales incluidos</span></v-pane-header><v-pane-content ms-scroll>\n<md-list style=\"max-height: 150px\"><md-list-item class=\"md-3-line md-long-text\" ng-repeat=\"g in campaign.materials\">\n<img ng-src=\"http://placehold.it/25x25\" class=\"md-avatar\" alt=\"{{g.name}}\" ng-hide=\"g.thumbnail\"> <img \nng-src=\"{{g.thumbnail.urlth}}\" class=\"md-avatar\" alt=\"{{g.name}}\" ng-show=\"g.thumbnail\"><div class=\"md-list-item-text\" \nlayout=\"column\"><h4 class=\"truncate-name\"><strong>{{ g.name }}</strong></h4><h3 class=\"red-500-fg\">X{{g.qty}} <span \nng-if=\"g.qty==1\">unidad</span><span ng-if=\"g.qty>1\">unidades</span></h3></div></md-list-item></md-list>\n</v-pane-content></v-pane></v-accordion></div></div></td></tr></tbody></table></div>");
$templateCache.put("app/components/statusOrder/statusOrder.html","<div ng-switch=\"$ctrl.status\"><div ng-switch-when=\"pending\"><span class=\"md-orange-800-bg p-10 h4\">Pendiente</span>\n</div><div ng-switch-when=\"accepted\"><span class=\"md-green-600-bg p-10 h4\">Aceptado</span></div><div \nng-switch-when=\"rejected\"><span class=\"md-red-600-bg p-10 h4\">Cancelado</span></div><div ng-switch-default><span \nclass=\"md-grey-600-bg p-10 h4\">No definido</span></div></div>");
$templateCache.put("app/components/statusPromotionals/statusPromotionals.html","<div class=\"simple-table-container md-whiteframe-4dp mt-32\" \nng-if=\"($ctrl.statusModel.length > 0 ) && ($ctrl.from!==\'my-promotionals\')\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"ph-16 pv-16\"><span id=\"status-promotional\" class=\"md-display-1\">\nDescuentos adicionales</span></div><div class=\"p-15\" layout=\"row\" layout-align=\"center center\" layout-wrap><div \nclass=\"promotional-card mb-10 p-10 pt-5\" ng-repeat=\"(key,item) in $ctrl.statusModel\" flex=\"100\" flex-gt-xs=\"70\"><div \nlayout=\"row\"><div layout=\"column\" flex=\"80\"><h3>{{item.promotional.description}}</h3><div layout=\"row\" flex=\"100\"><div \nflex=\"20\"><img width=\"80px\" ng-src=\"/assets/images/placeholder/no-disponible.png\" alt=\"\" ng-hide=\"item.thumbnail\"> <img\n width=\"80px\" ng-show=\"item.thumbnail\" ng-src=\"{{item.thumbnail.urlth}}\" alt=\"\"></div><div flex=\"80\"><div \nlayout=\"column\"><span class=\"mb-10\">\n{{item.type == \'promotion\' ? \'Promoción\': (item.type == \'campaign\' ? \'Campaña\' : \'\') }}</span> <span class=\"h4\">\n{{item.name}}</span> <span class=\"font-size-10\" ng-if=\"item.type==\'campaign\'\">\nDescuento sobre los productos de esta campaña</span></div></div></div></div><div layout=\"column\" \nlayout-align=\"center center\" ng-if=\"item.promotional.id\" flex=\"20\"><span class=\"font-size-30 red-500-fg\">\n- {{item.promotional.percent}}%</span> <span class=\"font-size-10\">\nHasta {{item.promotional.date_to | momentFormat : \'DD/MM/YYYY\'}}</span></div></div><div \nng-if=\"$ctrl.hasComercialAccess && item.promotional.id\" layout=\"row\" layout-align=\"center center\" flex=\"100\"><md-select\n placeholder=\"Seleccione un descuento\" ng-model=\"$ctrl.promotional[key]\"><md-option \nng-repeat=\"(k,availableItem) in item.available\" ng-value=\"availableItem.id\">\n{{availableItem.ref+\' - \' +availableItem.description}}</md-option></md-select><md-button flex=\"25\" \nng-click=\"$ctrl.savePromotional(item,$ctrl.promotional[key])\" class=\"md-raised md-purple-600-bg md-background-fg\">\nCambiar</md-button></div></div></div></div><div \nng-if=\"($ctrl.statusModel.length > 0 ) && ($ctrl.from==\'my-promotionals\')\" class=\"promotional-card mb-10 p-10 pt-5\" \nng-repeat=\"(key,item) in $ctrl.statusModel\" flex=\"100\"><div layout=\"row\"><div layout=\"column\" flex=\"80\"><h3>\n{{item.promotional.description}}</h3><div layout=\"row\" flex=\"100\"><div flex=\"20\"><img width=\"80px\" \nng-src=\"/assets/images/placeholder/no-disponible.png\" alt=\"\" ng-hide=\"item.thumbnail\"> <img width=\"80px\" \nng-show=\"item.thumbnail\" ng-src=\"{{item.thumbnail.urlth}}\" alt=\"\"></div><div flex=\"80\"><div layout=\"column\"><span \nclass=\"mb-10\">{{item.type == \'promotion\' ? \'Promoción\': (item.type == \'campaign\' ? \'Campaña\' : \'\') }}</span> <span \nclass=\"h4\">{{item.name}}</span> <span class=\"font-size-10\" ng-if=\"item.type==\'campaign\'\">\nDescuento sobre los productos de esta campaña</span></div></div></div></div><div layout=\"column\" \nlayout-align=\"center center\" flex=\"20\" ng-if=\"item.promotional.id\"><span \nng-if=\"item.promotional.discount_type==\'direct\'\" class=\"font-size-30 red-500-fg\">- {{item.promotional.percent}}%</span>\n <span ng-if=\"item.promotional.discount_type==\'range\'\" class=\"font-size-30 red-500-fg\">Escalado</span> <span \nclass=\"font-size-10\">Hasta {{item.promotional.date_to | momentFormat : \'DD/MM/YYYY\'}}</span></div></div></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Row Color\" md-menu-origin \nng-click=\"$mdOpenMenu($event)\" ng-class=\"selectedColor.class\"><span ng-show=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-show=\"!selectedColor.palette\">Select Color</span>\n</md-button><md-menu-content class=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-if=\"!selectedColor.palette\">Select Color</span>\n<md-button class=\"remove-color-button md-icon-button\" ng-click=\"removeColor()\" aria-label=\"Remove Color\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-if=\"!selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in palettes\" ng-click=\"activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-if=\"selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+selectedPalette+\'-\'+hue+\'-bg\'\" \nng-repeat=\"(hue, values) in selectedHues\" ng-click=\"selectColor(selectedPalette,hue)\" layout=\"row\" \nlayout-align=\"start end\" md-ink-ripple><span class=\"label\">{{hue}} </span><i \nng-if=\"selectedPalette == selectedColor.palette && hue == selectedColor.hue\" class=\"s16 icon-check\"></i></div></div>\n</div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><md-icon \nid=\"ms-search-bar-collapser\" md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></label><input \nid=\"ms-search-bar-input\" type=\"text\" ng-model=\"global.search\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div>");
$templateCache.put("app/components/uploader/views/uploader.html","<style>\n.my-drop-zone{\r\n    border: dashed 3px #d7d7d7;\r\n    margin: 20px 20px;\r\n    min-height: 150px;\r\n  }\r\n  .another-file-over-class{\r\n    border-color:red;\r\n  }\r\n  .myCard{\r\n    display: inline-block;\r\n  }\r\n  .uploader-extensions i{\r\n    font-size: 135px;\r\n\r\n  }\r\n  .uploader-files {\r\n    min-width: 135px;\r\n  }\n</style><md-content><div layout=\"row\" layout-wrap><div ng-show=\"$ctrl.uploader.isHTML5\" layout=\"row\" class=\"fullwidth\">\n<div nv-file-drop=\"\" uploader=\"$ctrl.uploader\" options=\"\" layout=\"row\"><div nv-file-over=\"\" uploader=\"$ctrl.uploader\" \nover-class=\"md-deep-purple-200-bg\" class=\"well my-drop-zone fullwidth\" layout=\"row\"><div layout=\"column\" \nlayout-align=\"center center\" flex><h3 ng-show=\"false\">Arrastrar y soltar aquí</h3></div><div class=\"md-padding\" \nlayout=\"row\" layout-wrap><div layout=\"column\" layout-align=\"center center\" flex \nng-hide=\"$ctrl.images.length > 0 || $ctrl.files.length > 0 || $ctrl.uploader.queue.length > 0\"><input class=\"ng-hide\" \nid=\"{{$ctrl.idInput}}\" multiple=\"multiple\" type=\"file\" nv-file-select uploader=\"$ctrl.uploader\"><label \nfor=\"{{$ctrl.idInput}}\" class=\"md-button md-raised md-primary\" aria-label=\"Subir archivo\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon>Seleccionar archivo</label></div><md-card ng-repeat=\"image in $ctrl.images\" \nstyle=\"max-width: 100%\"><img src=\"{{image.urlth}}\" class=\"md-card-image\"><md-button \nng-click=\"$ctrl.deleteFile(image.id)\" title=\"Borrar\" ng-disabled=\"false\" aria-label=\"Borrar\" \nclass=\"md-icon-button launch md-warn\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></md-card><md-card \nclass=\"uploader-files\" ng-repeat=\"file in $ctrl.files\" style=\"max-width: 100%\"><div class=\"uploader-extensions\" \nng-switch=\"file.extension\"><div ng-switch-when=\"txt\"><i class=\"fa fa-file-text-o\"></i></div><div ng-switch-when=\"doc\">\n<i class=\"fa fa-file-word-o\"></i></div><div ng-switch-when=\"docx\"><i class=\"fa fa-file-word-o\"></i></div><div \nng-switch-when=\"pdf\"><i class=\"fa fa-file-pdf-o\"></i></div><div ng-switch-when=\"xlsx\"><i class=\"fa fa-file-excel-o\">\n</i></div><div ng-switch-when=\"csv\"><i class=\"fa fa-file-excel-o\"></i></div><div ng-switch-default><i \nclass=\"fa fa-file-o\"></i></div></div><md-button ng-if=\"$ctrl.uploader.allowDelete\" \nng-click=\"$ctrl.deleteFile(file.id)\" title=\"Borrar\" ng-disabled=\"false\" aria-label=\"Borrar\" \nclass=\"md-icon-button launch md-warn\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><span class=\"h6 mt-30\">\n{{file.filename}}</span></md-card><md-card ng-class=\"{\'uploader-files\':!$ctrl.uploader.isImage(item)}\" \nng-repeat=\"item in $ctrl.uploader.queue\" style=\"max-width: 100%\"><div \nng-show=\"$ctrl.uploader.isHTML5 && $ctrl.uploader.isImage(item)\" ng-thumb=\"{ file: item._file, height: 130 }\"></div>\n<div ng-show=\"!$ctrl.uploader.isImage(item)\" class=\"uploader-extensions\"><i class=\"fa fa-file-text-o fa-5\"></i></div>\n<md-button ng-click=\"item.remove()\" title=\"Delete\" ng-disabled=\"false\" aria-label=\"Google.com\" \nclass=\"md-icon-button launch md-warn\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><span class=\"h6\">\n{{item.file.name}}</span></md-card></div></div></div><div layout=\"column\" layout-align=\"center center\" flex \nng-show=\"$ctrl.images.length > 0 || $ctrl.files.length > 0 || $ctrl.uploader.queue.length > 0\"><input class=\"ng-hide\" \nid=\"{{$ctrl.idInput}}\" multiple=\"multiple\" type=\"file\" nv-file-select uploader=\"$ctrl.uploader\"><label \nfor=\"{{$ctrl.idInput}}\" class=\"md-button md-raised md-primary\" aria-label=\"Subir archivo\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon>Seleccionar archivo</label></div></div></div></md-content>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><img ng-src=\"assets/images/logos/imago-mirafarma.png\" alt=\"\" \nclass=\"logo-image\" ng-show=\"vm.folded\"> <img ng-src=\"assets/images/logos/logo-mirafarma.png\" alt=\"\" class=\"logo-text\" \nng-show=\"!vm.folded\"></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/main/admin/category/createCategory.html","<md-dialog ng-controller=\"CategoryController as vm2\" aria-label=\"Añadir categoría\" ng-cloak><form><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Categoría</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm2.cancel()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Cerrar ventana\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\"><form name=\"vm2.fcategory\" ng-submit=\"vm2.store()\" \nclass=\"form-wrapper\" novalidate><md-input-container layout=\"row\"><md-icon md-font-icon=\"icon-folder\" \nclass=\"md-primary\"></md-icon><input type=\"text\" value=\"\" ng-model=\"vm2.category.name\" \nplaceholder=\"Nombre de la categoría\" style=\"min-width: 300px; max-width: 100%\"></md-input-container></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm2.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon>Cancelar</md-button><md-button ng-click=\"vm2.store()\" style=\"margin-right:20px\">\n<md-icon md-font-icon=\"icon-content-save\"></md-icon>Guardar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/category/editCategory.html","<md-dialog aria-label=\"Añadir categoría\" ng-cloak><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>Categoría</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-controller=\"ModalController as mc\" ng-click=\"mc.cancel()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Cerrar ventana\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\"><form name=\"vm2.fcategory\" ng-submit=\"vm2.store()\" \nclass=\"form-wrapper\" novalidate><md-input-container layout=\"row\"><md-icon md-font-icon=\"icon-folder\" \nclass=\"md-primary\"></md-icon><input type=\"text\" value=\"\" ng-model=\"category.name\" placeholder=\"Nombre de la categoría\" \nstyle=\"min-width: 300px; max-width: 100%\"></md-input-container></form></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-controller=\"ModalController as mc\" ng-click=\"mc.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon>Cancelar</md-button><md-button ng-click=\"vm2.update(category)\" \nstyle=\"margin-right:20px\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>Guardar</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/admin/category/index.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">\nCategorias</div></div><md-button ng-controller=\"CategoryController as vm2\" ng-click=\"vm2.showAdvanced()\" \nclass=\"md-fab md-warn button-fixed-bottom\" aria-label=\"Eat cake\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div><div class=\"content\"><div class=\"simple-table-container md-whiteframe-4dp\"><div layout=\"row\" flex \nhide-xs hide-sm class=\"mr-16 searchbar md-background-bg md-hue-2\" layout-align=\"space-between stretch\"><input \ntype=\"text\" name=\"search\" placeholder=\"Buscar...\" ng-model=\"vm.search\" flex><md-icon md-font-icon=\"icon-magnify\">\n</md-icon></div><table class=\"simple\" ms-responsive-table><thead><tr><th>#Id</th><th>Nombre</th><th class=\"article\">Art\n<md-tooltip>Artículos</md-tooltip></th><th>Camp<md-tooltip>Campañas</md-tooltip></th><th>Promos<md-tooltip>Promociones\n</md-tooltip></th><th>Mat<md-tooltip>Materiales</md-tooltip></th><th>Acciones</th></tr></thead><tfoot><tr><td></td>\n</tr></tfoot><tbody><tr ng-repeat=\"(key,cat) in vm.categories | filter:vm.search\"><td>{{cat.id}}</td><td class=\"name\">\n{{cat.name}}</td><td>{{cat.articles}}</td><td>{{cat.campaigns}}</td><td>{{cat.promotions}}</td><td>{{cat.materials}}\n</td><td><md-button ng-click=\"vm.showAdvancedEdit(cat)\" class=\"md-raised\"><md-icon md-font-icon=\"icon-open-in-new\">\n</md-icon><md-tooltip>Editar</md-tooltip></md-button><md-button ng-click=\"vm.delete(cat)\" class=\"md-raised\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><md-tooltip>Borrar</md-tooltip></md-button></td></tr></tbody></table></div></div>\n</div>");
$templateCache.put("app/main/admin/downloads/create.html","<div class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\" style=\"min-height: 100px;height: 100px\"><div\n class=\"breadcrumb layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16 ng-isolate-scope md-font icon-home material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator ng-isolate-scope md-font icon-chevron-right material-icons md-default-theme\" aria-hidden=\"true\">\n</md-icon><span class=\"parent\">Descargas</span></div><span class=\"h2\">Descargas</span> <span class=\"h3\">\n{{ vm.download.name }}</span></div><div class=\"content\" md-background-bg><div \nng-include=\"\'app/main/admin/downloads/forms/create.html\'\"></div></div></div>");
$templateCache.put("app/main/admin/downloads/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div \nclass=\"breadcrumb layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16 ng-isolate-scope md-font icon-home material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator ng-isolate-scope md-font icon-chevron-right material-icons md-default-theme\" aria-hidden=\"true\">\n</md-icon><span class=\"parent\">Descargas</span></div><div class=\"title\">Descargas</div></div><md-button \nui-sref=\"app.downloads-create\" class=\"md-fab md-warn button-fixed-bottom\" aria-label=\"Añadir regalo\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"content\"><div \nclass=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" ms-responsive-table><thead><tr><th>#</th><th>\nNombre</th><th>Archivo</th><th>Enlace</th><th>Acciones</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr \nng-repeat=\"(key,download) in vm.downloads\"><td class=\"id\">{{ download.id }}</td><td class=\"name\">{{download.name}}</td>\n<td class=\"filename\">{{download.filename}}</td><td class=\"link\"><a ui-sref=\"app.download({id:download.id})\">\n{{$state.href(\'app.download\',{id:download.id},{absolute: true})}}</a></td><td><md-menu md-offset=\"0 -7\"><md-button \naria-label=\"open menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical \"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nui-sref=\"app.downloads-edit({id:download.id})\"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon>Editar</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.destroy(download.id,$index)\"><md-icon \nmd-font-icon=\"icon-delete-variant\"></md-icon>Eliminar</md-button></md-menu-item></md-menu-content></md-menu></td></tr>\n</tbody></table></div></div></div>");
$templateCache.put("app/main/admin/home/dashboard.html","<div id=\"dashboard-ecommerce\" class=\"page-layout simple fullwidth\" layout=\"row\"><div class=\"center\" flex ms-scroll><div\n class=\"content\"><md-tabs md-dynamic-height><md-tab label=\"Panel\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><md-select \nclass=\"simplified font-size-16\" ng-model=\"vm.widget1.currentRange\" aria-label=\"Change range\"><md-option \nng-selected=\"$first\" ng-repeat=\"(key, range) in vm.widget1.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select>\n<md-button class=\"md-icon-button\" aria-label=\"More\"><md-icon title=\"Ver pedidos\" md-font-icon=\"icon-arrow-right\" \nui-sref=\"app.orders\"><md-tooltip>Ver pedidos</md-tooltip></md-icon></md-button></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">\n{{vm.widget1.data.count[vm.widget1.currentRange]}}</div><div class=\"h3 secondary-text font-weight-500 text-uppercase\">\n{{vm.widget1.data.label}} {{vm.widget1.ranges[vm.widget1.currentRange] | lowercase}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\" ng-hide=\"vm.widget1.currentRange == \'TM\'\">\nEsta semana: {{vm.widget1.data.count.TW}} </span><span class=\"h4 secondary-text text-truncate\" \nng-show=\"vm.widget1.currentRange == \'TM\'\">Mes pasado: {{vm.widget1.data.count.LM}}</span></div></ms-widget-front>\n<ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" ng-model=\"vm.widget2.currentRange\" \naria-label=\"Change range\"><md-option ng-selected=\"$first\" ng-repeat=\"(key, range) in vm.widget2.ranges\" \nvalue=\"{{key}}\">{{range}}</md-option></md-select><md-button class=\"md-icon-button\" aria-label=\"More\"><md-icon \ntitle=\"Ver pedidos\" md-font-icon=\"icon-arrow-right\" ui-sref=\"app.orders\"><md-tooltip>Ver pedidos</md-tooltip></md-icon>\n</md-button></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"red-fg font-size-40 line-height-72\">{{vm.widget2.data.count[vm.widget2.currentRange]|currency}}</div><div \nclass=\"h3 secondary-text font-weight-500 text-uppercase\">\n{{vm.widget2.data.label}} {{vm.widget2.ranges[vm.widget2.currentRange] | lowercase}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\" ng-hide=\"vm.widget2.currentRange == \'TM\'\">\nEsta semana: {{vm.widget2.data.count.TW |currency}} </span><span class=\"h4 secondary-text text-truncate\" \nng-show=\"vm.widget2.currentRange == \'TM\'\">Mes pasado: {{vm.widget2.data.count.LM |currency}}</span></div>\n</ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Usuarios</div></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"orange-fg font-size-72 line-height-72\">{{vm.widget3.today}}\n</div><div class=\"h3 secondary-text font-weight-500\">HOY</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">Usuarios activados:</span> <span\n class=\"h4 ml-8\">{{vm.widget3.total_activated}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\">\n<div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget3.detail}}</div></ms-widget-back>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\"><ms-widget-front \nclass=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\nPromociones</div><md-button class=\"md-icon-button\" aria-label=\"More\"><md-icon title=\"Ver pedidos\" \nmd-font-icon=\"icon-arrow-right\" ui-sref=\"app.promotions\"><md-tooltip>Ver promociones</md-tooltip></md-icon></md-button>\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"font-size-72 line-height-72\" \nstyle=\"color:#FBC02D !important\">{{vm.general.promotions.activated}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Activadas</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">Artículos relacionados:</span> <span \nclass=\"h4 ml-8\">{{vm.general.promotions.used_articles}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"20\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Campañas</div><md-button class=\"md-icon-button\" aria-label=\"More\">\n<md-icon title=\"Ver campañas\" md-font-icon=\"icon-arrow-right\" ui-sref=\"app.campaigns\"><md-tooltip>Ver campañas\n</md-tooltip></md-icon></md-button></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"font-size-72 line-height-72\" style=\"color:#0D47A1 !important\">{{vm.general.campaigns.activated}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Activadas</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">Artículos relacionados:</span> <span \nclass=\"h4 ml-8\">{{vm.general.campaigns.used_articles}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget3.detail}}</div></ms-widget-back></ms-widget></div><div layout=\"row\" flex=\"100\"><div class=\"widget-group\" \nlayout=\"row\" flex=\"50\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\n{{vm.widget5.title}}</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" \nflex-sm=\"100\"><md-button class=\"ph-16\" ng-repeat=\"(key, range) in vm.widget5.ranges\" \nng-click=\"vm.widget5.changeRange(key)\" ng-disabled=\"vm.widget5.currentRange == key\">{{range}}</md-button></div></div>\n<div class=\"p-16\"><nvd3 class=\"h-420 remove-x-lines\" config=\"vm.widget5.mainChart.config\" \noptions=\"vm.widget5.mainChart.options\" data=\"vm.widget5.mainChart.data\" margin=\"{left:90,top:20,bottom:20,right:20}\">\n</nvd3></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"50\" layout-wrap>\n<ms-widget layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget6.title}}</div><div class=\"pv-16\"></div></div><div \nclass=\"p-16\"><table class=\"simple\" ms-responsive-table><thead><tr><th>REF</th><th>Nombre</th><th>Total</th><th>Pedidos\n</th></tr></thead><tbody><tr ng-repeat=\"(key, article) in vm.widget6.articles\" \nui-sref=\"app.articles-edit({idArticle:article.id})\" class=\"md-button\"><td style=\"padding:10px 5px\">\n{{ article.national_code }}</td><td style=\"padding:10px 5px\">{{ article.name | truncateText:20 }}</td><td \nstyle=\"padding:10px 5px\">{{ article.sumqty}}</td><td style=\"padding:10px 5px\">{{ article.distinct_orders }}</td></tr>\n</tbody></table></div></ms-widget-front></ms-widget></div></div><div layout=\"row\" flex=\"100\"><ms-widget \nlayout=\"column\" flex=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget7.title}}</div><div class=\"pv-16\"><md-select \nclass=\"simplified\" ng-model=\"vm.widget7.currentRange\" ng-change=\"vm.widget7.changeRange(vm.widget7.currentRange)\" \naria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget7.ranges\" value=\"{{key}}\">{{range}}\n</md-option></md-select></div></div><div class=\"p-16\"><nvd3 class=\"h-400\" config=\"vm.widget7.mainChart.config\" \noptions=\"vm.widget7.mainChart.options\" data=\"vm.widget7.mainChart.data\"></nvd3></div><div \nclass=\"pv-8 mh-16 border-top\" layout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"pv-8 border-right\" \nlayout=\"column\" layout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-15\">\nHora con mas pedidos: {{vm.widget7.max_order.hour}}H</span> <span class=\"h4\">({{vm.widget7.max_order.count}} pedidos)\n</span></div><div class=\"pv-8\" layout=\"column\" layout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span \nclass=\"font-size-15\">Media entre {{vm.widget7.total_order}} pedidos</span></div></div></ms-widget-front></ms-widget>\n<ms-widget layout=\"column\" flex=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3 pv-16\">Comerciales</div></div><div class=\"p-16\"><nvd3 \noptions=\"vm.donutChart.options\" data=\"vm.donutChart.data\"></nvd3></div><div class=\"pv-8 mh-16 border-top\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"pv-8 border-right\" layout=\"column\" layout-align=\"center center\" \nflex=\"100\"><span class=\"font-size-15\">Pedidos totales hechos por comerciales : {{vm.donutChart.totalOrders}}</span>\n</div></div></ms-widget-front></ms-widget></div></md-tab><md-tab label=\"Utilidades\"><div \nng-include=\"\'app/main/admin/home/exports.html\'\"></div></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/main/admin/home/exports.html","<h2>Exportaciones</h2><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget style=\"cursor:pointer\" \nng-click=\"vm.export(\'promotions\');\" class=\"h-300 export-card\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-fg\" style=\"background-color:#FBC02D !important\" layout=\"row\" flex>\n<div layout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-3 pb-8\">\n{{vm.exportInfo.promotions.count}}</div><div class=\"h3 font-weight-500\">Promociones</div></div><div \nclass=\"background-image-center\"><md-icon md-font-icon=\"icon-tag-multiple\" class=\"s256 faint-text\"></md-icon></div>\n</ms-widget-front></ms-widget><ms-widget style=\"cursor:pointer\" ng-click=\"vm.export(\'users\');\" \nclass=\"h-300 export-card\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 deep-orange-bg white-fg\" layout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-3 pb-8\">{{vm.exportInfo.users.count}}</div><div class=\"h3 font-weight-500\">Farmacias</div></div><div \nclass=\"background-image-center\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s256 faint-text\"></md-icon></div>\n</ms-widget-front></ms-widget><ms-widget style=\"cursor:pointer\" ng-click=\"vm.export(\'articles\')\" \nclass=\"h-300 export-card\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 cyan-bg white-fg\" layout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-3 pb-8\">{{vm.exportInfo.articles.count}}</div><div class=\"h3 font-weight-500\">Artículos</div></div>\n<div class=\"background-image-center\"><md-icon md-font-icon=\"icon-cube-outline\" class=\"s256 faint-text\"></md-icon></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/admin/home/home.html","<h1>Home view</h1>");
$templateCache.put("app/main/admin/sample/uploader.html","<uploader files=\"vm.uploadFiles\" uploader=\"vm.uploader\" filters=\"[\'file\']\"></uploader><div layout=\"row\" class=\"mt-60\">\n<div flex=\"50\"><json-formatter json=\"vm.uploader\" open=\"1\"></json-formatter></div><div flex=\"50\"><json-formatter \njson=\"vm.uploader2\" open=\"1\"></json-formatter></div></div>");
$templateCache.put("app/main/admin/seller/main.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"center center\" style=\"min-height: 100px; height: 100px\"><div class=\"title\">\nNuevo pedido - Comercial</div></div><div class=\"content\"><div \nclass=\"order-card md-background-bg md-whiteframe-1dp export-order\"><div layout=\"row\" layout-align=\"center center\">\n<md-button ng-if=\"!vm.selectedClient.id\" class=\"md-raised md-primary\" ng-click=\"vm.selectClient()\"><md-icon \nmd-font-icon=\"icon-account-plus\" class=\"m-0 mr-16\"></md-icon>Seleccionar cliente</md-button></div><div \nng-if=\"vm.selectedClient.id\" layout=\"row\" class=\"p-16\" layout=\"row\"><div class=\"order-block-user-info\" layout=\"column\" \nflex=\"40\"><span class=\"h4\">{{vm.selectedClient.username}}</span> <span class=\"h4\">{{vm.selectedClient.name}}</span> \n<span class=\"h4\">{{vm.selectedClient.email}}</span> <span class=\"h4\">{{vm.selectedClient.phone}}</span> <span \nclass=\"h4\">{{vm.selectedClient.address}} - {{vm.selectedClient.postal_code}} -{{vm.selectedClient.city}}</span> <span \nclass=\"h4\">{{vm.selectedClient.state}}</span></div><div layout=\"column\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-green-500-bg md-background-fg p-20\" ng-click=\"vm.startOrder()\"><md-icon \nmd-font-icon=\"icon-arrow-right-bold-circle\" class=\"m-0 mr-16 md-background-fg\"></md-icon>Comenzar</md-button><md-button\n class=\"md-raised md-red-500-bg md-background-fg\" ng-click=\"vm.selectedClient={}\"><md-icon md-font-icon=\"icon-trash\" \nclass=\"md-background-fg\"></md-icon></md-button></div></div></div></div></div>");
$templateCache.put("app/main/pharmacist/downloads/list.html","<md-card class=\"p-30 pb-60\" layout=\"column\"><div layout-align=\"center-center\" layout=\"row\"><h1>Descargas</h1></div>\n<md-button layout-align=\"center center\" ng-repeat=\"download in vm.downloads\" \nclass=\"md-accent md-raised md-hue-1 md-background-fg\" ng-class=\"download.featured ? \'featured\':\'\'\" \nui-sref=\"app.download({id:download.id})\" ng-click=\"vm.download()\">{{download.name}}</md-button></md-card>");
$templateCache.put("app/main/pharmacist/home/account.html","<div class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\" style=\"min-height: 100px;height: 100px\">\n<span class=\"h2\">Mi cuenta</span></div><div class=\"content\" md-background-bg><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"userform\" ng-submit=\"vm.update()\" class=\"md-inline-form\" \nnovalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"name\" ng-model=\"vm.user.name\" placeholder=\"Nombre\" required><div ng-messages=\"userform.name.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Nombre es requerido.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"address\" ng-model=\"vm.user.address\" placeholder=\"Dirección\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" layout-wrap><md-input-container flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-sm=\"20\"><input type=\"text\" name=\"city\" ng-model=\"vm.user.city\" placeholder=\"Ciudad\">\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"20\"><input type=\"text\" name=\"state\" \nng-model=\"vm.user.state\" placeholder=\"Provincia\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-sm=\"20\"><input type=\"text\" name=\"postal_code\" ng-model=\"vm.user.postal_code\" placeholder=\"Código postal\">\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"20\"><input required type=\"text\" \nname=\"phone\" ng-model=\"vm.user.phone\" placeholder=\"Teléfono\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"30\"><label>Email</label><input type=\"email\" name=\"email\" \nng-model=\"vm.user.email\" required email><div ng-messages=\"userform.email.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Email es requerido.</span></div><div ng-message=\"email\"><span>\nEmail no tiene un formato correcto.</span></div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"30\"><input type=\"text\" disabled=\"disabled\" name=\"username\" ng-model=\"vm.user.username\" \nplaceholder=\"Nombre de usuario\" required><div ng-messages=\"userform.username.$error\" role=\"alert\"><div \nng-message=\"required\"><span>El nombre de usuario es requerido.</span></div></div></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"30\"><input type=\"password\" name=\"password\" ng-model=\"vm.user.password\" \nplaceholder=\"Contraseña\" ng-minlength=\"5\"></md-input-container></div><div layout=\"row\" layout-align=\"center center\">\n<md-input-container layout=\"row\" layout-align=\"center\" class=\"md-block\"><md-button type=\"submit\" \nclass=\"md-raised md-accent\" ng-click=\"vm.updateAccount()\" ng-disabled=\"userform.$invalid || fuser.$pristine\" \naria-label=\"Submit\">Guardar</md-button></md-input-container></div></form></div></div></div></div>");
$templateCache.put("app/main/pharmacist/home/home.html","<style>\n#campaign-slider {\r\n    height: auto;\r\n  }\r\n\r\n  #home-promotions product-card,\r\n  #home-promotions .product-card {\r\n    max-width: 100%;\r\n  }\r\n\r\n  @media (min-width: 600px) {\r\n    #home-promotions product-card,\r\n    #home-promotions .product-card {\r\n      max-width: 47%;\r\n    }\r\n  }\r\n\r\n  @media (min-width: 960px) {\r\n    #home-promotions product-card,\r\n    #home-promotions .product-card {\r\n      max-width: 32%;\r\n    }\r\n  }\n</style><slider slider=\"vm.slider\"></slider><div id=\"home-promotions\" layout=\"column\" layout-gt-xs=\"row\" layout-wrap \nlayout-align=\"start stretch\" class=\"p-32\"><product-card ng-repeat=\"p in vm.activePromotions\" product=\"p\" \ntype=\"\'promotion\'\" has-commercial-access=\"vm.hasCommercialAccess\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"30\" \nflex-gt-lg=\"15\" flex-grow=\"0\" layout=\"column\" layout-align=\"space-between center\"></product-card></div>");
$templateCache.put("app/main/pharmacist/login/loginDialog.html","<md-dialog aria-label=\"Establecer contraseña\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Establecer contraseña</h2>\n</div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" layout=\"column\" layout-align=\"start center\"><p \nclass=\"h3\">\nSu usuario todavía no está activado. Por favor, introduzca una nueva contraseña para activar y proteger su cuenta.</p>\n<form name=\"vm.fuser\" ng-submit=\"activate()\" novalidate ng-cloak style=\"width: 100%; max-width: 500px\"><div \nlayout=\"column\" layout-align=\"start stretch\"><md-input-container class=\"mv-10\" flex><label>Escriba su nueva contraseña\n</label><input type=\"password\" name=\"newpsw\" ng-model=\"user.password\" required></md-input-container><md-input-container\n class=\"mv-10\" flex><label>Reescriba su contraseña</label><input type=\"password\" name=\"repeatnewpswd\" \nng-model=\"user.repeatnewpswd\" required></md-input-container><span style=\"color:red\" \nng-if=\"user.repeatnewpswd!==user.password\">No coinciden las contraseñas</span><md-input-container class=\"mv-10\" flex>\n<label>Introduzca un correo electrónico válido</label><input required type=\"text\" name=\"newemail\" \nng-model=\"user.email\"></md-input-container></div><md-button type=\"submit\" class=\"md-raised\" \nng-disabled=\"vm.fuser.$invalid || vm.fuser.$pristine || user.password !== user.repeatnewpswd\" \naria-label=\"Restablecer contraseña\"><md-icon md-font-icon=\"icon-send\"></md-icon>Guardar</md-button></form></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/pharmacist/modal/ie.html","<md-dialog aria-label=\"Tu navegador no es compatible\" ng-cloak class=\"md-background md-hue-1\" ng-cloak><md-toolbar><div\n class=\"md-toolbar-tools md-warng-bg\"><h2>Tu navegador no es compatible</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"mc.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Cerrar ventana\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content layout=\"column\" layout-align=\"start center\" class=\"pv-16 ph-32\"><span\n class=\"md-display-1\">Parece que estás usando un navegador no compatible</span><p>\nEsta web sólo se puede visualizar con <a href=\"https://www.google.com/chrome\" target=\"_blank\">Google Chrome</a>, <a \nhref=\"https://www.mozilla.org/es-ES/firefox/new/\" target=\"_blank\">Mozilla Firefox</a> o <a \nhref=\"https://www.microsoft.com/es-es/windows/microsoft-edge\" target=\"_blank\">Microsoft Edge</a>\n. Utiliza uno de ellos para poder usar la web.</p></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"mc.cancel()\" class=\"md-raised\"><md-icon md-font-icon=\"icon-close\"></md-icon>Cancelar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/pharmacist/promotionals/list.html","<div layout-align=\"center-center\" layout=\"row\"><h1>Mis descuentos promocionales</h1></div><md-card \nclass=\"generic-card-item p-30 pb-60\" layout-align=\"center center\" layout=\"row\" layout-wrap><status-promotionals \nfrom=\"\'my-promotionals\'\" status-model=\"vm.promotionals\" flex=\"70\"></status-promotionals></md-card>");
$templateCache.put("app/main/pharmacist/tools/calculators.html","<h2>Calculadoras</h2><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget style=\"cursor:pointer\" \nui-sref=\"app.calculator_retail\" class=\"h-300 export-card\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"p-16 white-fg\" style=\"background-color:#009688 !important\" layout=\"row\" flex><div \nlayout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-3 pb-8\">PVP</div><div \nclass=\"h3 font-weight-500\">Precio de Venta al Público</div></div><div class=\"background-image-center\"><md-icon \nmd-font-icon=\"icon-calculator\" class=\"s256 faint-text\"></md-icon></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/pharmacist/tools/downloads.html","<h2>Descargas</h2><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nng-repeat=\"download in vm.downloads\" style=\"cursor:pointer\" ng-click=\"vm.download(download.id)\" \nclass=\"h-200 export-card\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 white-fg orange-400-bg\" layout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"h2 pb-8 text-center\">{{ download.name }}</div></div><div class=\"background-image-center\"><md-icon \nmd-font-icon=\"icon-download\" class=\"s200 faint-text\"></md-icon></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/pharmacist/tools/tools.html","<div id=\"tools-home\" class=\"page-layout simple fullwidth\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"content\"><div ng-include=\"\'app/main/pharmacist/tools/calculators.html\'\"></div><div \nng-if=\"vm.downloads && vm.downloads.length > 0\" ng-include=\"\'app/main/pharmacist/tools/downloads.html\'\"></div></div>\n</div></div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\">\n<div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> \n<span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list>\n<md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span>\n</md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div \nclass=\"md-list-item-text\"><h3>{{event.title}}</h3><p>{{event.detail}}</p></div></md-list-item></md-list><md-divider>\n</md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader>\n<md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\">\n<h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list>\n<md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader>\n<md-list-item><h3 translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.notify\" aria-label=\"Notifications\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item><md-list-item><h3 \ntranslate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.cloud\" \naria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch class=\"md-secondary md-warn\" \nng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"toolbar-separator\"></div><ms-search-bar></ms-search-bar><div class=\"toolbar-separator\"></div><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" \nmd-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button></md-menu></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><ms-search-bar>\n</ms-search-bar><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n</div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><md-button ng-controller=\"IndexController\" \nng-if=\"hasAdminAccess\" class=\"md-warn md-raised md-hue-2\" ui-sref=\"app.home\"><md-icon md-font-icon=\"icon-security\">\n</md-icon>Inicio Admin</md-button><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" \nlayout-align=\"start center\"><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span ng-controller=\"UserProfileCtrl as vm\" class=\"username\" hide-xs>{{vm.userprofile.username}}</span>\n<md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content \nwidth=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" \nclass=\"icon\"></md-icon><md-button ui-sref=\"app.guest-account\">Mi cuenta</md-button></md-menu-item><md-menu-divider>\n</md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button\n ng-controller=\"LoginController as vm\" ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content>\n</md-menu></md-menu-bar><md-menu-bar><md-menu id=\"toolbar-cart\" ng-controller=\"MenuCartCtrl as cartvm\"><button \nclass=\"md-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Carrito\"><div layout=\"row\" layout-align=\"space-between center\">\n<md-icon md-font-icon=\"icon-cart\" class=\"icon s32 md-accent\" ng-show=\"cartvm.cart.cartDetails.length > 0\"></md-icon>\n<md-icon md-font-icon=\"icon-cart-outline\" class=\"icon s32\" ng-hide=\"cartvm.cart.cartDetails.length > 0\"></md-icon>\n<md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div><span class=\"badge\" \nng-class=\"{\'md-primary-bg md-hue-3\': cartvm.cart.cartDetails.length > 0, \'md-warn-bg\' : cartvm.cart.cartDetails.length == 0}\">\n{{ cartvm.cart.cartDetails.length }}</span></button><md-menu-content width=\"3\"><md-menu-item \nng-repeat-start=\"detail in cartvm.cart.cartDetails | limitTo:3\" layout=\"row\" layout-align=\"space-between start\" \nstyle=\"height: auto\" class=\"{{ detail.cart_detail_type | lowercase }}\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"cart-item-info\"><img ng-src=\"{{detail.cart_detail.thumbnail.urlth}}\" \nui-sref=\"app.guest-{{ detail.cart_detail_type | lowercase }}-show({id:detail.cart_detail.id})\" alt=\"\" width=\"50\" \nheight=\"50\" ng-show=\"detail.cart_detail.thumbnail\"> <img ng-src=\"http://placehold.it/75x75\" \nui-sref=\"app.guest-{{ detail.cart_detail_type | lowercase }}-show({id:detail.cart_detail.id})\" alt=\"\" width=\"50\" \nheight=\"50\" ng-hide=\"detail.cart_detail.thumbnail\"><div layout=\"column\" layout-align=\"start stretch\" flex><md-button \naria-label=\"{{ detail.cart_detail.name }}\" title=\"{{ detail.cart_detail.name }}\" \nui-sref=\"app.guest-{{ detail.cart_detail_type | lowercase }}-show({id:detail.cart_detail.id})\" \nstyle=\"text-transform: none\">{{ detail.cart_detail.name | truncateText:40 }}</md-button><div class=\"mh-15 mb-15\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"h4 ml-5 md-primary-fg md-hue-3\">\n{{ detail.cart_detail_type == \"Article\" ? \"Artículo\" : detail.cart_detail_type == \"Promotion\" ? \"Promoción\" : \"Material\" }}\n</span> <span class=\"h4 ml-5 md-primary-fg md-hue-3\">{{ detail.qty + \" unidad\" + (detail.qty > 1 ? \'es\' : \'\') }}</span>\n <span class=\"h4 ml-5 md-accent-fg\">{{ detail.cart_detail.price }}€</span></div></div><md-button \naria-label=\"Quitar del carrito\" title=\"Quitar del carrito\" class=\"del-cart-item\" flex=\"nogrow\" \nng-click=\"cartvm.delItem(detail.id)\" style=\"width: auto; min-width: initial; margin-top: 0\"><md-icon \nmd-font-icon=\"icon-close\" style=\"margin: 0\"></md-icon></md-button></div></md-menu-item><md-menu-divider ng-repeat-end \nstyle=\"margin: 0\"></md-menu-divider><md-menu-item layout=\"row\" layout-align=\"center center\" \nng-show=\"cartvm.cart.cartDetails.length > 3\"><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-menu-item>\n<md-menu-divider ng-show=\"cartvm.cart.cartDetails.length > 3\" style=\"margin: 0\"></md-menu-divider><md-menu-item \nlayout=\"row\" layout-align=\"center center\" ng-show=\"cartvm.cart.cartDetails.length > 0\"><span style=\"width: auto\" \nclass=\"md-title\">Total: <span style=\"width: auto\" class=\"md-accent-fg md-title\">{{ cartvm.cart.price | currency }}\n</span></span></md-menu-item><md-menu-divider ng-show=\"cartvm.cart.cartDetails.length > 0\" style=\"margin: 0\">\n</md-menu-divider><md-menu-item ng-show=\"cartvm.cart.cartDetails.length > 0\" class=\"mt-16\"><button \nclass=\"md-button md-raised\" layout=\"row\" layout-align=\"center center\" ui-sref=\"app.cart\">Ver todo el carrito</button>\n</md-menu-item><md-menu-item ng-show=\"cartvm.cart.cartDetails.length == 0\" layout=\"row\" align=\"center\" \nlayout-align=\"center center\"><span class=\"md-subhead md-warn-fg\">El carrito está vacío.</span></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-hide=\"checkAccess(node)\" ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-hide=\"checkAccess(node)\" ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"\n\n            ></li>\n    </ul>\n</script><script>\n$(document).ready(function(){\n    setTimeout(() => {\n      let dat = document.getElementsByClassName(\'ms-navigation-node\')[0]\n      dat.style.display = \'hidden\'\n      dat.style.display = \'block\'\n    }, 2000);\n  })\n</script>");
$templateCache.put("app/main/admin/articles/views/createArticle.html","<div class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\" style=\"min-height: 100px;height: 100px\"><div\n class=\"breadcrumb layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16 ng-isolate-scope md-font icon-home material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator ng-isolate-scope md-font icon-chevron-right material-icons md-default-theme\" aria-hidden=\"true\">\n</md-icon><span class=\"parent\">Artículo</span></div><span class=\"h2\">Artículo</span> <span class=\"h3\">\n{{ vm.article.name }}</span></div><div class=\"content\" md-background-bg><md-tabs md-dynamic-height><md-tab \nlabel=\"Articulo\"><md-card class=\"product-list-card\"><div \nng-include=\"\'app/main/admin/articles/views/forms/create.html\'\"></div></md-card></md-tab><md-tab label=\"Manager\"><div \nng-controller=\"RulesMainCtrl as vm\" ng-include=\"\'app/main/admin/rules/views/manager.html\'\"></div></md-tab></md-tabs>\n</div></div>");
$templateCache.put("app/main/admin/articles/views/listArticles.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div \nclass=\"breadcrumb layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16 ng-isolate-scope md-font icon-home material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator ng-isolate-scope md-font icon-chevron-right material-icons md-default-theme\" aria-hidden=\"true\">\n</md-icon><span class=\"parent\">Artículos</span></div><div class=\"title\">Lista de artículos</div></div><div \nlayout=\"column\"><md-button ui-sref=\"app.articles-create\" class=\"md-fab md-warn button-fixed-bottom\" \naria-label=\"Añadir article\"><md-tooltip md-direction=\"left\">Crear uno nuevo</md-tooltip><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><md-button ui-sref=\"app.articles-vip\" \nclass=\"md-fab yellow-700-bg button-fixed-bottom\" aria-label=\"Añadir article\"><md-tooltip md-direction=\"left\">\nArtículos VIP</md-tooltip><md-icon md-font-icon=\"icon-star\"></md-icon></md-button></div></div><div layout=\"row\" flex \nhide-xs hide-sm class=\"mr-16 searchbar md-background-bg md-hue-2\" layout-align=\"space-between stretch\"><input \ntype=\"text\" name=\"search\" placeholder=\"Buscar...\" ng-model=\"vm.filter.search\" \nng-keyup=\"($event.which === 13) ? vm.refreshArticles() : 0 \" flex><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<md-button class=\"btn btn-md md-icon-button\" title=\"Borrar búsqueda\" aria-label=\"Borrar búsqueda\" \nng-click=\"vm.filter.search=null ; vm.refreshArticles()\" ng-show=\"vm.filter.search\"><md-icon md-font-icon=\"icon-eraser\">\n</md-icon></md-button><md-button class=\"submit-search\" title=\"Buscar\" aria-label=\"Buscar\" \nng-click=\"vm.refreshArticles()\">Buscar</md-button></div><div class=\"content\"><div \nclass=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" ms-responsive-table><thead><tr><th>CN</th><th>\nMiniatura</th><th>Nombre</th><th>Estado</th><th>Precio</th><th>Acciones</th></tr></thead><tfoot><tr><td></td></tr>\n</tfoot><tbody><tr \nng-class=\"{\'md-grey-100-bg\' : article.status==\'disabled\',\'md-teal-50-bg\' : article.status==\'coming_soon\', \'md-yellow-200-bg\' : article.vip_order > 0}\" \nng-repeat=\"(key,article) in vm.pagination.data\"><td class=\"id\">{{ article.national_code }}</td><td class=\"thumbnail\">\n<img ng-hide=\"article.thumbnail\" ng-src=\"http://placehold.it/50x50\" alt=\"\" width=\"50\" height=\"50\"> <img \nng-show=\"article.thumbnail\" ng-src=\"{{article.thumbnail.urlth}}\" alt=\"\" width=\"50\" height=\"50\"></td><td class=\"name\">\n{{article.name}}</td><td class=\"status\">\n{{ article.status == \'enabled\' ? \'Activado\' : article.status == \'coming_soon\' ? \'Próximamente\' : \'Desactivada\' }}</td>\n<td class=\"price\">{{article.price | currency }}</td><td><md-menu md-offset=\"0 -7\"><md-button aria-label=\"open menu\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical \"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ui-sref=\"app.articles-edit({idArticle:article.id})\">\n<md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon>Editar</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.toggleVip(article, $index)\"><md-icon md-font-icon=\"icon-star\"></md-icon><span \nng-if=\"article.vip_order < 1\">Hacer VIP</span> <span ng-if=\"article.vip_order > 0\">Deshacer VIP</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.destroy(article.id,$index)\"><md-icon \nmd-font-icon=\"icon-delete-variant\"></md-icon>Eliminar</md-button></md-menu-item></md-menu-content></md-menu></td></tr>\n</tbody></table><pagination pagination=\"vm.pagination\" filter=\"vm.filter\" api-method=\"vm.api\"></pagination></div></div>\n</div>");
$templateCache.put("app/main/admin/articles/views/vipArticles.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"md-teal-500-bg header md-accent-bg\" layout=\"row\" style=\"min-height: 100px; height: 100px\"><md-button \nlayout-align=\"start center\" class=\"md-raised md-fab md-primary mr-32\" back><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon></md-button><div layout-align=\"center center\" class=\"title\">Configurar VIP</div></div><div class=\"content\">\n<div class=\"order-card md-background-bg md-whiteframe-1dp\" layout=\"column\" layout-align=\"start stretch\" \nlayout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\"><div class=\"pb-16\" layout=\"row\" \nlayout-align=\"start center\" flex=\"100\" flex-gt-sm=\"50\"><ul class=\"md-list\" ui-sortable=\"vm.sortableOptions\" \nng-model=\"vm.articles\" style=\"list-style: none\"><li class=\"sortable-vip-article\" data-article-id=\"{{ item.id }}\" \nng-repeat=\"item in vm.articles track by $index\" style=\"cursor: move; cursor: grab\"><md-card class=\"product-list-card\" \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start center\" layout-align-gt-sm=\"space-between center\" \nng-class=\'{\"grey-500-fg\": item.status != \"enabled\"}\'><div layout=\"row\" layout-align=\"center center\" class=\"ph-15\"><span\n class=\"md-headline\" ng-class=\'{\"teal-300-fg\": item.status == \"enabled\", \"grey-400-fg\": item.status != \"enabled\"}\'>\n#{{ $index + 1 }}</span></div><md-card-title-media flex-xs=\"100\" flex-sm=\"100\"><div \nclass=\"md-media-lg card-media md-card-image hover-effect-zoom\" \nstyle=\"background-image: url({{ item.thumbnail.url ? item.thumbnail.url : \'/assets/images/placeholder/no-disponible.png\' }}); width: 40px; height: 40px\">\n<a ui-sref=\"app.guest-article-show({ id: item.id })\" class=\"overlay\"></a></div></md-card-title-media>\n<md-card-title-text class=\"ph-16 pv-8\" layout=\"column\" flex=\"100\" flex-gt-xs=\"auto\"><span class=\"md-subhead\" \nui-sref=\"app.guest-article-show({ id: item.id })\" style=\"cursor: pointer\">{{ item.name }}</span> <span class=\"h5\">\nREF : {{ item.national_code }}</span></md-card-title-text><div layout=\"row\" layout-align=\"center center\" class=\"\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.delVip(item.id,$index)\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\"></md-icon></md-button></div></md-card></li></ul></div><div flex=\"100\" \nflex-gt-sm=\"50\" layout=\"column\" layout-align=\"start stretch\"><div layout=\"row\" flex \nclass=\"mv-16 searchbar md-background-bg md-hue-2\" layout-align=\"space-between stretch\" flex><input autocomplete=\"off\" \ntype=\"text\" placeholder=\"Buscar articulo\" flex \nng-keyup=\"($event.which === 13) ? vm.searchArticle(article.searchTerm) : 0 \" name=\"searchArticle\" \nng-model=\"article.searchTerm\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-button \nclass=\"btn btn-md md-icon-button\" title=\"Borrar búsqueda\" aria-label=\"Borrar búsqueda\" \nng-click=\"vm.setSearch(false, \'null\')\" ng-show=\"vm.filter.search\"><md-icon md-font-icon=\"icon-eraser\"></md-icon>\n</md-button><md-button class=\"submit-search\" title=\"Buscar\" aria-label=\"Buscar\" \nng-click=\"vm.searchArticle(article.searchTerm)\">Buscar</md-button></div><div layout=\"column\" \nlayout-align=\"start stretch\"><ul style=\"list-style: none\"><li ng-repeat=\"item in vm.searchingArticles track by $index\">\n<md-card class=\"product-list-card\" layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start center\" \nlayout-align-gt-sm=\"space-between center\"><md-card-title-media flex-xs=\"100\" flex-sm=\"100\"><div \nclass=\"md-media-lg card-media md-card-image hover-effect-zoom\" \nstyle=\"background-image: url({{ item.thumbnail.url ? item.thumbnail.url : \'/assets/images/placeholder/no-disponible.png\' }}); width: 40px; height: 40px\">\n<a ui-sref=\"app.guest-article-show({ id: item.id })\" class=\"overlay\"></a></div></md-card-title-media>\n<md-card-title-text class=\"ph-32 pv-8\" layout=\"column\" flex=\"100\" flex-gt-xs=\"auto\"><span class=\"md-subhead\" \nui-sref=\"app.guest-article-show({ id: item.id })\" style=\"cursor: pointer\">{{ item.name }}</span> <span class=\"h5\">\nREF : {{ item.national_code }}</span></md-card-title-text><md-card-actions layout=\"row\" layout-align=\"center center\" \nng-controller=\"CartCtrl as cvm\"><md-button title=\"Añadir\" aria-label=\"Añadir\" \nclass=\"btn btn-sm btn-fullwidth md-raised md-accent\" ng-click=\"vm.addVip(item.id,$index)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>Añadir</md-button></md-card-actions></md-card></li></ul></div></div></div><div \nlayout=\"row\" class=\"p-16\" layout=\"row\"><div class=\"order-block-user-info\" layout=\"column\" flex=\"40\"><span class=\"h4\">\n{{vm.order.cart.user.username}}</span> <span class=\"h4\">{{vm.order.cart.user.name}}</span> <span class=\"h4\">\n{{vm.order.cart.user.email}}</span> <span class=\"h4\">{{vm.order.cart.user.phone}}</span></div></div></div></div>");
$templateCache.put("app/main/admin/campaigns/views/createCampaign.html","<div class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\" style=\"min-height: 100px;height: 100px\"><div\n class=\"breadcrumb layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16 ng-isolate-scope md-font icon-home material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator ng-isolate-scope md-font icon-chevron-right material-icons md-default-theme\" aria-hidden=\"true\">\n</md-icon><span class=\"parent\">Campañas</span></div><span class=\"h1\">Campaña</span> <span class=\"h2\">\n{{ vm.campaign.name }}</span></div><div class=\"content\" md-background-bg><md-tabs md-dynamic-height><md-tab \nlabel=\"Articulo\"><md-card class=\"product-list-card\"><div \nng-include=\"\'app/main/admin/campaigns/views/forms/create.html\'\"></div></md-card></md-tab><md-tab label=\"Manager\"><div \nng-controller=\"RulesMainCtrl as vm\" ng-include=\"\'app/main/admin/rules/views/manager.html\'\"></div></md-tab></md-tabs>\n</div></div>");
$templateCache.put("app/main/admin/campaigns/views/listCampaigns.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div \nclass=\"breadcrumb layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16 ng-isolate-scope md-font icon-home material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator ng-isolate-scope md-font icon-chevron-right material-icons md-default-theme\" aria-hidden=\"true\">\n</md-icon><span class=\"parent\">Campañas</span></div><div class=\"title\">Lista de campañas</div></div><div layout=\"row\" \nlayout-align=\"end start\"><md-button ui-sref=\"app.campaigns-create\" class=\"md-fab md-warn button-fixed-bottom\" \naria-label=\"Añadir campaña\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nui-sref=\"app.campaigns-trash\" class=\"md-fab blue-grey-700-bg button-fixed-bottom\" aria-label=\"Papelera\"><md-tooltip \nmd-direction=\"left\">Papelera</md-tooltip><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></div></div><div \nclass=\"content\"><div class=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" ms-responsive-table><thead>\n<tr><th>#</th><th>Miniatura</th><th>Nombre</th><th>Estado</th><th>Finaliza</th><th>Acciones</th></tr></thead><tfoot>\n<tr><td></td></tr></tfoot><tbody><tr \nng-class=\"{\'md-grey-100-bg\' : campaign.status==\'disabled\',\'md-teal-50-bg\' : campaign.status==\'coming_soon\'}\" \nng-repeat=\"(key,campaign) in vm.pagination.data\"><td class=\"id\">{{ campaign.id }}</td><td class=\"thumbnail\"><img \nng-hide=\"campaign.thumbnail\" ng-src=\"http://placehold.it/50x50\" alt=\"\" width=\"50\" height=\"50\"> <img \nng-show=\"campaign.thumbnail\" ng-src=\"{{campaign.thumbnail.urlth}}\" alt=\"\" width=\"50\" height=\"50\"></td><td class=\"name\">\n{{campaign.name}}</td><td class=\"status\">\n{{ campaign.status == \'enabled\' ? \'Activado\' : campaign.status == \'coming_soon\' ? \'Próximamente\' : \'Desactivada\' }}\n</td><td class=\"created_at\">{{campaign.expiration_date | momentFormat:\'DD/MM/YYYY\' }}</td><td><md-menu \nmd-offset=\"0 -7\"><md-button aria-label=\"open menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical \"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nui-sref=\"app.campaigns-edit({idCampaign:campaign.id})\"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon>Editar\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.destroy(campaign.id,$index)\"><md-icon \nmd-font-icon=\"icon-delete-variant\"></md-icon>Eliminar</md-button></md-menu-item></md-menu-content></md-menu></td></tr>\n</tbody></table><pagination pagination=\"vm.pagination\" filter=\"vm.filter\" api-method=\"vm.api\"></pagination></div></div>\n</div>");
$templateCache.put("app/main/admin/campaigns/views/trashedCampaigns.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><md-button class=\"md-raised md-fab md-primary mr-32\" back><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"center start\"><div \nclass=\"breadcrumb layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16 ng-isolate-scope md-font icon-home material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator ng-isolate-scope md-font icon-chevron-right material-icons md-default-theme\" aria-hidden=\"true\">\n</md-icon><span class=\"parent\">Campañas</span></div><div class=\"title\">Papelera</div></div><div layout=\"column\"></div>\n</div><div class=\"content\"><div class=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" \nms-responsive-table><thead><tr><th>#</th><th>Nombre</th><th>Estado</th><th>Creada</th><th>Restaurar</th></tr></thead>\n<tfoot><tr><td></td></tr></tfoot><tbody><tr \nng-class=\"{\'md-grey-100-bg\' : campaign.status==\'disabled\',\'md-teal-50-bg\' : campaign.status==\'coming_soon\'}\" \nng-repeat=\"(key,campaign) in vm.campaigns\"><td class=\"id\">{{ campaign.id }}</td><td class=\"name\">{{campaign.name}}</td>\n<td class=\"status\">\n{{ campaign.status == \'enabled\' ? \'Activado\' : campaign.status == \'coming_soon\' ? \'Próximamente\' : \'Desactivada\' }}\n</td><td class=\"created_at\">{{campaign.created_at[\'date\'] | momentHumanize }}</td><td><md-button \nclass=\"md-icon-button\" ng-click=\"vm.restore(campaign.id,$index)\"><md-icon md-font-icon=\"icon-backup-restore\"></md-icon>\n<md-tooltip md-direction=\"left\">Restaurar</md-tooltip></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/admin/downloads/forms/create.html","<div layout=\"row\"><div class=\"md-whiteframe-1dp\" flex=\"100\"><div layout=\"row\" class=\"md-primary-bg\" \nstyle=\"padding: 5px 20px\"><h2>Datos de descarga</h2></div><form name=\"vm.fuser\" ng-submit=\"vm.store()\" \nclass=\"form-wrapper md-inline-form\" novalidate><div layout=\"column\" flex><div layout=\"row\"><md-input-container \nflex=\"70\"><input type=\"text\" name=\"name\" ng-model=\"vm.download.name\" placeholder=\"Nombre\" required>\n</md-input-container><span>Destacada</span><md-checkbox ng-model=\"vm.download.featured\" aria-label=\"Destacado\">\n</md-checkbox><span>Mostrar en utilidades</span><md-checkbox ng-model=\"vm.download.show_in_tools\" \naria-label=\"Mostrar en utilidades\"></md-checkbox></div><uploader files=\"vm.uploadFiles\" uploader=\"vm.uploader\" \nfilters=\"[\'file\']\"></uploader><div layout=\"row\" layout-align=\"center top\"><md-input-container class=\"md-block\">\n<md-button type=\"submit\" class=\"md-raised md-accent\" ng-click=\"vm.create()\" aria-label=\"Submit\">Guardar</md-button>\n</md-input-container></div></div></form></div></div>");
$templateCache.put("app/main/admin/gifts/views/createGift.html","<div class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\" style=\"min-height: 100px;height: 100px\"><div\n class=\"breadcrumb layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16 ng-isolate-scope md-font icon-home material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator ng-isolate-scope md-font icon-chevron-right material-icons md-default-theme\" aria-hidden=\"true\">\n</md-icon><span class=\"parent\">Regalos</span></div><span class=\"h2\">Regalo</span> <span class=\"h3\">\n{{ vm.article.name }}</span></div><div class=\"content\" md-background-bg><div \nng-include=\"\'app/main/admin/gifts/views/forms/create.html\'\"></div></div></div>");
$templateCache.put("app/main/admin/gifts/views/listGifts.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div \nclass=\"breadcrumb layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16 ng-isolate-scope md-font icon-home material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator ng-isolate-scope md-font icon-chevron-right material-icons md-default-theme\" aria-hidden=\"true\">\n</md-icon><span class=\"parent\">Regalos</span></div><div class=\"title\">Lista de regalos</div></div><md-button \nui-sref=\"app.gifts-create\" class=\"md-fab md-warn button-fixed-bottom\" aria-label=\"Añadir regalo\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"content\"><div \nclass=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" ms-responsive-table><thead><tr><th>#</th><th>\nMiniatura</th><th>Nombre</th><th>Estado</th><th>Creada</th><th>Acciones</th></tr></thead><tfoot><tr><td></td></tr>\n</tfoot><tbody><tr \nng-class=\"{\'md-grey-100-bg\' : article.status==\'disabled\',\'md-teal-50-bg\' : article.status==\'coming_soon\'}\" \nng-repeat=\"(key,article) in vm.articles\"><td class=\"id\">{{ article.id }}</td><td class=\"thumbnail\"><img \nng-hide=\"article.thumbnail\" ng-src=\"http://placehold.it/50x50\" alt=\"\" width=\"50\" height=\"50\"> <img \nng-show=\"article.thumbnail\" ng-src=\"{{article.thumbnail.urlth}}\" alt=\"\" width=\"50\" height=\"50\"></td><td class=\"name\">\n{{article.name}}</td><td class=\"status\">\n{{ article.status == \'enabled\' ? \'Activado\' : article.status == \'coming_soon\' ? \'Próximamente\' : \'Desactivada\' }}</td>\n<td class=\"created_at\">{{article.created_at[\'date\'] | momentHumanize }}</td><td><md-menu md-offset=\"0 -7\"><md-button \naria-label=\"open menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical \"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nui-sref=\"app.gifts-edit({idGift:article.id})\"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon>Editar</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.destroy(article.id,$index)\"><md-icon \nmd-font-icon=\"icon-delete-variant\"></md-icon>Eliminar</md-button></md-menu-item></md-menu-content></md-menu></td></tr>\n</tbody></table></div></div></div>");
$templateCache.put("app/main/admin/imports/views/create.html","<div class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\" style=\"min-height: 100px;height: 100px\"><div\n class=\"breadcrumb layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16 ng-isolate-scope md-font icon-home material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator ng-isolate-scope md-font icon-chevron-right material-icons md-default-theme\" aria-hidden=\"true\">\n</md-icon><span class=\"parent\">Importaciones</span></div><span class=\"h2\">Importaciones</span> <span class=\"h3\">\n{{ vm.download.name }}</span></div><div class=\"content\" md-background-bg><md-card><div layout=\"row\"><div \nclass=\"md-whiteframe-1dp\" flex=\"100\"><div layout=\"row\" class=\"md-primary-bg\" style=\"padding: 5px 20px\"><h2>\nConfigurar importación</h2></div><form name=\"vm.fuser\" ng-submit=\"vm.store()\" class=\"form-wrapper md-inline-form\" \nnovalidate><div layout=\"column\" flex><div layout=\"column\" layout-align=\"center center\" flex=\"30\"><md-input-container>\n<md-select required placeholder=\"Tipo de importacion\" ng-model=\"vm.importType\" flex style=\"overflow: hidden\"><md-option\n value=\"users\">Clientes</md-option><md-option value=\"articles\">Artículos (Masiva)</md-option><md-option \nvalue=\"articlesout\">Artículos Descatalogados</md-option><md-option value=\"upimages\">Subida Fotos</md-option><md-option \nvalue=\"sortPromotions\">Ordenar promociones</md-option></md-select></md-input-container><md-input-container><md-select \nng-if=\"vm.importType==\'upimages\'\" ng-required=\"vm.importType==\'images\'\" placeholder=\"Tipo de importacion\" \nng-model=\"vm.imageElementType\" flex style=\"overflow: hidden\"><md-option value=\"articles\">Artículos</md-option>\n<md-option value=\"promotions\">Promociones</md-option><md-option value=\"materials\">Materiales</md-option></md-select>\n</md-input-container><span ng-show=\"vm.importType==\'upimages\'\">\nRecuerda que para hacer la importación de fotos debes de seleccionar el tipo de importacion ademas de seleccionar un archivo con extensión \n<code><span class=\"red-400-fg\">extensión .zip y no superior a 60MB</span></code></span> <span \nng-show=\"vm.importType==\'articlesout\'\">\nElimina los articulos que estén en el listado. Si el archivo es muy grande se debe de guardar como .csv <code><a \nhref=\"http://mirafarma.org/docs/ejemplo_descatalogados.xls\">Descargar demo</a></code></span> <span \nng-show=\"vm.importType==\'articles\'\">\nProcedimiento: Actualiza los precios y descripciones de los productos que aparezcan en el archivo que no estén en campaña. Crea los que no existan en la intranet y desactiva los que no aparecen en el archivo. \n<code><span class=\"red-400-fg\">Sólo seran validos archivos xls o xlsx con el siguiente formato : <a \nhref=\"http://mirafarma.org/docs/ejemplo_subida_articulos.xlsx\">Descargar demo</a> </span></code></span><span \nng-show=\"vm.importType==\'sortPromotions\'\">\nProcedimiento: Ordena las promociones VIP igual que estén en el Excel. La columna A tiene que ser el código y la columna G tiene que ser \"SI\" (sin comillas). \n<span class=\"red-400-fg\">\nTodos las promociones que no estén en el Excel con la columna G con valor SI dejarán de ser VIP. Sólo serán válidos archivos xls o xlsx con el siguiente formato: \n<a href=\"http://mirafarma.org/docs/ejemplo_ordenar_promos.xlsx\">Descargar demo</a></span></span></div><uploader \nng-hide=\"vm.importType==\'images\'\" files=\"vm.uploadFiles\" uploader=\"vm.uploader\" filters=\"[]\"></uploader><div \nlayout=\"row\" layout-align=\"center top\"><md-input-container class=\"md-block\"><md-button \nng-hide=\"vm.uploader.isUploading\" type=\"submit\" class=\"md-raised md-accent\" \nng-click=\"vm.run(vm.importType==\'images\'?\'action\':\'upload\')\" ng-disabled=\"vm.fuser.$invalid || vm.fuser.$pristine\" \naria-label=\"Submit\">Iniciar</md-button></md-input-container></div><md-progress-linear \nng-show=\"(vm.uploader.isUploading||vm.importing) && vm.importType==\'upimages\'\" md-mode=\"determinate\" \nvalue=\"{{vm.uploader.progress}}\"></md-progress-linear><md-progress-linear \nng-show=\"(vm.uploader.isUploading||vm.importing) && vm.importType!==\'upimages\' \" md-mode=\"indeterminate\">\n</md-progress-linear></div></form></div></div></md-card></div></div>");
$templateCache.put("app/main/admin/materials/views/createMaterial.html","<div class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\" style=\"min-height: 100px;height: 100px\">\n<span class=\"h2\">Material</span> <span class=\"h3\">{{ vm.material.name }}</span></div><div class=\"content\" \nmd-background-bg><div ng-include=\"\'app/main/admin/materials/views/forms/create.html\'\"></div></div></div>");
$templateCache.put("app/main/admin/materials/views/listMaterials.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">\nMateriales</div></div><md-button ui-sref=\"app.materials-create\" class=\"md-fab md-warn button-fixed-bottom\" \naria-label=\"Añadir material\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"content\"><div \nclass=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" ms-responsive-table><thead><tr><th>#</th><th>\nMiniatura</th><th>Nombre</th><th>Estado</th><th>Creada</th><th>Acciones</th></tr></thead><tfoot><tr><td></td></tr>\n</tfoot><tbody><tr ng-class=\"{\'md-grey-A200-bg\' : material.status == false}\" \nng-repeat=\"(key,material) in vm.materials\"><td class=\"id\">{{ material.id }}</td><td class=\"thumbnail\"><img \nng-hide=\"material.thumbnail\" ng-src=\"http://placehold.it/50x50\" alt=\"\" width=\"50\" height=\"50\"> <img \nng-show=\"material.thumbnail\" ng-src=\"{{material.thumbnail.urlth}}\" alt=\"\" width=\"50\" height=\"50\"></td><td class=\"name\">\n{{material.name}}</td><td class=\"status\">{{ material.status == true ? \'Activado\' : \'Desactivado\'}}</td><td \nclass=\"created_at\">{{material.created_at[\'date\'] | momentHumanize }}</td><td><md-menu md-offset=\"0 -7\"><md-button \naria-label=\"open menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical \"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nui-sref=\"app.materials-edit({idMaterial:material.id})\"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon>Editar\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.destroy(material.id,$index)\"><md-icon \nmd-font-icon=\"icon-delete-variant\"></md-icon>Eliminar</md-button></md-menu-item><md-menu-item ng-switch \non=\"material.status\"><md-button ng-click=\"vm.toggleStatus(material.id,$index)\" aria-label=\"none\"><span \nng-switch-when=\"false\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon>Activar </span><span ng-switch-when=\"true\">\n<md-icon md-font-icon=\"icon-window-close\"></md-icon>Desactivar</span></md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/admin/orders/views/listOrders.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"center center\" style=\"min-height: 100px; height: 100px\"><div class=\"title\">Pedidos</div>\n</div><div class=\"content\"><div class=\"order-card md-background-bg md-whiteframe-1dp export-order\"><div class=\"\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-file-document\" class=\"m-0 mr-16\"></md-icon><div \nclass=\"h2 secondary-text\">Exportación</div></div><form name=\"exportForm\" \nng-submit=\"vm.exportByDate ? vm.exportOrders():vm.exportOrders(\'custom\')\" novalidate><div layout=\"row\" \nlayout-align=\"space-around center\" class=\"p-5\"><md-switch flex=\"20\" ng-model=\"vm.exportByDate\" \nng-change=\"vm.refreshOrders()\">Por fecha</md-switch><md-input-container flex=\"30\" ng-if=\"vm.exportByDate==true\"><label>\nDesde</label><md-datepicker timezoned-date ng-model=\"vm.export.from\" name=\"fromDate\" md-min-date=\"minDate\" auto-open \nmd-max-date=\"maxDate\" required></md-datepicker><div ng-messages=\"exportForm.fromDate.$error\" role=\"alert\"><div \nng-message=\"required\">Campo requerido</div></div></md-input-container><md-input-container flex=\"30\" \nng-if=\"vm.exportByDate==true\"><label>Hasta</label><md-datepicker timezoned-date ng-model=\"vm.export.to\" name=\"toDate\" \nmd-min-date=\"vm.export.from\" auto-open required></md-datepicker><div ng-messages=\"exportForm.toDate.$error\" \nrole=\"alert\"><div ng-message=\"required\">Campo requerido</div></div></md-input-container><md-chips flex=\"60\" \nplaceholder=\"Numero de pedidos\" ng-if=\"vm.exportByDate==false\" ng-model=\"vm.customOrders\" readonly=\"tr\" \nmd-removable=\"ctrl.removable\"></md-chips><md-button class=\"export-button md-raised md-green-600-bg md-background-fg\" \ntype=\"submit\" ng-disabled=\"exportForm.$invalid || exportForm.$pristine\">Exportar</md-button><md-button \nclass=\"export-button md-raised md-purple-600-bg md-background-fg\" ng-click=\"vm.exportOrders(\'today\')\">Los de hoy\n</md-button></div></form><span ng-show=\"vm.exportByDate==false\">*Presionar Enter al introducir numero de pedido</span>\n<div layout=\"row\" ng-if=\"hasAdminAccess\" layout-align=\"center start\"><md-button class=\"export-button md-raised\" \nng-click=\"vm.showMoreOptions=!vm.showMoreOptions\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Mas opciones</md-button>\n</div><div layout=\"column\" ng-if=\"hasAdminAccess && vm.showMoreOptions\"><h3>Exportar cabeceras</h3><div layout=\"row\">\n<md-input-container><label>Mes</label><md-select ng-model=\"vm.headExport.month\" style=\"min-width: 200px\"><md-option \nvalue=\"all\">Año completo</md-option><md-option value=\"1\">Enero</md-option><md-option value=\"2\">Febrero</md-option>\n<md-option value=\"3\">Marzo</md-option><md-option value=\"4\">Abril</md-option><md-option value=\"5\">Mayo</md-option>\n<md-option value=\"6\">Junio</md-option><md-option value=\"7\">Julio</md-option><md-option value=\"8\">Agosto</md-option>\n<md-option value=\"9\">Septiembre</md-option><md-option value=\"10\">Octubre</md-option><md-option value=\"11\">Noviembre\n</md-option><md-option value=\"12\">Diciembre</md-option></md-select></md-input-container><md-input-container><label>Año\n</label><md-select ng-model=\"vm.headExport.year\" style=\"min-width: 200px\"><md-option \nng-repeat=\"(key,year) in vm.headExport.years\" value=\"{{year}}\">{{year}}</md-option></md-select></md-input-container>\n<md-button class=\"export-button md-raised md-green-600-bg md-background-fg\" ng-click=\"vm.processHeadExport()\" \ntype=\"button\">Exportar</md-button></div></div></div><div ng-if=\"vm.showFilter!=false\" \nclass=\"order-card md-background-bg md-whiteframe-1dp export-order\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h2 secondary-text\"><md-icon md-font-icon=\"icon-filter\" \nclass=\"m-0 mr-16\"></md-icon>Filtro <i ng-click=\"vm.showFilter=false\" class=\"fa fa-minus minimize-filter\" \naria-hidden=\"true\"><md-tooltip>Minimizar</md-tooltip></i></div><md-button ng-click=\"vm.clearFilter()\" \nclass=\"h3 secondary-text md-raised\"><md-icon md-font-icon=\"icon-eraser\"></md-icon>Limpiar filtro</md-button></div><div \nlayout=\"column\" class=\"p-16\"><div layout=\"row\" flex=\"100\"><div layout=\"row\" \nclass=\"mr-16 searchbar md-background-bg md-hue-2 search-orders\" layout-align=\"space-between stretch\"><input \ntype=\"text\" name=\"search\" placeholder=\"Buscar...\" ng-model=\"vm.filter.search\" \nng-keyup=\"($event.which === 13) ? vm.refreshOrders() : 0 \" flex><md-icon md-font-icon=\"icon-magnify\"></md-icon></div>\n<md-input-container><label>Desde</label><md-datepicker timezoned-date ng-model=\"vm.filter.from\" name=\"fromDate\" \nmd-min-date=\"minDate\" auto-open md-max-date=\"maxDate\" ng-change=\"vm.refreshOrders()\"></md-datepicker><div \nng-messages=\"exportForm.fromDate.$error\" role=\"alert\"><div ng-message=\"required\">Campo requerido</div></div>\n</md-input-container><md-input-container><label>Hasta</label><md-datepicker timezoned-date ng-model=\"vm.filter.to\" \nname=\"toDate\" md-min-date=\"vm.filter.from\" auto-open ng-change=\"vm.refreshOrders()\"></md-datepicker><div \nng-messages=\"exportForm.toDate.$error\" role=\"alert\"><div ng-message=\"required\">Campo requerido</div></div>\n</md-input-container><div><md-switch class=\"mt-5\" ng-model=\"vm.filter.pending\" ng-change=\"vm.refreshOrders()\">\nSolo pendientes</md-switch></div></div><div layout=\"row\" layout-align=\"center center\" class=\"mt-10\"><md-select \nplaceholder=\"Comerciales\" ng-model=\"vm.filter.sellers\" style=\"min-width: 200px\" multiple=\"true\"><md-option \nvalue=\"{{seller.id}}\" ng-repeat=\"seller in vm.sellers | filter:searchTerm\">{{seller.name}}</md-option></md-select>\n<md-button ng-click=\"vm.refreshOrders()\" class=\"h3 secondary-text md-raised red-500-bg md-background-fg\"><md-icon \nclass=\"md-background-fg\" md-font-icon=\"icon-filter\"></md-icon>Filtrar</md-button></div></div></div><md-button \nng-if=\"vm.showFilter==false\" ng-click=\"vm.showFilter=true\" class=\"md-raised h2 secondary-text\"><md-icon \nmd-font-icon=\"icon-filter\" class=\"m-0 mr-16\"></md-icon>Ver filtro</md-button></div><div \nclass=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" ms-responsive-table id=\"cart\"><thead><tr><th \nstyle=\"width: 50px;min-width: 50px\">#Ref</th><th>Cliente</th><th>Comercial</th><th>Creado</th><th>Estado</th><th \nstyle=\"width: 50px;min-width: 50px\">Unidades</th><th>Total</th><th></th></tr></thead><tbody><tr \nng-class=\"order.seller?\'tr-seller\':\'\'\" ng-repeat=\"(key,order) in vm.pagination.data\"><td class=\"id\">#{{order.id}}</td>\n<td class=\"client\"><a ui-sref=\"app.user-edit({idUser:order.client.id})\">{{order.client.name |truncateText:25}}\n<md-tooltip>{{order.client.name}}</md-tooltip></a><p class=\"font-size-10\">{{order.client.username}}</p></td><td><span \nclass=\"font-size-14 text-boxed-light\">{{order.seller.name}}</span></td><td class=\"date\">\n{{order.created_at[\'date\'] | momentHumanize }}</td><td class=\"status\"><status-order status=\"order.status\">\n</status-order></td><td class=\"qty\"><span class=\"h3\">{{order.total_qty}}</span></td><td class=\"price\"><span class=\"h3\">\n{{order.price | currency}}</span> <span ng-if=\"order.monthly_discount_info.has_advance_discount\"><md-icon \nmd-font-icon=\"icon-tag-text-outline\"><md-tooltip md-direction=\"top\">Tiene un adelanto</md-tooltip></md-icon></span>\n</td><td><md-button class=\"md-fab md-mini md-hue-4\" \nng-if=\"order.monthly_discount_info.available_advance && order.discounts.length==0 && order.status==\'pending\'&&!hasAdminAccess\" \nng-click=\"vm.applyAdvanceMonthlyDiscount(order)\"><md-icon md-font-icon=\"icon-clock-fast\"></md-icon><md-tooltip>\nAplicar Adelanto D. Mensual</md-tooltip></md-button><md-button ng-show=\"order.status!==\'pending\' || !hasAdminAccess\" \nui-sref=\"app.orders-edit({id:order.id})\" class=\"md-fab md-mini md-primary md-hue-2\" aria-label=\"Detalles\"><md-tooltip \nmd-direction=\"right\">Detalles</md-tooltip><md-icon md-font-icon=\"icon-open-in-new\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini md-warn md-hue-2\" ng-show=\"order.status==\'pending\' && !hasAdminAccess\" \nng-click=\"vm.cancel(order.id,$index)\"><md-tooltip md-direction=\"right\">Cancelar</md-tooltip><md-icon \nmd-font-icon=\"icon-delete-variant\"></md-icon></md-button><md-menu ng-show=\"order.status==\'pending\' && hasAdminAccess\" \nmd-offset=\"0 -7\"><md-button aria-label=\"open menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical \"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nui-sref=\"app.orders-edit({id:order.id})\"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon>Ver/Editar</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.confirm(order)\"><md-icon md-font-icon=\"icon-check\"></md-icon>\nConfirmar</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.cancel(order.id,$index)\"><md-icon \nmd-font-icon=\"icon-delete-variant\"></md-icon>Cancelar</md-button></md-menu-item></md-menu-content></md-menu></td></tr>\n</tbody></table><pagination pagination=\"vm.pagination\" filter=\"vm.filter\" api-method=\"vm.api\"></pagination></div></div>");
$templateCache.put("app/main/admin/orders/views/showOrder.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"md-teal-500-bg header md-accent-bg\" layout=\"row\" style=\"min-height: 100px; height: 100px\"><md-button \nlayout-align=\"start center\" class=\"md-raised md-fab md-primary mr-32\" back><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon></md-button><div layout-align=\"center center\" class=\"title\">Pedido #{{vm.order.id}}</div></div><div \nclass=\"content\"><div class=\"order-card md-background-bg md-whiteframe-1dp\"><div class=\"pb-16\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-file-document\" class=\"m-0 mr-16\"></md-icon><div \nclass=\"h2 secondary-text\">Detalles</div></div><div layout=\"row\" class=\"p-16\" layout-wrap><div \nclass=\"order-block-user-info\" layout=\"column\" flex=\"100\" flex-gt-lg=\"30\"><span class=\"h4\">\n{{vm.order.cart.user.username}}</span> <span class=\"h4\">{{vm.order.cart.user.name}}</span> <span class=\"h4\">\n{{vm.order.cart.user.email}}</span> <span class=\"h4\">{{vm.order.cart.user.phone}}</span> <span class=\"h4\">\n{{vm.order.cart.user.address}} - {{vm.order.cart.user.postal_code}} -{{vm.order.cart.user.city}}</span> <span \nclass=\"h4\">{{vm.order.cart.user.state}}</span></div><div layout=\"column\" class=\"ph-8\" flex=\"100\" flex-gt-lg=\"30\"><span>\nCreado: {{vm.order.created_at[\'date\'] | momentFormat : \'D-MM-YYYY [a las] H:mm\'}}</span> <span>\nAceptado: {{vm.order.accepted_at[\'date\'] | momentFormat : \'D-MM-YYYY [a las] H:mm\'}} </span><span>Actualizado: <span \nng-if=\"vm.order.updated_at\">{{vm.order.updated_at[\'date\'] | momentFormat : \'D-MM-YYYY [a las] h:mm\'}}</span> </span>\n<span>Eliminado: <span ng-if=\"vm.order.deleted_at\">\n{{vm.order.deleted_at[\'date\'] | momentFormat : \'D-MM-YYYY [a las] h:mm\'}}</span></span> <span layout=\"row\" \nclass=\"mt-20\">Estado:<status-order class=\"ml-20\" status=\"vm.order.status\"></status-order></span></div><div \nng-if=\"vm.order.comment\" class=\"ph-8\" flex=\"100\" flex-gt-lg=\"40\"><h4 class=\"h4 mt-0\"><strong>Comentario</strong></h4>\n<p>{{ vm.order.comment }}</p></div></div></div><div class=\"simple-table-container md-whiteframe-4dp\"><div class=\"p-24\" \nlayout=\"row\" layout-align=\"start center\"><div ng-if=\"vm.order.status===\'pending\'\" flex=\"25\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-cart-outline\" class=\"m-0 mr-16\"></md-icon><div class=\"h2 secondary-text\">Carrito</div></div><div \nng-if=\"vm.order.status!==\'pending\'\" flex=\"25\" layout=\"row\"><md-icon md-font-icon=\"icon-file-document\" \nclass=\"m-0 mr-16\"></md-icon><div class=\"h2 secondary-text\">Detalle pedido</div></div><div flex=\"75\" \nng-show=\"vm.order.status==\'pending\' && hasAdminAccess\" layout-align=\"end center\" \nclass=\"add-element-btnadd-element-btn\" layout=\"row\"><md-button \nng-if=\"vm.order.monthly_discount_info.available_current\" class=\"md-raised md-green-200-bg\" \nng-click=\"vm.applyMonthlyDiscount(vm.order)\"><md-icon md-font-icon=\"icon-tag-text-outline\"></md-icon>\nAplicar descuento mensual</md-button><md-button \nng-if=\"vm.order.monthly_discount_info.available_advance && vm.order.discounts.length==0 && !vm.order.monthly_discount_info.available_current\" \nclass=\"md-raised md-indigo-200-bg\" ng-click=\"vm.applyAdvanceMonthlyDiscount(vm.order)\"><md-icon \nmd-font-icon=\"icon-clock-fast\"></md-icon>Aplicar adelanto descuento mensual</md-button><md-button \nclass=\"md-raised md-red-200-bg\" ng-if=\"vm.order.discounts.length>0\" ng-click=\"vm.deleteMonthlyDiscount(vm.order)\">\n<md-icon md-font-icon=\"icon-tag-text-outline\"></md-icon>Eliminar D. Mensual</md-button><md-button \nclass=\"md-raised md-cyan-200-bg\" ng-click=\"vm.showSelectElement(\'article\')\">+ Articulo</md-button><md-button \nclass=\"md-raised md-yellow-400-bg\" ng-click=\"vm.showSelectElement(\'promotion\')\">+ Promo</md-button><md-button \nclass=\"md-raised md-grey-800-bg md-background-fg\" ng-click=\"vm.showSelectElement(\'material\')\">+ Material</md-button>\n</div></div><table class=\"simple\" ms-responsive-table id=\"cart\"><thead><tr><th>Descripción</th><th>Cantidad</th><th>\nPrecio</th><th></th></tr></thead><tbody><tr order-item detail=\"detail\" block-order=\"!hasAdminAccess\" vm-order=\"vm\" \nkey=\"key\" order=\"vm.order\" ng-repeat=\"(key,detail) in vm.order.orderDetails\" \nid=\"{{detail.ordeable_type | lowercase }}-{{detail.ordeable_id}}\" class=\"{{ detail.ordeable_type | lowercase }}\"></tr>\n<tr ng-class=\"vm.order.monthly_discount_info.has_advance_discount?\'md-orange-100-bg\':\'md-indigo-100-bg\'\" \nng-if=\"vm.order.discounts.length>0\" ng-repeat=\"(key,discount) in vm.order.discounts\"><td><span class=\"font-size-16\">\nDescuento mensual</span> <span class=\"font-size-16\"><strong>\n{{discount.created_at[\'date\'] | momentFormat : \'MMMM\'|uppercase}} / {{discount.created_at[\'date\'] | momentFormat : \'YYYY\'}}\n</strong></span></td><td></td><td class=\"font-weight-800 font-size-14\" style=\"text-align: center\">\n-{{discount.reduction|currency}}</td><td></td></tr></tbody><tfoot><tr></tr><tr><td colspan><div layout=\"row\" \nlayout-align=\"end center\" class=\"p-24\"><span class=\"md-subheader\">\n{{ vm.order.cart.details_qty + \" producto\" + (vm.order.cart.details_qty > 1 ? \'s\' : \'\') }}</span></div></td><td><div \nlayout=\"row\" layout-align=\"end center\" class=\"p-24\"><span class=\"md-subheader\">\n{{ vm.order.cart.total_qty + \" unidad\" + (vm.order.cart.total_qty > 1 ? \'es\' : \'\') }}</span></div></td><td><span \nclass=\"md-accent-fg md-title\">{{ vm.order.price | currency }}</span></td><td><md-button \nng-if=\"vm.order.status==\'pending\' && hasAdminAccess\" class=\"md-raised md-green-600-bg md-background-fg\" \nng-click=\"vm.adminConfirm()\"><md-icon class=\"md-background-fg\" md-font-icon=\"icon-check\"></md-icon>Confirmar pedido\n</md-button></td></tr></tfoot></table></div><status-campaigns from=\"\'guest-order\'\" \nstatus-model=\"vm.order.cart.campaigns_status.campaigns\"></status-campaigns><status-promotionals \nstatus-model=\"vm.order.cart.promotional_status\"></status-promotionals></div></div>");
$templateCache.put("app/main/admin/pharmacies/views/createPharmacy.html","<div class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\" style=\"min-height: 100px;height: 100px\">\n<span class=\"h2\">Farmacia {{ vm.pharmacy.name }}</span></div><div class=\"content\" md-background-bg><div \nng-include=\"\'app/main/admin/pharmacies/views/forms/create.html\'\"></div></div></div>");
$templateCache.put("app/main/admin/pharmacies/views/listPharmacies.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">Farmacias\n</div></div><md-button ui-sref=\"app.pharmacy-create\" class=\"md-fab md-warn button-fixed-bottom\" aria-label=\"Eat cake\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"content\"><div \nclass=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" ms-responsive-table><thead><tr><th>Nombre</th>\n<th>Creado</th><th>Email</th><th>Usuario asociado</th><th>Acciones</th></tr></thead><tfoot><tr><td></td></tr></tfoot>\n<tbody><tr ng-class=\"{\'md-grey-A200-bg\' : pharmacy.status==0}\" ng-repeat=\"(key,pharmacy) in vm.pharmacies\"><td \nclass=\"name\">{{pharmacy.name}}</td><td class=\"created_at\">{{pharmacy.created_at | momentHumanize }}</td><td \nclass=\"email\">{{pharmacy.email}}</td><td class=\"user\">\n{{ pharmacy.user.firstname + \" \" + pharmacy.user.lastname + \" (\" + pharmacy.user.username + \")\" }}</td><td><md-menu \nmd-offset=\"0 -7\"><md-button aria-label=\"open menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical \"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nui-sref=\"app.pharmacy-edit({idPharmacy:pharmacy.id})\"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon>Editar\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.destroy(pharmacy.id,$index)\"><md-icon \nmd-font-icon=\"icon-delete-variant\"></md-icon>Eliminar</md-button></md-menu-item><md-menu-item ng-switch \non=\"pharmacy.status\"><md-button ng-click=\"vm.statusToggle(pharmacy.id,$index)\" aria-label=\"none\"><span \nng-switch-when=\"0\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon>Activar </span><span ng-switch-when=\"1\"><md-icon\n md-font-icon=\"icon-account-remove\"></md-icon>Desactivar</span></md-button></md-menu-item></md-menu-content></md-menu>\n</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/admin/promotions/views/createPromotion.html","<div class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\" style=\"min-height: 100px;height: 100px\">\n<span class=\"h2\">Promoción</span> <span class=\"h3\">{{ vm.promotion.name }}</span></div><div class=\"content\" \nmd-background-bg><md-tabs md-dynamic-height><md-tab label=\"Promoción\"><md-card class=\"product-list-card\"><div \nng-include=\"\'app/main/admin/promotions/views/forms/create.html\'\"></div></md-card></md-tab><md-tab label=\"Manager\"><div \nng-controller=\"RulesMainCtrl as vm\" ng-include=\"\'app/main/admin/rules/views/manager.html\'\"></div></md-tab></md-tabs>\n</div></div>");
$templateCache.put("app/main/admin/promotions/views/listPromotions.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">\nPromociones</div></div><div layout=\"row\" layout-align=\"end start\"><md-button ui-sref=\"app.promotions-create\" \nclass=\"md-fab md-warn button-fixed-bottom\" aria-label=\"Añadir promotion\"><md-tooltip md-direction=\"left\">\nCrear Promocion</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nui-sref=\"app.promotions-vip\" class=\"md-fab yellow-700-bg button-fixed-bottom\" aria-label=\"Promociones vip\"><md-tooltip \nmd-direction=\"left\">Promociones VIP</md-tooltip><md-icon md-font-icon=\"icon-star\"></md-icon></md-button><md-button \nui-sref=\"app.promotions-trash\" class=\"md-fab blue-grey-700-bg button-fixed-bottom\" aria-label=\"Papelera\"><md-tooltip \nmd-direction=\"left\">Papelera</md-tooltip><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></div></div><div \nlayout=\"row\" flex hide-xs hide-sm class=\"mr-16 searchbar md-background-bg md-hue-2\" \nlayout-align=\"space-between stretch\"><input type=\"text\" name=\"search\" placeholder=\"Buscar...\" \nng-model=\"vm.filter.search\" ng-keyup=\"($event.which === 13) ? vm.refreshPromotions() : 0 \" flex><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><md-button class=\"btn btn-md md-icon-button\" title=\"Borrar búsqueda\" \naria-label=\"Borrar búsqueda\" ng-click=\"vm.filter.search=null ; vm.refreshPromotions()\" ng-show=\"vm.filter.search\">\n<md-icon md-font-icon=\"icon-eraser\"></md-icon></md-button><md-button class=\"submit-search\" title=\"Buscar\" \naria-label=\"Buscar\" ng-click=\"vm.refreshPromotions()\">Buscar</md-button></div><div class=\"content\"><div \nclass=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" ms-responsive-table><thead><tr><th>CN</th><th>\nMiniatura</th><th>Nombre</th><th>Estado</th><th>Precio</th><th>Acciones</th></tr></thead><tfoot><tr><td></td></tr>\n</tfoot><tbody><tr \nng-class=\"{\'md-grey-100-bg\' : promotion.status==\'disabled\',\'md-teal-50-bg\' : promotion.status==\'coming_soon\' ,\'md-yellow-200-bg\' : promotion.vip_order > 0}\" \nng-repeat=\"(key,promotion) in vm.pagination.data\"><td class=\"id\">{{ promotion.code }}</td><td class=\"thumbnail\"><img \nng-hide=\"promotion.thumbnail\" ng-src=\"http://placehold.it/50x50\" alt=\"\" width=\"50\" height=\"50\"> <img \nng-show=\"promotion.thumbnail\" ng-src=\"{{promotion.thumbnail.urlth}}\" alt=\"\" width=\"50\" height=\"50\"></td><td \nclass=\"name\">{{promotion.name}}</td><td class=\"status\">\n{{ promotion.status == \'enabled\' ? \'Activada\' : promotion.status == \'coming_soon\' ? \'Próximamente\' : \'Desactivada\' }}\n</td><td class=\"price\">{{promotion.price | currency }}</td><td><md-menu md-offset=\"0 -7\"><md-button \naria-label=\"open menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical \"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nui-sref=\"app.promotions-edit({idPromotion:promotion.id})\"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon>Editar\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.toggleVip(promotion, $index)\"><md-icon \nmd-font-icon=\"icon-star\"></md-icon><span ng-if=\"promotion.vip_order < 1\">Hacer VIP</span> <span \nng-if=\"promotion.vip_order > 0\">Deshacer VIP</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.destroy(promotion.id,$index)\"><md-icon md-font-icon=\"icon-delete-variant\"></md-icon>Eliminar</md-button>\n</md-menu-item></md-menu-content></md-menu></td></tr></tbody></table><pagination pagination=\"vm.pagination\" \nfilter=\"vm.filter\" api-method=\"vm.api\"></pagination></div></div></div>");
$templateCache.put("app/main/admin/promotions/views/trashedPromotions.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><md-button class=\"md-raised md-fab md-primary mr-32\" back><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"center start\"><div \nclass=\"title\">Papelera de promociones</div></div><div layout=\"column\"></div></div><div layout=\"row\" flex hide-xs \nhide-sm class=\"mr-16 searchbar md-background-bg md-hue-2\" layout-align=\"space-between stretch\"><input type=\"text\" \nname=\"search\" placeholder=\"Buscar...\" ng-model=\"vm.filter.search\" \nng-keyup=\"($event.which === 13) ? vm.refreshPromotions() : 0 \" flex><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<md-button class=\"btn btn-md md-icon-button\" title=\"Borrar búsqueda\" aria-label=\"Borrar búsqueda\" \nng-click=\"vm.filter.search=null ; vm.refreshPromotions()\" ng-show=\"vm.filter.search\"><md-icon \nmd-font-icon=\"icon-eraser\"></md-icon></md-button><md-button class=\"submit-search\" title=\"Buscar\" aria-label=\"Buscar\" \nng-click=\"vm.refreshPromotions()\">Buscar</md-button></div><div class=\"content\"><div \nclass=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" ms-responsive-table><thead><tr><th>CN</th><th>\nMiniatura</th><th>Nombre</th><th>Estado</th><th>Precio</th><th>Restaurar</th></tr></thead><tfoot><tr><td></td></tr>\n</tfoot><tbody><tr \nng-class=\"{\'md-grey-100-bg\' : promotion.status==\'disabled\',\'md-teal-50-bg\' : promotion.status==\'coming_soon\' ,\'md-yellow-200-bg\' : promotion.vip_order > 0}\" \nng-repeat=\"(key,promotion) in vm.pagination.data\"><td class=\"id\">{{ promotion.code }}</td><td class=\"thumbnail\"><img \nng-hide=\"promotion.thumbnail\" ng-src=\"http://placehold.it/50x50\" alt=\"\" width=\"50\" height=\"50\"> <img \nng-show=\"promotion.thumbnail\" ng-src=\"{{promotion.thumbnail.urlth}}\" alt=\"\" width=\"50\" height=\"50\"></td><td \nclass=\"name\">{{promotion.name}}</td><td class=\"status\">\n{{ promotion.status == \'enabled\' ? \'Activada\' : promotion.status == \'coming_soon\' ? \'Próximamente\' : \'Desactivada\' }}\n</td><td class=\"price\">{{promotion.price | currency }}</td><td><md-button class=\"md-icon-button\" \nng-click=\"vm.restore(promotion.id,$index)\"><md-icon md-font-icon=\"icon-backup-restore\"></md-icon><md-tooltip \nmd-direction=\"left\">Restaurar</md-tooltip></md-button></td></tr></tbody></table><pagination pagination=\"vm.pagination\" \nfilter=\"vm.filter\" api-method=\"vm.api\"></pagination></div></div></div>");
$templateCache.put("app/main/admin/promotions/views/vipPromotions.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"md-teal-500-bg header md-accent-bg\" layout=\"row\" style=\"min-height: 100px; height: 100px\"><md-button \nlayout-align=\"start center\" class=\"md-raised md-fab md-primary mr-32\" back><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon></md-button><div layout-align=\"center center\" class=\"title\">Configurar VIP</div></div><div class=\"content\">\n<div class=\"order-card md-background-bg md-whiteframe-1dp\" layout=\"column\" layout-align=\"start stretch\"><div \nlayout=\"row\" flex class=\"mv-16 searchbar md-background-bg md-hue-2\" layout-align=\"space-between stretch\"><input \nautocomplete=\"off\" type=\"text\" placeholder=\"Buscar promoción\" flex \nng-keyup=\"($event.which === 13) ? vm.searchPromotion(promotion.searchTerm) : 0 \" name=\"searchArticle\" \nng-model=\"promotion.searchTerm\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-button \nclass=\"btn btn-md md-icon-button\" title=\"Borrar búsqueda\" aria-label=\"Borrar búsqueda\" \nng-click=\"vm.setSearch(false, \'null\')\" ng-show=\"vm.filter.search\"><md-icon md-font-icon=\"icon-eraser\"></md-icon>\n</md-button><md-button class=\"submit-search\" title=\"Buscar\" aria-label=\"Buscar\" \nng-click=\"vm.searchPromotion(article.searchTerm)\">Buscar</md-button></div><div \nng-if=\"vm.searchingPromotion.length > 0\" layout=\"row\" layout-align=\"center center\"><md-button title=\"Limpiar búsqueda\" \naria-label=\"Limpiar búsqueda\" ng-click=\"vm.searchingPromotion = []\">Limpiar búsqueda</md-button></div><ul \nstyle=\"list-style: none\"><li ng-repeat=\"item in vm.searchingPromotion track by $index\"><md-card \nclass=\"product-list-card\" layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start center\" \nlayout-align-gt-sm=\"space-between center\"><md-card-title-media flex-xs=\"100\" flex-sm=\"100\"><div \nclass=\"md-media-lg card-media md-card-image hover-effect-zoom\" \nstyle=\"background-image: url({{ item.thumbnail.url ? item.thumbnail.url : \'/assets/images/placeholder/no-disponible.png\' }}); width: 40px; height: 40px\">\n<a ui-sref=\"app.guest-article-show({ id: item.id })\" class=\"overlay\"></a></div></md-card-title-media>\n<md-card-title-text class=\"ph-32 pv-8\" layout=\"column\" flex=\"100\" flex-gt-xs=\"auto\"><span class=\"md-subhead\" \nui-sref=\"app.guest-article-show({ id: item.id })\" style=\"cursor: pointer\">{{ item.name }}</span> <span class=\"h5\">\nREF : {{ item.national_code }}</span></md-card-title-text><md-card-actions layout=\"row\" layout-align=\"center center\" \nng-controller=\"CartCtrl as cvm\"><md-button title=\"Añadir\" aria-label=\"Añadir\" \nclass=\"btn btn-sm btn-fullwidth md-raised md-accent\" ng-click=\"vm.addVip(item.id,$index)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>Añadir</md-button></md-card-actions></md-card></li></ul><ul \nclass=\"vip-article-list\" ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.promotions\" layout=\"row\" layout-wrap><li \nclass=\"sortable-vip-article\" data-article-id=\"{{ item.id }}\" ng-repeat=\"item in vm.promotions track by $index\" \nflex=\"100\" flex-gt-md=\"50\" flex-gt-lg=\"33\"><md-card class=\"product-list-card\" \nng-class=\'{\"grey-500-fg\": item.status != \"enabled\"}\'><md-card-title><a \nui-sref=\"app.guest-article-show({ id: item.id })\" class=\"promotion-image\"><img \nng-src=\"{{ item.thumbnail.url ? item.thumbnail.url : \'/assets/images/placeholder/no-disponible.png\' }}\" \nclass=\"md-card-image\" alt=\"{{ item.name }}\"></a><md-card-title-text class=\"promotion-header\"><p \nclass=\"promotion-order\" ng-class=\'{\"teal-300-fg\": item.status == \"enabled\", \"grey-400-fg\": item.status != \"enabled\"}\'>\n#{{ $index + 1 }} | <span class=\"promotion-ref\">REF : {{ item.code }}</span></p><p class=\"promotion-title\" \nui-sref=\"app.guest-article-show({ id: item.id })\" style=\"cursor: pointer\" title=\"{{ item.name }}\">{{ item.name }}</p>\n</md-card-title-text><md-button class=\"md-icon-button remove-promotion\" ng-click=\"vm.delVip(item.id,$index)\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\"></md-icon></md-button></md-card-title></md-card></li></ul></div></div></div>");
$templateCache.put("app/main/admin/rules/views/manager.html","<div layout=\"column\"><ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nmd-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Artículo / Promo</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><div ng-include=\"\'app/main/admin/rules/views/steps/step-1.html\'\">\n</div></form></md-tab-body></md-tab><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Opciones</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" \nms-form-wizard-form novalidate><div ng-include=\"\'app/main/admin/rules/views/steps/step-2.html\'\"></div></form>\n</md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><div \nlayout=\"row\" flex=\"30\" layout-align=\"start center\"><md-button ng-click=\"vm.rule.clearAll()\" \nlayout-align=\"start center\" ng-click=\"vm.rule.launchSelectElement=\'\'\" \ntitle=\"Restablecer seleccion de elemento para crear regla\" class=\"md-raised md-warn md-red-400-bg h5\"><md-icon \nmd-font-icon=\"icon-format-clear\"></md-icon><span>Limpiar campos</span></md-button></div><div flex=\"60\" layout=\"row\">\n<md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Atrás\n</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Siguiente</md-button><md-button \nclass=\"md-raised md-green-600-bg md-background-fg\" ng-click=\"vm.rule.save();\" ng-show=\"msWizard.isLastStep()\">Guardar\n</md-button></div></div></ms-form-wizard><div layout=\"row\" flex=\"20\" layout-align=\"center center\" \nclass=\"clear-zone mt-20\"><md-button ng-click=\"vm.rule.deleteAllRules()\" ng-show=\"vm.rule.selectedElement\" \ntitle=\"Elimina todas las reglas asociadas a la campaña , articulo o pormo seleccionada\" \nclass=\"md-raised md-warn md-red-400-bg h5\"><md-icon md-font-icon=\"icon-delete-variant\"></md-icon><span>\nEliminar todas reglas asociadas</span></md-button></div></div><md-card \nng-if=\"vm.rule.selectedElement.rules.ranges.length > 0 || vm.rule.selectedElement.rules.direct.id || vm.rule.selectedElement.rules.gifts.length > 0\" \nclass=\"p-8\"><div layout=\"column\" layout-align=\"center center\" class=\"mt-16 mb-16\"><h2>Descuentos Aplicados <small \nclass=\"orange-500-fg\" ng-show=\"vm.current_campaign.name && vm.rule.launchSelectElement==\'article\'\">\nSincronizado con campaña:</small></h2><h3 class=\"light-green-500-fg\" \nng-show=\"vm.current_campaign.name  && vm.rule.launchSelectElement==\'article\'\">{{vm.current_campaign.name}}</h3></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><div class=\"ph-16\" layout-gt-xs=\"column\" flex=\"60\"><h5 \nng-if=\"vm.rule.selectedElement.rules.ranges.length > 0\" align=\"center\">Por rango</h5><div flex=\"80\" layout=\"colum\" \nlayout-align=\"center center\" class=\"rule-ranges\" ng-repeat=\"(key,range) in  vm.rule.selectedElement.rules.ranges\"><div \nlayout=\"column\" layout-gt-xs=\"row\"><div flex=\"10\"><md-input-container class=\"md-icon-float md-icon-right md-block\">\n<label>Desde</label><input ng-model=\"range.from\" type=\"number\" min=\"0\" step=\"1\"></md-input-container></div><div \nflex=\"10\"><md-input-container class=\"md-icon-float md-icon-right md-block\"><label>Hasta</label><input \nng-model=\"range.to\" type=\"number\" min=\"0\" step=\"1\"></md-input-container></div><div flex=\"10\" layout=\"row\" \nlayout-align=\"space-between center\"><span style=\"margin-bottom: 24px;margin-right: 4px;font-size: 50px\">-</span>\n<md-input-container flex><input placeholder=\"Descuento\" flex ng-model=\"range.percent\" min=\"0\" type=\"number\" step=\"1\">\n</md-input-container><span style=\"margin-bottom: 19px;font-size: 23px\">%</span></div><div flex=\"10\" layout=\"row\" \nlayout-align=\"center center\"><a href=\"javascript:void(0)\" class=\"rule-range-delete mb-10\" \nng-click=\"vm.rule.rangeDestroy(range.id,$index)\"><md-icon md-font-icon=\"icon-delete-variant\" class=\"red-500-fg\">\n</md-icon></a></div></div></div></div><div ng-hide=\"vm.rule.launchSelectElement===\'campaign\'\" class=\"ph-16\" \nlayout=\"column\" flex=\"30\"><h5 align=\"center\">Descuento directo</h5><div flex=\"80\" layout=\"row\" \nlayout-align=\"center center\" class=\"rule-ranges\"><div layout=\"row\" flex><md-input-container flex><input \nplaceholder=\"Descuento\" flex ng-model=\"vm.rule.selectedElement.rules.direct.percent\" min=\"0\" type=\"number\" step=\"1\">\n</md-input-container></div><div layout=\"row\" flex><span class=\"h2 mb-20\">%</span></div><div flex=\"10\" layout=\"row\" \nlayout-align=\"center left\"><a href=\"javascript:void(0)\" class=\"rule-range-delete mb-10\" \nng-click=\"vm.rule.discountDestroy(vm.rule.selectedElement.rules.direct.id)\"><md-icon \nmd-font-icon=\"icon-delete-variant\" class=\"red-500-fg\"></md-icon></a></div></div></div></div><div \nng-if=\"vm.rule.selectedElement.rules.gifts.length > 0\" layout=\"column\" layout-align=\"center center\"><div \nlayout-align=\"center center\" class=\"mt-16 mb-16\"><h2>Regalos asociados</h2></div><div layout=\"column\"><div \nclass=\"ph-16\" layout-gt-xs=\"row\" layout=\"row\" layout-align=\"center center\" flex=\"80\"><table class=\"simple\" \nms-responsive-table><thead><tr><th>#</th><th>Miniatura</th><th>Nombre</th><th>Comprando X</th><th>Regalamos Y</th><th>\n</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr \nng-class=\"{\'md-grey-100-bg\' : rule.gift.status==\'disabled\',\'md-teal-50-bg\' : rule.gift.status==\'coming_soon\'}\" \nng-repeat=\"(key,rule) in vm.rule.selectedElement.rules.gifts\"><td class=\"id\">{{ rule.id }}</td><td class=\"thumbnail\">\n<img ng-hide=\"rule.gift.thumbnail\" ng-src=\"http://placehold.it/50x50\" alt=\"\" width=\"50\" height=\"50\"> <img \nstyle=\"width: 50px !important;height: 50px!important\" ng-show=\"rule.gift.thumbnail\" \nng-src=\"{{rule.gift.thumbnail.urlth}}\" alt=\"\"></td><td class=\"name\">{{rule.gift.name}}</td><td><md-input-container \nflex><input placeholder=\"\" flex ng-model=\"rule.every_quantity\" min=\"0\" type=\"number\" step=\"1\"></md-input-container>\n</td><td><md-input-container flex><input placeholder=\"\" flex ng-model=\"rule.gift_quantity\" min=\"0\" type=\"number\" \nstep=\"1\"></md-input-container></td><td><md-button ng-click=\"vm.rule.giftDestroy(rule.id,$index)\"><md-icon \nmd-font-icon=\"icon-delete-variant\"></md-icon>Eliminar</md-button></td></tr></tbody></table></div><div \nclass=\"ph-16 mt-20\" layout-gt-xs=\"row\" layout=\"row\" layout-align=\"center center\" flex=\"80\"></div></div></div><div \nclass=\"ph-16 mt-20\" layout-gt-xs=\"row\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-green-600-bg md-background-fg\" \nng-click=\"vm.rule.updateDiscounts(vm.rule.launchSelectElement,vm.rule.selectedElement.id)\"><md-icon \nmd-font-icon=\"icon-content-save md-background-fg\"></md-icon>Guardar</md-button></div></md-card>");
$templateCache.put("app/main/admin/rules/views/monthlyDiscount.html","<div layout=\"column\"><md-card class=\"p-8\"><h1>Configurar descuento mensual</h1><div layout=\"row\"><md-input-container \nflex=\"25\"><input type=\"text\" name=\"name\" ng-model=\"vm.options[\'min-order-amount-monthly-discount\'].value\" required \nplaceholder=\"Importe mínimo de pedido\"></md-input-container><md-input-container flex=\"25\"><input type=\"text\" \nname=\"name\" ng-model=\"vm.options[\'monthly-discount-reduction\'].value\" required \nplaceholder=\"Descuento aplicado (cuota 50)\"></md-input-container><md-input-container flex=\"25\"><input type=\"text\" \nname=\"name\" ng-model=\"vm.options[\'monthly-discount-reduction-35\'].value\" required \nplaceholder=\"Descuento aplicado (cuota 35)\"></md-input-container></div><div class=\"ph-16 mt-20\" layout-gt-xs=\"row\" \nlayout=\"row\" layout-align=\"center center\"><md-button ng-click=\"vm.save()\" \nclass=\"md-raised md-green-600-bg md-background-fg\"><md-icon md-font-icon=\"icon-content-save md-background-fg\">\n</md-icon>Guardar</md-button></div></md-card></div>");
$templateCache.put("app/main/admin/rules/views/rulesList.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">\nLista de reglas</div></div></div><div class=\"content\"><md-card class=\"p-8\"><div layout=\"column\"><div class=\"ph-16\" \nlayout-gt-xs=\"row\" layout=\"row\" layout-align=\"center center\" flex=\"80\"><table class=\"simple\" ms-responsive-table>\n<thead><tr><th>#</th><th>Tipo</th><th>Nombre</th><th></th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr \nng-repeat=\"(key,item) in vm.ItemsWithRules\"><td class=\"thumbnail\"><img ng-hide=\"item.thumbnail\" \nng-src=\"http://placehold.it/50x50\" alt=\"\" width=\"50\" height=\"50\"> <img \nstyle=\"width: 50px !important;height: 50px!important\" ng-show=\"item.thumbnail\" ng-src=\"{{rule.gift.thumbnail.urlth}}\" \nalt=\"\"></td><td>{{ item.type }}</td><td class=\"name\">{{item.name}}</td></tr></tbody></table></div><div \nclass=\"ph-16 mt-20\" layout-gt-xs=\"row\" layout=\"row\" layout-align=\"center center\" flex=\"80\"></div></div></md-card></div>\n</div>");
$templateCache.put("app/main/admin/rules/views/rulesPromotionalCreate.html","<div class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\" style=\"min-height: 100px;height: 100px\"><div\n class=\"breadcrumb layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16 ng-isolate-scope md-font icon-home material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon></div><span class=\"h2\">Descuento promocional</span> <span class=\"h3\">{{ vm.article.name }}\n</span></div><div class=\"content\" md-background-bg><div layout=\"row\"><div class=\"md-whiteframe-1dp\" flex=\"100\"><div \nlayout=\"row\" class=\"md-primary-bg\" style=\"padding: 5px 20px\"><h2>Datos del descuento promocional</h2></div><form \nname=\"vm.fuser\" ng-submit=\"vm.promotional.create()\" class=\"form-wrapper md-inline-form\" novalidate><div layout=\"row\" \nlayout-align=\"center top\" ng-cloak><div layout=\"column\" flex><div layout=\"row\"><md-input-container flex=\"75\"><input \ntype=\"text\" name=\"description\" ng-model=\"vm.promotional.description\" placeholder=\"Descripcion\" required>\n</md-input-container><md-input-container flex=\"25\"><input type=\"string\" name=\"national_code\" \nng-model=\"vm.promotional.ref\" placeholder=\"Referencia\" required></md-input-container></div><div layout=\"row\">\n<md-radio-group ng-model=\"vm.promotional.entity\" flex=\"40\"><md-radio-button value=\"promotion\">Promoción\n</md-radio-button><md-radio-button value=\"campaign\">Campaña</md-radio-button></md-radio-group><md-select \nng-if=\"vm.promotional.entity==\'promotion\'\" required placeholder=\"Promoción\" ng-model=\"vm.promotional.entity_id\" \nflex=\"60\"><md-select-header><input ng-model=\"searchTerm\" type=\"search\" placeholder=\"Buscar\" \nng-keydown=\"vm.onSearchChange($event)\" style=\"padding: 10px\"></md-select-header><md-option value=\"{{promotion.id}}\" \nng-repeat=\"promotion in vm.promotions | filter:searchTerm\">{{promotion.name }}</md-option></md-select><md-select \nng-if=\"vm.promotional.entity==\'campaign\'\" required placeholder=\"Campaña\" ng-model=\"vm.promotional.entity_id\" flex=\"60\">\n<md-select-header><input ng-model=\"searchTerm\" type=\"search\" placeholder=\"Buscar\" \nng-keydown=\"vm.onSearchChange($event)\" style=\"padding: 10px\"></md-select-header><md-option value=\"{{campaign.id}}\" \nng-repeat=\"campaign in vm.campaigns | filter:searchTerm\">{{campaign.name }}</md-option></md-select></div><div \nlayout=\"row\"><md-input-container flex=\"20\"><md-select placeholder=\"Tipo de descuento \" required \nng-model=\"vm.promotional.discount_type\"><md-option ng-if=\"vm.promotional.entity==\'campaign\'\" ng-value=\"\'range\'\">\nPor rango</md-option><md-option ng-value=\"\'direct\'\">Directo</md-option></md-select></md-input-container>\n<md-input-container ng-if=\"vm.promotional.discount_type==\'direct\'\" flex=\"20\"><input type=\"text\" name=\"percent\" \nng-model=\"vm.promotional.percent\" placeholder=\"Porcentaje\" required></md-input-container><md-input-container flex=\"20\">\n<label>Desde</label><md-datepicker timezoned-date ng-model=\"vm.promotional.date_from\" name=\"fromDate\" \nmd-min-date=\"minDate\" auto-open md-max-date=\"maxDate\" required></md-datepicker></md-input-container><md-input-container\n flex=\"20\"><label>Hasta</label><md-datepicker timezoned-date ng-model=\"vm.promotional.date_to\" name=\"toDate\" \nmd-min-date=\"vm.export.from\" auto-open required></md-datepicker></md-input-container></div><div \nng-if=\"vm.promotional.discount_type==\'range\' && vm.promotional.entity==\'campaign\'\" layout=\"column\"><div layout=\"row\">\n<h1>Gestor de rangos</h1><md-button ng-click=\"vm.newRange()\" class=\"md-raised md-primary\">Nuevo</md-button></div><div \nlayout=\"row\" layout-align=\"center center\" class=\"rule-ranges\" ng-repeat=\"(key,range) in  vm.promotional.ranges\"><div \nflex=\"20\"><md-input-container class=\"md-icon-float md-icon-right md-block\"><label>Desde</label><input \nng-model=\"range.from\" type=\"number\" min=\"0\" step=\"1\"></md-input-container></div><div flex=\"20\"><md-input-container \nclass=\"md-icon-float md-icon-right md-block\"><label>Hasta</label><input ng-model=\"range.to\" type=\"number\" min=\"0\" \nstep=\"1\"></md-input-container></div><div flex=\"20\" layout=\"row\" layout-align=\"space-between center\"><span \nstyle=\"margin-bottom: 24px;margin-right: 4px;font-size: 50px\">-</span><md-input-container flex><input required \nplaceholder=\"Descuento\" flex ng-model=\"range.percent\" min=\"0\" type=\"number\" step=\"1\"></md-input-container><span \nstyle=\"margin-bottom: 19px;font-size: 23px\">%</span></div></div></div><div layout=\"row\" layout-align=\"center top\">\n<md-input-container class=\"md-block\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"vm.fuser.$invalid || vm.fuser.$pristine\">Guardar</md-button></md-input-container></div></div></div></form>\n</div></div></div></div>");
$templateCache.put("app/main/admin/rules/views/rulesPromotionalList.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">\nDescuentos promocionales</div></div><md-button ui-sref=\"app.rules-promotional-create\" \nclass=\"md-fab md-warn button-fixed-bottom\" aria-label=\"Nuevo descuento promocional\"><md-tooltip>\nNuevo descuento promocional</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nclass=\"content\"><md-card class=\"p-8 generic-card-item\"><div layout=\"column\"><div class=\"ph-16\" layout-gt-xs=\"row\" \nlayout=\"row\" layout-align=\"center center\" flex=\"100\"><table class=\"simple\"><thead><tr><th>#ref</th><th>Descripcion</th>\n<th>Caducidad</th><th>Farmacéuticos</th><th>Descuento</th><th>Acciones</th></tr></thead><tfoot><tr><td></td></tr>\n</tfoot><tbody><tr ng-repeat=\"(key,item) in vm.promotionals\"><td>{{item.ref}}</td><td width=\"120px\">\n{{item.description}}</td><td><span ng-if=\"item.in_time\" class=\"md-green-800-bg p-5 h4\">Activo</span> <span \nng-if=\"!item.in_time\" class=\"md-red-800-bg p-5 h4\">No disponible</span></td><td>{{item.users}}</td><td><span \nng-if=\"item.sub_type==\'promotional\'\">{{item.percent}}%</span> <span ng-if=\"item.sub_type==\'promotional-range\'\">Escalado\n</span></td><td><section layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-wrap><md-button \nng-click=\"vm.details(item)\" title=\"Detalles\" class=\"md-icon-button\" aria-label=\"More\"><md-icon \nmd-font-icon=\"icon-clipboard-text\"><md-tooltip>Detalles</md-tooltip></md-icon></md-button><md-button \nng-click=\"vm.addPharma(item)\" title=\"Asignar a farmacéuticos\" class=\"md-icon-button\" \naria-label=\"Asignar farmacéuticos\"><md-icon md-font-icon=\"icon-account-plus\"><md-tooltip>Asignar a farmacéuticos\n</md-tooltip></md-icon></md-button><md-button ui-sref=\"app.rules-promotional-edit({idPromotional:item.id})\" \nclass=\"md-icon-button\" title=\"Editar\" aria-label=\"Editar\"><md-icon md-font-icon=\"icon-open-in-new\"><md-tooltip>Editar\n</md-tooltip></md-icon></md-button><md-button ng-click=\"vm.destroy(item.id,key)\" class=\"md-icon-button\" \ntitle=\"Eliminar\" aria-label=\"Eliminar\"><md-icon md-font-icon=\"icon-trash\"><md-tooltip>Eliminar</md-tooltip></md-icon>\n</md-button></section></td></tr></tbody></table></div><div class=\"ph-16 mt-20\" layout-gt-xs=\"row\" layout=\"row\" \nlayout-align=\"center center\" flex=\"80\"></div></div></md-card></div></div>");
$templateCache.put("app/main/admin/rules/views/rulesWizard.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">\nConfigurador por cantidades</div></div></div><div class=\"content\"><div \nng-include=\"\'app/main/admin/rules/views/manager.html\'\"></div></div></div>");
$templateCache.put("app/main/admin/seller/dialogs/addpharmacist.html","<md-dialog flex=\"80%\" aria-label=\"{{modal.promotional.description}}\" ng-cloak><form><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Selecciona un cliente</h2><span flex></span><md-button class=\"md-icon-button\" \nng-controller=\"ModalController as  mc\" ng-click=\"mc.hide()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-card class=\"generic-card-item p-40\"><div layout=\"row\" \nlayout-align=\"center stretch\"><div flex=\"40\" layout=\"column\" layout-align=\"start center\" class=\"mb-10\">\n<md-input-container><input autocomplete=\"off\" placeholder=\"Buscar\" \nng-keyup=\"($event.which === 13) ? modal.searchPharmacist(searchTerm) : 0 \" name=\"searhArticle\" ng-model=\"searchTerm\">\n</md-input-container></div><div flex=\"60\" layout=\"column\" class=\"pharmacist-promotional ml-10 pl-10\">\n<md-progress-circular ng-show=\"loadingSearch\" md-mode=\"indeterminate\"></md-progress-circular><md-list><md-subheader \nclass=\"md-no-sticky\"></md-subheader><md-list-item ng-repeat=\"result in modal.searchResult\"><div layout=\"row\" flex><p \nng-click=\"modal.addPharma(result)\" style=\"cursor:pointer\" flex=\"80\" title=\"{{result.name}}\">\n{{result.username}} - {{result.name | characters : 40}}</p><md-button flex=\"20\" ng-click=\"modal.addPharma(result)\" \nclass=\"md-icon-button\" aria-label=\"More\"><md-icon md-font-icon=\"icon-plus\"><md-tooltip>Añadir</md-tooltip></md-icon>\n</md-button></div></md-list-item></md-list></div></div></md-card></md-dialog-content><md-dialog-actions layout=\"row\">\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/sliders/views/createSlider.html","<div class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\" style=\"min-height: 100px;height: 100px\"><div\n class=\"breadcrumb layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16 ng-isolate-scope md-font icon-home material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator ng-isolate-scope md-font icon-chevron-right material-icons md-default-theme\" aria-hidden=\"true\">\n</md-icon><span class=\"parent\">Sliders</span></div><span class=\"h1\">Slider</span> <span class=\"h2\">{{ vm.slider.name }}\n</span></div><div class=\"content\" md-background-bg><div ng-include=\"\'app/main/admin/sliders/views/forms/create.html\'\">\n</div></div></div>");
$templateCache.put("app/main/admin/sliders/views/listSliders.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div \nclass=\"breadcrumb layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16 ng-isolate-scope md-font icon-home material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator ng-isolate-scope md-font icon-chevron-right material-icons md-default-theme\" aria-hidden=\"true\">\n</md-icon><span class=\"parent\">Sliders</span></div><div class=\"title\">Lista de sliders</div></div></div><div \nclass=\"content\"><div class=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" ms-responsive-table><thead>\n<tr><th>#</th><th>Nombre</th><th>Estado</th><th>Creado</th><th>Acciones</th></tr></thead><tfoot><tr><td></td></tr>\n</tfoot><tbody><tr \nng-class=\"{\'md-grey-100-bg\' : slider.status==\'disabled\',\'md-teal-50-bg\' : slider.status==\'coming_soon\'}\" \nng-repeat=\"(key,slider) in vm.sliders\"><td class=\"id\">{{ slider.id }}</td><td class=\"name\">{{slider.name}}</td><td \nclass=\"status\">{{ slider.status ? \'Activado\' : \'Desactivado\' }}</td><td class=\"created_at\">\n{{slider.created_at[\'date\'] | momentHumanize }}</td><td><md-menu md-offset=\"0 -7\"><md-button aria-label=\"open menu\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical \"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ui-sref=\"app.sliders-edit({idSlider:slider.id})\">\n<md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon>Editar</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.destroy(slider.id,$index)\"><md-icon md-font-icon=\"icon-delete-variant\"></md-icon>Eliminar</md-button>\n</md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/admin/sync/views/create.html","<div class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\" style=\"min-height: 100px;height: 100px\"><div\n class=\"breadcrumb layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16 ng-isolate-scope md-font icon-home material-icons md-default-theme\" \naria-hidden=\"true\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator ng-isolate-scope md-font icon-chevron-right material-icons md-default-theme\" aria-hidden=\"true\">\n</md-icon><span class=\"parent\">Sincronización</span></div><span class=\"h2\">Sincronización de stock</span></div><div \nclass=\"content\" md-background-bg><md-card><div layout=\"row\"><div class=\"md-whiteframe-1dp\" flex=\"100\"><div \nlayout=\"row\" class=\"md-primary-bg\" style=\"padding: 5px 20px\"><h2>Actualiza stock de artículos y promos</h2></div><div \nclass=\"pb-60 pt-60\" layout=\"column\" layout-align=\"center center\"><md-button ng-click=\"vm.run()\" \nclass=\"btn btn-md md-raised md-green-600-bg md-background-fg\"><md-icon class=\"md-background-fg\" \nmd-font-icon=\"icon-sync\"></md-icon>Sincronizar ahora !</md-button><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.isSync\"></md-progress-linear></div></div></div></md-card></div></div>");
$templateCache.put("app/main/admin/users/views/createUser.html","<div class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\" style=\"min-height: 100px;height: 100px\">\n<span class=\"h2\">Nuevo usuario</span></div><div class=\"content\" md-background-bg><div \nng-include=\"\'app/main/admin/users/views/forms/create.html\'\"></div></div></div>");
$templateCache.put("app/main/admin/users/views/editUser.html","<div class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\" style=\"min-height: 100px;height: 100px\">\n<span class=\"h2\">Nuevo empleado</span></div><div class=\"content\" md-background-bg><div \nng-include=\"\'app/main/admin/users/views/forms/edit.html\'\"></div></div></div>");
$templateCache.put("app/main/admin/users/views/listUsers.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">Usuarios\n</div></div><md-button ui-sref=\"app.user-create\" class=\"md-fab md-warn button-fixed-bottom\" aria-label=\"Eat cake\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div layout=\"row\" flex hide-xs hide-sm \nclass=\"mr-16 searchbar md-background-bg md-hue-2\" layout-align=\"space-between stretch\"><div flex=\"80\" layout=\"row\">\n<input flex=\"80\" type=\"text\" name=\"search\" placeholder=\"Buscar...\" ng-model=\"vm.filter.search\" \nng-keyup=\"($event.which === 13) ? vm.refreshUsers() : 0 \" flex><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<md-button class=\"btn btn-md md-icon-button\" title=\"Borrar búsqueda\" aria-label=\"Borrar búsqueda\" \nng-click=\"vm.filter.search=null ; vm.refreshUsers()\" ng-show=\"vm.filter.search\"><md-icon md-font-icon=\"icon-eraser\">\n</md-icon></md-button><md-button class=\"submit-search\" title=\"Buscar\" aria-label=\"Buscar\" ng-click=\"vm.refreshUsers()\">\nBuscar</md-button></div><div flex=\"20\"><md-switch ng-change=\"vm.refreshUsers()\" ng-model=\"vm.filter.activated\">\nSolo activados</md-switch></div></div><div class=\"content\"><div layout=\"row\" class=\"pagination-count mb-16\" flex \nlayout-align=\"start center\"><span class=\"h3\">\nMostrando resultados {{ vm.users.from }} - {{ vm.users.to }} de {{ vm.users.total }} ({{ vm.users.last_page }} páginas)\n</span></div><div class=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" ms-responsive-table><thead>\n<tr><th>#Id</th><th>Nombre</th><th>Activado</th><th>Ultima conexion</th><th>Email</th><th>Cuota</th><th>Acciones</th>\n</tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr ng-class=\"{\'md-grey-A200-bg\' : person.status==0}\" \nng-repeat=\"(key,person) in vm.users.data\"><td>{{person.id}}</td><td class=\"name\">{{person.name}}</td><td \nclass=\"created_at\">{{person.activated_on ? (person.activated_on[\'date\'] | momentHumanize) : \'NO\' }}</td><td \nclass=\"created_at\">{{person.last_seen_at[\'date\'] ? ( person.last_seen_at[\'date\'] | momentHumanize ) : \'NO\' }}</td><td \nclass=\"email\">{{person.email}}</td><td><span class=\"md-grey-600-bg p-5\" ng-if=\"person.contract_type==\'none\'\">- - \n</span><span class=\"md-green-600-bg p-5\" ng-if=\"person.contract_type==\'50\'\">{{person.contract_type}}</span> <span \nclass=\"md-orange-800-bg p-5\" ng-if=\"person.contract_type==\'35\'\">{{person.contract_type}}</span> <span \nclass=\"md-red-600-bg p-5\" ng-if=\"person.contract_type==\'25\'\">{{person.contract_type}}</span></td><td><md-menu \nmd-offset=\"0 -7\"><md-button aria-label=\"open menu\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical \"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nui-sref=\"app.user-edit({idUser:person.id})\"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon>Editar</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.destroy(person.id,$index)\"><md-icon \nmd-font-icon=\"icon-delete-variant\"></md-icon>Eliminar</md-button></md-menu-item><md-menu-item ng-switch \non=\"person.status\"><md-button ng-click=\"vm.statusToggle(person.id,$index)\" aria-label=\"none\"><span ng-switch-when=\"0\">\n<md-icon md-font-icon=\"icon-account-plus\"></md-icon>Activar </span><span ng-switch-when=\"1\"><md-icon \nmd-font-icon=\"icon-account-remove\"></md-icon>Desactivar</span></md-button></md-menu-item></md-menu-content></md-menu>\n</td></tr></tbody></table><pagination pagination=\"vm.users\" filter=\"vm.filter\" api-method=\"vm.api\"></pagination></div>\n</div></div>");
$templateCache.put("app/main/pharmacist/articles/views/add.html","<md-dialog aria-label=\"Añadir artículo\" ng-cloak class=\"md-background md-hue-1\" ng-cloak><form><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Añadir artículo</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"caddvm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Cerrar ventana\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start stretch\" \nlayout-align-gt-sm=\"center stretch\"><md-card class=\"product-list-card\" layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start center\" layout-align-gt-sm=\"space-between center\" flex=\"100\" flex-gt-sm=\"75\"><md-card-title-media \nflex=\"100\" flex-gt-sm=\"20\"><div class=\"md-media-lg card-media md-card-image hover-effect-zoom\" \nstyle=\"background-image: url({{ caddvm.item.thumbnail.url ? caddvm.item.thumbnail.url : \'/assets/images/placeholder/no-disponible.png\' }})\">\n<a href=\"#\" class=\"overlay\"></a></div></md-card-title-media><md-card-title-text class=\"ph-32 pv-16\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"60\"><span class=\"md-headline\">{{ caddvm.item.name }}</span> <span class=\"md-subhead\">\n{{ caddvm.item.category.name }}</span><span class=\"md-warn-fg md-title\">{{ caddvm.item.price | currency}}</span>\n</md-card-title-text><div layout=\"column\" class=\"p-16\"></div></md-card><md-card layout=\"column\" \nlayout-align=\"center center\" flex=\"25\"><span class=\"md-warn-fg md-display-1\">{{ caddvm.item.price | currency}}</span>\n<sync-number-spinner class=\"mv-16 number-spinner\" model=\"caddvm.quantity\" min=\"1\" step=\"1\"></sync-number-spinner><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"start stretch\"><md-button ng-click=\"caddvm.submit(true)\" \nclass=\"md-raised md-accent\"><md-icon md-font-icon=\"icon-chevron-double-right\"></md-icon>Finalizar</md-button><md-button\n ng-click=\"caddvm.submit(false)\" class=\"md-raised\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Añadir y seguir\n</md-button></div></md-card></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"caddvm.cancel()\" \nclass=\"md-raised\"><md-icon md-font-icon=\"icon-close\"></md-icon>Cancelar</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pharmacist/articles/views/listArticles.html","<style>\n#campaign-slider {\r\n    height: auto;\r\n  }\r\n\r\n  @media(min-width:1680px) {\r\n    #promotion-list-view {\r\n      max-width: 1024px;\r\n      display: block;\r\n      margin-right: auto;\r\n      margin-left: auto;\r\n    }\r\n  }\r\n\r\n  #home-promotions product-card,\r\n  #home-promotions .product-card {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    min-width: 100%;\r\n  }\r\n\r\n  @media (min-width: 600px) {\r\n    #home-promotions product-card,\r\n    #home-promotions .product-card {\r\n      width: 50%;\r\n      max-width: 50%;\r\n      min-width: 50%;\r\n    }\r\n  }\r\n\r\n  @media (min-width: 1280px) {\r\n    #home-promotions product-card,\r\n    #home-promotions .product-card {\r\n      width: 33%;\r\n      max-width: 33%;\r\n      min-width: 33%;\r\n    }\r\n  }\r\n\r\n  @media (min-width: 1920px) {\r\n    #home-promotions product-card,\r\n    #home-promotions .product-card {\r\n      width: 16.666%;\r\n      max-width: 16.666%;\r\n      min-width: 16.666%;\r\n    }\r\n  }\n</style><div class=\"page-layout simple fullwidth\"><slider slider=\"vm.slider\"></slider><div \nclass=\"md-cyan-400-bg header md-accent-bg header-with-toolbar\" style=\"min-height: 100px;height: auto\" layout=\"column\" \nlayout-align=\"space-between center\"><span class=\"md-display-1 mv-0\">Artículos</span><md-toolbar \nclass=\"mt-8 pr-16 md-menu-toolbar calculator-toolbar md-background-bg\"><div class=\"md-toolbar-tools\" \nstyle=\"font-size: 16px\" layout-align=\"space-between center\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button><div layout=\"row\" flex hide-xs class=\"mr-16 searchbar md-background-bg md-hue-2\" \nlayout-align=\"space-between stretch\"><input type=\"text\" name=\"search\" placeholder=\"Buscar...\" \nng-model=\"vm.filter.search\" ng-keyup=\"($event.which === 13) ? vm.refreshArticles() : 0 \" flex><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><md-button class=\"btn btn-md md-icon-button\" title=\"Borrar búsqueda\" \naria-label=\"Borrar búsqueda\" ng-click=\"vm.setSearch(false, \'null\')\" ng-show=\"vm.filter.search\"><md-icon \nmd-font-icon=\"icon-eraser\"></md-icon></md-button><md-button class=\"submit-search\" title=\"Buscar\" aria-label=\"Buscar\" \nng-click=\"vm.refreshArticles()\">Buscar</md-button></div><div layout=\"row\" class=\"mr-8\" hide-xs hide-sm hide-md><md-icon\n style=\"margin-right: .5em;margin-left: .6em\" md-font-icon=\"icon-checkbox-multiple-blank-outline\"></md-icon><md-select \nplaceholder=\"Artículos por página\" ng-change=\"vm.refreshArticles()\" ng-model=\"vm.filter.items\" \nstyle=\"overflow: hidden\"><md-select-header></md-select-header><md-option value=\"12\">12 artículos</md-option><md-option \nvalue=\"24\">24 artículos</md-option><md-option value=\"36\">36 artículos</md-option><md-option value=\"48\">48 artículos\n</md-option><md-option value=\"60\">60 artículos</md-option></md-select></div><div hide-xs hide-sm><md-button \nclass=\"btn btn-md ml-16\" title=\"Mostrar cuadrícula\" aria-label=\"Mostrar cuadrícula\" \nng-class=\"{\'md-accent\': vm.view==\'grid\'}\" aria-label=\"Favorite\" ng-click=\"vm.setView(\'grid\')\"><md-icon \nmd-font-icon=\"fa fa-th\"></md-icon></md-button><md-button class=\"btn btn-md\" title=\"Mostrar lista\" \naria-label=\"Mostrar lista\" ng-class=\"{\'md-accent\': vm.view==\'list\'}\" aria-label=\"More\" ng-click=\"vm.setView(\'list\')\">\n<md-icon md-font-icon=\"fa fa-th-list\"></md-icon></md-button></div></div></md-toolbar></div><div class=\"content\" \nmd-background-bg layout=\"row\" layout-align=\"space-between start\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-sidenav-helper ms-scroll><md-content><div \nlayout=\"row\" flex hide-gt-md class=\"searchbar md-background-bg md-hue-2\" layout-align=\"space-between stretch\"><input \ntype=\"text\" name=\"search\" placeholder=\"Buscar...\" ng-model=\"vm.filter.search\" \nng-keyup=\"($event.which === 13) ? vm.refreshArticles() : 0 \" flex><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<md-button class=\"btn btn-md md-icon-button\" title=\"Borrar búsqueda\" aria-label=\"Borrar búsqueda\" \nng-click=\"vm.setSearch(false, \'null\')\" ng-show=\"vm.filter.search\"><md-icon md-font-icon=\"icon-eraser\"></md-icon>\n</md-button><md-button class=\"submit-search\" title=\"Buscar\" aria-label=\"Buscar\" ng-click=\"vm.refreshArticles()\">Buscar\n</md-button></div><md-list hide-gt-md><md-subheader class=\"md-no-sticky\">Artículos por página</md-subheader>\n<md-list-item class=\"md-no-proxy\" ng-class=\"{\'md-accent-bg\' : vm.filter.items == 12}\" ng-click=\"vm.setItems(12,true)\">\n12 artículos</md-list-item><md-divider></md-divider><md-list-item class=\"md-no-proxy\" \nng-class=\"{\'md-accent-bg\' : vm.filter.items == 24}\" ng-click=\"vm.setItems(24,true)\">24 artículos</md-list-item>\n<md-divider></md-divider><md-list-item class=\"md-no-proxy\" ng-class=\"{\'md-accent-bg\' : vm.filter.items == 36}\" \nng-click=\"vm.setItems(36,true)\">36 artículos</md-list-item><md-divider></md-divider><md-list-item class=\"md-no-proxy\" \nng-class=\"{\'md-accent-bg\' : vm.filter.items == 48}\" ng-click=\"vm.setItems(48,true)\">48 artículos</md-list-item>\n<md-divider></md-divider><md-list-item class=\"md-no-proxy\" ng-class=\"{\'md-accent-bg\' : vm.filter.items == 60}\" \nng-click=\"vm.setItems(60,true)\">60 artículos</md-list-item><md-divider></md-divider></md-list><md-list><md-subheader \nclass=\"md-no-sticky\">Categorías</md-subheader><div layout=\"row\" flex class=\"searchbar md-background-bg md-hue-2\" \nlayout-align=\"space-between stretch\"><input type=\"text\" name=\"searchcat\" placeholder=\"Buscar...\" ng-model=\"searchcat\" \nflex><md-icon md-font-icon=\"icon-magnify\"></md-icon></div><md-list-item class=\"md-no-proxy\" \nng-class=\"{\'md-accent-bg\' : !vm.filter.category}\" ng-click=\"vm.setCategory(null,true)\"><p>Mostrar todas</p>\n</md-list-item><md-divider></md-divider><md-list-item class=\"md-no-proxy\" \nng-class=\"{\'md-accent-bg\' : vm.filter.category == category.id}\" \nng-repeat-start=\"category in vm.categories | filter:searchcat\" ng-click=\"vm.setCategory(category.id,true)\">\n{{ category.name }}</md-list-item><md-divider ng-repeat-end></md-divider></md-list></md-content></md-sidenav><div \nlayout=\"column\" flex><section id=\"home-promotions\" class=\"ph-32\" layout=\"column\" layout-align=\"stretch center\"><div \nlayout=\"row\" class=\"pagination-count mb-16\" flex layout-align=\"start center\" ng-show=\"vm.pagination.data.length > 0\">\n<span class=\"h3\">\nMostrando resultados {{ vm.pagination.from }} - {{ vm.pagination.to }} de {{ vm.pagination.total }} ({{ vm.pagination.last_page }} páginas)\n</span> <span class=\"h3 ml-10\">Las compras de artículos las debe realizar a través del terminal.</span></div><div \nlayout=\"column\" flex layout-align=\"center center\" class=\"pv-36 ph-18\" ng-show=\"!vm.pagination.data.length > 0\"><span \nclass=\"md-title\">No hay ningún artículo con esas características.</span><md-button \nclass=\"btn btn-md md-raised md-warn\" ng-click=\"vm.resetFilter()\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon>\nRestablecer filtro</md-button></div><div ng-show=\"vm.view==\'grid\'\" ng-hide=\"vm.view==\'list\'\" flex=\"100\" \nlayout=\"column\" layout-gt-xs=\"row\" layout-wrap layout-align=\"start stretch\"><product-card \nng-repeat=\"p in vm.pagination.data\" product=\"p\" type=\"\'article\'\" has-commercial-access=\"vm.hasCommercialAccess\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-lg=\"25\" flex-grow=\"0\" layout=\"column\" layout-align=\"space-between center\">\n</product-card></div><div id=\"promotion-list-view\" ng-show=\"vm.view==\'list\'\" flex=\"100\" ng-hide=\"vm.view==\'grid\'\" \nlayout=\"column\" layout-wrap layout-align=\"start stretch\"><md-card class=\"product-list-card\" \nng-repeat=\"p in vm.pagination.data\" layout=\"column\" layout-gt-md=\"row\" layout-align=\"start center\" \nlayout-align-gt-md=\"space-between center\"><md-card-title-media flex-xs=\"100\" flex-md=\"100\"><div \nclass=\"md-media-lg card-media md-card-image hover-effect-zoom\" \nstyle=\"background-image: url({{ p.thumbnail.url ? p.thumbnail.url : \'/assets/images/placeholder/no-disponible.png\' }})\">\n<a ui-sref=\"app.guest-article-show({ id: p.id })\" class=\"overlay\"></a></div></md-card-title-media><md-card-title-text \nclass=\"ph-32 pv-16\" layout=\"column\" flex=\"100\" flex-gt-xs=\"auto\"><span class=\"md-headline\" \nui-sref=\"app.guest-article-show({ id: p.id })\">{{ p.name }}</span> <span class=\"h4\">REF : {{ p.national_code }}</span> \n<span class=\"md-subhead\">{{ p.category.name }}</span><md-content \nng-bind=\"p.description | htmlToPlaintext | truncateText:150\"></md-content><div class=\"mv-10\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap=\"nowrap\"><div class=\"mh-15\" ng-if=\"p.hasCampaigns\" layout=\"row\" \nlayout-align=\"start center\"><md-icon class=\"blue-800-fg mr-10\" md-font-icon=\"fa fa-bullhorn\"><md-tooltip \nmd-direction=\"left\">Está en campaña</md-tooltip></md-icon><span class=\"blue-800-fg\" aria-label=\"Está en campaña\">\nEstá en campaña</span></div><div class=\"mh-15\" ng-if=\"p.hasPromotions\" layout=\"row\" layout-align=\"start center\">\n<md-icon class=\"yellow-800-fg mr-10\" md-font-icon=\"icon-tag-multiple\"><md-tooltip md-direction=\"left\">\nParte de una promoción</md-tooltip></md-icon><span class=\"yellow-800-fg\" aria-label=\"Parte de una promoción\">\nParte de una promoción</span></div><div class=\"mh-15\" ng-if=\"p.hasPromotions\" layout=\"row\" layout-align=\"start center\">\n<md-icon class=\"green-A700-fg mr-10\" md-font-icon=\"icon-gift\"><md-tooltip md-direction=\"left\">Tiene regalo</md-tooltip>\n</md-icon><span class=\"green-A700-fg\" aria-label=\"Tiene regalo\">Tiene regalo</span></div><div class=\"mh-15\" \nng-if=\"p.hasGiftCampaign\" layout=\"row\" layout-align=\"start center\"><md-icon class=\"pink-A400-fg mr-10\" \nmd-font-icon=\"icon-gift\"><md-tooltip md-direction=\"left\">Está en campaña con regalo</md-tooltip></md-icon><span \nclass=\"pink-A400-fg\" aria-label=\"Tiene regalo\">Está en campaña con regalo</span></div><div class=\"mh-15\" \nng-if=\"p.min_amount > 1 && (p.min_amount <= p.stock )\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"green-500-fg mt-10\">Mínimo de {{p.min_amount}} unidades</span></div><div class=\"mh-15\" ng-if=\"p.discounted\" \nlayout=\"row\" layout-align=\"start center\"><md-icon class=\"lime-A700-fg mr-10\" md-font-icon=\"icon-arrow-down-bold\">\n<md-tooltip md-direction=\"left\">Precio rebajado</md-tooltip></md-icon><span class=\"lime-A700-fg\" \naria-label=\"Precio rebajado\">Precio rebajado</span></div></div></md-card-title-text><div layout=\"column\" class=\"p-16\">\n<md-card-price layout=\"row\" layout-align=\"space-around center\" flex class=\"mv-8\"><div layout=\"column\"><span \nng-if=\"p.best_price.applied_rule\" class=\"md-subhead mh-8\"><s>{{ p.price|currency}}</s></span> <span \nng-if=\"p.best_price.applied_rule\" class=\"md-warn-fg md-title mh-8\">{{ p.best_price.discounted_price | currency}}</span>\n <span ng-if=\"p.best_price.applied_rule==null\" class=\"md-warn-fg md-title mh-8\">{{ p.price | currency}}</span></div>\n<span ng-if=\"p.best_price.applied_rule\" class=\"yellow-800-fg\">\n{{p.best_price.applied_rule.sub_type==\'range\'? \'Hasta\':\'\'}} -{{p.best_price.applied_rule.percent}}%</span>\n</md-card-price><md-card-actions layout=\"row\" layout-align=\"center center\" ng-controller=\"CartCtrl as cvm\"><md-button \nng-if=\"p.stock > 0 && (p.hasCampaigns || vm.hasCommercialAccess)\" title=\"Comprar\" aria-label=\"Comprar\" \nclass=\"btn btn-sm btn-fullwidth md-raised md-accent\" ng-click=\"cvm.showAdvanced(p.id,\'article\')\"><md-icon \nmd-font-icon=\"icon-cart-outline\"></md-icon>Comprar</md-button></md-card-actions><div layout=\"column\" \nlayout-align=\"center center\"><span ng-if=\"p.stock == 0\" class=\"md-red-600-bg p-10 h4\" style=\"margin-bottom: 8px\">\nAgotado</span></div></div></md-card></div><div layout=\"row\" class=\"pagination-count\" flex layout-align=\"start center\" \nng-show=\"vm.pagination.data.length > 0\"><span class=\"h3\">\nMostrando resultados {{ vm.pagination.from }} - {{ vm.pagination.to }} de {{ vm.pagination.total }} ({{ vm.pagination.last_page }} páginas)\n</span></div></section><pagination pagination=\"vm.pagination\" filter=\"vm.filter\" api-method=\"vm.api\" layout=\"row\" \nlayout-align=\"stretch center\"></pagination></div></div></div>");
$templateCache.put("app/main/pharmacist/articles/views/showArticle.html","<style>#item {\r\n    max-width: 1200px;\r\n  }</style><div class=\"page-layout simple fullwidth doc-page element-doc-page\">\n<div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><md-button \nclass=\"md-raised md-fab md-primary mr-32\" back><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><div \nlayout=\"column\" layout-align=\"center center\" class=\"ph-32\"><span class=\"md-display-1\">{{ vm.article.name }}</span> \n<span class=\"md-title\">Artículo</span></div><md-button ng-if=\"vm.article.stock > 0\" title=\"Comprar\" \naria-label=\"Comprar\" class=\"md-fab md-raised md-primary\" ng-controller=\"CartCtrl as cvm\" \nng-click=\"cvm.showAdvanced(vm.article.id,\'article\')\"><md-icon md-font-icon=\"icon-cart\"></md-icon></md-button></div><div\n layout=\"column\" layout-align=\"center center\" class=\"p-8\"><md-card class=\"generic-card-item\" id=\"item\" layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start center\" layout-align-gt-sm=\"space-between start\"><md-card-title-media \nflex=\"100\" flex-gt-sm=\"40\"><div class=\"md-media-lg card-media md-card-image hover-effect-zoom\" flex><img \nng-src=\"/assets/images/placeholder/no-disponible.png\" alt=\"\" ng-hide=\"vm.article.thumbnail\"> <img \nng-src=\"{{ vm.article.thumbnail.url }}\" alt=\"\" ng-show=\"vm.article.thumbnail\"></div><div \nng-if=\"vm.article.hasCampaigns\" class=\"p-10\" layout=\"row\"><h3>Campaña asociada: <a \nui-sref=\"app.guest-campaign-show({id:vm.article.campaign.id})\">{{vm.article.campaign.name}} </a></h3></div>\n</md-card-title-media><md-card-title-text class=\"ph-32 pv-16\" layout=\"column\" flex=\"100\" flex-gt-xs=\"60\"><span \nclass=\"md-headline\">{{ vm.article.name }}</span> <span class=\"h4\">REF : {{ vm.article.national_code }}</span> <span \nclass=\"md-subhead\">{{ vm.article.category.name }}</span><md-content ng-bind-html=\"vm.article.description\"></md-content>\n<div layout=\"column\"><div ng-if=\"vm.article.avaliable_rules.ranges.length > 0\"><h3>Escalado disponible</h3><div \nclass=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" ms-responsive-table><thead><tr><th>Desde</th>\n<th>Hasta</th><th>Descuento</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr \nng-repeat=\"(key,range) in vm.article.avaliable_rules.ranges\"><td class=\"from\">{{ range.quantity_from }}</td><td \nclass=\"from\">{{ range.quantity_to }}</td><td class=\"from\">{{ range.percent }}%</td></tr></tbody></table></div></div>\n<div layout=\"column\"><div ng-if=\"vm.article.avaliable_rules.gifts.length > 0\"><h3><md-icon class=\"mr-10\" \nmd-font-icon=\"icon-gift\"></md-icon>Regalos disponibles</h3><div class=\"simple-table-container md-whiteframe-4dp\"><table\n class=\"simple\" ms-responsive-table><thead><tr><th></th><th>Nombre</th><th>Descripción</th></tr></thead><tfoot><tr><td>\n</td></tr></tfoot><tbody><tr ng-repeat=\"(key,gift) in vm.article.avaliable_rules.gifts\"><td class=\"from\"><img \nng-src=\"/assets/images/placeholder/no-disponible.png\" alt=\"\" ng-hide=\"gift.gift.thumbnail\"> <img \nstyle=\"width: 50px !important;height: 50px!important\" ng-show=\"gift.gift.thumbnail\" \nng-src=\"{{gift.gift.thumbnail.urlth}}\" alt=\"\"></td><td class=\"from\">{{ gift.gift.name }}</td><td class=\"from\">\n{{ gift.gift_quantity}} de regalo por cada {{gift.every_quantity==1 ? \'\':gift.every_quantity}} articulo{{gift.every_quantity > 1 ? \'s\':\'\'}} comprado{{gift.every_quantity > 1 ? \'s\':\'\'}}.\n</td></tr></tbody></table></div></div></div></div><div layout=\"column\" class=\"p-16\"><md-card-actions layout=\"row\" \nlayout-align=\"space-around center\"><span \nng-if=\"vm.article.avaliable_rules.direct && vm.article.avaliable_rules.ranges.length==0\" style=\"font-size: 20px\">\n-{{ vm.article.avaliable_rules.direct.percent}} %</span><div layout=\"column\" flex=\"30\"><span \nclass=\"md-display-1 md-warn-fg\">\n{{ vm.article.avaliable_rules.ranges.length==0 ? vm.article.avaliable_rules.discounted_price : vm.article.price | currency }} \n</span><span ng-if=\"vm.article.avaliable_rules.direct && vm.article.avaliable_rules.ranges.length==0\" \nclass=\"md-subhead\"><s>{{ vm.article.price | currency}}</s></span></div><md-input-container \nng-if=\"vm.article.stock > 0 && (vm.article.hasCampaigns || vm.hasCommercialAccess)\" style=\"margin-top: 56px\" flex=\"20\">\n<label style=\"font-size: 16px;color: rgba(0,0,0,0.87)\">Cantidad</label><input \nstyle=\"font-size: 18px;color:rgba(0,0,0,0.87)\" id=\"quantity\" type=\"number\" ng-model=\"vm.qty\" min=\"1\" step=\"1\">\n</md-input-container></md-card-actions><md-button \nng-if=\"vm.article.stock > 0 && (vm.article.hasCampaigns || vm.hasCommercialAccess)\" flex=\"30\" \nlayout-align=\"center center\" ng-controller=\"CartAddCtrl as caddvm\" \nng-click=\"caddvm.submit(false,vm.article.id,\'article\', vm.qty)\" title=\"Comprar\" aria-label=\"Comprar\" \nclass=\"btn btn-md md-raised md-accent\"><md-icon md-font-icon=\"icon-cart\"></md-icon>Comprar</md-button><span \nng-if=\"vm.article.stock == 0\" class=\"md-red-600-bg p-10 h4 text-center mt-20\" style=\"margin-bottom: 8px\">Agotado</span>\n</div></md-card-title-text></md-card></div></div>");
$templateCache.put("app/main/pharmacist/campaigns/views/listCampaigns.html","<style>\n#coming-soon-campaigns md-card,\r\n  #coming-soon-campaigns .md-card {\r\n    max-width: 100%;\r\n  }\r\n\r\n  @media (min-width: 600px) {\r\n    #coming-soon-campaigns md-card,\r\n    #coming-soon-campaigns .md-card {\r\n      max-width: 47%;\r\n    }\r\n  }\r\n\r\n  @media (min-width: 960px) {\r\n    #coming-soon-campaigns md-card,\r\n    #coming-soon-campaigns .md-card {\r\n      max-width: 32%;\r\n    }\r\n  }\r\n\r\n  .product-list-card .product-list-card {\r\n    max-width: 100%;\r\n  }\r\n\r\n  @media (min-width: 600px) {\r\n    .product-list-card .product-list-card {\r\n      max-width: 50%;\r\n    }\r\n  }\r\n\r\n  @media (min-width: 1280px) {\r\n    .product-list-card .product-list-card {\r\n      max-width: 20%;\r\n    }\r\n  }\n</style><div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"md-blue-900-bg header md-accent-bg\" layout=\"row\" layout-align=\"center center\" \nstyle=\"min-height: 100px; height: 100px\"><span class=\"md-display-2\">Campañas</span></div><section layout=\"row\" \nclass=\"mb-64\" layout-wrap><div class=\"campaign-item\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"33\" \nng-repeat=\"c in vm.campaigns\"><md-card class=\"product-list-card campaign campaign-label promotion-label\" \nlayout=\"column\" layout-align=\"start stretch\"><md-card-title-media flex=\"100\"><div \nclass=\"md-media-lg card-media md-card-image hover-effect-zoom\" \nstyle=\"width: 100%; background-image: url({{ c.thumbnail ? c.thumbnail.url : \'/assets/images/placeholder/no-disponible.png\' }})\">\n<div class=\"labels\" layout=\"column\" layout-align=\"start end\"><span \nclass=\"md-blue-500-bg white-fg has-promotions has-promotions--text\" ng-if=\"c.covid19\" aria-label=\"COVID19\">COVID19\n</span></div><a ui-sref=\"app.guest-campaign-show({id:c.id})\" class=\"overlay\"></a> <img class=\"ratio-helper\" \nsrc=\"/assets/images/empty.png\" alt=\"\"></div></md-card-title-media><md-card-title-text class=\"ph-32 pv-16\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"75\"><span class=\"md-headline\">{{ c.name }}</span> <span class=\"md-subhead\">\n{{ c.category.name }}</span><span ng-show=\"c.articles.length > 0\" class=\"h3 mt-24\">{{c.articles.length}} Artículos\n</span><div ng-show=\"c.articles.length > 0\" layout=\"column\" layout-align=\"start center\" layout-wrap layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\"><md-card class=\"mini-product-list-card product-list-card m-0\" \nng-repeat=\"a in c.articles | limitTo: 5\" layout=\"column\" layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"center center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\"><md-card-title-media flex=\"100\" \nflex-gt-xs=\"25\"><div class=\"md-media-lg card-media md-card-image hover-effect-zoom\" \nstyle=\"background-image: url({{ a.thumbnail.url ? a.thumbnail.url : \'/assets/images/placeholder/no-disponible.png\' }})\" \nflex><a ui-sref=\"app.guest-article-show({ id: a.id })\" class=\"overlay\"></a></div></md-card-title-media>\n<md-card-title-text class=\"ph-8 pv-8\" layout=\"column\" flex=\"100\" flex-gt-xs=\"75\"><a \nui-sref=\"app.guest-article-show({ id: a.id })\" class=\"product-title h5 md-accent-fg md-hue-1\" aria-label=\"{{a.name}}\" \ntitle=\"{{a.name}}\">{{ a.name }}</a> <span class=\"product-category h6\" aria-label=\"{{a.category.name}}\" \ntitle=\"{{a.category.name}}\">{{ a.category.name }}</span></md-card-title-text></md-card></div><span \nng-show=\"c.materials.length > 0\" class=\"h3 mt-24\">{{c.materials.length}} Materiales</span><div \nng-show=\"c.materials.length > 0\" layout=\"column\" layout-align=\"start center\" layout-wrap layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\"><md-card class=\"mini-product-list-card product-list-card m-0\" \nng-repeat=\"m in c.materials | limitTo: 5\" layout=\"column\" layout-align=\"start center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"center center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\"><md-card-title-media flex=\"100\" \nflex-gt-xs=\"25\"><div class=\"md-media-lg card-media md-card-image hover-effect-zoom\" \nstyle=\"background-image: url({{ m.thumbnail.url ? m.thumbnail.url : \'/assets/images/placeholder/no-disponible.png\' }})\" \nflex><a ui-sref=\"app.guest-material-show({ id: m.id })\" class=\"overlay\"></a></div></md-card-title-media>\n<md-card-title-text class=\"ph-8 pv-8\" layout=\"column\" flex=\"100\" flex-gt-xs=\"75\"><a \nui-sref=\"app.guest-material-show({ id: m.id })\" class=\"product-title h5 md-accent-fg md-hue-1\" aria-label=\"{{m.name}}\" \ntitle=\"{{m.name}}\">{{ m.name }}</a> <span class=\"product-category h6\" aria-label=\"{{m.category.name}}\" \ntitle=\"{{m.category.name}}\">{{ m.category.name }}</span></md-card-title-text></md-card></div><div layout=\"column\" \nclass=\"p-16\"><md-card-actions layout=\"row\" layout-align=\"center center\"><md-button \nui-sref=\"app.guest-campaign-show({id:c.id})\" title=\"Comprar\" aria-label=\"Comprar\" \nclass=\"btn btn-sm btn-fullwidth md-raised md-accent\"><md-icon md-font-icon=\"icon-information-outline\"></md-icon>\nMás información</md-button></md-card-actions></div></md-card-title-text></md-card></div></section><section \nclass=\"ph-64 pb-32 mt-64\" id=\"coming-soon-campaigns\" ng-show=\"vm.comingSoonCampaigns.length > 0\"><h2 \nclass=\"md-display-1\">Próximamente</h2><div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start stretch\"><md-card \nclass=\"campaign-label promotion-label coming-soon generic-card-item\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"30\" \nflex-gt-md=\"15\" flex-grow=\"0\" ng-repeat=\"cs in vm.comingSoonCampaigns\" layout=\"column\" \nlayout-align=\"space-between stretch\"><span class=\"discount\" ng-show=\"cs.discount\">{{ cs.discount }}</span><div \nclass=\"labels\" layout=\"column\" layout-align=\"start center\"><span class=\"md-blue-A400-bg has-campaigns\" \nng-show=\"cs.hasCampaigns\" title=\"Está en campaña\" aria-label=\"Está en campaña\"><md-icon md-font-icon=\"fa fa-bullhorn\">\n</md-icon></span><span class=\"md-teal-A700-bg has-promotions\" ng-show=\"cs.hasPromotions\" \ntitle=\"Parte de una promoción\" aria-label=\"Parte de una promoción\"><md-icon md-font-icon=\"icon-tag-multiple\"></md-icon>\n</span></div><div class=\"md-card-image hover-effect-zoom\" \nstyle=\"background-image: url({{ cs.thumbnail.url ? cs.thumbnail.url : \'/assets/images/placeholder/no-disponible.png\' }})\">\n<a ui-sref=\"{{\'app.guest-\' + cs.type + \'-show({ id: cs.id })\'}}\" class=\"overlay\"></a></div><md-card-title \nflex=\"nogrow\"><md-card-title-text><span title=\"{{ cs.name }}\" aria-label=\"{{ cs.name }}\" class=\"title h3\" \ndata-ng-bind=\"cs.name | truncateText:40\"></span> <span title=\"{{ cs.category.name }}\" \naria-label=\"{{ cs.category.name }}\" class=\"category-title h4 secondary-text\" \ndata-ng-bind=\"cs.category.name | truncateText:40\"></span></md-card-title-text></md-card-title><md-card-content \nng-bind=\"cs.description | htmlToPlaintext | truncateText:150\"></md-card-content><span flex></span></md-card></div>\n</section></div>");
$templateCache.put("app/main/pharmacist/campaigns/views/showCampaign.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"md-blue-900-bg header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-raised md-fab md-primary mr-32\" back><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"center center\" class=\"ph-32\">\n<span class=\"md-display-1\">{{ vm.campaign.name }}</span> <span class=\"md-title\">Campaña</span></div><span></span></div>\n<div layout=\"column\" layout-align=\"center stretch\" class=\"p-8\"><md-card class=\"generic-card-item\" id=\"item\" \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start center\" layout-align-gt-sm=\"space-between center\">\n<md-card-title-media flex=\"100\" flex-gt-sm=\"40\"><div class=\"md-media-lg card-media md-card-image hover-effect-zoom\" \nflex><img ng-src=\"/assets/images/placeholder/no-disponible.png\" alt=\"\" ng-hide=\"vm.campaign.thumbnail\"> <img \nng-src=\"{{ vm.campaign.thumbnail.url }}\" alt=\"\" ng-show=\"vm.campaign.thumbnail\"></div></md-card-title-media>\n<md-card-title-text class=\"ph-32 pv-16\" layout=\"column\" flex=\"100\" flex-gt-xs=\"60\"><span class=\"md-headline\">\n{{ vm.campaign.name }}</span> <span class=\"md-subhead\">{{ vm.campaign.category.name }}</span><md-content \nng-bind-html=\"vm.campaign.description\"></md-content><div class=\"md-indigo-50-bg p-20\" \nng-if=\"vm.campaign.restriction_mode!==\'none\'\" flex=\"100\"><h3>Acceso a la campaña</h3><span \nng-show=\"vm.campaign.restriction_mode==\'particular_qty\'\">Artículos con cantidad miníma, consultar más abajo.</span> \n<span ng-show=\"vm.campaign.restriction_mode==\'global_qty\'\">Necesario pedir al menos <span class=\"font-weight-600\">\n{{vm.campaign.min_global_qty}} unidades </span>de los productos en campaña.</span></div><div layout=\"column\"><div \nng-if=\"vm.campaign.available_gifts.length > 0\"><h3><md-icon class=\"mr-10\" md-font-icon=\"icon-gift\"></md-icon>\nRegalos disponibles</h3><div class=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" \nms-responsive-table><thead><tr><th></th><th>Nombre</th><th>Descripción</th></tr></thead><tfoot><tr><td></td></tr>\n</tfoot><tbody><tr ng-repeat=\"(key,gift) in vm.campaign.available_gifts\"><td class=\"from\"><img \nng-src=\"/assets/images/placeholder/no-disponible.png\" alt=\"\" ng-hide=\"gift.gift.thumbnail\"> <img \nstyle=\"width: 50px !important;height: 50px!important\" ng-show=\"gift.gift.thumbnail\" \nng-src=\"{{gift.gift.thumbnail.urlth}}\" alt=\"\"></td><td class=\"from\">{{ gift.gift.name }}</td><td class=\"from\">\n{{ gift.gift_quantity}} de regalo por cada {{gift.every_quantity}} unidades compradas.</td></tr></tbody></table></div>\n</div></div></md-card-title-text></md-card><md-card layout=\"column\" layout-align=\"start start\" \nclass=\"p-24 md-background-bg\" ng-show=\"vm.campaign.questionsAndAnswers.length > 0\"><v-accordion \nclass=\"vAccordion--default\" multiple=\"multiple\"><v-pane ng-repeat=\"qaa in vm.campaign.questionsAndAnswers\">\n<v-pane-header><span class=\"md-title pr-20\">{{ qaa.question }}</span></v-pane-header><v-pane-content><p \nng-bind-html=\"qaa.answer | split\"></p></v-pane-content></v-pane></v-accordion></md-card><md-card layout=\"column\" \nlayout-align=\"start stretch\" class=\"p-24\" flex ng-show=\"vm.campaign.articles.length > 0\"><span class=\"md-display-1\">\n{{ vm.campaign.articles.length > 1 ? vm.campaign.articles.length + \' artículos\' : \'1 artículo\' }}</span><div \nlayout=\"row\" layout-align=\"start stretch\" layout-wrap><product-card from=\"article-campaign\" \nshow-min-qty=\"{{vm.campaign.restriction_mode==\'particular_qty\' ? \'true\':\'\'}}\" ng-repeat=\"a in vm.campaign.articles\" \nproduct=\"a\" type=\"\'article\'\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\" flex-grow=\"0\" layout=\"column\" \nlayout-align=\"space-between center\"></product-card></div></md-card><md-card layout=\"column\" \nlayout-align=\"start stretch\" class=\"p-24\" flex ng-show=\"vm.campaign.materials.length > 0\"><span class=\"md-display-1\">\n{{ vm.campaign.materials.length > 1 ? vm.campaign.materials.length + \' materiales\' : \'1 material\' }}</span><div \nlayout=\"row\" layout-align=\"start stretch\" layout-wrap><product-card ng-repeat=\"a in vm.campaign.materials\" product=\"a\" \ntype=\"\'material\'\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\" flex-grow=\"0\" layout=\"column\" \nlayout-align=\"space-between center\"></product-card></div></md-card></div></div>");
$templateCache.put("app/main/pharmacist/cart/views/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"md-teal-500-bg header md-accent-bg\" layout=\"row\" layout-align=\"center center\" \nstyle=\"min-height: 100px; height: 100px\"><div class=\"title\">Confirmar pedido</div></div><div class=\"content\"><md-card \nng-show=\"vm.cart.campaigns_status.restricted\" class=\"alert alert-info\" layout=\"column\" layout-align=\"start center\" \nlayout-gt-xs=\"row\"><div><md-icon class=\"cyan-500-fg\" md-font-icon=\"icon-information-outline\"></md-icon></div><div flex>\n<div>Hay artículos en campaña,<a ng-href=\"#status-campaign\"> consultar condiciones más abajo.</a></div></div></md-card>\n<md-card ng-show=\"vm.cart.promotional_status.length > 0\" class=\"alert alert-info\" layout=\"column\" \nlayout-align=\"start center\" layout-gt-xs=\"row\"><div><md-icon class=\"cyan-500-fg\" \nmd-font-icon=\"icon-information-outline\"></md-icon></div><div flex><div>Tienes descuentos adicionales,<a \nng-href=\"#status-promotional\"> consultar condiciones más abajo.</a></div></div></md-card><div \nclass=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" ms-responsive-table id=\"cart\"><thead><tr><th>\nMiniatura</th><th>Descripción</th><th>Cantidad</th><th>Precio</th><th></th></tr></thead><tbody><tr \nid=\"{{detail.cart_detail_type | lowercase }}-{{detail.cart_detail.id}}\" \nng-repeat=\"(key,detail) in vm.cart.cartDetails\" \nng-class=\"detail.cart_detail.stock ? (detail.cart_detail_type | lowercase)  : \'out\' \"><td class=\"thumbnail\"><img \nng-hide=\"detail.cart_detail.thumbnail\" ng-src=\"assets/images/placeholder/no-disponible.png\" alt=\"\" width=\"120\" \nheight=\"120\"> <img ng-show=\"detail.cart_detail.thumbnail\" ng-src=\"{{detail.cart_detail.thumbnail.urlth}}\" alt=\"\" \nwidth=\"120\" height=\"120\"></td><td class=\"name\"><div layout=\"column\" layout-align=\"center start\"><span class=\"h4 mb-10\">\n{{ detail.cart_detail_type == \"Article\" ? \"Artículo\" : detail.cart_detail_type == \"Promotion\" ? \"Promoción\" : \"Material\" }}\n</span> <span class=\"h3 truncate-name\" style=\"width: 100%; max-width: 33vw\">{{detail.cart_detail.name}}</span> <span \nclass=\"h4 truncate-name\" style=\"width: 100%; max-width: 60vw\" ng-if=\"detail.cart_detail.national_code\">\nREF : {{ detail.cart_detail.national_code }}</span> <span class=\"h4 truncate-name\" \nstyle=\"width: 100%; max-width: 60vw\" ng-if=\"detail.cart_detail.code\">REF : {{ detail.cart_detail.code }}</span> <span \nclass=\"h4 truncate-name\">{{detail.cart_detail.category.name}}</span> <span class=\"green-500-fg\" \nng-if=\"(detail.cart_detail_type == \'Promotion\' || (detail.cart_detail_type == \'Article\' && detail.cart_detail.hasCampaigns==false)) && detail.cart_detail.min_amount > 1\">\nMínimo de {{detail.cart_detail.min_amount}} unidades</span> <span class=\"green-500-fg\" \nng-if=\"detail.cart_detail_type == \'Material\' && detail.cart_detail.max_amount\">\nMáximo de {{detail.cart_detail.max_amount}} unidades</span> <span ng-if=\"detail.cart_detail.stock==false\" \nclass=\"md-red-600-bg p-10 h4\" style=\"margin-bottom: 8px\">Agotado</span><div layout=\"column\" \nng-if=\"detail.price.applied_discount\"><span class=\"yellow-800-fg\">Descuento aplicado</span><div layout=\"row\" \nng-if=\"detail.price.applied_discount.sub_type==\'range\'\"><div>\nEscalado de {{detail.price.applied_discount.from}} hasta {{detail.price.applied_discount.to}} <span class=\"red-500-fg\">\n-{{detail.price.applied_discount.percent}}%</span></div></div><div layout=\"row\" \nng-if=\"detail.price.applied_discount.sub_type==\'direct\' || detail.price.applied_discount.sub_type==\'direct-campaign\'\">\n<div>Descuento del <span class=\"red-500-fg\">-{{detail.price.applied_discount.percent}}%</span></div></div><span \nng-if=\"detail.price.applied_discount.campaign\">Campaña asociada: <a \nhref=\"{{detail.price.applied_discount.campaign.url}}\">{{detail.price.applied_discount.campaign.name}}</a></span></div>\n<div layout=\"column\" ng-if=\"detail.price.rule_promotional\"><span class=\"indigo-400-fg\">Descuento</span><div \nlayout=\"row\"><div><span class=\"red-500-fg\">- {{detail.price.rule_promotional.percent}}% </span><span>\nRef: {{detail.price.rule_promotional.ref}} -</span> <span title=\"{{detail.price.rule_promotional.description}}\">\n{{detail.price.rule_promotional.description | characters : 20}}</span></div></div></div><v-accordion \nclass=\"vAccordion--default\" style=\"width: 100%; max-width: 60vw\" multiple=\"multiple\"><v-pane class=\"mt-16\" \nng-if=\"detail.gifts.items.length > 0\" expanded><v-pane-header class=\"mb-0\"><span class=\"md-subheader\"><md-icon \nmd-font-icon=\"icon-gift\"></md-icon>Regalos</span></v-pane-header><v-pane-content ms-scroll><md-list \nstyle=\"max-height: 150px\"><md-list-item class=\"md-2-line\" ng-repeat=\"a in detail.gifts.items\"><img \nng-src=\"assets/images/placeholder/no-disponible.png\" width=\"25\" height=\"25\" class=\"md-avatar\" alt=\"{{a.gift.name}}\" \nng-hide=\"a.gift.thumbnail\"> <img ng-src=\"{{a.gift.thumbnail.urlth}}\" class=\"md-avatar\" alt=\"{{a.gift.name}}\" \nng-show=\"a.gift.thumbnail\"><div class=\"md-list-item-text\" layout=\"column\"><h4 class=\"truncate-name\">{{ a.gift.name }}\n</h4><h3 class=\"red-500-fg\">X{{a.qty}} <span ng-if=\"a.qty==1\">unidad</span><span ng-if=\"a.qty>1\">unidades</span></h3>\n</div></md-list-item></md-list></v-pane-content></v-pane></v-accordion><v-accordion class=\"vAccordion--default\" \nstyle=\"width: 300px !important\" multiple=\"multiple\"><v-pane class=\"mt-16\" \nng-if=\"detail.cart_detail.materials.length > 0\" expanded><v-pane-header class=\"mb-0\"><span class=\"md-subheader\">\n<md-icon md-font-icon=\"icon-gift\"></md-icon>Materiales incluidos</span></v-pane-header><v-pane-content ms-scroll>\n<md-list style=\"max-height: 150px\"><md-list-item class=\"md-3-line md-long-text\" \nng-repeat=\"g in detail.cart_detail.materials\"><img ng-src=\"http://placehold.it/25x25\" class=\"md-avatar\" \nalt=\"{{g.name}}\" ng-hide=\"g.thumbnail\"> <img ng-src=\"{{g.thumbnail.urlth}}\" class=\"md-avatar\" alt=\"{{g.name}}\" \nng-show=\"g.thumbnail\"><div class=\"md-list-item-text\" layout=\"column\"><h4 class=\"truncate-name\"><strong>{{ g.name }}\n</strong></h4><h3 class=\"red-500-fg\">X{{g.qty}} <span ng-if=\"g.qty==1\">unidad</span><span ng-if=\"g.qty>1\">unidades\n</span></h3></div></md-list-item></md-list></v-pane-content></v-pane></v-accordion></div></td><td class=\"qty\">\n<numberspinner class=\"number-spinner\" role=\"\'cart\'\" data=\"{cart_id:vm.cart.id,detail:detail}\" model=\"detail.qty\" \nmin=\"1\" step=\"1\"></numberspinner></td><td class=\"price\"><md-card-price layout=\"column\" layout-align=\"center center\" \nflex class=\"mv-8\"><span ng-if=\"detail.price.applied_discount\" class=\"md-subhead mh-8\"><s>\n{{ detail.price.total_base |currency }}</s></span> <span class=\"yellow-900-fg\" ng-if=\"detail.price.applied_discount\">\nDTO {{detail.price.applied_discount.percent}}% </span><span ng-if=\"detail.price.rule_promotional\" \nclass=\"md-subhead mh-8\"><s>{{ detail.price.total_price_without_promotional |currency }}</s></span> <span \nclass=\"yellow-900-fg\" ng-if=\"detail.price.rule_promotional\">DTO {{detail.price.rule_promotional.percent}}% </span><span\n class=\"md-warn-fg md-title mh-8\">{{ detail.price.total_price |currency }}</span><div layout=\"row\"><span class=\"h-6\">\n<small>Unidad {{ detail.price.base | currency }}</small></span></div></md-card-price></td><td><md-button \nng-click=\"vm.delItem(detail.id)\" class=\"md-raised md-background-bg md-hue-3\"><md-tooltip>Eliminar</md-tooltip><md-icon \nmd-font-icon=\"icon-delete-variant\"></md-icon></md-button></td></tr></tbody><tfoot><tr><td colspan=\"2\"><div \nlayout=\"row\" layout-align=\"end center\" class=\"p-24\"><span class=\"md-subheader\">\n{{ vm.cart.details_qty + \" producto\" + (vm.cart.details_qty > 1 ? \'s\' : \'\') }}</span></div></td><td><div layout=\"row\" \nlayout-align=\"end center\" class=\"p-24\"><span class=\"md-subheader\">\n{{ vm.cart.total_qty + \" unidad\" + (vm.cart.total_qty > 1 ? \'es\' : \'\') }}</span></div></td><td><span \nclass=\"md-accent-fg md-title\">{{ vm.cart.price | currency }}</span></td><td><md-button hide-xs hide-sm hide-md \nclass=\"md-raised md-green-600-bg md-background-fg\" ng-if=\"vm.cart.total_qty>0\" ng-click=\"vm.confirm()\"><md-icon \nclass=\"md-background-fg\" md-font-icon=\"icon-check\"></md-icon>Confirmar pedido</md-button></td></tr></tfoot></table><div\n hide-gt-md layout=\"column\" layout-align=\"start stretch\"><md-button flex \nclass=\"md-raised md-green-600-bg md-background-fg\" ng-if=\"vm.cart.total_qty>0\" ng-click=\"vm.confirm()\"><md-icon \nclass=\"md-background-fg\" md-font-icon=\"icon-check\"></md-icon>Confirmar pedido</md-button></div></div><status-campaigns \nstatus-model=\"vm.cart.campaigns_status.campaigns\"></status-campaigns><status-promotionals flex=\"75\" \nhas-comercial-access=\"hasComercialAccess\" status-model=\"vm.cart.promotional_status\"></status-promotionals><div \nclass=\"mt-10 p-10\"><span class=\"h4\">*El plazo de entrega del pedido es de <span class=\"green-700-fg\">48/72 horas</span>\n después de ser aceptado por Mirafarma.</span></div></div></div>");
$templateCache.put("app/main/pharmacist/materials/views/add.html","<md-dialog aria-label=\"Añadir material\" ng-cloak class=\"md-background md-hue-1\" ng-cloak><form><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Añadir material</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"caddvm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Cerrar ventana\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start stretch\" \nlayout-align-gt-xs=\"center stretch\"><md-card class=\"product-list-card\" layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start center\" layout-align-gt-sm=\"space-between center\" flex=\"100\" flex-gt-sm=\"75\"><md-card-title-media \nflex=\"100\" flex-gt-sm=\"20\"><div class=\"md-media-lg card-media md-card-image hover-effect-zoom\" \nstyle=\"background-image: url({{ caddvm.item.thumbnail.url ? caddvm.item.thumbnail.url : \'/assets/images/placeholder/no-disponible.png\' }})\">\n<a href=\"#\" class=\"overlay\"></a></div></md-card-title-media><md-card-title-text class=\"ph-32 pv-16\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"60\"><span class=\"md-headline\">{{ caddvm.item.name }}</span> <span class=\"md-subhead\">\n{{ caddvm.item.category.name }}</span><span class=\"md-warn-fg md-title\">{{ caddvm.item.price | currency}}</span>\n</md-card-title-text><div layout=\"column\" class=\"p-16\"></div></md-card><md-card layout=\"column\" \nlayout-align=\"center center\" flex=\"25\"><span class=\"md-warn-fg md-display-1\">{{ caddvm.item.price |currency}}</span>\n<sync-number-spinner class=\"mv-16 number-spinner\" model=\"caddvm.quantity\" min=\"1\" step=\"1\"></sync-number-spinner><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"start stretch\"><md-button ng-click=\"caddvm.submit(true)\" \nclass=\"md-raised md-accent\"><md-icon md-font-icon=\"icon-chevron-double-right\"></md-icon>Finalizar</md-button><md-button\n ng-click=\"caddvm.submit(false)\" class=\"md-raised\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Añadir y seguir\n</md-button></div></md-card></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"caddvm.cancel()\" \nclass=\"md-raised\"><md-icon md-font-icon=\"icon-close\"></md-icon>Cancelar</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pharmacist/materials/views/listMaterials.html","<style>\n#campaign-slider {\r\n    height: auto;\r\n  }\r\n\r\n  @media(min-width:1680px) {\r\n    #material-list-view {\r\n      max-width: 1024px;\r\n      display: block;\r\n      margin-right: auto;\r\n      margin-left: auto;\r\n    }\r\n  }\r\n\r\n  #materials-index product-card,\r\n  #materials-index .product-card {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    min-width: 100%;\r\n  }\r\n\r\n  @media (min-width: 600px) {\r\n    #materials-index product-card,\r\n    #materials-index .product-card {\r\n      width: 50%;\r\n      max-width: 50%;\r\n      min-width: 50%;\r\n    }\r\n  }\r\n\r\n  @media (min-width: 1280px) {\r\n    #materials-index product-card,\r\n    #materials-index .product-card {\r\n      width: 33%;\r\n      max-width: 33%;\r\n      min-width: 33%;\r\n    }\r\n  }\r\n\r\n  @media (min-width: 1920px) {\r\n    #materials-index product-card,\r\n    #materials-index .product-card {\r\n      width: 16.666%;\r\n      max-width: 16.666%;\r\n      min-width: 16.666%;\r\n    }\r\n  }\n</style><div class=\"page-layout simple fullwidth\"><slider slider=\"vm.slider\"></slider><div \nclass=\"md-blue-grey-700-bg header md-accent-bg header-with-toolbar\" style=\"min-height: 100px;height: auto\" \nlayout=\"column\" layout-align=\"space-between center\"><span class=\"md-display-1 mv-0\">Materiales</span><md-toolbar \nclass=\"mt-8 pr-16 md-menu-toolbar list-toolbar md-background-bg\"><div class=\"md-toolbar-tools\" style=\"font-size: 16px\" \nlayout-align=\"space-between center\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button><div layout=\"row\" flex hide-xs class=\"mr-16 searchbar md-background-bg md-hue-2\" \nlayout-align=\"space-between stretch\"><input type=\"text\" name=\"search\" placeholder=\"Buscar...\" \nng-model=\"vm.filter.search\" ng-keyup=\"($event.which === 13) ? vm.refreshMaterials() : 0 \" flex><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><md-button class=\"btn btn-md md-icon-button\" title=\"Borrar búsqueda\" \naria-label=\"Borrar búsqueda\" ng-click=\"vm.setSearch(false, \'null\')\" ng-show=\"vm.filter.search\"><md-icon \nmd-font-icon=\"icon-eraser\"></md-icon></md-button><md-button class=\"submit-search\" title=\"Buscar\" aria-label=\"Buscar\" \nng-click=\"vm.refreshMaterials()\">Buscar</md-button></div><div layout=\"row\" class=\"mr-8\" hide-xs hide-sm hide-md>\n<md-icon style=\"margin-right: .5em;margin-left: .6em\" md-font-icon=\"icon-checkbox-multiple-blank-outline\" \nclass=\"md-primary md-hue-3\"></md-icon><md-select placeholder=\"Artículos por página\" ng-change=\"vm.refreshMaterials()\" \nng-model=\"vm.filter.items\" style=\"overflow: hidden\"><md-select-header></md-select-header><md-option value=\"12\">\n12 materiales</md-option><md-option value=\"24\">24 materiales</md-option><md-option value=\"36\">36 materiales</md-option>\n<md-option value=\"48\">48 materiales</md-option><md-option value=\"60\">60 materiales</md-option></md-select></div><div \nlayout=\"row\" class=\"mr-8\" hide-xs hide-sm><md-button class=\"btn btn-sm ml-16\" title=\"Mostrar cuadrícula\" \naria-label=\"Mostrar cuadrícula\" ng-class=\"{\'md-accent\': vm.view==\'grid\'}\" aria-label=\"Favorite\" \nng-click=\"vm.setView(\'grid\')\"><md-icon md-font-icon=\"fa fa-th\"></md-icon></md-button><md-button class=\"btn btn-sm\" \ntitle=\"Mostrar lista\" aria-label=\"Mostrar lista\" ng-class=\"{\'md-accent\': vm.view==\'list\'}\" aria-label=\"More\" \nng-click=\"vm.setView(\'list\')\"><md-icon md-font-icon=\"fa fa-th-list\"></md-icon></md-button></div></div></md-toolbar>\n</div><div class=\"content\" md-background-bg layout=\"row\" layout-align=\"space-between start\"><md-sidenav \nclass=\"sidenav\" hide-gt-md md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-sidenav-helper ms-scroll>\n<md-content><md-input-container layout=\"row\" flex hide-gt-md><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \ntype=\"text\" name=\"search\" placeholder=\"Buscar...\" ng-model=\"vm.filter.search\" \nng-keyup=\"($event.which === 13) ? vm.setSearch(true) : 0 \" flex></md-input-container><md-list hide-gt-md><md-subheader \nclass=\"md-no-sticky\">Materiales por página</md-subheader><md-list-item class=\"md-no-proxy\" \nng-class=\"{\'md-accent-bg\' : vm.filter.items == 12}\" ng-click=\"vm.setItems(12, true)\">12 materiales</md-list-item>\n<md-divider></md-divider><md-list-item class=\"md-no-proxy\" ng-class=\"{\'md-accent-bg\' : vm.filter.items == 24}\" \nng-click=\"vm.setItems(24, true)\">24 materiales</md-list-item><md-divider></md-divider><md-list-item \nclass=\"md-no-proxy\" ng-class=\"{\'md-accent-bg\' : vm.filter.items == 36}\" ng-click=\"vm.setItems(36, true)\">36 materiales\n</md-list-item><md-divider></md-divider><md-list-item class=\"md-no-proxy\" \nng-class=\"{\'md-accent-bg\' : vm.filter.items == 48}\" ng-click=\"vm.setItems(48, true)\">48 materiales</md-list-item>\n<md-divider></md-divider><md-list-item class=\"md-no-proxy\" ng-class=\"{\'md-accent-bg\' : vm.filter.items == 60}\" \nng-click=\"vm.setItems(60, true)\">60 materiales</md-list-item><md-divider></md-divider></md-list></md-content>\n</md-sidenav><div layout=\"column\" flex><section id=\"materials-index\" class=\"ph-32\" layout=\"column\" \nlayout-align=\"stretch center\"><div layout=\"row\" class=\"pagination-count mb-16\" flex layout-align=\"start center\" \nng-show=\"vm.pagination.data.length > 0\"><span class=\"h3\">\nMostrando resultados {{ vm.pagination.from }} - {{ vm.pagination.to }} de {{ vm.pagination.total }} ({{ vm.pagination.last_page }} páginas)\n</span></div><div layout=\"column\" flex layout-align=\"center center\" class=\"pv-36 ph-18\" \nng-show=\"!vm.pagination.data.length > 0\"><span class=\"md-title\">No hay ningún material con esas características.</span>\n<md-button class=\"btn btn-md md-raised md-warn\" ng-click=\"vm.resetFilter()\"><md-icon md-font-icon=\"icon-filter-remove\">\n</md-icon>Restablecer filtro</md-button></div><div ng-show=\"vm.view==\'grid\'\" ng-hide=\"vm.view==\'list\'\" flex=\"100\" \nlayout=\"column\" layout-gt-xs=\"row\" layout-wrap layout-align=\"start stretch\"><product-card \nng-repeat=\"m in vm.pagination.data\" product=\"m\" type=\"\'material\'\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" \nflex-gt-lg=\"25\" flex-grow=\"0\" layout=\"column\" layout-align=\"space-between center\"></product-card></div><div \nid=\"material-list-view\" ng-show=\"vm.view==\'list\'\" flex=\"100\" ng-hide=\"vm.view==\'grid\'\" layout=\"column\" layout-wrap \nlayout-align=\"start stretch\"><md-card class=\"product-list-card\" ng-repeat=\"m in vm.pagination.data\" layout=\"column\" \nlayout-gt-md=\"row\" layout-align=\"start center\" layout-align-gt-md=\"space-between center\"><md-card-title-media \nflex-xs=\"100\" flex-md=\"100\"><div class=\"md-media-lg card-media md-card-image hover-effect-zoom\" \nstyle=\"background-image: url({{ m.thumbnail.url ? m.thumbnail.url : \'/assets/images/placeholder/no-disponible.png\' }})\">\n<a ui-sref=\"app.guest-material-show({ id: m.id })\" class=\"overlay\"></a></div></md-card-title-media><md-card-title-text \nclass=\"ph-32 pv-16\" layout=\"column\" flex=\"100\" flex-gt-xs=\"auto\"><span class=\"md-headline\" \nui-sref=\"app.guest-material-show({ id: m.id })\">{{ m.name }}</span> <span class=\"md-subhead\">{{ m.category.name }}\n</span><md-content ng-bind-html=\"m.description\"></md-content><div class=\"mv-10\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap=\"nowrap\"><div class=\"mh-15\" ng-if=\"m.hasCampaigns\" layout=\"row\" \nlayout-align=\"start center\"><md-icon class=\"blue-800-fg mr-10\" md-font-icon=\"fa fa-bullhorn\"><md-tooltip \nmd-direction=\"left\">Está en campaña</md-tooltip></md-icon><span class=\"blue-800-fg\" aria-label=\"Está en campaña\">\nEstá en campaña</span></div><div class=\"mh-15\" ng-if=\"m.hasPromotions\" layout=\"row\" layout-align=\"start center\">\n<md-icon class=\"yellow-800-fg mr-10\" md-font-icon=\"icon-tag-multiple\"><md-tooltip md-direction=\"left\">\nParte de una promoción</md-tooltip></md-icon><span class=\"yellow-800-fg\" aria-label=\"Parte de una promoción\">\nParte de una promoción</span></div></div></md-card-title-text><div layout=\"column\" class=\"p-16\"><md-card-price \nlayout=\"column\" layout-align=\"start center\"><span class=\"md-warn-fg md-title\">{{ m.price | currency}}</span>\n</md-card-price><md-card-actions layout=\"row\" layout-align=\"center center\"><md-button ng-if=\"m.stock > 0\" \ntitle=\"pedir\" aria-label=\"Comprar\" class=\"btn btn-sm btn-fullwidth md-raised md-accent\" \nng-controller=\"CartCtrl as cvm\" ng-click=\"cvm.showAdvanced(m.id,\'material\')\"><md-icon md-font-icon=\"icon-cart-outline\">\n</md-icon>Pedir</md-button></md-card-actions><div layout=\"column\" layout-align=\"center center\"><span \nng-if=\"m.stock == 0\" class=\"md-red-600-bg p-10 h4\" style=\"margin-bottom: 8px\">Agotado</span></div></div></md-card>\n</div><div layout=\"row\" class=\"pagination-count\" flex layout-align=\"start center\" \nng-show=\"vm.pagination.data.length > 0\"><span class=\"h3\">\nMostrando resultados {{ vm.pagination.from }} - {{ vm.pagination.to }} de {{ vm.pagination.total }} ({{ vm.pagination.last_page }} páginas)\n</span></div></section><pagination pagination=\"vm.pagination\" filter=\"vm.filter\" api-method=\"vm.api\" layout=\"row\" \nlayout-align=\"stretch center\"></pagination></div></div></div>");
$templateCache.put("app/main/pharmacist/materials/views/showMaterial.html","<style>#item {\r\n    max-width: 1200px;\r\n  }</style><div class=\"page-layout simple fullwidth doc-page element-doc-page\">\n<div class=\"md-blue-grey-700-bg header\" layout=\"row\" layout-align=\"space-between center\"><md-button \nclass=\"md-raised md-fab md-primary mr-32\" back><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><div \nlayout=\"column\" layout-align=\"center center\" class=\"ph-32\"><span class=\"md-display-1\">{{ vm.material.name }}</span> \n<span class=\"md-title\">Material</span></div><md-button ng-if=\"vm.material.stock > 0\" title=\"Comprar\" \naria-label=\"Comprar\" class=\"md-fab md-raised md-primary\" ng-controller=\"CartCtrl as cvm\" \nng-click=\"cvm.showAdvanced(vm.material.id,\'material\')\"><md-icon md-font-icon=\"icon-cart\"></md-icon></md-button></div>\n<div layout=\"column\" layout-align=\"center center\" class=\"p-8\"><md-card class=\"generic-card-item\" id=\"item\" \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start center\" layout-align-gt-sm=\"space-between center\">\n<md-card-title-media flex=\"100\" flex-gt-sm=\"40\"><div class=\"md-media-lg card-media md-card-image hover-effect-zoom\" \nflex><img ng-src=\"/assets/images/placeholder/no-disponible.png\" alt=\"\" ng-hide=\"vm.material.thumbnail\"> <img \nng-src=\"{{ vm.material.thumbnail.url }}\" alt=\"\" ng-show=\"vm.material.thumbnail\"></div></md-card-title-media>\n<md-card-title-text class=\"ph-32 pv-16\" layout=\"column\" flex=\"100\" flex-gt-xs=\"60\"><span class=\"md-headline\">\n{{ vm.material.name }}</span> <span class=\"md-subhead\">{{ vm.material.category.name }}</span><md-content \nng-bind-html=\"vm.material.description\"></md-content><div layout=\"column\" layout-align=\"center center\"><span \nclass=\"md-display-1 md-warn-fg\">{{ vm.material.price |currency }}</span></div><div layout=\"column\" class=\"p-16\">\n<md-card-actions layout=\"row\" layout-align=\"center center\"><md-input-container ng-if=\"vm.material.stock >0\"><input \nid=\"quantity\" type=\"number\" ng-model=\"vm.qty\" min=\"1\" step=\"1\"></md-input-container><md-button \nng-if=\"vm.material.stock >0\" ng-controller=\"CartAddCtrl as caddvm\" \nng-click=\"caddvm.submit(true,vm.material.id,\'material\', vm.qty)\" title=\"pedir\" aria-label=\"pedir\" \nclass=\"btn btn-md md-raised md-accent\"><md-icon md-font-icon=\"icon-cart\"></md-icon>Pedir</md-button></md-card-actions>\n<span ng-if=\"vm.material.stock == 0\" class=\"md-red-600-bg p-10 h4 text-center mt-20\" style=\"margin-bottom: 8px\">Agotado\n</span></div></md-card-title-text></md-card></div></div>");
$templateCache.put("app/main/pharmacist/orders/views/listOrders.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"center center\" style=\"min-height: 100px; height: 100px\"><div class=\"title\">Mis pedidos</div>\n</div><div class=\"content\"><div ng-hide=\"vm.myOrders.length > 0 \"><span class=\"h2\">No tienes ningun pedido</span></div>\n<div ng-show=\"vm.myOrders.length > 0\" class=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" \nms-responsive-table id=\"cart\"><thead><tr><th>#Ref</th><th>Comercial</th><th>Creado</th><th>Estado</th><th>Unidades</th>\n<th>Total</th><th></th></tr></thead><tbody><tr ng-class=\"order.seller?\'tr-seller\':\'\'\" \nng-repeat=\"(key,order) in vm.myOrders\"><td class=\"id\">#{{order.id}}</td><td><span \nclass=\"font-size-14 text-boxed-light\"><span ng-if=\"order.seller\">{{order.seller.name}}</span> <span \nng-if=\"!order.seller\">---</span> </span></td><td class=\"date\">{{order.created_at[\'date\'] | momentHumanize }}</td><td \nclass=\"status\"><status-order status=\"order.status\"></status-order></td><td class=\"qty\"><span class=\"h3\">\n{{order.total_qty}}</span></td><td class=\"price\"><span class=\"h3\">{{order.price | currency}}</span> <span \nng-if=\"order.monthly_discount_info.has_advance_discount\"><md-icon md-font-icon=\"icon-tag-text-outline\"><md-tooltip \nmd-direction=\"top\">Tiene un adelanto</md-tooltip></md-icon></span></td><td><md-button \nui-sref=\"app.guest-orders-show({id:order.id })\" class=\"md-fab md-mini md-primary md-hue-2\" aria-label=\"Detalles\">\n<md-tooltip md-direction=\"right\">Detalles</md-tooltip><md-icon md-font-icon=\"icon-open-in-new\"></md-icon></md-button>\n<md-button ng-click=\"vm.cancelOrder(order.id)\" ng-if=\"order.status==\'pending\'\" \nclass=\"detail-my-orders md-raised md-warn\">Cancelar</md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pharmacist/orders/views/showOrder.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"md-teal-500-bg header md-accent-bg\" layout=\"row\" layout-align=\"center center\" \nstyle=\"min-height: 100px; height: 100px\"><div class=\"title\">Pedido #{{vm.order.id}}</div></div><div class=\"content\"><h1\n ng-if=\"vm.order.seller\">Comercial : <small>{{vm.order.seller.name}}</small></h1><div \nclass=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" ms-responsive-table id=\"cart\"><thead><tr><th>\nDetalle</th><th>Cantidad</th><th>Precio</th><th></th></tr></thead><tbody><tr from=\"guest\" order-item detail=\"detail\" \nvm-order=\"vm\" key=\"key\" order=\"vm.order\" ng-repeat=\"(key,detail) in vm.order.orderDetails\" \nid=\"{{detail.ordeable_type | lowercase }}-{{detail.ordeable_id}}\" class=\"{{ detail.ordeable_type | lowercase }}\"></tr>\n</tbody><tfoot><tr \nng-class=\"vm.order.monthly_discount_info.has_advance_discount?\'md-orange-100-bg\':\'md-indigo-100-bg\'\" class=\"discounts\" \nng-if=\"vm.order.discounts.length>0\" ng-repeat=\"(key,discount) in vm.order.discounts\"><td><span class=\"font-size-16\">\nDescuento mensual</span> <span class=\"font-size-16\"><strong>\n{{vm.monthDiscountDate | momentFormat : \'MMMM\'|uppercase}} / {{discount.created_at[\'date\'] | momentFormat : \'YYYY\'}}\n</strong></span></td><td></td><td class=\"font-weight-800 font-size-14\" style=\"text-align: center\">\n-{{discount.reduction|currency}}</td><td></td></tr><tr><td><div layout=\"row\" layout-align=\"end center\" class=\"p-24\">\n<span class=\"md-subheader\">{{ vm.order.details_qty + \" producto\" + (vm.order.details_qty > 1 ? \'s\' : \'\') }}</span>\n</div></td><td><div layout=\"row\" layout-align=\"end center\" class=\"p-24\"><span class=\"md-subheader\">\n{{ vm.order.total_qty + \" unidad\" + (vm.order.total_qty > 1 ? \'es\' : \'\') }}</span></div></td><td><span \nclass=\"md-accent-fg md-title\">{{ vm.order.price | currency }}</span></td></tr></tfoot></table></div><status-campaigns \nfrom=\"\'guest-order\'\" status-model=\"vm.order.campaigns_status.campaigns\"></status-campaigns><status-promotionals \nstatus-model=\"vm.order.promotional_status\"></status-promotionals></div></div>");
$templateCache.put("app/main/pharmacist/promotions/views/add.html","<md-dialog aria-label=\"Añadir promoción\" ng-cloak class=\"md-background md-hue-1\" ng-cloak><form><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Añadir promoción</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"caddvm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Cerrar ventana\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start stretch\" \nlayout-align-gt-xs=\"center stretch\"><md-card class=\"product-list-card\" layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start center\" layout-align-gt-sm=\"space-between center\" flex=\"100\" flex-gt-sm=\"75\"><md-card-title-media \nflex=\"100\" flex-gt-sm=\"20\"><div class=\"md-media-lg card-media md-card-image hover-effect-zoom\" \nstyle=\"background-image: url({{ caddvm.item.thumbnail.url ? caddvm.item.thumbnail.url : \'/assets/images/placeholder/no-disponible.png\' }})\">\n<a href=\"#\" class=\"overlay\"></a></div></md-card-title-media><md-card-title-text class=\"ph-32 pv-16\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"60\"><span class=\"md-headline\">{{ caddvm.item.name }}</span> <span class=\"md-subhead\">\n{{ caddvm.item.category.name }}</span> <span class=\"green-500-fg\" ng-if=\"caddvm.item.min_amount\">\nMínimo de {{caddvm.item.min_amount}} unidades</span><span class=\"md-warn-fg md-title\">{{ caddvm.item.price |currency}}\n</span></md-card-title-text><div layout=\"column\" class=\"p-16\"></div></md-card><md-card layout=\"column\" \nlayout-align=\"center center\" flex=\"25\"><span class=\"md-warn-fg md-display-1\">{{ caddvm.item.price | currency}}</span>\n<sync-number-spinner class=\"mv-16 number-spinner\" model=\"caddvm.quantity\" min=\"1\" step=\"1\"></sync-number-spinner><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"start stretch\"><md-button ng-click=\"caddvm.submit(true)\" \nclass=\"md-raised md-accent\"><md-icon md-font-icon=\"icon-chevron-double-right\"></md-icon>Finalizar</md-button><md-button\n ng-click=\"caddvm.submit(false)\" class=\"md-raised\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Añadir y seguir\n</md-button></div></md-card></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"caddvm.cancel()\" \nclass=\"md-raised\"><md-icon md-font-icon=\"icon-close\"></md-icon>Cancelar</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pharmacist/promotions/views/listPromotions.html","<style>\n#campaign-slider {\r\n    height: auto;\r\n  }\r\n\r\n  @media(min-width:1680px) {\r\n    #promotion-list-view {\r\n      max-width: 1024px;\r\n      display: block;\r\n      margin-right: auto;\r\n      margin-left: auto;\r\n    }\r\n  }\r\n\r\n  #promotions-index product-card,\r\n  #promotions-index .product-card {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    min-width: 100%;\r\n  }\r\n\r\n  @media (min-width: 600px) {\r\n    #promotions-index product-card,\r\n    #promotions-index .product-card {\r\n      width: 50%;\r\n      max-width: 50%;\r\n      min-width: 50%;\r\n    }\r\n  }\r\n\r\n  @media (min-width: 1280px) {\r\n    #promotions-index product-card,\r\n    #promotions-index .product-card {\r\n      width: 33%;\r\n      max-width: 33%;\r\n      min-width: 33%;\r\n    }\r\n  }\r\n\r\n  @media (min-width: 1920px) {\r\n    #promotions-index product-card,\r\n    #promotions-index .product-card {\r\n      width: 16.666%;\r\n      max-width: 16.666%;\r\n      min-width: 16.666%;\r\n    }\r\n  }\n</style><div class=\"page-layout simple fullwidth\"><slider slider=\"vm.slider\"></slider><div \nclass=\"md-yellow-700-bg pt-0 header md-accent-bg header-with-toolbar\" style=\"min-height: 100px;height: auto\" \nlayout=\"column\" layout-align=\"space-between center\"><span class=\"md-display-1 mv-0\">Promociones</span><md-toolbar \nclass=\"mt-8 pr-16 md-menu-toolbar list-toolbar md-background-bg\"><div class=\"md-toolbar-tools\" style=\"font-size: 16px\" \nlayout-align=\"space-between center\"><div layout=\"row\" flex hide-xs class=\"mr-16 searchbar md-background-bg md-hue-2\" \nlayout-align=\"space-between stretch\"><input type=\"text\" name=\"search\" placeholder=\"Buscar...\" \nng-model=\"vm.filter.search\" ng-keyup=\"($event.which === 13) ? vm.refreshPromotions() : 0 \" flex><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><md-button class=\"btn btn-md md-icon-button\" title=\"Borrar búsqueda\" \naria-label=\"Borrar búsqueda\" ng-click=\"vm.setSearch(false, \'null\')\" ng-show=\"vm.filter.search\"><md-icon \nmd-font-icon=\"icon-eraser\"></md-icon></md-button><md-button class=\"submit-search\" title=\"Buscar\" aria-label=\"Buscar\" \nng-click=\"vm.refreshPromotions()\">Buscar</md-button></div><div layout=\"row\" class=\"mr-8\" hide-xs hide-sm hide-md>\n<md-icon style=\"margin-right: .5em;margin-left: .6em\" md-font-icon=\"icon-checkbox-multiple-blank-outline\" \nclass=\"md-primary md-hue-3\"></md-icon><md-select placeholder=\"Artículos por página\" ng-change=\"vm.refreshPromotions()\" \nng-model=\"vm.filter.items\" style=\"overflow: hidden\"><md-select-header></md-select-header><md-option value=\"12\">\n12 promociones</md-option><md-option value=\"24\">24 promociones</md-option><md-option value=\"36\">36 promociones\n</md-option><md-option value=\"48\">48 promociones</md-option><md-option value=\"60\">60 promociones</md-option>\n</md-select></div><div layout=\"row\" class=\"mr-8\" hide-xs hide-sm><md-button class=\"md-primary btn btn-sm ml-16\" \ntitle=\"Mostrar cuadrícula\" aria-label=\"Mostrar cuadrícula\" ng-class=\"{\'md-accent\': vm.view==\'grid\'}\" \naria-label=\"Favorite\" ng-click=\"vm.setView(\'grid\')\"><md-icon md-font-icon=\"fa fa-th\"></md-icon></md-button><md-button \nclass=\"md-primary btn btn-sm\" title=\"Mostrar lista\" aria-label=\"Mostrar lista\" \nng-class=\"{\'md-accent\': vm.view==\'list\'}\" aria-label=\"More\" ng-click=\"vm.setView(\'list\')\"><md-icon \nmd-font-icon=\"fa fa-th-list\"></md-icon></md-button></div></div></md-toolbar></div><div class=\"content\" \nmd-background-bg layout=\"row\" layout-align=\"space-between start\"><div layout=\"column\" flex><section \nid=\"promotions-index\" class=\"ph-32\" layout=\"column\" layout-align=\"stretch center\"><div layout=\"row\" \nclass=\"pagination-count mb-16\" flex layout-align=\"start center\" ng-show=\"vm.pagination.data.length > 0\"><span \nclass=\"h3\">\nMostrando resultados {{ vm.pagination.from }} - {{ vm.pagination.to }} de {{ vm.pagination.total }} ({{ vm.pagination.last_page }} página{{ vm.pagination.last_page > 1 ? \'s\' : \'\' }})\n</span></div><div layout=\"column\" flex layout-align=\"center center\" class=\"pv-36 ph-18\" \nng-show=\"!vm.pagination.data.length > 0\"><span class=\"md-title\">No hay ninguna promoción con esas características.\n</span><md-button class=\"btn btn-md md-raised md-warn\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon>\nRestablecer filtro</md-button></div><div ng-show=\"vm.view==\'grid\'\" ng-hide=\"vm.view==\'list\'\" flex=\"100\" \nlayout=\"column\" layout-gt-xs=\"row\" layout-wrap layout-align=\"start stretch\"><product-card \nng-repeat=\"p in vm.pagination.data\" product=\"p\" type=\"\'promotion\'\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" \nflex-gt-lg=\"25\" flex-grow=\"0\" layout=\"column\" layout-align=\"space-between center\"></product-card></div><div \nid=\"promotion-list-view\" ng-show=\"vm.view==\'list\'\" flex=\"100\" ng-hide=\"vm.view==\'grid\'\" layout=\"column\" layout-wrap \nlayout-align=\"start stretch\"><md-card class=\"product-list-card\" ng-repeat=\"p in vm.pagination.data\" layout=\"column\" \nlayout-gt-md=\"row\" layout-align=\"start center\" layout-align-gt-md=\"space-between center\"><md-card-title-media \nflex-xs=\"100\" flex-md=\"100\"><div class=\"md-media-lg card-media md-card-image hover-effect-zoom\" \nstyle=\"background-image: url({{ p.thumbnail.url ? p.thumbnail.url : \'/assets/images/placeholder/no-disponible.png\' }})\">\n<a ui-sref=\"app.guest-promotion-show({ id: p.id })\" class=\"overlay\"></a></div></md-card-title-media><md-card-title-text\n class=\"ph-32 pv-16\" layout=\"column\" flex=\"100\" flex-gt-xs=\"auto\"><span class=\"md-headline\" \nui-sref=\"app.guest-promotion-show({ id: p.id })\">{{ p.name }}</span> <span class=\"h4\">REF : {{ p.code }}</span> <span \nclass=\"md-subhead\">{{ p.category.name }}</span> <span class=\"green-500-fg\" ng-if=\"p.min_amount > 1\">\nMínimo de {{p.min_amount}} unidades</span><md-content ng-bind-html=\"p.description\"></md-content><div class=\"mv-10\" \nlayout=\"row\" layout-align=\"start center\" layout-wrap=\"nowrap\"><div class=\"mh-15\" \nng-if=\"p.avaliable_rules.gifts.length > 0\" layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"green-400-fg mr-10\" md-font-icon=\"icon-gift\"><md-tooltip md-direction=\"left\">Tiene regalo</md-tooltip></md-icon>\n<span class=\"green-400-fg\" aria-label=\"Tiene regalo\">Tiene regalo</span></div><div class=\"mh-15\" \nng-if=\"p.materials.length > 0\" layout=\"row\" layout-align=\"start center\"><md-icon class=\"blue-grey-A700-fg mr-10\" \nmd-font-icon=\"icon-presentation\"><md-tooltip md-direction=\"left\">Tiene material</md-tooltip></md-icon><span \nclass=\"blue-grey-A700-fg\" aria-label=\"Tiene regalo\">Tiene material</span></div><div class=\"mh-15\" ng-if=\"p.low_stock\" \nlayout=\"row\" layout-align=\"start center\"><md-icon class=\"orange-A400-fg mr-10\" md-font-icon=\"icon-flash\"><md-tooltip \nmd-direction=\"left\">Últimas unidades</md-tooltip></md-icon><span class=\"orange-A400-fg\" aria-label=\"Últimas unidades\">\nÚltimas unidades</span></div><div class=\"mh-15\" ng-if=\"p.discounted\" layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"red-A700-fg mr-10\" md-font-icon=\"icon-arrow-down-bold\"><md-tooltip md-direction=\"left\">Precio rebajado\n</md-tooltip></md-icon><span class=\"red-A700-fg\" aria-label=\"Precio rebajado\">Precio rebajado</span></div></div>\n</md-card-title-text><div layout=\"column\" class=\"p-16\"><md-card-price layout=\"row\" layout-align=\"space-around center\" \nflex class=\"mv-8\"><div layout=\"column\"><span ng-if=\"p.best_price.applied_rule\" class=\"md-subhead mh-8\"><s>\n{{ p.price|currency}}</s></span> <span ng-if=\"p.best_price.applied_rule\" class=\"md-warn-fg md-title mh-8\">\n{{ p.best_price.discounted_price | currency}}</span> <span ng-if=\"p.best_price.applied_rule==null\" \nclass=\"md-warn-fg md-title mh-8\">{{ p.price | currency}}</span></div><span ng-if=\"p.best_price.applied_rule\" \nclass=\"yellow-800-fg\">\n{{p.best_price.applied_rule.sub_type==\'range\'? \'Hasta\':\'\'}} -{{p.best_price.applied_rule.percent}}%</span>\n</md-card-price><md-card-actions layout=\"row\" layout-align=\"center center\" ng-controller=\"CartCtrl as cvm\"><md-button \nng-if=\"p.stock > 0\" title=\"Comprar\" aria-label=\"Comprar\" class=\"btn btn-sm btn-fullwidth md-raised md-accent\" \nng-click=\"cvm.showAdvanced(p.id,\'promotion\')\"><md-icon md-font-icon=\"icon-cart-outline\"></md-icon>Comprar</md-button>\n</md-card-actions><div layout=\"column\" layout-align=\"center center\"><span ng-if=\"p.stock == 0\" \nclass=\"md-red-600-bg p-10 h4\" style=\"margin-bottom: 8px\">Agotado</span></div></div></md-card></div><div layout=\"row\" \nclass=\"pagination-count\" flex layout-align=\"start center\" ng-show=\"vm.pagination.data.length > 0\"><span class=\"h3\">\nMostrando resultados {{ vm.pagination.from }} - {{ vm.pagination.to }} de {{ vm.pagination.total }} ({{ vm.pagination.last_page }} página{{ vm.pagination.last_page > 1 ? \'s\' : \'\' }})\n</span></div></section><pagination ng-show=\"vm.pagination.last_page > 1\" api-method=\"vm.api\" \npagination=\"vm.pagination\" filter=\"vm.filter\" layout=\"row\" layout-align=\"stretch center\"></pagination></div></div>\n</div>");
$templateCache.put("app/main/pharmacist/promotions/views/showPromotion.html","<div class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"md-yellow-600-bg header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-raised md-fab md-primary mr-32\" back><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"center center\" class=\"ph-32\">\n<span class=\"md-display-1\">{{ vm.promotion.name }}</span> <span class=\"md-title\">Promoción</span></div><md-button \nng-if=\"vm.promotion.stock > 0\" title=\"Comprar\" aria-label=\"Comprar\" class=\"md-fab md-raised md-primary\" \nng-controller=\"CartCtrl as cvm\" ng-click=\"cvm.showAdvanced(vm.promotion.id,\'promotion\')\"><md-icon \nmd-font-icon=\"icon-cart\"></md-icon></md-button></div><div layout=\"column\" layout-align=\"center stretch\" class=\"p-8\">\n<md-card class=\"generic-card-item\" id=\"item\" layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start center\" \nlayout-align-gt-sm=\"space-between start\"><md-card-title-media flex=\"100\" flex-gt-sm=\"40\"><div \nclass=\"md-media-lg card-media md-card-image hover-effect-zoom\" flex><img \nng-src=\"/assets/images/placeholder/no-disponible.png\" alt=\"\" ng-hide=\"vm.promotion.thumbnail\"> <img \nng-src=\"{{ vm.promotion.thumbnail.url }}\" alt=\"\" ng-show=\"vm.promotion.thumbnail\"></div></md-card-title-media>\n<md-card-title-text class=\"ph-32 pv-16\" layout=\"column\" flex=\"100\" flex-gt-xs=\"60\"><span class=\"md-headline\">\n{{ vm.promotion.name }}</span> <span class=\"h4\">REF : {{ vm.promotion.code }}</span> <span class=\"md-subhead\">\n{{ vm.promotion.category.name }}</span> <span class=\"green-500-fg mt-10\" ng-if=\"vm.promotion.min_amount > 1\">\nMínimo de {{vm.promotion.min_amount}} unidades</span><md-content ng-bind-html=\"vm.promotion.description\"></md-content>\n<div layout=\"column\"><div ng-if=\"vm.promotion.avaliable_rules.ranges.length > 0\"><h3><md-icon class=\"mr-10\" \nmd-font-icon=\"icon-sort-ascending\"></md-icon>Escalado disponible</h3><div \nclass=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" ms-responsive-table><thead><tr><th>Desde</th>\n<th>Hasta</th><th>Descuento</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr \nng-repeat=\"(key,range) in vm.promotion.avaliable_rules.ranges\"><td class=\"from\">{{ range.quantity_from }}</td><td \nclass=\"from\">{{ range.quantity_to }}</td><td class=\"from\">{{ range.percent }}%</td></tr></tbody></table></div></div>\n</div><div layout=\"column\"><div ng-if=\"vm.promotion.avaliable_rules.gifts.length > 0\"><h3><md-icon class=\"mr-10\" \nmd-font-icon=\"icon-gift\"></md-icon>Regalos disponibles</h3><div class=\"simple-table-container md-whiteframe-4dp\"><table\n class=\"simple\" ms-responsive-table><thead><tr><th></th><th>Nombre</th><th>Descripción</th></tr></thead><tfoot><tr><td>\n</td></tr></tfoot><tbody><tr ng-repeat=\"(key,gift) in vm.promotion.avaliable_rules.gifts\"><td class=\"from\"><img \nng-src=\"/assets/images/placeholder/no-disponible.png\" alt=\"\" ng-hide=\"gift.gift.thumbnail\"> <img \nstyle=\"width: 50px !important;height: 50px!important\" ng-show=\"gift.gift.thumbnail\" \nng-src=\"{{gift.gift.thumbnail.urlth}}\" alt=\"\"></td><td class=\"from\">{{ gift.gift.name }}</td><td class=\"from\">\n{{ gift.gift_quantity}} de regalo por cada {{gift.every_quantity==1 ? \'\':gift.every_quantity}} promo{{gift.every_quantity > 1 ? \'s\':\'\'}} comprada{{gift.every_quantity > 1 ? \'s\':\'\'}}.\n</td></tr></tbody></table></div></div></div><div layout=\"column\" class=\"p-16\"><md-card-actions layout=\"row\" \nlayout-align=\"space-around  center\"><span \nng-if=\"vm.promotion.avaliable_rules.direct && vm.promotion.avaliable_rules.ranges.length==0\" style=\"font-size: 20px\">\n-{{ vm.promotion.avaliable_rules.direct.percent}} %</span><div layout=\"column\" flex=\"30\"><span \nclass=\"md-display-1 md-warn-fg\">\n{{ vm.promotion.avaliable_rules.ranges.length==0 ? vm.promotion.avaliable_rules.discounted_price : vm.promotion.price | currency }} \n</span><span ng-if=\"vm.promotion.avaliable_rules.direct && vm.promotion.avaliable_rules.ranges.length==0\" \nclass=\"md-subhead\"><s>{{ vm.promotion.price | currency}}</s></span></div><md-input-container \nng-if=\"vm.promotion.stock > 0\" style=\"margin-top: 56px\" flex=\"20\"><label \nstyle=\"font-size: 16px;color: rgba(0,0,0,0.87)\">Cantidad</label><input style=\"font-size: 18px;color:rgba(0,0,0,0.87)\" \nid=\"quantity\" type=\"number\" ng-model=\"vm.qty\" min=\"1\" step=\"1\"></md-input-container></md-card-actions><md-button \nng-if=\"vm.promotion.stock > 0\" flex=\"30\" ng-controller=\"CartAddCtrl as caddvm\" \nng-click=\"caddvm.submit(true,vm.promotion.id,\'promotion\', vm.qty)\" title=\"Comprar\" aria-label=\"Comprar\" \nclass=\"btn btn-md md-raised md-accent\"><md-icon md-font-icon=\"icon-cart\"></md-icon>Comprar</md-button><span \nng-if=\"vm.promotion.stock == 0\" class=\"md-red-600-bg p-10 h4 text-center mt-20\" style=\"margin-bottom: 8px\">Agotado\n</span></div></md-card-title-text></md-card><md-card layout=\"column\" layout-align=\"start stretch\" class=\"p-24\" flex \nng-show=\"vm.promotion.articles.length > 0\"><span class=\"md-display-1\">\n{{ vm.promotion.articles.length > 1 ? vm.promotion.articles.length + \' artículos\' : \'1 artículo\' }}</span><div \nlayout=\"row\" layout-align=\"start stretch\" layout-wrap><product-card ng-repeat=\"a in vm.promotion.articles\" product=\"a\" \ntype=\"\'article\'\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\" flex-grow=\"0\" layout=\"column\" \nlayout-align=\"space-between center\"></product-card></div></md-card></div></div>");
$templateCache.put("app/main/pharmacist/tools/views/calculator-retail.html","<div id=\"calculator-retail\" class=\"page-layout simple fullwidth\"><div \nclass=\"md-teal-400-bg header md-accent-bg header-with-toolbar\" \nstyle=\"min-height: 100px;height: auto; max-height: none\" layout=\"column\" layout-align=\"space-between center\"><span \nng-if=\"!vm.result || !vm.result.calculated || !vm.result.calculated.retail\" class=\"md-display-1 mv-96\">\nIntroduce los datos y pulsa CALCULAR</span><div \nng-if=\"vm.result && vm.result.calculated && vm.result.calculated.retail && vm.saved\" class=\"results\"><table \nclass=\"info\" cellspacing=\"0\" cellpadding=\"0\"><thead><tr><th colspan=\"5\">Cálculo de PVP</th></tr></thead><tbody><tr><td>\n<p>Coste (Sin IVA)</p><p>{{ vm.result.calculated.wholesale }}</p></td><td><p>Margen ({{ vm.saved.profit }} %)</p><p>\n{{ vm.result.calculated.profit }}</p></td><td><p>PVP (Sin IVA)</p><p>{{ vm.result.calculated.retail_tax_excl }}</p>\n</td><td><p>IVA ({{ vm.saved.tax }} %)</p><p>{{ vm.result.calculated.tax }}</p></td><td><p>PVP</p><p>\n{{ vm.result.calculated.retail }}</p></td></tr></tbody></table><table class=\"profits\" cellspacing=\"0\" cellpadding=\"0\">\n<thead><tr><th>Margen</th><th>PVP</th></tr></thead><tbody><tr><td>{{ vm.saved.profit - 5}} %</td><td>\n{{ vm.result.prev.retail }}</td></tr><tr class=\"requested\"><td>{{ vm.saved.profit }} %</td><td>\n{{ vm.result.calculated.retail }}</td></tr><tr><td>{{ vm.saved.profit + 5}} %</td><td>{{ vm.result.next.retail }}</td>\n</tr></tbody></table></div><md-toolbar class=\"md-menu-toolbar pr-0 calculator-toolbar md-background-bg\"><div \nclass=\"md-toolbar-tools pr-0\" layout-align=\"space-between center\"><form name=\"vm.fretail\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><md-input-container class=\"wholesale\"><input type=\"number\" name=\"wholesale\" \nng-model=\"vm.wholesale\" min=\"0\" placeholder=\"Precio de compra\" required><md-icon md-font-icon=\"icon-currency-eur\">\n</md-icon></md-input-container><md-input-container class=\"tax\"><label>Tipo de impuestos</label><md-select \nng-model=\"vm.tax\" ng-change=\"vm.updateRecargo()\" style=\"overflow: hidden\"><md-option ng-repeat=\"t in vm.tax_types\" \nvalue=\"{{ t }}\">{{ t }}%</md-option></md-select></md-input-container><div class=\"recargo\"><md-checkbox \nng-model=\"vm.use_recargo\" aria-label=\"Usar recargo\">Usar recargo</md-checkbox></div><md-input-container class=\"profit\">\n<input type=\"number\" name=\"profit\" ng-model=\"vm.profit\" placeholder=\"Margen de beneficio\" required><md-icon \nmd-font-icon=\"icon-percent\"></md-icon></md-input-container></form><div flex flex-shrink=\"0\" flex-grow=\"1\"><md-button \nclass=\"md-raised md-primary submit\" ng-disabled=\"vm.fretail.$invalid || vm.fretail.$pristine || vm.wholesale === 0\" \nng-click=\"vm.calculateAll()\">Calcular</md-button></div></div></md-toolbar></div></div>");
$templateCache.put("app/main/pharmacist/tools/views/show_in_tools-retail.html","");
$templateCache.put("app/main/pharmacist/tools/views/ultimas_noticias-retail.html","");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps\" layout=\"row\" layout-align=\"start center\"><div class=\"step md-accent-bg\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{step.stepNumber}} \n</span><span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Atras</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\">\n</span></div><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Siguiente\n</md-button><md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" \nng-if=\"MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isFormValid()\">Guardar</md-button></div></div>");
$templateCache.put("app/main/admin/articles/views/forms/create.html","<div layout=\"row\"><div class=\"md-whiteframe-1dp\" flex=\"100\"><div layout=\"row\" class=\"md-primary-bg\" \nstyle=\"padding: 5px 20px\"><h2>Datos del Articulo</h2></div><form name=\"vm.fuser\" ng-submit=\"vm.store()\" \nclass=\"form-wrapper md-inline-form\" novalidate><div layout=\"row\" layout-align=\"center top\" ng-cloak><div \nlayout=\"column\" flex><div layout=\"row\"><md-input-container flex=\"75\"><input type=\"text\" name=\"name\" \nng-model=\"vm.article.name\" placeholder=\"Nombre\" required><div ng-messages=\"vm.article.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>El nombre es obligatorio.</span></div></div></md-input-container><md-input-container \nflex=\"25\"><input type=\"string\" name=\"national_code\" ng-model=\"vm.article.national_code\" placeholder=\"Código\" required>\n<div ng-messages=\"vm.article.national_code.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEl código es obligatorio.</span></div></div></md-input-container></div><div layout=\"row\" layout-align=\"center center\" \nng-cloak><div layout=\"column\" flex=\"20\"><md-select placeholder=\"Estado\" required ng-model=\"vm.article.status\" \nstyle=\"padding-bottom: 18px\"><md-option value=\"enabled\">Activado</md-option><md-option value=\"disabled\">Desactivado\n</md-option><md-option value=\"coming_soon\">Próximamente</md-option></md-select></div><md-input-container flex=\"20\">\n<label>Precio</label><input type=\"text\" name=\"price\" ng-model=\"vm.article.price\" required><div \nng-messages=\"vm.article.price.$error\" role=\"alert\"><div ng-message=\"required\"><span>El precio es obligatorio.</span>\n</div></div></md-input-container><md-input-container flex=\"20\"><label>Stock</label><input type=\"number\" name=\"stock\" \nng-model=\"vm.article.stock\"><div ng-messages=\"vm.article.stock.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEl stock es obligatorio.</span></div></div></md-input-container><md-input-container flex=\"20\"><label>Cantidad mínima\n</label><input type=\"number\" name=\"stock\" ng-model=\"vm.article.min_amount\" required><div \nng-messages=\"vm.article.min_amount.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nLa cantidad mínima es obligatoria.</span></div></div></md-input-container><md-input-container flex=\"20\"><label>\nCantidad máxima por farmacia</label><input type=\"number\" name=\"stock_per_pharmacy\" \nng-model=\"vm.article.stock_per_pharmacy\" required><div ng-messages=\"vm.article.stock_per_pharmacy.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>La cantidad máxima por farmacia es obligatoria.</span></div></div>\n</md-input-container></div><div layout=\"row\" flex><md-icon style=\"margin-right: .5em;margin-left: .6em\" \nmd-font-icon=\"icon-folder-multiple-outline\" class=\"md-primary\"></md-icon><md-select required placeholder=\"Categoría\" \nng-model=\"vm.article.category_id\" flex style=\"overflow: hidden\"><md-select-header><input ng-model=\"searchTerm\" \ntype=\"search\" placeholder=\"Buscar\" ng-keydown=\"vm.onSearchChange($event)\" style=\"padding: 10px\"></md-select-header>\n<md-option value=\"{{category.id}}\" ng-repeat=\"category in vm.categories | filter:searchTerm\">{{category.name }}\n</md-option></md-select><div ng-controller=\"CategoryController as vm2\"><md-button type=\"button\" \nng-click=\"vm2.showAdvanced()\" aria-label=\"Añadir categoría\" class=\"md-accent md-raised md-hue-2\"><md-icon \nmd-font-icon=\"icon-plus-box\"></md-icon><span>Añadir categoría</span></md-button></div></div><div layout=\"row\" \nlayout-align=\"center top\"><div layout=\"column\" flex><textarea aria-label=\"Descripción\" name=\"description\" id=\"\" \nui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.article.description\"></textarea></div></div><uploader \nimages=\"vm.uploadImages\" uploader=\"vm.uploader\"></uploader><div layout=\"row\" layout-align=\"center top\">\n<md-input-container class=\"md-block\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"vm.fuser.$invalid || vm.fuser.$pristine\">Guardar</md-button></md-input-container></div></div></div></form>\n</div></div>");
$templateCache.put("app/main/admin/campaigns/views/dialogs/addpharmacist.html","<md-dialog flex=\"80%\" aria-label=\"{{modal.campaign.description}}\" ng-cloak><form><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Añadir farmacéuticos a {{modal.promotion.name}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-controller=\"ModalController as  mc\" ng-click=\"mc.hide()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-card class=\"generic-card-item p-40\"><div layout=\"row\" \nlayout-align=\"center stretch\"><div flex=\"80\" layout=\"column\" layout-align=\"start center\" class=\"mb-10\">\n<md-input-container class=\"md-block\"><label>Pegar aqui los usuarios para añadir de forma masiva</label><textarea \nng-model=\"modal.masiveUsers\" rows=\"3\" cols=\"120\"></textarea></md-input-container></div><div flex=\"20\"><md-button \nng-click=\"modal.sendMasive()\" class=\"md-raised md-primary\">Añadir</md-button></div></div><div layout=\"row\" \nlayout-align=\"center stretch\"><div flex=\"50\" layout=\"column\" layout-align=\"start center\" class=\"mb-10\">\n<md-input-container><input autocomplete=\"off\" placeholder=\"Buscar farmacéutico\" \nng-keyup=\"($event.which === 13) ? modal.searchPharmacist(searchTerm) : 0 \" name=\"searhArticle\" ng-model=\"searchTerm\">\n</md-input-container><md-progress-circular ng-show=\"loadingSearch\" md-mode=\"indeterminate\"></md-progress-circular>\n<md-list><md-subheader class=\"md-no-sticky\"></md-subheader><md-list-item ng-repeat=\"result in modal.searchResult\"><div \nlayout=\"row\" flex><p flex=\"80\" title=\"{{result.name}}\">{{result.username}} - {{result.name | characters : 30}}</p>\n<md-button flex=\"20\" ng-click=\"modal.addPharma(modal.campaign.id,result.id)\" class=\"md-icon-button\" aria-label=\"More\">\n<md-icon md-font-icon=\"icon-plus\"><md-tooltip>Añadir</md-tooltip></md-icon></md-button></div></md-list-item></md-list>\n</div><div flex=\"50\" layout=\"column\" class=\"pharmacist-promotional ml-10 pl-10\"><h2>Farmaceuticos <span \nclass=\"md-primary-bg generic-badge\">{{modal.campaign.activated_users.length}}</span><md-button flex \nng-click=\"modal.delMasive()\" class=\"\" aria-label=\"More\"><md-icon md-font-icon=\"icon-trash\"><md-tooltip></md-tooltip>\n</md-icon>ELiminar todos</md-button></h2><div layout=\"column\"><div layout=\"row\" \nng-repeat=\"(key,user) in modal.campaign.activated_users\"><div flex=\"90\"><a target=\"_blank\" \nui-sref=\"app.user-edit({idUser:user.id})\"><span class=\"mr-20\">{{user.username}} -</span> <span>\n{{user.name | characters : 30}}</span></a></div><md-button flex=\"10\" \nng-click=\"modal.delPharma(modal.campaign.id,user.id)\" class=\"md-icon-button\" aria-label=\"More\"><md-icon \nmd-font-icon=\"icon-trash\"><md-tooltip>Eliminar</md-tooltip></md-icon></md-button></div></div></div></div></md-card>\n</md-dialog-content><md-dialog-actions layout=\"row\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/campaigns/views/dialogs/selectArticle.html","<md-dialog flex=\"90\" aria-label=\"{{opt.title}}\" ng-cloak style=\"overflow: hidden\"><form><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{opt.title}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div><div layout=\"row\" flex class=\"mv-16 searchbar md-background-bg md-hue-2\" \nlayout-align=\"space-between stretch\" flex><input autocomplete=\"off\" type=\"text\" placeholder=\"Buscar articulo\" flex \nng-keyup=\"($event.which === 13) ? modal.searchArticle(article.searchTerm) : 0 \" name=\"searchArticle\" \nng-model=\"article.searchTerm\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-button \nclass=\"btn btn-md md-icon-button\" title=\"Borrar búsqueda\" aria-label=\"Borrar búsqueda\" \nng-click=\"vm.setSearch(false, \'null\')\" ng-show=\"vm.filter.search\"><md-icon md-font-icon=\"icon-eraser\"></md-icon>\n</md-button><md-button class=\"submit-search\" title=\"Buscar\" aria-label=\"Buscar\" \nng-click=\"modal.searchArticle(article.searchTerm)\">Buscar</md-button></div><div layout=\"column\" \nlayout-align=\"start stretch\" layout-gt-sm=\"row\" layout-align-gt-sm=\"center start\" flex><div flex=\"50\"><md-list \nstyle=\"height: 40vh; max-height: 100%; overflow-y: auto; overflow-x: hidden\"><md-list-item class=\"md-2-line\" \nng-repeat=\"(key,article) in elementData\" layout=\"row\" layout-align=\"start center\" ng-click=\"modal.setItem(article)\">\n<img class=\"mr-16\" width=\"50\" height=\"50\" ng-src=\"https://placehold.it/50x50\" alt=\"\" ng-hide=\"article.thumbnail\"> <img \nclass=\"mr-16\" width=\"50\" height=\"50\" ng-src=\"{{ article.thumbnail.urlth }}\" alt=\"\" ng-show=\"article.thumbnail\"><div \nclass=\"md-list-item-text\" layout=\"column\" flex><h3 class=\"truncate-name\">{{ article.name }}</h3><h4>\n{{ article.category.name }}</h4></div></md-list-item></md-list></div><div flex=\"50\"><md-list \nstyle=\"height: 40vh; max-height: 100%; overflow-y: auto; overflow-x: hidden\"><span ng-if=\"selectedArticles.length > 0\" \nclass=\"mt-10\">*Introduzca el número mínimo de articulos para la restriccion de la campaña.</span><md-list-item \nclass=\"md-2-line\" ng-repeat=\"(key,article) in selectedArticles\" layout=\"row\" layout-align=\"start center\" flex><img \nclass=\"mr-16\" width=\"50\" height=\"50\" ng-src=\"https://placehold.it/50x50\" alt=\"\" ng-hide=\"article.thumbnail\"> <img \nclass=\"mr-16\" width=\"50\" height=\"50\" ng-src=\"{{ article.thumbnail.urlth }}\" alt=\"\" ng-show=\"article.thumbnail\"><div \nclass=\"md-list-item-text\" layout=\"column\" flex><h3 class=\"truncate-name\">{{ article.name }}</h3><span>\nCN:{{article.national_code}}</span><h4>{{ article.category.name }}</h4></div><input type=\"number\" \nng-model=\"article.campaign_min_qty\" min=\"1\" step=\"1\"><md-button class=\"md-icon-button\" aria-label=\"Quitar artículo\" \nng-click=\"modal.delItem(\'article\',$index)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-list-item>\n</md-list></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nclass=\"md-raised md-primary\" aria-label=\"Guardar\" ng-click=\"confirm(\'articles\')\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon>Guardar</md-button><md-button class=\"md-raised\" aria-label=\"Guardar\" \nng-click=\"hide()\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>Cancelar</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/admin/campaigns/views/dialogs/selectMaterial.html","<md-dialog flex=\"90\" aria-label=\"{{opt.title}}\" ng-cloak style=\"overflow: hidden\"><form><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{opt.title}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div><div layout=\"row\" flex class=\"mv-16 searchbar md-background-bg md-hue-2\" \nlayout-align=\"space-between stretch\" flex><input autocomplete=\"off\" type=\"text\" placeholder=\"Buscar articulo\" flex \nng-keyup=\"($event.which === 13) ? modal.searchMaterial(material.searchTerm) : 0 \" name=\"searchMaterial\" \nng-model=\"material.searchTerm\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-button \nclass=\"btn btn-md md-icon-button\" title=\"Borrar búsqueda\" aria-label=\"Borrar búsqueda\" \nng-click=\"vm.setSearch(false, \'null\')\" ng-show=\"vm.filter.search\"><md-icon md-font-icon=\"icon-eraser\"></md-icon>\n</md-button><md-button class=\"submit-search\" title=\"Buscar\" aria-label=\"Buscar\" \nng-click=\"modal.searchMaterial(material.searchTerm)\">Buscar</md-button></div><div layout=\"column\" \nlayout-align=\"start stretch\" layout-gt-sm=\"row\" layout-align-gt-sm=\"center start\" flex><div flex=\"50\"><md-list \nstyle=\"height: 40vh; max-height: 100%; overflow-y: auto; overflow-x: hidden\"><md-list-item class=\"md-2-line\" \nng-repeat=\"(key,material) in elementData\" layout=\"row\" layout-align=\"start center\" ng-click=\"modal.setItem(material)\">\n<img class=\"mr-16\" width=\"50\" height=\"50\" ng-src=\"https://placehold.it/50x50\" alt=\"\" ng-hide=\"material.thumbnail\"> <img\n class=\"mr-16\" width=\"50\" height=\"50\" ng-src=\"{{ material.thumbnail.urlth }}\" alt=\"\" ng-show=\"material.thumbnail\"><div \nclass=\"md-list-item-text\" layout=\"column\" flex><h3 class=\"truncate-name\">{{ material.name }}</h3><h4>\n{{ material.category.name }}</h4></div></md-list-item></md-list></div><div flex=\"50\"><md-list \nstyle=\"height: 40vh; max-height: 100%; overflow-y: auto; overflow-x: hidden\"><md-list-item class=\"md-2-line\" \nng-repeat=\"(key,material) in selectedMaterials\" layout=\"row\" layout-align=\"start center\" flex><img class=\"mr-16\" \nwidth=\"50\" height=\"50\" ng-src=\"https://placehold.it/50x50\" alt=\"\" ng-hide=\"material.thumbnail\"> <img class=\"mr-16\" \nwidth=\"50\" height=\"50\" ng-src=\"{{ material.thumbnail.urlth }}\" alt=\"\" ng-show=\"material.thumbnail\"><div \nclass=\"md-list-item-text\" layout=\"column\" flex><h3 class=\"truncate-name\">{{ material.name }}</h3><h4>\n{{ material.category.name }}</h4></div><input type=\"number\" ng-model=\"material.qty\" min=\"1\" step=\"1\"><md-button \nclass=\"md-icon-button\" aria-label=\"Quitar artículo\" ng-click=\"modal.delItem(\'material\',$index)\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></md-list-item></md-list></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-primary\" aria-label=\"Guardar\" \nng-click=\"confirm(\'materials\')\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>Guardar</md-button><md-button \nclass=\"md-raised\" aria-label=\"Guardar\" ng-click=\"hide()\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>Cancelar\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/campaigns/views/forms/create.html","<div layout=\"row\"><div class=\"md-whiteframe-1dp\" flex=\"100\"><div layout=\"row\" class=\"md-primary-bg\" \nstyle=\"padding: 5px 20px\"><h2>Datos de la campaña</h2></div><form name=\"vm.fuser\" ng-submit=\"vm.store()\" \nclass=\"form-wrapper md-inline-form\" novalidate><div layout=\"row\"><md-input-container layout=\"row\" flex=\"80\"><md-icon \nmd-font-icon=\"icon-format-text\" class=\"md-primary\" style=\"margin-right: 1em\"></md-icon><input type=\"text\" name=\"name\" \nng-model=\"vm.campaign.name\" placeholder=\"Nombre\" required><div ng-messages=\"vm.campaign.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>El nombre es obligatorio.</span></div></div></md-input-container><div class=\"pl-24\">\n<md-checkbox ng-model=\"vm.campaign.from_hefame\" aria-label=\"Hefame\">Hefame</md-checkbox></div><div class=\"pl-24\">\n<md-checkbox ng-model=\"vm.campaign.covid19\" aria-label=\"COVID19\">COVID19</md-checkbox></div></div><div layout=\"row\">\n<md-input-container flex><textarea aria-label=\"Descripción\" name=\"description\" ui-tinymce=\"vm.tinymceOptions\" \nng-model=\"vm.campaign.description\"></textarea><div ng-messages=\"vm.campaign.description.$error\" role=\"alert\"><div \nng-message=\"required\"><span>La descripción es obligatoria.</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"start stretch\" layout-align-gt-xs=\"center end\" ng-cloak><div \nlayout=\"row\" flex><md-icon style=\"margin-right: .5em;margin-left: .6em\" md-font-icon=\"icon-folder-multiple-outline\" \nclass=\"md-primary\"></md-icon><md-select required placeholder=\"Categoría\" ng-model=\"vm.campaign.category_id\" flex \nstyle=\"overflow: hidden\"><md-select-header><input ng-model=\"searchTerm\" type=\"search\" placeholder=\"Buscar\" \nng-keydown=\"vm.onSearchChange($event)\" style=\"padding: 10px\"></md-select-header><md-option value=\"{{category.id}}\" \nng-repeat=\"category in vm.categories | filter:searchTerm\">{{category.name }}</md-option></md-select><div \nng-controller=\"CategoryController as vm2\"><md-icon class=\"mt-20\" ng-click=\"vm2.showAdvanced()\" \naria-label=\"Añadir categoría\" md-font-icon=\"icon-plus-box\"></md-icon></div></div><div layout=\"row\" flex-gt-xs=\"20\" \nflex-xs=\"100\"><md-icon style=\"margin-right: .5em;margin-left: .5em\" md-font-icon=\"icon-check\" \nng-show=\"vm.campaign.status == \'enabled\'\" class=\"md-accent\"></md-icon><md-icon \nstyle=\"margin-right: .5em;margin-left: .5em\" md-font-icon=\"icon-calendar-clock\" class=\"md-primary\" \nng-show=\"vm.campaign.status == \'coming_soon\'\" class=\"md-accent\"></md-icon><md-icon \nstyle=\"margin-right: .5em;margin-left: .5em\" md-font-icon=\"icon-close\" \nng-show=\"vm.campaign.status == null || vm.campaign.status == \'disabled\'\"></md-icon><md-select placeholder=\"Estado\" \nrequired ng-model=\"vm.campaign.status\" flex><md-option value=\"enabled\">Activada</md-option><md-option \nvalue=\"coming_soon\">Próximamente</md-option><md-option value=\"disabled\">Desactivada</md-option></md-select></div><div \nlayout=\"row\" flex-gt-xs=\"20\" flex-xs=\"100\"><md-datepicker timezoned-date ng-model=\"vm.campaign.launch_date\" \nng-value=\"\" md-placeholder=\"Fecha de inicio\" required style=\"margin-bottom: 22px\" class=\"fullwidth\" flex>\n</md-datepicker></div><div layout=\"row\" flex-gt-xs=\"20\" flex-xs=\"100\"><md-datepicker timezoned-date \nng-model=\"vm.campaign.expiration_date\" md-placeholder=\"Fecha de finalización\" required style=\"margin-bottom: 22px\" \nclass=\"fullwidth\" flex></md-datepicker></div></div><h4>Restricciones de acceso a la campaña y asociaciones.</h4><div \nlayout=\"row\" layout-align=\"center center\"><div layout=\"row\" flex-gt-xs=\"20\" flex-xs=\"100\"><md-select \nplaceholder=\"Tipo de restricción\" required ng-model=\"vm.campaign.restriction_mode\" flex><md-option value=\"none\">Ninguna\n</md-option><md-option value=\"global_qty\">Artículos totales</md-option><md-option value=\"particular_qty\">\nArtículo por artículo</md-option></md-select></div><md-input-container \nng-if=\"vm.campaign.restriction_mode==\'global_qty\'\" layout=\"row\" flex=\"30\"><input type=\"number\" name=\"min_global_qty\" \nng-model=\"vm.campaign.min_global_qty\" placeholder=\"Cantidad mínima de artículos\"></md-input-container><div><md-button \nclass=\"md-raised\" aria-label=\"Asociar artículo\" ng-click=\"vm.showSelectElement(\'article\')\">Asociar artículo <span \nclass=\"badge\">({{vm.campaign.articles.length ? vm.campaign.articles.length:0}})</span></md-button><md-button \nclass=\"md-raised\" aria-label=\"Asociar material\" ng-click=\"vm.showSelectElement(\'material\')\">Asociar material <span \nclass=\"badge\">({{vm.campaign.materials.length ? vm.campaign.materials.length:0 }})</span></md-button></div></div><h3>\nDescuento para todos los articulos asociados <small>\nPrevalece sobre cualquier otro descuento que tenga algún articulo asociado</small></h3><div layout=\"row\" \nlayout-align=\"center center\"><md-input-container layout=\"row\" flex=\"20\"><input type=\"number\" name=\"direct_campaign\" \nng-model=\"vm.campaign.direct_discount_percent\" placeholder=\"Descuento\"></md-input-container><span>%</span></div><div \nng-if=\"vm.mode==\'create\'\" class=\"text-center\">*Guardar primero para establecer accesos</div><div layout=\"column\" \nng-if=\"vm.mode!==\'create\'\" layout-align=\"start center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"center start\"><div \nflex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start stretch\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"center center\" class=\"mt-48\"><h3 class=\"text-center h3 mr-15\">Clientes con o sin acceso</h3>\n<md-select flex=\"25\" placeholder=\"Ninguna\" required ng-model=\"vm.campaign.restriction_type\" flex><md-option \nvalue=\"none\">No especificar</md-option><md-option value=\"inclusion\">Con acceso</md-option><md-option value=\"exclusion\">\nSin acceso</md-option></md-select><div flex=\"25\"><md-button \nng-show=\"vm.campaign.restriction_type == \'inclusion\' || vm.campaign.restriction_type == \'exclusion\'\" \nng-click=\"vm.addPharma(vm.campaign)\" title=\"Seleccionar clientes\" aria-label=\"Seleccionar clientes\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon>Seleccionar clientes</md-button></div></div></div><md-card layout=\"column\">\n<div layout=\"row\" layout-align=\"space-between center\" class=\"md-primary-bg\" style=\"padding: 5px 20px\"><h2>\nPreguntas y respuestas</h2><md-button type=\"button\" ng-click=\"vm.addQaa()\" aria-label=\"Añadir pregunta\" \nclass=\"md-accent md-raised md-hue-2\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon><span>Añadir pregunta</span>\n</md-button></div><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Pregunta {{$index+1}}\" \nng-repeat=\"(key,qaa) in vm.campaign.questionsAndAnswers track by $index\"><md-content class=\"md-padding\"><div \nlayout=\"row\" layout-align=\"end center\" flex><md-button aria-label=\"Borrar pregunta\" title=\"Borrar pregunta\" \nclass=\"md-fab md-primary md-mini\" ng-click=\"vm.delQaa($index)\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><div layout=\"column\" style=\"padding: 0px 30px 10px\"><md-input-container class=\"md-block m-0\" flex>\n<md-icon md-font-icon=\"icon-information-outline\"></md-icon><input type=\"text\" name=\"question[]\" \nng-model=\"qaa.question\" placeholder=\"Pregunta\" required></md-input-container><md-input-container class=\"md-block m-0\" \nflex><h3>Respuesta</h3><textarea aria-label=\"Respuesta\" name=\"answer[]\" ui-tinymce=\"vm.tinymceOptions\" \nng-model=\"qaa.answer\">Respuesta</textarea></md-input-container></div></md-content></md-tab></md-tabs></md-card><div \nlayout=\"column\" layout-gt-xs=\"row\"><div flex=\"100\" flex-gt-xs=\"33\"><h3>Imagen principal</h3><uploader \nimages=\"vm.uploadImagesSquare\" uploader=\"vm.uploader\"></uploader></div><div flex=\"100\" flex-gt-xs=\"67\"><h3>\nImagen slider</h3><uploader images=\"vm.uploadImagesPanoramic\" uploader=\"vm.uploaderSlider\"></uploader></div></div><div \nlayout=\"row\" layout-align=\"center center\"><md-input-container layout=\"row\" layout-align=\"center\" class=\"md-block\">\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"vm.fuser.$invalid || vm.fuser.$pristine\">Guardar</md-button></md-input-container></div></form></div></div>");
$templateCache.put("app/main/admin/gifts/views/forms/create.html","<div layout=\"row\"><div class=\"md-whiteframe-1dp\" flex=\"100\"><div layout=\"row\" class=\"md-primary-bg\" \nstyle=\"padding: 5px 20px\"><h2>Datos del regalo</h2></div><form name=\"vm.fuser\" ng-submit=\"vm.store()\" \nclass=\"form-wrapper md-inline-form\" novalidate><div layout=\"row\" layout-align=\"center top\" ng-cloak><div \nlayout=\"column\" flex><div layout=\"row\"><md-input-container flex=\"75\"><input type=\"text\" name=\"name\" \nng-model=\"vm.article.name\" placeholder=\"Nombre\" required><div ng-messages=\"vm.article.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>El nombre es obligatorio.</span></div></div></md-input-container><md-input-container \nflex=\"25\"><input type=\"string\" name=\"national_code\" ng-model=\"vm.article.national_code\" placeholder=\"Código\" required>\n<div ng-messages=\"vm.article.national_code.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEl código es obligatorio.</span></div></div></md-input-container></div><div layout=\"row\" layout-align=\"center top\"><div\n layout=\"column\" flex><textarea aria-label=\"Descripción\" name=\"description\" id=\"\" ui-tinymce=\"vm.tinymceOptions\" \nng-model=\"vm.article.description\"></textarea></div></div><uploader images=\"vm.uploadImages\" uploader=\"vm.uploader\" \nfilters=\"[\'images\']\"></uploader><div layout=\"row\" layout-align=\"center top\"><md-input-container class=\"md-block\">\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"vm.fuser.$invalid || vm.fuser.$pristine\">Guardar</md-button></md-input-container></div></div></div></form>\n</div></div>");
$templateCache.put("app/main/admin/materials/views/forms/create.html","<div layout=\"row\"><div class=\"md-whiteframe-1dp\" flex=\"100\"><div layout=\"row\" class=\"md-primary-bg\" \nstyle=\"padding: 5px 20px\"><h2>Datos del material</h2></div><form name=\"vm.fuser\" ng-submit=\"vm.store()\" \nclass=\"form-wrapper md-inline-form\" novalidate><md-input-container layout=\"row\" flex><md-icon \nmd-font-icon=\"icon-format-text\" style=\"margin-right: 1em\"></md-icon><input type=\"text\" name=\"name\" \nng-model=\"vm.material.name\" placeholder=\"Nombre\" required><div ng-messages=\"vm.material.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>El nombre es obligatorio.</span></div></div></md-input-container><div layout=\"row\">\n<md-input-container flex style=\"margin-bottom: 0\"><textarea aria-label=\"Descripción\" name=\"description\" id=\"\" \nui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.material.description\"></textarea><div \nng-messages=\"vm.material.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nLa descripción es obligatoria.</span></div></div></md-input-container></div><div layout=\"row\" style=\"margin-top: 25px\">\n<div layout=\"row\" flex layout-align=\"space-between center\"><md-switch ng-model=\"vm.material.status\" \naria-label=\"Activado\">{{ vm.material.status ? \'Activado\' : \'Desactivado\' }}</md-switch></div><md-input-container flex \nlayout=\"row\" style=\"margin-right: 2em\"><md-icon md-font-icon=\"icon-cash-multiple\" style=\"margin-right: .5em\"></md-icon>\n<input type=\"text\" name=\"price\" ng-model=\"vm.material.price\" flex placeholder=\"Precio\" required><div \nng-messages=\"vm.material.price.$error\" role=\"alert\"><div ng-message=\"required\"><span>El precio es obligatorio.</span>\n</div></div></md-input-container><md-input-container flex layout=\"row\" style=\"margin-right: 2em\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-marked-outline\" style=\"margin-right: .5em\"></md-icon><input type=\"number\" \nname=\"stock\" ng-model=\"vm.material.stock\" flex placeholder=\"Stock\"><div ng-messages=\"vm.material.stock.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>El stock es obligatorio.</span></div></div></md-input-container>\n<md-input-container flex layout=\"row\" style=\"margin-right: 2em\"><md-icon md-font-icon=\"icon-plus\" \nstyle=\"margin-right: .5em\"></md-icon><input type=\"number\" name=\"stock\" placeholder=\"Cantidad máxima\" \nng-model=\"vm.material.max_amount\"></md-input-container></div><div layout=\"row\" flex><md-icon \nstyle=\"margin-right: .5em;margin-left: 1em\" class=\"md-primary\" md-font-icon=\"icon-folder-multiple-outline\r\n\"></md-icon>\n<md-select required placeholder=\"Categoría\" ng-model=\"vm.material.category_id\" flex style=\"overflow: hidden\">\n<md-select-header><input ng-model=\"searchTerm\" type=\"search\" placeholder=\"Buscar\" \nng-keydown=\"vm.onSearchChange($event)\" style=\"padding: 10px\"></md-select-header><md-option value=\"{{category.id}}\" \nng-repeat=\"category in vm.categories | filter:searchTerm\">{{category.name }}</md-option></md-select><div \nng-controller=\"CategoryController as vm2\"><md-button type=\"button\" ng-click=\"vm2.showAdvanced()\" \naria-label=\"Añadir categoría\" class=\"md-accent md-raised md-hue-2\"><md-icon md-font-icon=\"icon-plus-box\"></md-icon>\n<span>Añadir categoría</span></md-button></div></div><uploader images=\"vm.uploadImages\" uploader=\"vm.uploader\">\n</uploader><div layout=\"row\" layout-align=\"center center\"><md-input-container layout=\"row\" layout-align=\"center\" \nclass=\"md-block\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"vm.fuser.$invalid || vm.fuser.$pristine\">Guardar</md-button></md-input-container></div></form></div></div>");
$templateCache.put("app/main/admin/pharmacies/views/forms/create.html","<div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"vm.fuser\" ng-submit=\"vm.store()\" \nclass=\"md-inline-form\" novalidate><div layout=\"row\"><md-input-container flex=\"70\"><input type=\"text\" name=\"name\" \nng-model=\"vm.pharmacy.name\" placeholder=\"Nombre\" required><div ng-messages=\"vm.pharmacy.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>El nombre es obligatorio.</span></div></div></md-input-container><md-input-container flex>\n<label>Email</label><input type=\"email\" name=\"email\" ng-model=\"vm.pharmacy.email\" required email><div \nng-messages=\"pharmacy.email.$error\" role=\"alert\"><div ng-message=\"required\"><span>El email es obligatorio.</span></div>\n<div ng-message=\"email\"><span>El email no tiene un formato correcto.</span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container flex=\"70\"><label>Dirección</label><input type=\"text\" name=\"address\" \nng-model=\"vm.pharmacy.address\" required email><div ng-messages=\"pharmacy.address.$error\" role=\"alert\"><div \nng-message=\"required\"><span>La dirección es obligatoria.</span></div></div></md-input-container><md-input-container \nflex><label>Teléfono</label><input type=\"phone\" name=\"phone\" ng-model=\"vm.pharmacy.phone\"></md-input-container></div>\n<div layout=\"row\"><md-input-container flex=\"30\" ng-hide=\"true\"><label>Geolocalización</label><input type=\"text\" \nname=\"geo\" ng-model=\"vm.pharmacy.geo\"><div ng-messages=\"pharmacy.geo.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>La geolocalización es obligatoria.</span></div></div></md-input-container><md-input-container flex=\"30\"><label>\nCiudad</label><input type=\"text\" name=\"city\" ng-model=\"vm.pharmacy.city\" required><div \nng-messages=\"pharmacy.city.$error\" role=\"alert\"><div ng-message=\"required\"><span>La ciudad es obligatoria.</span></div>\n</div></md-input-container><md-input-container flex><label>Provincia</label><input type=\"text\" name=\"state\" \nng-model=\"vm.pharmacy.state\" required><div ng-messages=\"pharmacy.state.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>La provincia es obligatoria.</span></div></div></md-input-container><md-input-container flex><label>Código Postal\n</label><input type=\"number\" name=\"postal_code\" ng-model=\"vm.pharmacy.postal_code\" required email><div \nng-messages=\"pharmacy.state.$error\" role=\"alert\"><div ng-message=\"required\"><span>El Código Postal es obligatorio.\n</span></div></div></md-input-container></div><div layout=\"row\" layout-align=\"center center\" ng-cloak><div \nlayout=\"column\" flex><md-checkbox ng-model=\"vm.pharmacy.status\" aria-label=\"Activada\">\n{{ vm.pharmacy.status ? \'Activado\' : \'Desactivado\' }}</md-checkbox></div><div layout=\"column\" flex=\"70\"><md-select \nplaceholder=\"Usuario\" required ng-model=\"vm.pharmacy.user_id\" style=\"min-width: 200px\"><md-select-header><input \nng-model=\"searchTerm\" type=\"search\" placeholder=\"Buscar\" ng-keydown=\"vm.onSearchChange($event)\" style=\"padding: 10px\">\n</md-select-header><md-optgroup label=\"users\"><md-option value=\"{{user.id}}\" \nng-repeat=\"user in vm.users | filter:searchTerm\">{{user.firstname + \" \" + user.lastname + \" (\" + user.username + \")\"}}\n</md-option></md-optgroup></md-select></div></div><div layout=\"row\" layout-align=\"center center\"><md-input-container \nlayout=\"row\" layout-align=\"center\" class=\"md-block\"><md-button type=\"submit\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-disabled=\"vm.fuser.$invalid || vm.fuser.$pristine\">Guardar</md-button></md-input-container>\n</div></form></div></div>");
$templateCache.put("app/main/admin/pharmacies/views/forms/edit--.html","<div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"vm.femployee\" \nng-submit=\"vm.update()\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nflex><input type=\"text\" name=\"firstname\" ng-model=\"vm.employee.firstname\" placeholder=\"Nombre\" required><div \nng-messages=\"employee.firstname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Nombre es requerido</span></div>\n</div></md-input-container><md-input-container flex><input type=\"text\" name=\"lastname\" ng-model=\"vm.employee.lastname\" \nplaceholder=\"Apellidos\" required><div ng-messages=\"employee.lastname.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Apellidos es requerido</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"60\"><label>Email</label><input type=\"email\" name=\"email\" ng-model=\"vm.employee.email\" \nrequired email><div ng-messages=\"employee.email.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEmail es requerido</span></div><div ng-message=\"email\"><span>Email no tiene un formato correcto</span></div></div>\n</md-input-container><md-input-container flex><label>Teléfono</label><input type=\"text\" name=\"phone\" \nng-model=\"vm.employee.phone\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><input type=\"text\" name=\"username\" ng-model=\"vm.employee.username\" placeholder=\"Usuario\" required><div \nng-messages=\"employee.username.$error\" role=\"alert\"><div ng-message=\"required\"><span>Usuario es requerido</span></div>\n</div></md-input-container><md-input-container flex><input type=\"password\" name=\"password\" \nng-model=\"vm.employee.password\" placeholder=\"Contraseña\" required ng-minlength=\"5\"><div \nng-messages=\"employee.password.$error\" role=\"alert\"><div ng-message=\"minlength\"><span>\nTiene que ser un minimo de 5 caracteres</span></div><div ng-message=\"required\"><span>Contraseña es requerida</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-align=\"center center\" style=\"padding:40px\" ng-cloak>\n<div layout=\"column\" layout-align=\"center center\" style=\"height: 100px\"><md-select placeholder=\"Roles\" \nng-model=\"vm.employee.roles | onlyId\" md-on-open=\"vm.loadRoles()\" style=\"min-width: 200px\" multiple=\"true\">\n<md-select-header><input ng-model=\"searchTerm\" type=\"search\" placeholder=\"Buscar\" \nng-keydown=\"vm.onSearchChange($event)\" style=\"padding: 10px\"></md-select-header><md-optgroup label=\"roles\"><md-option \nvalue=\"{{role.id}}\" ng-repeat=\"role in vm.roles | filter:searchTerm\">{{role.name}}</md-option></md-optgroup>\n</md-select></div></div><div layout=\"row\" layout-align=\"center center\"><md-input-container layout=\"row\" \nlayout-align=\"center\" class=\"md-block\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\">Crear\n</md-button></md-input-container></div></form></div><div></div></div>");
$templateCache.put("app/main/admin/promotions/views/dialogs/addpharmacist.html","<md-dialog flex=\"80%\" aria-label=\"{{modal.promotion.description}}\" ng-cloak><form><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Añadir farmacéuticos a {{modal.promotion.name}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-controller=\"ModalController as  mc\" ng-click=\"mc.hide()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-card class=\"generic-card-item p-40\"><div layout=\"row\" \nlayout-align=\"center stretch\"><div flex=\"80\" layout=\"column\" layout-align=\"start center\" class=\"mb-10\">\n<md-input-container class=\"md-block\"><label>Pegar aqui los usuarios para añadir de forma masiva</label><textarea \nng-model=\"modal.masiveUsers\" rows=\"3\" cols=\"120\"></textarea></md-input-container></div><div flex=\"20\"><md-button \nng-click=\"modal.sendMasive()\" class=\"md-raised md-primary\">Añadir</md-button></div></div><div layout=\"row\" \nlayout-align=\"center stretch\"><div flex=\"50\" layout=\"column\" layout-align=\"start center\" class=\"mb-10\">\n<md-input-container><input autocomplete=\"off\" placeholder=\"Buscar farmacéutico\" \nng-keyup=\"($event.which === 13) ? modal.searchPharmacist(searchTerm) : 0 \" name=\"searhArticle\" ng-model=\"searchTerm\">\n</md-input-container><md-progress-circular ng-show=\"loadingSearch\" md-mode=\"indeterminate\"></md-progress-circular>\n<md-list><md-subheader class=\"md-no-sticky\"></md-subheader><md-list-item ng-repeat=\"result in modal.searchResult\"><div \nlayout=\"row\" flex><p flex=\"80\" title=\"{{result.name}}\">{{result.username}} - {{result.name | characters : 30}}</p>\n<md-button flex=\"20\" ng-click=\"modal.addPharma(modal.promotion.id,result.id)\" class=\"md-icon-button\" aria-label=\"More\">\n<md-icon md-font-icon=\"icon-plus\"><md-tooltip>Añadir</md-tooltip></md-icon></md-button></div></md-list-item></md-list>\n</div><div flex=\"50\" layout=\"column\" class=\"pharmacist-promotional ml-10 pl-10\"><h2>Farmaceuticos <span \nclass=\"md-primary-bg generic-badge\">{{modal.promotion.activated_users.length}}</span><md-button flex \nng-click=\"modal.delMasive()\" class=\"\" aria-label=\"More\"><md-icon md-font-icon=\"icon-trash\"><md-tooltip></md-tooltip>\n</md-icon>ELiminar todos</md-button></h2><div layout=\"column\"><div layout=\"row\" \nng-repeat=\"(key,user) in modal.promotion.activated_users\"><div flex=\"90\"><a target=\"_blank\" \nui-sref=\"app.user-edit({idUser:user.id})\"><span class=\"mr-20\">{{user.username}} -</span> <span>\n{{user.name | characters : 30}}</span></a></div><md-button flex=\"10\" \nng-click=\"modal.delPharma(modal.promotion.id,user.id)\" class=\"md-icon-button\" aria-label=\"More\"><md-icon \nmd-font-icon=\"icon-trash\"><md-tooltip>Eliminar</md-tooltip></md-icon></md-button></div></div></div></div></md-card>\n</md-dialog-content><md-dialog-actions layout=\"row\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/promotions/views/dialogs/selectArticle.html","<md-dialog flex=\"90\" aria-label=\"{{opt.title}}\" ng-cloak style=\"overflow: hidden\"><form><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{opt.title}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div><div layout=\"row\" flex class=\"mv-16 searchbar md-background-bg md-hue-2\" \nlayout-align=\"space-between stretch\" flex><input autocomplete=\"off\" type=\"text\" placeholder=\"Buscar articulo\" flex \nng-keyup=\"($event.which === 13) ? modal.searchArticle(article.searchTerm) : 0 \" name=\"searchArticle\" \nng-model=\"article.searchTerm\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-button \nclass=\"btn btn-md md-icon-button\" title=\"Borrar búsqueda\" aria-label=\"Borrar búsqueda\" \nng-click=\"vm.setSearch(false, \'null\')\" ng-show=\"vm.filter.search\"><md-icon md-font-icon=\"icon-eraser\"></md-icon>\n</md-button><md-button class=\"submit-search\" title=\"Buscar\" aria-label=\"Buscar\" \nng-click=\"modal.searchArticle(article.searchTerm)\">Buscar</md-button></div><div layout=\"column\" \nlayout-align=\"start stretch\" layout-gt-sm=\"row\" layout-align-gt-sm=\"center start\" flex><div flex=\"50\"><md-list \nstyle=\"height: 40vh; max-height: 100%; overflow-y: auto; overflow-x: hidden\"><md-list-item class=\"md-2-line\" \nng-repeat=\"(key,article) in elementData\" layout=\"row\" layout-align=\"start center\" ng-click=\"modal.setItem(article)\">\n<img class=\"mr-16\" width=\"50\" height=\"50\" ng-src=\"https://placehold.it/50x50\" alt=\"\" ng-hide=\"article.thumbnail\"> <img \nclass=\"mr-16\" width=\"50\" height=\"50\" ng-src=\"{{ article.thumbnail.urlth }}\" alt=\"\" ng-show=\"article.thumbnail\"><div \nclass=\"md-list-item-text\" layout=\"column\" flex><h3 class=\"truncate-name\">{{ article.name }}</h3><h4>\n{{ article.category.name }}</h4></div></md-list-item></md-list></div><div flex=\"50\"><md-list \nstyle=\"height: 40vh; max-height: 100%; overflow-y: auto; overflow-x: hidden\"><md-list-item class=\"md-2-line\" \nng-repeat=\"(key,article) in selectedArticles\" layout=\"row\" layout-align=\"start center\" flex><img class=\"mr-16\" \nwidth=\"50\" height=\"50\" ng-src=\"https://placehold.it/50x50\" alt=\"\" ng-hide=\"article.thumbnail\"> <img class=\"mr-16\" \nwidth=\"50\" height=\"50\" ng-src=\"{{ article.thumbnail.urlth }}\" alt=\"\" ng-show=\"article.thumbnail\"><div \nclass=\"md-list-item-text\" layout=\"column\" flex><h3 class=\"truncate-name\">{{ article.name }}</h3><h4>\n{{ article.category.name }}</h4></div><md-button class=\"md-icon-button\" aria-label=\"Quitar artículo\" \nng-click=\"modal.delItem(\'article\',$index)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></md-list-item>\n</md-list></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nclass=\"md-raised md-primary\" aria-label=\"Guardar\" ng-click=\"confirm(\'articles\')\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon>Guardar</md-button><md-button class=\"md-raised\" aria-label=\"Guardar\" \nng-click=\"hide()\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>Cancelar</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/admin/promotions/views/dialogs/selectMaterial.html","<md-dialog flex=\"90\" aria-label=\"{{opt.title}}\" ng-cloak style=\"overflow: hidden\"><form><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{opt.title}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div><div layout=\"row\" flex class=\"mv-16 searchbar md-background-bg md-hue-2\" \nlayout-align=\"space-between stretch\" flex><input autocomplete=\"off\" type=\"text\" placeholder=\"Buscar articulo\" flex \nng-keyup=\"($event.which === 13) ? modal.searchMaterial(material.searchTerm) : 0 \" name=\"searchMaterial\" \nng-model=\"material.searchTerm\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-button \nclass=\"btn btn-md md-icon-button\" title=\"Borrar búsqueda\" aria-label=\"Borrar búsqueda\" \nng-click=\"vm.setSearch(false, \'null\')\" ng-show=\"vm.filter.search\"><md-icon md-font-icon=\"icon-eraser\"></md-icon>\n</md-button><md-button class=\"submit-search\" title=\"Buscar\" aria-label=\"Buscar\" \nng-click=\"modal.searchMaterial(material.searchTerm)\">Buscar</md-button></div><div layout=\"column\" \nlayout-align=\"start stretch\" layout-gt-sm=\"row\" layout-align-gt-sm=\"center start\" flex><div flex=\"50\"><md-list \nstyle=\"height: 40vh; max-height: 100%; overflow-y: auto; overflow-x: hidden\"><md-list-item class=\"md-2-line\" \nng-repeat=\"(key,material) in elementData\" layout=\"row\" layout-align=\"start center\" ng-click=\"modal.setItem(material)\">\n<img class=\"mr-16\" width=\"50\" height=\"50\" ng-src=\"https://placehold.it/50x50\" alt=\"\" ng-hide=\"material.thumbnail\"> <img\n class=\"mr-16\" width=\"50\" height=\"50\" ng-src=\"{{ material.thumbnail.urlth }}\" alt=\"\" ng-show=\"material.thumbnail\"><div \nclass=\"md-list-item-text\" layout=\"column\" flex><h3 class=\"truncate-name\">{{ material.name }}</h3><h4>\n{{ material.category.name }}</h4></div></md-list-item></md-list></div><div flex=\"50\"><md-list \nstyle=\"height: 40vh; max-height: 100%; overflow-y: auto; overflow-x: hidden\"><md-list-item class=\"md-2-line\" \nng-repeat=\"(key,material) in selectedMaterials\" layout=\"row\" layout-align=\"start center\" flex><img class=\"mr-16\" \nwidth=\"50\" height=\"50\" ng-src=\"https://placehold.it/50x50\" alt=\"\" ng-hide=\"material.thumbnail\"> <img class=\"mr-16\" \nwidth=\"50\" height=\"50\" ng-src=\"{{ material.thumbnail.urlth }}\" alt=\"\" ng-show=\"material.thumbnail\"><div \nclass=\"md-list-item-text\" layout=\"column\" flex><h3 class=\"truncate-name\">{{ material.name }}</h3><h4>\n{{ material.category.name }}</h4></div><md-button class=\"md-icon-button\" aria-label=\"Quitar artículo\" \nng-click=\"modal.delItem(\'material\',$index)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button><input \ntype=\"number\" ng-model=\"material.qty\" min=\"1\" step=\"1\"></md-list-item></md-list></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"md-raised md-primary\" aria-label=\"Guardar\" \nng-click=\"confirm(\'materials\')\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>Guardar</md-button><md-button \nclass=\"md-raised\" aria-label=\"Guardar\" ng-click=\"hide()\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>Cancelar\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/promotions/views/forms/create.html","<div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"vm.fuser\" ng-submit=\"vm.store()\" \nclass=\"md-inline-form\" novalidate><div layout=\"row\" layout-align=\"center top\" ng-cloak><div layout=\"column\" flex><div \nlayout=\"row\"><md-input-container flex=\"60\"><md-icon md-font-icon=\"icon-format-text\" class=\"md-primary\" \nstyle=\"margin-right: 1em\"></md-icon><input type=\"text\" name=\"name\" ng-model=\"vm.promotion.name\" placeholder=\"Nombre\" \nrequired><div ng-messages=\"vm.promotion.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nEl nombre es obligatorio.</span></div></div></md-input-container><md-input-container flex=\"20\"><md-icon \nmd-font-icon=\"icon-barcode\" class=\"md-primary\" style=\"margin-right: 1em\"></md-icon><input type=\"text\" name=\"code\" \nng-model=\"vm.promotion.code\" placeholder=\"Código\" required></md-input-container><md-input-container layout=\"row\" \nflex=\"20\"><md-icon md-font-icon=\"icon-code-string\" class=\"md-primary\" style=\"margin-right: 1em\"></md-icon><input \ntype=\"number\" name=\"stock\" ng-model=\"vm.promotion.stock\" placeholder=\"Stock\"></md-input-container></div><div \nlayout=\"row\" layout-align=\"center top\"><div layout=\"column\" flex><textarea aria-label=\"Descripción\" name=\"description\" \nid=\"\" ui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.promotion.description\"></textarea></div></div><div layout=\"row\" \nlayout-align=\"space-around center\"><md-select flex=\"20\" placeholder=\"Estado\" required ng-model=\"vm.promotion.status\">\n<md-option value=\"enabled\">Activada</md-option><md-option value=\"disabled\">Desactivada</md-option></md-select>\n<md-select flex=\"20\" required placeholder=\"Categoría\" ng-model=\"vm.promotion.category_id\"><md-select-header><input \nng-model=\"searchTerm\" type=\"search\" placeholder=\"Buscar\" ng-keydown=\"vm.onSearchChange($event)\" style=\"padding: 10px\">\n</md-select-header><md-option value=\"{{category.id}}\" ng-repeat=\"category in vm.categories | filter:searchTerm\">\n{{category.name }}</md-option></md-select><md-input-container flex=\"15\" class=\"mt-20\"><input type=\"number\" \nname=\"min_amount\" ng-model=\"vm.promotion.min_amount\" placeholder=\"Cant.Mínima\"></md-input-container><md-input-container\n flex=\"15\" class=\"mt-20\"><input type=\"text\" name=\"price\" ng-model=\"vm.promotion.price\" placeholder=\"Precio\" required>\n<div ng-messages=\"vm.promotion.price.$error\" role=\"alert\"><div ng-message=\"required\"><span>El precio es obligatorio.\n</span></div></div></md-input-container><md-input-container flex=\"15\"><md-checkbox ng-model=\"vm.promotion.discounted\" \naria-label=\"Precio rebajado\">Precio rebajado</md-checkbox></md-input-container><md-input-container flex=\"15\">\n<md-checkbox ng-model=\"vm.promotion.soon\" aria-label=\"Próximamente\">Próximamente</md-checkbox></md-input-container>\n<md-input-container flex=\"15\"><md-checkbox ng-model=\"vm.promotion.covid19\" aria-label=\"Precio rebajado\">COVID19\n</md-checkbox></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised\" \naria-label=\"Asociar artículo\" ng-click=\"vm.showSelectElement(\'article\')\">Asociar artículo <span class=\"badge\">\n({{vm.promotion.articles.length ? vm.promotion.articles.length :0 }})</span></md-button><md-button class=\"md-raised\" \naria-label=\"Asociar material\" ng-click=\"vm.showSelectElement(\'material\')\">Asociar material <span class=\"badge\">\n({{vm.promotion.materials.length ? vm.promotion.materials.length:0 }})</span></md-button><md-input-container \nlayout=\"row\" flex=\"20\"><input type=\"number\" name=\"direct\" ng-model=\"vm.promotion.avaliable_rules.direct.percent\" \nplaceholder=\"Descuento Directo %\"></md-input-container></div><div layout=\"column\" layout-align=\"start center\" \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"center start\"><div ng-if=\"vm.mode!==\'create\'\" flex=\"100\" flex-gt-xs=\"50\" \nlayout=\"column\" layout-align=\"start stretch\" layout-gt-xs=\"row\" layout-align-gt-xs=\"center center\" class=\"mt-48\"><h3 \nclass=\"text-center h3 mr-15\">Clientes con o sin acceso</h3><md-select flex=\"25\" placeholder=\"Ninguna\" required \nng-model=\"vm.promotion.restriction_type\" flex><md-option value=\"none\">No especificar</md-option><md-option \nvalue=\"inclusion\">Con acceso</md-option><md-option value=\"exclusion\">Sin acceso</md-option></md-select><div flex=\"25\">\n<md-button ng-show=\"vm.promotion.restriction_type == \'inclusion\' || vm.promotion.restriction_type == \'exclusion\'\" \nng-click=\"vm.addPharma(vm.promotion)\" title=\"Seleccionar clientes\" aria-label=\"Seleccionar clientes\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon>Seleccionar clientes</md-button></div></div><div ng-if=\"vm.mode==\'create\'\" \nclass=\"text-center\">*Guardar primero para establecer accesos</div></div><uploader images=\"vm.uploadImages\" \nuploader=\"vm.uploader\" filters=\"[\'imageFilter\']\"></uploader><div layout=\"row\" layout-align=\"center top\">\n<md-input-container class=\"md-block\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"vm.fuser.$invalid || vm.fuser.$pristine\">Guardar</md-button></md-input-container></div></div></div></form>\n</div></div>");
$templateCache.put("app/main/admin/rules/views/dialogs/addpharmacist.html","<md-dialog flex=\"80%\" aria-label=\"{{modal.promotional.description}}\" ng-cloak><form><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{modal.promotional.description}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-controller=\"ModalController as  mc\" ng-click=\"mc.hide()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-card class=\"generic-card-item p-40\"><div layout=\"row\" \nlayout-align=\"center stretch\"><div flex=\"50\" layout=\"column\" layout-align=\"start center\" class=\"mb-10\">\n<md-input-container><input autocomplete=\"off\" placeholder=\"Buscar farmacéutico\" \nng-keyup=\"($event.which === 13) ? modal.searchPharmacist(searchTerm) : 0 \" name=\"searhArticle\" ng-model=\"searchTerm\">\n</md-input-container><md-progress-circular ng-show=\"loadingSearch\" md-mode=\"indeterminate\"></md-progress-circular>\n<md-list><md-subheader class=\"md-no-sticky\"></md-subheader><md-list-item ng-repeat=\"result in modal.searchResult\"><div \nlayout=\"row\" flex><p flex=\"80\" title=\"{{result.name}}\">{{result.username}} - {{result.name | characters : 30}}</p>\n<md-button flex=\"20\" ng-click=\"modal.addPharma(modal.promotional.id,result.id)\" class=\"md-icon-button\" \naria-label=\"More\"><md-icon md-font-icon=\"icon-plus\"><md-tooltip>Añadir</md-tooltip></md-icon></md-button></div>\n</md-list-item></md-list></div><div flex=\"50\" layout=\"column\" class=\"pharmacist-promotional ml-10 pl-10\"><h2>\nFarmaceuticos con descuento <span class=\"md-primary-bg generic-badge\">{{modal.promotional.activated_users.length}}\n</span></h2><div layout=\"column\"><div layout=\"row\" ng-repeat=\"(key,user) in modal.promotional.activated_users\"><div \nflex=\"90\"><a target=\"_blank\" ui-sref=\"app.user-edit({idUser:user.id})\"><span class=\"mr-20\">{{user.username}} -</span> \n<span>{{user.name | characters : 30}}</span></a></div><md-button flex=\"10\" \nng-click=\"modal.delPharma(modal.promotional.id,user.id)\" class=\"md-icon-button\" aria-label=\"More\"><md-icon \nmd-font-icon=\"icon-trash\"><md-tooltip>Eliminar</md-tooltip></md-icon></md-button></div></div></div></div></md-card>\n</md-dialog-content><md-dialog-actions layout=\"row\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/rules/views/dialogs/details.html","<md-dialog flex=\"80%\" aria-label=\"{{modal.promotional.description}}\" ng-cloak><form><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{modal.promotional.description}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-controller=\"ModalController as  mc\" ng-click=\"mc.hide()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-card class=\"generic-card-item p-40\"><div layout=\"row\"><div flex=\"50\"><div \nlayout=\"row\" class=\"mb-20\" flex><h2>{{modal.promotional.description}}</h2></div><div layout=\"row\" class=\"mb-20\" flex>\n<span>\nVálido desde {{modal.promotional.date_from | momentFormat: \'DD-MM-YYYY\' }} hasta {{modal.promotional.date_to | momentFormat: \'DD-MM-YYYY\' }}\n</span></div><span ng-if=\"modal.promotional.in_time\" class=\"md-green-800-bg p-10 h4\">Activo</span> <span \nng-if=\"!modal.promotional.in_time\" class=\"md-red-800-bg p-10 h4\">No disponible</span><h2 class=\"mt-30\">Descuento</h2>\n<div class=\"md-indigo-50-bg p-20\" layout=\"row\" flex=\"100\"><div flex=\"20\"><img width=\"60px\" \nng-src=\"{{modal.promotional.active_entity.thumbnail.urlth}}\"></div><div flex=\"80\"><span class=\"font-weight-800 h3\" \nng-if=\"modal.promotional.entity==\'campaign\'\">Campaña</span> <span class=\"font-weight-800 h3\" \nng-if=\"modal.promotional.entity==\'promotion\'\">Promoción</span> <span>{{modal.promotional.active_entity.name}}</span> <a\n target=\"_blank\" ng-if=\"modal.promotional.entity==\'campaign\'\" \nui-sref=\"app.guest-campaign-show({id:modal.promotional.entity_id})\">Ver </a><a target=\"_blank\" \nng-if=\"modal.promotional.entity==\'promotion\'\" ui-sref=\"app.guest-promotion-show({ id: modal.promotional.entity_id })\">\nVer</a><div layout=\"column\" layout-align=\"center center\"><span class=\"red-500-fg font-weight-400 font-size-24 mt-10\">\n-{{modal.promotional.percent}}%</span></div></div></div></div><div flex=\"50\" \nclass=\"pharmacist-promotional ml-10 pl-10\"><h2>Farmaceuticos con descuento <span class=\"md-primary-bg generic-badge\">\n{{modal.promotional.activated_users.length}}</span><md-button \nng-click=\"modal.promotional.addPharma(modal.promotional)\" class=\"md-icon-button\" aria-label=\"Asignar farmacéuticos\">\n<md-icon md-font-icon=\"icon-account-plus\"><md-tooltip>Asignar a farmacéuticos</md-tooltip></md-icon></md-button></h2>\n<div layout=\"column\"><div layout=\"row\" ng-repeat=\"(key,user) in modal.promotional.activated_users\"><a href=\"#\"><span \nclass=\"mr-20\">{{user.username}} - </span><span>{{user.name}}</span></a></div></div></div></div></md-card>\n<md-dialog-actions layout=\"row\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/rules/views/dialogs/selectArticle.html","<md-dialog flex=\"80%\" aria-label=\"{{opt.title}}\" ng-cloak><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>\n{{opt.title}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-controller=\"ModalController as mc\" \nng-click=\"mc.cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\">\n<div layout=\"row\" layout-align=\"center\"><md-input-container flex=\"60\"><input autocomplete=\"off\" \nplaceholder=\"Buscar articulo\" ng-keyup=\"($event.which === 13) ? modal.searchArticle(article.searchTerm) : 0 \" \nname=\"searhArticle\" ng-model=\"article.searchTerm\"></md-input-container><md-progress-circular ng-show=\"loadingSearch\" \nmd-mode=\"indeterminate\"></md-progress-circular></div><p ng-show=\"elementData.length > 0\">\n{{elementData.length}} resultados</p><p class=\"red-700-fg\" ng-show=\"withOutResults\">Sin resultados</p><div \nng-show=\"elementData.length > 0\" class=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" \nms-responsive-table><thead><tr><th>Código</th><th>Miniatura</th><th>Nombre</th><th>Estado</th><th>Creado</th><th>\nAcciones</th></tr></thead><tfoot><tr><td></td></tr><tbody><tr \nng-class=\"{\'md-grey-100-bg\' : article.status==\'disabled\',\'md-teal-50-bg\' : article.status==\'coming_soon\'}\" \nng-repeat=\"(key,article) in elementData\"><td class=\"id\">{{ article.national_code }}</td><td class=\"thumbnail\"><img \nng-hide=\"article.thumbnail\" ng-src=\"http://placehold.it/50x50\" alt=\"\" width=\"50\" height=\"50\"> <img \nng-show=\"article.thumbnail\" ng-src=\"{{article.thumbnail.urlth}}\" alt=\"\" width=\"50\" height=\"50\"></td><td class=\"name\">\n{{article.name}}</td><td class=\"status\">\n{{ article.status == \'enabled\' ? \'Activado\' : article.status == \'coming_soon\' ? \'Próximamente\' : \'Desactivada\' }}</td>\n<td class=\"created_at\">{{article.created_at[\'date\'] | momentHumanize }}</td><td><div layout=\"row\"><input \nng-if=\"showQtyInputs\" flex=\"30\" type=\"number\" placeholder=\"Cantidad\" ng-model=\"article.selectedQty\"><md-button \nng-click=\"modal.setElement(article,opt)\" class=\"md-raised md-green-600-bg md-background-fg\">+</md-button></div></td>\n</tr></tbody></tfoot></table></div></div></md-dialog-content><md-dialog-actions layout=\"row\"></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/admin/rules/views/dialogs/selectGift.html","<md-dialog flex=\"80%\" aria-label=\"{{opt.title}}\" ng-cloak><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>\n{{opt.title}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"center\"><md-input-container \nflex=\"60\"><input autocomplete=\"off\" placeholder=\"Buscar regalo\" type=\"text\" ng-model=\"search\"></md-input-container>\n</div><div ng-show=\"elementData.length > 0\" class=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" \nms-responsive-table><thead><tr><th>#</th><th>Miniatura</th><th>Nombre</th><th>Estado</th><th>Creada</th><th>Acciones\n</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr \nng-class=\"{\'md-grey-100-bg\' : gift.status==\'disabled\',\'md-teal-50-bg\' : gift.status==\'coming_soon\'}\" \nng-repeat=\"gift in elementData  | filter:search\"><td class=\"id\">{{ gift.id }}</td><td class=\"thumbnail\"><img \nng-hide=\"gift.thumbnail\" ng-src=\"http://placehold.it/50x50\" alt=\"\" width=\"50\" height=\"50\"> <img \nng-show=\"gift.thumbnail\" ng-src=\"{{gift.thumbnail.urlth}}\" alt=\"\" width=\"50\" height=\"50\"></td><td class=\"name\">\n{{gift.name}}</td><td class=\"status\">\n{{ gift.status == \'enabled\' ? \'Activada\' : gift.status == \'coming_soon\' ? \'Próximamente\' : \'Desactivada\' }}</td><td \nclass=\"created_at\">{{gift.created_at[\'date\'] | momentHumanize }}</td><td><md-button ng-click=\"modal.setGift(gift,opt)\" \nmd-no-ink class=\"md-raised md-green-600-bg md-background-fg\">Seleccionar</md-button></td></tr></tbody></table></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/rules/views/dialogs/selectMaterial.html","<md-dialog flex=\"80%\" aria-label=\"{{opt.title}}\" ng-cloak><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>\n{{opt.title}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-controller=\"ModalController as mc\" \nng-click=\"mc.cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" \nlayout-align=\"center\"><md-input-container flex=\"60\"><input autocomplete=\"off\" placeholder=\"Buscar material\" \nng-keyup=\"\" name=\"searhArticle\" ng-model=\"material.searchTerm\"></md-input-container></div><div \nng-if=\"elementData.length > 0\" class=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" \nms-responsive-table><thead><tr><th>#</th><th>Miniatura</th><th>Nombre</th><th>Estado</th><th>Creada</th><th>Acciones\n</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr \nng-class=\"{\'md-grey-100-bg\' : material.status==\'disabled\',\'md-teal-50-bg\' : material.status==\'coming_soon\'}\" \nng-repeat=\"(key,material) in elementData | filter: material.searchTerm\"><td class=\"id\">{{ material.id }}</td><td \nclass=\"thumbnail\"><img src=\"http://placehold.it/50x50\" alt=\"\" width=\"50\" height=\"50\"></td><td class=\"name\">\n{{material.name}}</td><td class=\"status\">\n{{ material.status == \'enabled\' ? \'Activada\' : material.status == \'coming_soon\' ? \'Próximamente\' : \'Desactivada\' }}\n</td><td class=\"created_at\">{{material.created_at[\'date\'] | momentHumanize }}</td><td><div layout=\"row\"><input \nng-if=\"showQtyInputs\" flex=\"30\" type=\"number\" placeholder=\"Cantidad\" ng-model=\"material.selectedQty\"><md-button \nng-click=\"modal.setElement(material,opt)\" class=\"md-raised md-green-600-bg md-background-fg\">+</md-button></div></td>\n</tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/rules/views/dialogs/selectPromotion.html","<md-dialog flex=\"80%\" aria-label=\"{{opt.title}}\" ng-cloak><form><md-toolbar><div class=\"md-toolbar-tools\"><h2>\n{{opt.title}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-controller=\"ModalController as mc\" \nng-click=\"mc.cancel()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" \nlayout-align=\"center\"><md-input-container flex=\"60\"><input autocomplete=\"off\" placeholder=\"Buscar promocion\" \nng-keyup=\"($event.which === 13) ? modal.searchPromotion(promotion.searchTerm) : 0 \" name=\"searhArticle\" \nng-model=\"promotion.searchTerm\"></md-input-container></div><div ng-if=\"elementData.length > 0\" \nclass=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" ms-responsive-table><thead><tr><th>#</th><th>\nMiniatura</th><th>Nombre</th><th>Estado</th><th>Creada</th><th>Acciones</th></tr></thead><tfoot><tr><td></td></tr>\n</tfoot><tbody><tr \nng-class=\"{\'md-grey-100-bg\' : promotion.status==\'disabled\',\'md-teal-50-bg\' : promotion.status==\'coming_soon\'}\" \nng-repeat=\"(key,promotion) in elementData\"><td class=\"id\">{{ promotion.id }}</td><td class=\"thumbnail\"><img \nsrc=\"http://placehold.it/50x50\" alt=\"\" width=\"50\" height=\"50\"></td><td class=\"name\">{{promotion.name}}</td><td \nclass=\"status\">\n{{ promotion.status == \'enabled\' ? \'Activada\' : promotion.status == \'coming_soon\' ? \'Próximamente\' : \'Desactivada\' }}\n</td><td class=\"created_at\">{{promotion.created_at[\'date\'] | momentHumanize }}</td><td><div layout=\"row\"><input \nng-if=\"showQtyInputs\" flex=\"30\" type=\"number\" placeholder=\"Cantidad\" ng-model=\"promotion.selectedQty\"><md-button \nng-click=\"modal.setElement(promotion,opt)\" class=\"md-raised md-green-600-bg md-background-fg\">+</md-button></div></td>\n</tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\"></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/rules/views/steps/step-1.html","<div><div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"space-around center\"><md-input-container><md-select \nplaceholder=\"Sin campaña asociada\" ng-model=\"vm.rule.selected_campaign\" flex style=\"overflow: hidden\"><md-option \nclass=\"orange-500-fg\" value=\"-1\">Sin campaña asociada</md-option><md-option value=\"{{campaign.id}}\" \nng-repeat=\"campaign in vm.campaigns | filter:searchTerm\">{{campaign.name }}</md-option></md-select>\n</md-input-container><md-input-container><md-select placeholder=\"Elige articulo o promo\" \nng-model=\"vm.rule.launchSelectElement\" \nng-change=\"vm.rule.launchSelectElement!==\'campaign\' ? vm.showSelectElement(vm.rule.launchSelectElement) : 0 \" flex \nstyle=\"overflow: hidden\"><md-option value=\"article\">Artículo</md-option><md-option ng-hide=\"vm.rule.selected_campaign\" \nvalue=\"promotion\">Promoción</md-option><md-option ng-show=\"vm.rule.selected_campaign\" value=\"campaign\">Campaña\n</md-option></md-select></md-input-container></div><div ng-if=\"vm.rule.selectedElement\" class=\"element-rule\" \nlayout=\"column\" layout-gt-xs=\"row\" flex><div flex=\"20\"><img ng-hide=\"vm.rule.selectedElement.thumbnail\" \nng-src=\"http://placehold.it/50x50\" alt=\"\" width=\"50\" height=\"50\"> <img ng-show=\"vm.rule.selectedElement.thumbnail\" \nng-src=\"{{vm.selectedElement.thumbnail.urlth}}\" alt=\"\" width=\"50\" height=\"50\"></div><div flex=\"30\"><p>\n{{vm.rule.selectedElement.name}}</p></div><div flex=\"30\"><p>{{vm.rule.selectedElement.price}}€</p></div></div></div>");
$templateCache.put("app/main/admin/rules/views/steps/step-2.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"60\"><md-select \nplaceholder=\"Elige una opción : DESCUENTO O REGALO\" required ng-model=\"vm.rule.discount_gift\"><md-option \nvalue=\"discount\">Descuento</md-option><md-option \nng-hide=\"vm.rule.launchSelectElement==\'article\' && vm.rule.selected_campaign\" value=\"gift\">Regalo</md-option>\n</md-select></md-input-container><md-input-container ng-if=\"vm.rule.discount_gift==\'discount\'\" flex=\"40\"><md-select \nplaceholder=\"Elige una opción \" required ng-model=\"vm.rule.discount_type\"><md-option \nng-if=\"vm.rule.launchSelectElement!==\'campaign\'\" value=\"range\">Por rango</md-option><md-option \nng-value=\"vm.rule.launchSelectElement==\'campaign\'? \'direct-campaign\':\'direct\'\">Directo</md-option></md-select>\n</md-input-container></div></div><div class=\"md-inline-form\"><div ng-if=\"vm.rule.discount_gift==\'discount\'\"><div \nng-if=\"vm.rule.discount_type==\'range\'\"><md-button ng-click=\"vm.rule.discount.newRange()\" class=\"md-raised md-primary\">\nNuevo</md-button><md-button ng-click=\"vm.rule.discount.cleanRanges()\" class=\"md-raised md-warn\">Limpiar</md-button><div\n layout=\"column\" layout-align=\"center center\" class=\"rule-ranges\" ng-repeat=\"(key,range) in  vm.rule.discount.ranges\">\n<div layout=\"column\" layout-gt-xs=\"row\" flex=\"70\"><div flex=\"20\"><md-input-container \nclass=\"md-icon-float md-icon-right md-block\"><label>Desde</label><input ng-model=\"range.from\" type=\"number\" min=\"0\" \nstep=\"1\"></md-input-container></div><div flex=\"20\"><md-input-container class=\"md-icon-float md-icon-right md-block\">\n<label>Hasta</label><input ng-model=\"range.to\" type=\"number\" min=\"0\" step=\"1\"></md-input-container></div><div \nflex=\"10\" layout=\"row\" layout-align=\"space-between center\"><span \nstyle=\"margin-bottom: 24px;margin-right: 4px;font-size: 50px\">-</span><md-input-container flex><input required \nplaceholder=\"Descuento\" flex ng-model=\"range.discount\" min=\"0\" type=\"number\" step=\"1\"></md-input-container><span \nstyle=\"margin-bottom: 19px;font-size: 23px\">%</span></div></div></div></div><div layout=\"column\" flex \nlayout-align=\"center center\" ng-if=\"vm.rule.discount_type==\'direct\'\"><div flex=\"30\" layout=\"row\" \nlayout-align=\"space-between center\"><span style=\"margin-bottom: 24px;margin-right: 4px;font-size: 50px\">-</span>\n<md-input-container flex><input required placeholder=\"Descuento\" flex ng-model=\"vm.rule.discount.direct_percent\" \ntype=\"number\" min=\"0\" max=\"100\" step=\"1\"></md-input-container><span style=\"margin-bottom: 19px;font-size: 23px\">%\n</span></div></div></div><div ng-if=\"vm.rule.discount_gift==\'gift\'\"><div layout=\"column\" layout-align=\"center center\">\n<md-button ng-click=\"vm.showSelectElement(\'gift\')\" class=\"md-raised md-accent-bg md-hue-2\">Seleccionar Regalo\n</md-button></div><div ng-show=\"vm.rule.gift.selected\" layout=\"column\" layout-gt-xs=\"row\" layout-align=\"center center\" \nclass=\"mt-16\"><div class=\"ph-16\"><span>#{{vm.rule.gift.selected.id}}</span></div><div class=\"ph-16\"><img \nng-hide=\"vm.rule.gift.selected.thumbnail\" ng-src=\"http://placehold.it/50x50\" alt=\"\" width=\"50\" height=\"50\"> <img \nng-show=\"vm.rule.gift.selected.thumbnail\" ng-src=\"{{vm.rule.gift.selected.thumbnail.urlth}}\" alt=\"\" width=\"50\" \nheight=\"50\"></div><div class=\"ph-16\"><span>{{vm.rule.gift.selected.name}}</span></div></div><div layout=\"column\" \nlayout-align=\"center center\" class=\"rule-opc-gift\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"70\"><div flex=\"20\">\n<md-input-container class=\"md-icon-float md-icon-right md-block\"><label>Comprando</label><input required \nng-model=\"vm.rule.gift.every_quantity\" min=\"1\" type=\"number\"></md-input-container></div><div flex=\"10\" layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container flex><input required flex \nng-model=\"vm.rule.gift.gift_quantity\" min=\"1\" type=\"number\"></md-input-container><span \nstyle=\"margin-bottom: 19px;font-size: 23px\">de regalo</span></div></div></div></div></div>");
$templateCache.put("app/main/admin/sliders/views/forms/create.html","<div layout=\"row\"><div class=\"md-whiteframe-1dp\" flex=\"100\"><div layout=\"row\" class=\"md-primary-bg\" \nstyle=\"padding: 5px 20px\" layout-align=\"space-between center\"><h2>Datos del slider</h2><md-switch \nng-model=\"vm.slider.status\" aria-label=\"{{ vm.slider.status ? \'Activado\' : \'Desactivado\' }}\" \naria-label=\"{{ vm.slider.status ? \'Activado\' : \'Desactivado\' }}\"></md-switch></div><form name=\"vm.fslider\" \nng-submit=\"vm.store()\" class=\"form-wrapper md-inline-form\" novalidate><md-input-container layout=\"row\" flex><md-icon \nmd-font-icon=\"icon-format-text\" class=\"md-primary\" style=\"margin-right: 1em\"></md-icon><input type=\"text\" name=\"name\" \nng-model=\"vm.slider.name\" placeholder=\"Nombre\" required><div ng-messages=\"vm.slider.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>El nombre es obligatorio.</span></div></div></md-input-container><md-card layout=\"column\">\n<div layout=\"row\" layout-align=\"space-between center\" class=\"md-primary-bg\" style=\"padding: 5px 20px\"><h2>Slides</h2>\n<md-button type=\"button\" ng-click=\"vm.addSlide()\" aria-label=\"Añadir slide\" class=\"md-accent md-raised md-hue-2\">\n<md-icon md-font-icon=\"icon-plus-box\"></md-icon><span>Añadir slide</span></md-button></div><md-tabs md-dynamic-height \nmd-border-bottom md-selected=\"vm.selectedSlide\"><md-tab label=\"Slide {{$index+1}}\" \nng-repeat=\"(key,slide) in vm.slider.slides track by $index\"><md-content class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"end center\" flex><md-button aria-label=\"Mover a la izquierda\" title=\"Mover a la izquierda\" \nclass=\"md-fab md-primary md-mini\" ng-click=\"vm.changeOrder($index, \'left\')\" ng-disabled=\"$index == 0\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button aria-label=\"Mover a la derecha\" \ntitle=\"Mover a la derecha\" class=\"md-fab md-primary md-mini\" ng-click=\"vm.changeOrder($index, \'right\')\" \nng-disabled=\"$index == vm.slider.slides.length - 1\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button>\n<md-button aria-label=\"Borrar slide\" title=\"Borrar slide\" class=\"md-fab md-primary md-mini\" \nng-click=\"vm.delSlide($index)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div layout=\"column\" \nstyle=\"padding: 0px 30px 10px\"><md-input-container layout=\"row\" flex><md-icon md-font-icon=\"icon-link-variant\" \nclass=\"md-primary\" style=\"margin-right: 1em\"></md-icon><input type=\"text\" name=\"link\" ng-model=\"slide.link\" \nplaceholder=\"Enlace\"></md-input-container><div layout=\"row\" flex><md-icon style=\"margin-right: .5em\" \nmd-font-icon=\"icon-view-carousel\" class=\"md-primary\"></md-icon><md-select placeholder=\"Tipo\" ng-model=\"slide.type\" \nflex style=\"overflow: hidden\"><md-option value=\"static\">Imagen fija</md-option><md-option value=\"campaign\">\nAsociado a campaña</md-option></md-select></div><div layout=\"row\" flex ng-show=\"slide.type == \'campaign\'\"><md-icon \nstyle=\"margin-right: .5em\" md-font-icon=\"fa fa-bullhorn\" class=\"md-primary\"></md-icon><md-select placeholder=\"Campaña\" \nng-model=\"slide.campaign_id\" flex style=\"overflow: hidden\"><md-select-header><input ng-model=\"searchTerm\" \ntype=\"search\" placeholder=\"Buscar\" ng-keydown=\"vm.onSearchChange($event)\" style=\"padding: 10px\"></md-select-header>\n<md-option value=\"{{campaign.id}}\" ng-repeat=\"campaign in vm.campaigns | filter:searchTerm\">{{campaign.name}}\n</md-option></md-select></div><div layout=\"column\" ng-show=\"slide.type == \'static\'\"><uploader images=\"slide.image\" \nuploader=\"vm.uploaders[$index]\" filters=\"imageFilter\"></uploader></div></div></md-content></md-tab></md-tabs></md-card>\n<div layout=\"row\" layout-align=\"center center\"><md-input-container layout=\"row\" layout-align=\"center\" class=\"md-block\">\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"vm.fslider.$invalid\">Guardar\n</md-button></md-input-container></div></form></div></div>");
$templateCache.put("app/main/admin/users/views/forms/create.html","<div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"userform\" ng-submit=\"vm.store()\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"name\" ng-model=\"vm.user.name\" placeholder=\"Nombre\" required><div \nng-messages=\"userform.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Nombre es requerido.</span></div>\n</div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"address\" \nng-model=\"vm.user.address\" placeholder=\"Dirección\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nlayout-wrap><md-input-container flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"20\"><input type=\"text\" name=\"city\" \nng-model=\"vm.user.city\" placeholder=\"Ciudad\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-sm=\"20\"><input type=\"text\" name=\"state\" ng-model=\"vm.user.state\" placeholder=\"Provincia\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"20\"><input type=\"text\" name=\"postal_code\" \nng-model=\"vm.user.postal_code\" placeholder=\"Código postal\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-sm=\"20\"><input type=\"text\" name=\"phone\" ng-model=\"vm.user.phone\" placeholder=\"Teléfono\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"30\">\n<label>Email</label><input type=\"email\" name=\"email\" ng-model=\"vm.user.email\" required email><div \nng-messages=\"userform.email.$error\" role=\"alert\"><div ng-message=\"required\"><span>Email es requerido.</span></div><div \nng-message=\"email\"><span>Email no tiene un formato correcto.</span></div></div></md-input-container><md-input-container\n flex=\"100\" flex-gt-xs=\"30\"><input type=\"text\" name=\"username\" ng-model=\"vm.user.username\" \nplaceholder=\"Nombre de usuario\" required><div ng-messages=\"userform.username.$error\" role=\"alert\"><div \nng-message=\"required\"><span>El nombre de usuario es requerido.</span></div></div></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"30\"><input type=\"password\" name=\"password\" ng-model=\"vm.user.password\" \nplaceholder=\"Contraseña\" required ng-minlength=\"5\"><div ng-messages=\"userform.password.$error\" role=\"alert\"><div \nng-message=\"minlength\"><span>Tiene que ser un minimo de 5 caracteres.</span></div><div ng-message=\"required\"><span>\nContraseña es requerida</span></div></div></md-input-container></div><div layout=\"column\" layout-align=\"center center\" \nstyle=\"padding:40px\" ng-cloak><div layout=\"row\" layout-align=\"center center\" style=\"height: 100px\"><md-select \nplaceholder=\"Roles\" required ng-model=\"vm.user.roles\" md-on-open=\"vm.loadRoles()\" style=\"min-width: 200px\" \nmultiple=\"true\"><md-select-header><input ng-model=\"searchTerm\" type=\"search\" placeholder=\"Buscar\" \nng-keydown=\"vm.onSearchChange($event)\" style=\"padding: 10px\"></md-select-header><md-optgroup label=\"roles\"><md-option \nvalue=\"{{role.id}}\" ng-hide=\"role.name===\'root\'\" ng-repeat=\"role in vm.roles | filter:searchTerm\">{{role.name}}\n</md-option></md-optgroup></md-select><md-select placeholder=\"Tipo de contrato\" required \nng-model=\"vm.user.contract_type\" style=\"min-width: 200px\"><md-optgroup label=\"Contratos\"><md-option \nselected=\"selected\" value=\"none\">No definido</md-option><md-option value=\"50\">Cuota 50</md-option><md-option \nvalue=\"35\">Cuota 35</md-option><md-option value=\"25\">Cuota 25</md-option></md-optgroup></md-select></div></div><div \nlayout=\"row\" layout-align=\"center center\"><md-input-container layout=\"row\" layout-align=\"center\" class=\"md-block\">\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\">Guardar</md-button></md-input-container></div>\n</form></div></div>");
$templateCache.put("app/main/admin/users/views/forms/edit.html","<div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"userform\" ng-submit=\"vm.update()\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"name\" ng-model=\"vm.user.name\" placeholder=\"Nombre\" required><div \nng-messages=\"userform.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Nombre es requerido.</span></div>\n</div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"address\" \nng-model=\"vm.user.address\" placeholder=\"Dirección\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nlayout-wrap><md-input-container flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"20\"><input type=\"text\" name=\"city\" \nng-model=\"vm.user.city\" placeholder=\"Ciudad\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-sm=\"20\"><input type=\"text\" name=\"state\" ng-model=\"vm.user.state\" placeholder=\"Provincia\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"20\"><input type=\"text\" name=\"postal_code\" \nng-model=\"vm.user.postal_code\" placeholder=\"Código postal\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-sm=\"20\"><input type=\"text\" name=\"phone\" ng-model=\"vm.user.phone\" placeholder=\"Teléfono\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"30\">\n<label>Email</label><input type=\"email\" name=\"email\" ng-model=\"vm.user.email\" required email><div \nng-messages=\"userform.email.$error\" role=\"alert\"><div ng-message=\"required\"><span>Email es requerido.</span></div><div \nng-message=\"email\"><span>Email no tiene un formato correcto.</span></div></div></md-input-container><md-input-container\n flex=\"100\" flex-gt-xs=\"30\"><input type=\"text\" name=\"username\" ng-model=\"vm.user.username\" \nplaceholder=\"Nombre de usuario\" required><div ng-messages=\"userform.username.$error\" role=\"alert\"><div \nng-message=\"required\"><span>El nombre de usuario es requerido.</span></div></div></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"30\"><input type=\"password\" name=\"password\" ng-model=\"vm.user.password\" \nplaceholder=\"Contraseña\" ng-minlength=\"5\"><div ng-messages=\"userform.password.$error\" role=\"alert\"><div \nng-message=\"minlength\"><span>La contraseña debe de tener como mínimo 5 caracteres</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-align=\"center center\" style=\"padding:40px\" ng-cloak><div \nlayout=\"row\" layout-align=\"center center\" style=\"height: 80px\"><md-select placeholder=\"Roles\" required \nng-model=\"vm.user.roles_id\" style=\"min-width: 200px\" multiple=\"true\"><md-option value=\"{{role.id}}\" \nng-hide=\"role.name==\'root\'\" ng-repeat=\"role in vm.roles | filter:searchTerm\">{{role.name}}</md-option></md-select>\n<md-select placeholder=\"Tipo de contrato\" ng-model=\"vm.user.contract_type\" style=\"min-width: 200px\"><md-optgroup \nlabel=\"Contratos\"><md-option ng-value=\"\'none\'\">No definido</md-option><md-option ng-value=\"\'50\'\">Cuota 50</md-option>\n<md-option ng-value=\"\'35\'\">Cuota 35</md-option><md-option ng-value=\"\'25\'\">Cuota 25</md-option></md-optgroup>\n</md-select></div></div><div layout=\"row\" layout-align=\"center center\"><md-input-container layout=\"row\" \nlayout-align=\"center\" class=\"md-block\"><md-button ng-disabled=\"userform.$invalid || userform.$pristine\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\">Guardar</md-button></md-input-container></div></form></div></div>");
$templateCache.put("app/main/pharmacist/cart/views/dialogs/addpharmacist.html","<md-dialog flex=\"80%\" aria-label=\"{{modal.promotional.description}}\" ng-cloak><form><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Selecciona un cliente</h2><span flex></span><md-button class=\"md-icon-button\" \nng-controller=\"ModalController as  mc\" ng-click=\"mc.hide()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><span class=\"red-500-fg ml-5 mb-10\">\n*Indique el receptor del pedido, quedará aceptado automáticamente.</span><md-card \nclass=\"generic-card-item select-pharmacist-card\"><div layout=\"row\" layout-align=\"center stretch\"><div flex=\"40\" \nlayout=\"column\" layout-align=\"start start\" class=\"mb-10\"><div layout=\"row\" layout-align=\"start center\" \nstyle=\"width: 100%\"><md-input-container flex=\"auto\" flex-grow><input autocomplete=\"off\" id=\"searchPharmacist\" \nplaceholder=\"Buscar\" ng-keyup=\"($event.which === 13) ? modal.searchPharmacist(searchTerm) : 0 \" name=\"searhArticle\" \nng-model=\"searchTerm\" input=\"text\"></md-input-container><md-button class=\"md-icon-button\" \nng-click=\"modal.searchPharmacist(searchTerm)\" ng-disabled=\"!searchTerm || searchTerm == \'\'\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div><div class=\"md-grey-200-bg ph-8\" fill-width=\"\"><p class=\"h3\">\n<strong>Cliente seleccionado</strong></p><p ng-if=\"modal.selectedClient && modal.selectedClient.id\">\n{{ modal.selectedClient.username+\"-\"+modal.selectedClient.name }}</p><p \nng-if=\"!modal.selectedClient || !modal.selectedClient.id\">No se ha seleccionado ningún cliente.</p></div>\n<md-input-container style=\"width: 100%\"><textarea placeholder=\"Comentarios sobre el pedido\" name=\"comment\" \nng-model=\"comment\"></textarea></md-input-container></div><div flex=\"60\" layout=\"column\" \nclass=\"pharmacist-promotional ml-10 pl-10\"><div class=\"text-center grey-300-fg\" ng-if=\"modal.searchResult.length == 0\">\n0 resultados</div><md-progress-circular ng-show=\"loadingSearch\" md-mode=\"indeterminate\"></md-progress-circular>\n<md-list><md-subheader class=\"md-no-sticky\"></md-subheader><md-list-item ng-repeat=\"result in modal.searchResult\" \nclass=\"pharmacist\" ng-class=\"{selected: result.id === modal.selectedClient.id}\"><div layout=\"row\" flex><p \nng-click=\"modal.selectedClient = result\" style=\"cursor:pointer\" flex=\"80\" title=\"{{result.name}}\">\n{{result.username}} - {{result.name | characters : 40}}</p><md-button flex=\"20\" \nng-click=\"modal.selectedClient = result\" class=\"md-icon-button\" aria-label=\"More\"><md-icon md-font-icon=\"icon-plus\">\n<md-tooltip>Añadir</md-tooltip></md-icon></md-button></div></md-list-item></md-list></div></div></md-card>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"modal.addPharma()\" style=\"margin-right:20px\" \nclass=\"md-raised md-background-fg\" ng-class=\"{\'md-green-600-bg\': modal.selectedClient && modal.selectedClient.id}\" \nng-disabled=\"!modal.selectedClient || !modal.selectedClient.id\"><md-icon md-font-icon=\"icon-check\" \nclass=\"md-background-fg\"></md-icon><span>Realizar pedido</span></md-button></md-dialog-actions></form></md-dialog>");}]);